(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {
'use strict';
angular.module('tmh.dynamicLocale', []).config(['$provide', function($provide) {
  function makeStateful($delegate) {
    $delegate.$stateful = true;
    return $delegate;
  }

  $provide.decorator('dateFilter', ['$delegate', makeStateful]);
  $provide.decorator('numberFilter', ['$delegate', makeStateful]);
  $provide.decorator('currencyFilter', ['$delegate', makeStateful]);

}])
.constant('tmhDynamicLocale.STORAGE_KEY', 'tmhDynamicLocale.locale')
.provider('tmhDynamicLocale', ['tmhDynamicLocale.STORAGE_KEY', function(STORAGE_KEY) {

  var defaultLocale,
    localeLocationPattern = 'angular/i18n/angular-locale_{{locale}}.js',
    nodeToAppend,
    storageFactory = 'tmhDynamicLocaleStorageCache',
    storage,
    storageKey = STORAGE_KEY,
    storageGet = 'get',
    storagePut = 'put',
    promiseCache = {},
    activeLocale,
    extraProperties = {};

  /**
   * Loads a script asynchronously
   *
   * @param {string} url The url for the script
   @ @param {function} callback A function to be called once the script is loaded
   */
  function loadScript(url, callback, errorCallback, $timeout) {
    var script = document.createElement('script'),
      element = nodeToAppend ? nodeToAppend : document.getElementsByTagName("body")[0],
      removed = false;

    script.type = 'text/javascript';
    if (script.readyState) { // IE
      script.onreadystatechange = function () {
        if (script.readyState === 'complete' ||
            script.readyState === 'loaded') {
          script.onreadystatechange = null;
          $timeout(
            function () {
              if (removed) return;
              removed = true;
              if (script.parentNode === element) {
                element.removeChild(script);
              }
              callback();
            }, 30, false);
        }
      };
    } else { // Others
      script.onload = function () {
        if (removed) return;
        removed = true;
        if (script.parentNode === element) {
          element.removeChild(script);
        }
        callback();
      };
      script.onerror = function () {
        if (removed) return;
        removed = true;
        if (script.parentNode === element) {
          element.removeChild(script);
        }
        errorCallback();
      };
    }
    script.src = url;
    script.async = true;
    element.appendChild(script);
  }

  /**
   * Loads a locale and replaces the properties from the current locale with the new locale information
   *
   * @param {string} localeUrl The path to the new locale
   * @param {Object} $locale The locale at the curent scope
   * @param {string} localeId The locale id to load
   * @param {Object} $rootScope The application $rootScope
   * @param {Object} $q The application $q
   * @param {Object} localeCache The current locale cache
   * @param {Object} $timeout The application $timeout
   */
  function loadLocale(localeUrl, $locale, localeId, $rootScope, $q, localeCache, $timeout) {

    function overrideValues(oldObject, newObject) {
      if (activeLocale !== localeId) {
        return;
      }
      angular.forEach(oldObject, function(value, key) {
        if (!newObject[key]) {
          delete oldObject[key];
        } else if (angular.isArray(newObject[key])) {
          oldObject[key].length = newObject[key].length;
        }
      });
      angular.forEach(newObject, function(value, key) {
        if (angular.isArray(newObject[key]) || angular.isObject(newObject[key])) {
          if (!oldObject[key]) {
            oldObject[key] = angular.isArray(newObject[key]) ? [] : {};
          }
          overrideValues(oldObject[key], newObject[key]);
        } else {
          oldObject[key] = newObject[key];
        }
      });
    }


    if (promiseCache[localeId]) {
      activeLocale = localeId;
      return promiseCache[localeId];
    }

    var cachedLocale,
      deferred = $q.defer();
    if (localeId === activeLocale) {
      deferred.resolve($locale);
    } else if ((cachedLocale = localeCache.get(localeId))) {
      activeLocale = localeId;
      $rootScope.$evalAsync(function() {
        overrideValues($locale, cachedLocale);
        storage[storagePut](storageKey, localeId);
        $rootScope.$broadcast('$localeChangeSuccess', localeId, $locale);
        deferred.resolve($locale);
      });
    } else {
      activeLocale = localeId;
      promiseCache[localeId] = deferred.promise;
      loadScript(localeUrl, function() {
        // Create a new injector with the new locale
        var localInjector = angular.injector(['ngLocale']),
          externalLocale = localInjector.get('$locale');

        overrideValues($locale, externalLocale);
        localeCache.put(localeId, externalLocale);
        delete promiseCache[localeId];

        $rootScope.$applyAsync(function() {
          storage[storagePut](storageKey, localeId);
          $rootScope.$broadcast('$localeChangeSuccess', localeId, $locale);
          deferred.resolve($locale);
        });
      }, function() {
        delete promiseCache[localeId];

        $rootScope.$applyAsync(function() {
          if (activeLocale === localeId) {
            activeLocale = $locale.id;
          }
          $rootScope.$broadcast('$localeChangeError', localeId);
          deferred.reject(localeId);
        });
      }, $timeout);
    }
    return deferred.promise;
  }

  this.localeLocationPattern = function(value) {
    if (value) {
      localeLocationPattern = value;
      return this;
    } else {
      return localeLocationPattern;
    }
  };

  this.appendScriptTo = function(nodeElement) {
    nodeToAppend = nodeElement;
  };

  this.useStorage = function(storageName) {
    storageFactory = storageName;
    storageGet = 'get';
    storagePut = 'put';
  };

  this.useCookieStorage = function() {
    if (angular.version.minor < 7) {
      this.useStorage('$cookieStore');
    } else {
      this.useStorage('$cookies');
      storageGet = 'getObject';
      storagePut = 'putObject';
    }
  };

  this.defaultLocale = function(value) {
    defaultLocale = value;
  };

  this.storageKey = function(value) {
    if (value) {
      storageKey = value;
      return this;
    } else {
      return storageKey;
    }
  };

  this.addLocalePatternValue = function(key, value) {
    extraProperties[key] = value;
  };

  this.$get = ['$rootScope', '$injector', '$interpolate', '$locale', '$q', 'tmhDynamicLocaleCache', '$timeout', function($rootScope, $injector, interpolate, locale, $q, tmhDynamicLocaleCache, $timeout) {
    var localeLocation = interpolate(localeLocationPattern);

    storage = $injector.get(storageFactory);
    $rootScope.$evalAsync(function() {
      var initialLocale;
      if ((initialLocale = (storage[storageGet](storageKey) || defaultLocale))) {
        loadLocaleFn(initialLocale);
      }
    });
    return {
      /**
       * @ngdoc method
       * @description
       * @param {string} value Sets the locale to the new locale. Changing the locale will trigger
       *    a background task that will retrieve the new locale and configure the current $locale
       *    instance with the information from the new locale
       */
      set: loadLocaleFn,
      /**
       * @ngdoc method
       * @description Returns the configured locale
       */
      get: function() {
        return activeLocale;
      }
    };

    function loadLocaleFn(localeId) {
      var baseProperties = {locale: localeId, angularVersion: angular.version.full};
      return loadLocale(localeLocation(angular.extend({}, extraProperties, baseProperties)), locale, localeId, $rootScope, $q, tmhDynamicLocaleCache, $timeout);
    }
  }];
}]).provider('tmhDynamicLocaleCache', function() {
  this.$get = ['$cacheFactory', function($cacheFactory) {
    return $cacheFactory('tmh.dynamicLocales');
  }];
}).provider('tmhDynamicLocaleStorageCache', function() {
  this.$get = ['$cacheFactory', function($cacheFactory) {
    return $cacheFactory('tmh.dynamicLocales.store');
  }];
}).run(['tmhDynamicLocale', angular.noop]);

return 'tmh.dynamicLocale';

}));

},{}],2:[function(require,module,exports){
/**
 * @license AngularJS v1.7.9
 * (c) 2010-2018 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

var forEach;
var isArray;
var isString;
var jqLite;

/**
 * @ngdoc module
 * @name ngMessages
 * @description
 *
 * The `ngMessages` module provides enhanced support for displaying messages within templates
 * (typically within forms or when rendering message objects that return key/value data).
 * Instead of relying on JavaScript code and/or complex ng-if statements within your form template to
 * show and hide error messages specific to the state of an input field, the `ngMessages` and
 * `ngMessage` directives are designed to handle the complexity, inheritance and priority
 * sequencing based on the order of how the messages are defined in the template.
 *
 * Currently, the ngMessages module only contains the code for the `ngMessages`, `ngMessagesInclude`
 * `ngMessage`, `ngMessageExp` and `ngMessageDefault` directives.
 *
 * ## Usage
 * The `ngMessages` directive allows keys in a key/value collection to be associated with a child element
 * (or 'message') that will show or hide based on the truthiness of that key's value in the collection. A common use
 * case for `ngMessages` is to display error messages for inputs using the `$error` object exposed by the
 * {@link ngModel ngModel} directive.
 *
 * The child elements of the `ngMessages` directive are matched to the collection keys by a `ngMessage` or
 * `ngMessageExp` directive. The value of these attributes must match a key in the collection that is provided by
 * the `ngMessages` directive.
 *
 * Consider the following example, which illustrates a typical use case of `ngMessages`. Within the form `myForm` we
 * have a text input named `myField` which is bound to the scope variable `field` using the {@link ngModel ngModel}
 * directive.
 *
 * The `myField` field is a required input of type `email` with a maximum length of 15 characters.
 *
 * ```html
 * <form name="myForm">
 *   <label>
 *     Enter text:
 *     <input type="email" ng-model="field" name="myField" required maxlength="15" />
 *   </label>
 *   <div ng-messages="myForm.myField.$error" role="alert">
 *     <div ng-message="required">Please enter a value for this field.</div>
 *     <div ng-message="email">This field must be a valid email address.</div>
 *     <div ng-message="maxlength">This field can be at most 15 characters long.</div>
 *   </div>
 * </form>
 * ```
 *
 * In order to show error messages corresponding to `myField` we first create an element with an `ngMessages` attribute
 * set to the `$error` object owned by the `myField` input in our `myForm` form.
 *
 * Within this element we then create separate elements for each of the possible errors that `myField` could have.
 * The `ngMessage` attribute is used to declare which element(s) will appear for which error - for example,
 * setting `ng-message="required"` specifies that this particular element should be displayed when there
 * is no value present for the required field `myField` (because the key `required` will be `true` in the object
 * `myForm.myField.$error`).
 *
 * ### Message order
 *
 * By default, `ngMessages` will only display one message for a particular key/value collection at any time. If more
 * than one message (or error) key is currently true, then which message is shown is determined by the order of messages
 * in the HTML template code (messages declared first are prioritised). This mechanism means the developer does not have
 * to prioritize messages using custom JavaScript code.
 *
 * Given the following error object for our example (which informs us that the field `myField` currently has both the
 * `required` and `email` errors):
 *
 * ```javascript
 * <!-- keep in mind that ngModel automatically sets these error flags -->
 * myField.$error = { required : true, email: true, maxlength: false };
 * ```
 * The `required` message will be displayed to the user since it appears before the `email` message in the DOM.
 * Once the user types a single character, the `required` message will disappear (since the field now has a value)
 * but the `email` message will be visible because it is still applicable.
 *
 * ### Displaying multiple messages at the same time
 *
 * While `ngMessages` will by default only display one error element at a time, the `ng-messages-multiple` attribute can
 * be applied to the `ngMessages` container element to cause it to display all applicable error messages at once:
 *
 * ```html
 * <!-- attribute-style usage -->
 * <div ng-messages="myForm.myField.$error" ng-messages-multiple>...</div>
 *
 * <!-- element-style usage -->
 * <ng-messages for="myForm.myField.$error" multiple>...</ng-messages>
 * ```
 *
 * ## Reusing and Overriding Messages
 * In addition to prioritization, ngMessages also allows for including messages from a remote or an inline
 * template. This allows for generic collection of messages to be reused across multiple parts of an
 * application.
 *
 * ```html
 * <script type="text/ng-template" id="error-messages">
 *   <div ng-message="required">This field is required</div>
 *   <div ng-message="minlength">This field is too short</div>
 * </script>
 *
 * <div ng-messages="myForm.myField.$error" role="alert">
 *   <div ng-messages-include="error-messages"></div>
 * </div>
 * ```
 *
 * However, including generic messages may not be useful enough to match all input fields, therefore,
 * `ngMessages` provides the ability to override messages defined in the remote template by redefining
 * them within the directive container.
 *
 * ```html
 * <!-- a generic template of error messages known as "my-custom-messages" -->
 * <script type="text/ng-template" id="my-custom-messages">
 *   <div ng-message="required">This field is required</div>
 *   <div ng-message="minlength">This field is too short</div>
 * </script>
 *
 * <form name="myForm">
 *   <label>
 *     Email address
 *     <input type="email"
 *            id="email"
 *            name="myEmail"
 *            ng-model="email"
 *            minlength="5"
 *            required />
 *   </label>
 *   <!-- any ng-message elements that appear BEFORE the ng-messages-include will
 *        override the messages present in the ng-messages-include template -->
 *   <div ng-messages="myForm.myEmail.$error" role="alert">
 *     <!-- this required message has overridden the template message -->
 *     <div ng-message="required">You did not enter your email address</div>
 *
 *     <!-- this is a brand new message and will appear last in the prioritization -->
 *     <div ng-message="email">Your email address is invalid</div>
 *
 *     <!-- and here are the generic error messages -->
 *     <div ng-messages-include="my-custom-messages"></div>
 *   </div>
 * </form>
 * ```
 *
 * In the example HTML code above the message that is set on required will override the corresponding
 * required message defined within the remote template. Therefore, with particular input fields (such
 * email addresses, date fields, autocomplete inputs, etc...), specialized error messages can be applied
 * while more generic messages can be used to handle other, more general input errors.
 *
 * ## Dynamic Messaging
 * ngMessages also supports using expressions to dynamically change key values. Using arrays and
 * repeaters to list messages is also supported. This means that the code below will be able to
 * fully adapt itself and display the appropriate message when any of the expression data changes:
 *
 * ```html
 * <form name="myForm">
 *   <label>
 *     Email address
 *     <input type="email"
 *            name="myEmail"
 *            ng-model="email"
 *            minlength="5"
 *            required />
 *   </label>
 *   <div ng-messages="myForm.myEmail.$error" role="alert">
 *     <div ng-message="required">You did not enter your email address</div>
 *     <div ng-repeat="errorMessage in errorMessages">
 *       <!-- use ng-message-exp for a message whose key is given by an expression -->
 *       <div ng-message-exp="errorMessage.type">{{ errorMessage.text }}</div>
 *     </div>
 *   </div>
 * </form>
 * ```
 *
 * The `errorMessage.type` expression can be a string value or it can be an array so
 * that multiple errors can be associated with a single error message:
 *
 * ```html
 *   <label>
 *     Email address
 *     <input type="email"
 *            ng-model="data.email"
 *            name="myEmail"
 *            ng-minlength="5"
 *            ng-maxlength="100"
 *            required />
 *   </label>
 *   <div ng-messages="myForm.myEmail.$error" role="alert">
 *     <div ng-message-exp="'required'">You did not enter your email address</div>
 *     <div ng-message-exp="['minlength', 'maxlength']">
 *       Your email must be between 5 and 100 characters long
 *     </div>
 *   </div>
 * ```
 *
 * Feel free to use other structural directives such as ng-if and ng-switch to further control
 * what messages are active and when. Be careful, if you place ng-message on the same element
 * as these structural directives, AngularJS may not be able to determine if a message is active
 * or not. Therefore it is best to place the ng-message on a child element of the structural
 * directive.
 *
 * ```html
 * <div ng-messages="myForm.myEmail.$error" role="alert">
 *   <div ng-if="showRequiredError">
 *     <div ng-message="required">Please enter something</div>
 *   </div>
 * </div>
 * ```
 *
 * ## Animations
 * If the `ngAnimate` module is active within the application then the `ngMessages`, `ngMessage` and
 * `ngMessageExp` directives will trigger animations whenever any messages are added and removed from
 * the DOM by the `ngMessages` directive.
 *
 * Whenever the `ngMessages` directive contains one or more visible messages then the `.ng-active` CSS
 * class will be added to the element. The `.ng-inactive` CSS class will be applied when there are no
 * messages present. Therefore, CSS transitions and keyframes as well as JavaScript animations can
 * hook into the animations whenever these classes are added/removed.
 *
 * Let's say that our HTML code for our messages container looks like so:
 *
 * ```html
 * <div ng-messages="myMessages" class="my-messages" role="alert">
 *   <div ng-message="alert" class="some-message">...</div>
 *   <div ng-message="fail" class="some-message">...</div>
 * </div>
 * ```
 *
 * Then the CSS animation code for the message container looks like so:
 *
 * ```css
 * .my-messages {
 *   transition:1s linear all;
 * }
 * .my-messages.ng-active {
 *   // messages are visible
 * }
 * .my-messages.ng-inactive {
 *   // messages are hidden
 * }
 * ```
 *
 * Whenever an inner message is attached (becomes visible) or removed (becomes hidden) then the enter
 * and leave animation is triggered for each particular element bound to the `ngMessage` directive.
 *
 * Therefore, the CSS code for the inner messages looks like so:
 *
 * ```css
 * .some-message {
 *   transition:1s linear all;
 * }
 *
 * .some-message.ng-enter {}
 * .some-message.ng-enter.ng-enter-active {}
 *
 * .some-message.ng-leave {}
 * .some-message.ng-leave.ng-leave-active {}
 * ```
 *
 * {@link ngAnimate See the ngAnimate docs} to learn how to use JavaScript animations or to learn
 * more about ngAnimate.
 *
 * ## Displaying a default message
 * If the ngMessages renders no inner ngMessage directive (i.e. when none of the truthy
 * keys are matched by a defined message), then it will render a default message
 * using the {@link ngMessageDefault} directive.
 * Note that matched messages will always take precedence over unmatched messages. That means
 * the default message will not be displayed when another message is matched. This is also
 * true for `ng-messages-multiple`.
 *
 * ```html
 * <div ng-messages="myForm.myField.$error" role="alert">
 *   <div ng-message="required">This field is required</div>
 *   <div ng-message="minlength">This field is too short</div>
 *   <div ng-message-default>This field has an input error</div>
 * </div>
 * ```
 *

 */
angular.module('ngMessages', [], function initAngularHelpers() {
  // Access helpers from AngularJS core.
  // Do it inside a `config` block to ensure `window.angular` is available.
  forEach = angular.forEach;
  isArray = angular.isArray;
  isString = angular.isString;
  jqLite = angular.element;
})
  .info({ angularVersion: '1.7.9' })

  /**
   * @ngdoc directive
   * @module ngMessages
   * @name ngMessages
   * @restrict AE
   *
   * @description
   * `ngMessages` is a directive that is designed to show and hide messages based on the state
   * of a key/value object that it listens on. The directive itself complements error message
   * reporting with the `ngModel` $error object (which stores a key/value state of validation errors).
   *
   * `ngMessages` manages the state of internal messages within its container element. The internal
   * messages use the `ngMessage` directive and will be inserted/removed from the page depending
   * on if they're present within the key/value object. By default, only one message will be displayed
   * at a time and this depends on the prioritization of the messages within the template. (This can
   * be changed by using the `ng-messages-multiple` or `multiple` attribute on the directive container.)
   *
   * A remote template can also be used (With {@link ngMessagesInclude}) to promote message
   * reusability and messages can also be overridden.
   *
   * A default message can also be displayed when no `ngMessage` directive is inserted, using the
   * {@link ngMessageDefault} directive.
   *
   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-message="stringValue">...</ANY>
   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
   *   <ANY ng-message-exp="expressionValue">...</ANY>
   *   <ANY ng-message-default>...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-message when="stringValue">...</ng-message>
   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
   *   <ng-message when-exp="expressionValue">...</ng-message>
   *   <ng-message-default>...</ng-message-default>
   * </ng-messages>
   * ```
   *
   * @param {string} ngMessages an AngularJS expression evaluating to a key/value object
   *                 (this is typically the $error object on an ngModel instance).
   * @param {string=} ngMessagesMultiple|multiple when set, all messages will be displayed with true
   *
   * @example
   * <example name="ngMessages-directive" module="ngMessagesExample"
   *          deps="angular-messages.js"
   *          animations="true" fixBase="true">
   *   <file name="index.html">
   *     <form name="myForm">
   *       <label>
   *         Enter your name:
   *         <input type="text"
   *                name="myName"
   *                ng-model="name"
   *                ng-minlength="5"
   *                ng-maxlength="20"
   *                required />
   *       </label>
   *       <pre>myForm.myName.$error = {{ myForm.myName.$error | json }}</pre>
   *
   *       <div ng-messages="myForm.myName.$error" style="color:maroon" role="alert">
   *         <div ng-message="required">You did not enter a field</div>
   *         <div ng-message="minlength">Your field is too short</div>
   *         <div ng-message="maxlength">Your field is too long</div>
   *         <div ng-message-default>This field has an input error</div>
   *       </div>
   *     </form>
   *   </file>
   *   <file name="script.js">
   *     angular.module('ngMessagesExample', ['ngMessages']);
   *   </file>
   * </example>
   */
  .directive('ngMessages', ['$animate', function($animate) {
    var ACTIVE_CLASS = 'ng-active';
    var INACTIVE_CLASS = 'ng-inactive';

    return {
      require: 'ngMessages',
      restrict: 'AE',
      controller: ['$element', '$scope', '$attrs', function NgMessagesCtrl($element, $scope, $attrs) {
        var ctrl = this;
        var latestKey = 0;
        var nextAttachId = 0;

        this.getAttachId = function getAttachId() { return nextAttachId++; };

        var messages = this.messages = {};
        var renderLater, cachedCollection;

        this.render = function(collection) {
          collection = collection || {};

          renderLater = false;
          cachedCollection = collection;

          // this is true if the attribute is empty or if the attribute value is truthy
          var multiple = isAttrTruthy($scope, $attrs.ngMessagesMultiple) ||
                         isAttrTruthy($scope, $attrs.multiple);

          var unmatchedMessages = [];
          var matchedKeys = {};
          var truthyKeys = 0;
          var messageItem = ctrl.head;
          var messageFound = false;
          var totalMessages = 0;

          // we use != instead of !== to allow for both undefined and null values
          while (messageItem != null) {
            totalMessages++;
            var messageCtrl = messageItem.message;

            var messageUsed = false;
            if (!messageFound) {
              forEach(collection, function(value, key) {
                if (truthy(value) && !messageUsed) {
                  truthyKeys++;

                  if (messageCtrl.test(key)) {
                    // this is to prevent the same error name from showing up twice
                    if (matchedKeys[key]) return;
                    matchedKeys[key] = true;

                    messageUsed = true;
                    messageCtrl.attach();
                  }
                }
              });
            }

            if (messageUsed) {
              // unless we want to display multiple messages then we should
              // set a flag here to avoid displaying the next message in the list
              messageFound = !multiple;
            } else {
              unmatchedMessages.push(messageCtrl);
            }

            messageItem = messageItem.next;
          }

          forEach(unmatchedMessages, function(messageCtrl) {
            messageCtrl.detach();
          });

          var messageMatched = unmatchedMessages.length !== totalMessages;
          var attachDefault = ctrl.default && !messageMatched && truthyKeys > 0;

          if (attachDefault) {
            ctrl.default.attach();
          } else if (ctrl.default) {
            ctrl.default.detach();
          }

          if (messageMatched || attachDefault) {
            $animate.setClass($element, ACTIVE_CLASS, INACTIVE_CLASS);
          } else {
            $animate.setClass($element, INACTIVE_CLASS, ACTIVE_CLASS);
          }
        };

        $scope.$watchCollection($attrs.ngMessages || $attrs['for'], ctrl.render);

        this.reRender = function() {
          if (!renderLater) {
            renderLater = true;
            $scope.$evalAsync(function() {
              if (renderLater && cachedCollection) {
                ctrl.render(cachedCollection);
              }
            });
          }
        };

        this.register = function(comment, messageCtrl, isDefault) {
          if (isDefault) {
            ctrl.default = messageCtrl;
          } else {
            var nextKey = latestKey.toString();
            messages[nextKey] = {
              message: messageCtrl
            };
            insertMessageNode($element[0], comment, nextKey);
            comment.$$ngMessageNode = nextKey;
            latestKey++;
          }

          ctrl.reRender();
        };

        this.deregister = function(comment, isDefault) {
          if (isDefault) {
            delete ctrl.default;
          } else {
            var key = comment.$$ngMessageNode;
            delete comment.$$ngMessageNode;
            removeMessageNode($element[0], comment, key);
            delete messages[key];
          }
          ctrl.reRender();
        };

        function findPreviousMessage(parent, comment) {
          var prevNode = comment;
          var parentLookup = [];

          while (prevNode && prevNode !== parent) {
            var prevKey = prevNode.$$ngMessageNode;
            if (prevKey && prevKey.length) {
              return messages[prevKey];
            }

            // dive deeper into the DOM and examine its children for any ngMessage
            // comments that may be in an element that appears deeper in the list
            if (prevNode.childNodes.length && parentLookup.indexOf(prevNode) === -1) {
              parentLookup.push(prevNode);
              prevNode = prevNode.childNodes[prevNode.childNodes.length - 1];
            } else if (prevNode.previousSibling) {
              prevNode = prevNode.previousSibling;
            } else {
              prevNode = prevNode.parentNode;
              parentLookup.push(prevNode);
            }
          }
        }

        function insertMessageNode(parent, comment, key) {
          var messageNode = messages[key];
          if (!ctrl.head) {
            ctrl.head = messageNode;
          } else {
            var match = findPreviousMessage(parent, comment);
            if (match) {
              messageNode.next = match.next;
              match.next = messageNode;
            } else {
              messageNode.next = ctrl.head;
              ctrl.head = messageNode;
            }
          }
        }

        function removeMessageNode(parent, comment, key) {
          var messageNode = messages[key];

          // This message node may have already been removed by a call to deregister()
          if (!messageNode) return;

          var match = findPreviousMessage(parent, comment);
          if (match) {
            match.next = messageNode.next;
          } else {
            ctrl.head = messageNode.next;
          }
        }
      }]
    };

    function isAttrTruthy(scope, attr) {
     return (isString(attr) && attr.length === 0) || //empty attribute
            truthy(scope.$eval(attr));
    }

    function truthy(val) {
      return isString(val) ? val.length : !!val;
    }
  }])

  /**
   * @ngdoc directive
   * @name ngMessagesInclude
   * @restrict AE
   * @scope
   *
   * @description
   * `ngMessagesInclude` is a directive with the purpose to import existing ngMessage template
   * code from a remote template and place the downloaded template code into the exact spot
   * that the ngMessagesInclude directive is placed within the ngMessages container. This allows
   * for a series of pre-defined messages to be reused and also allows for the developer to
   * determine what messages are overridden due to the placement of the ngMessagesInclude directive.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-messages-include="remoteTplString">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-messages-include src="expressionValue1">...</ng-messages-include>
   * </ng-messages>
   * ```
   *
   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
   *
   * @param {string} ngMessagesInclude|src a string value corresponding to the remote template.
   */
  .directive('ngMessagesInclude',
    ['$templateRequest', '$document', '$compile', function($templateRequest, $document, $compile) {

    return {
      restrict: 'AE',
      require: '^^ngMessages', // we only require this for validation sake
      link: function($scope, element, attrs) {
        var src = attrs.ngMessagesInclude || attrs.src;
        $templateRequest(src).then(function(html) {
          if ($scope.$$destroyed) return;

          if (isString(html) && !html.trim()) {
            // Empty template - nothing to compile
            replaceElementWithMarker(element, src);
          } else {
            // Non-empty template - compile and link
            $compile(html)($scope, function(contents) {
              element.after(contents);
              replaceElementWithMarker(element, src);
            });
          }
        });
      }
    };

    // Helpers
    function replaceElementWithMarker(element, src) {
      // A comment marker is placed for debugging purposes
      var comment = $compile.$$createComment ?
          $compile.$$createComment('ngMessagesInclude', src) :
          $document[0].createComment(' ngMessagesInclude: ' + src + ' ');
      var marker = jqLite(comment);
      element.after(marker);

      // Don't pollute the DOM anymore by keeping an empty directive element
      element.remove();
    }
  }])

  /**
   * @ngdoc directive
   * @name ngMessage
   * @restrict AE
   * @scope
   * @priority 1
   *
   * @description
   * `ngMessage` is a directive with the purpose to show and hide a particular message.
   * For `ngMessage` to operate, a parent `ngMessages` directive on a parent DOM element
   * must be situated since it determines which messages are visible based on the state
   * of the provided key/value map that `ngMessages` listens on.
   *
   * More information about using `ngMessage` can be found in the
   * {@link module:ngMessages `ngMessages` module documentation}.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-message="stringValue">...</ANY>
   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-message when="stringValue">...</ng-message>
   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
   * </ng-messages>
   * ```
   *
   * @param {expression} ngMessage|when a string value corresponding to the message key.
   */
  .directive('ngMessage', ngMessageDirectiveFactory())


  /**
   * @ngdoc directive
   * @name ngMessageExp
   * @restrict AE
   * @priority 1
   * @scope
   *
   * @description
   * `ngMessageExp` is the same as {@link directive:ngMessage `ngMessage`}, but instead of a static
   * value, it accepts an expression to be evaluated for the message key.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression">
   *   <ANY ng-message-exp="expressionValue">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression">
   *   <ng-message when-exp="expressionValue">...</ng-message>
   * </ng-messages>
   * ```
   *
   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
   *
   * @param {expression} ngMessageExp|whenExp an expression value corresponding to the message key.
   */
  .directive('ngMessageExp', ngMessageDirectiveFactory())

  /**
   * @ngdoc directive
   * @name ngMessageDefault
   * @restrict AE
   * @scope
   *
   * @description
   * `ngMessageDefault` is a directive with the purpose to show and hide a default message for
   * {@link directive:ngMessages}, when none of provided messages matches.
   *
   * More information about using `ngMessageDefault` can be found in the
   * {@link module:ngMessages `ngMessages` module documentation}.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-message="stringValue">...</ANY>
   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
   *   <ANY ng-message-default>...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-message when="stringValue">...</ng-message>
   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
   *   <ng-message-default>...</ng-message-default>
   * </ng-messages>
   *
  */
  .directive('ngMessageDefault', ngMessageDirectiveFactory(true));

function ngMessageDirectiveFactory(isDefault) {
  return ['$animate', function($animate) {
    return {
      restrict: 'AE',
      transclude: 'element',
      priority: 1, // must run before ngBind, otherwise the text is set on the comment
      terminal: true,
      require: '^^ngMessages',
      link: function(scope, element, attrs, ngMessagesCtrl, $transclude) {
        var commentNode, records, staticExp, dynamicExp;

        if (!isDefault) {
          commentNode = element[0];
          staticExp = attrs.ngMessage || attrs.when;
          dynamicExp = attrs.ngMessageExp || attrs.whenExp;

          var assignRecords = function(items) {
            records = items
                ? (isArray(items)
                      ? items
                      : items.split(/[\s,]+/))
                : null;
            ngMessagesCtrl.reRender();
          };

          if (dynamicExp) {
            assignRecords(scope.$eval(dynamicExp));
            scope.$watchCollection(dynamicExp, assignRecords);
          } else {
            assignRecords(staticExp);
          }
        }

        var currentElement, messageCtrl;
        ngMessagesCtrl.register(commentNode, messageCtrl = {
          test: function(name) {
            return contains(records, name);
          },
          attach: function() {
            if (!currentElement) {
              $transclude(function(elm, newScope) {
                $animate.enter(elm, null, element);
                currentElement = elm;

                // Each time we attach this node to a message we get a new id that we can match
                // when we are destroying the node later.
                var $$attachId = currentElement.$$attachId = ngMessagesCtrl.getAttachId();

                // in the event that the element or a parent element is destroyed
                // by another structural directive then it's time
                // to deregister the message from the controller
                currentElement.on('$destroy', function() {
                  // If the message element was removed via a call to `detach` then `currentElement` will be null
                  // So this handler only handles cases where something else removed the message element.
                  if (currentElement && currentElement.$$attachId === $$attachId) {
                    ngMessagesCtrl.deregister(commentNode, isDefault);
                    messageCtrl.detach();
                  }
                  newScope.$destroy();
                });
              });
            }
          },
          detach: function() {
            if (currentElement) {
              var elm = currentElement;
              currentElement = null;
              $animate.leave(elm);
            }
          }
        }, isDefault);

        // We need to ensure that this directive deregisters itself when it no longer exists
        // Normally this is done when the attached element is destroyed; but if this directive
        // gets removed before we attach the message to the DOM there is nothing to watch
        // in which case we must deregister when the containing scope is destroyed.
        scope.$on('$destroy', function() {
          ngMessagesCtrl.deregister(commentNode, isDefault);
        });
      }
    };
  }];

  function contains(collection, key) {
    if (collection) {
      return isArray(collection)
          ? collection.indexOf(key) >= 0
          : collection.hasOwnProperty(key);
    }
  }
}


})(window, window.angular);

},{}],3:[function(require,module,exports){
require('./angular-messages');
module.exports = 'ngMessages';

},{"./angular-messages":2}],4:[function(require,module,exports){
/*!
 * angular-translate - v2.18.1 - 2018-05-19
 * 
 * Copyright (c) 2018 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

$translateMissingTranslationHandlerLog.$inject = ['$log'];
angular.module('pascalprecht.translate')

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateMissingTranslationHandlerLog
 * @requires $log
 *
 * @description
 * Uses angular's `$log` service to give a warning when trying to translate a
 * translation id which doesn't exist.
 *
 * @returns {function} Handler function
 */
.factory('$translateMissingTranslationHandlerLog', $translateMissingTranslationHandlerLog);

function $translateMissingTranslationHandlerLog ($log) {

  'use strict';

  return function (translationId) {
    $log.warn('Translation for ' + translationId + ' doesn\'t exist');
  };
}

$translateMissingTranslationHandlerLog.displayName = '$translateMissingTranslationHandlerLog';
return 'pascalprecht.translate';

}));

},{}],5:[function(require,module,exports){
/*!
 * angular-translate - v2.18.1 - 2018-05-19
 * 
 * Copyright (c) 2018 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

angular.module('pascalprecht.translate')
/**
 * @ngdoc object
 * @name pascalprecht.translate.$translatePartialLoaderProvider
 *
 * @description
 * By using a $translatePartialLoaderProvider you can configure a list of a needed
 * translation parts directly during the configuration phase of your application's
 * lifetime. All parts you add by using this provider would be loaded by
 * angular-translate at the startup as soon as possible.
 */
  .provider('$translatePartialLoader', $translatePartialLoader);

function $translatePartialLoader() {

  'use strict';

  /**
   * @constructor
   * @name Part
   *
   * @description
   * Represents Part object to add and set parts at runtime.
   */
  function Part(name, priority, urlTemplate) {
    this.name = name;
    this.isActive = true;
    this.tables = {};
    this.priority = priority || 0;
    this.langPromises = {};
    this.urlTemplate = urlTemplate;
  }

  /**
   * @name parseUrl
   * @method
   *
   * @description
   * Returns a parsed url template string and replaces given target lang
   * and part name it.
   *
   * @param {string|function} urlTemplate - Either a string containing an url pattern (with
   *                                        '{part}' and '{lang}') or a function(part, lang)
   *                                        returning a string.
   * @param {string} targetLang - Language key for language to be used.
   * @return {string} Parsed url template string
   */
  Part.prototype.parseUrl = function (urlTemplate, targetLang) {
    if (angular.isFunction(urlTemplate)) {
      return urlTemplate(this.name, targetLang);
    }
    return urlTemplate.replace(/\{part\}/g, this.name).replace(/\{lang\}/g, targetLang);
  };

  Part.prototype.getTable = function (lang, $q, $http, $httpOptions, urlTemplate, errorHandler) {

    //locals
    var self = this;
    var lastLangPromise = this.langPromises[lang];
    var deferred = $q.defer();

    //private helper helpers
    var fetchData = function () {
      return $http(
        angular.extend({
            method : 'GET',
            url : self.parseUrl(self.urlTemplate || urlTemplate, lang)
          },
          $httpOptions)
      );
    };

    //private helper
    var handleNewData = function (data) {
      self.tables[lang] = data;
      deferred.resolve(data);
    };

    //private helper
    var rejectDeferredWithPartName = function () {
      deferred.reject(self.name);
    };

    //private helper
    var tryGettingThisTable = function () {
      //data fetching logic
      fetchData().then(
        function (result) {
          handleNewData(result.data);
        },
        function (errorResponse) {
          if (errorHandler) {
            errorHandler(self.name, lang, errorResponse).then(handleNewData, rejectDeferredWithPartName);
          } else {
            rejectDeferredWithPartName();
          }
        });
    };

    //loading logic
    if (!this.tables[lang]) {
      //let's try loading the data
      if (!lastLangPromise) {
        //this is the first request - just go ahead and hit the server
        tryGettingThisTable();
      } else {
        //this is an additional request after one or more unfinished or failed requests
        //chain the deferred off the previous request's promise so that this request conditionally executes
        //if the previous request succeeds then the result will be passed through, but if it fails then this request will try again and hit the server
        lastLangPromise.then(deferred.resolve, tryGettingThisTable);
      }
      //retain a reference to the last promise so we can continue the chain if another request is made before any succeed
      //you can picture the promise chain as a singly-linked list (formed by the .then handler queues) that's traversed by the execution context
      this.langPromises[lang] = deferred.promise;
    }
    else {
      //the part has already been loaded - if lastLangPromise is also undefined then the table has been populated using setPart
      //this breaks the promise chain because we're not tying langDeferred's outcome to a previous call's promise handler queues, but we don't care because there's no asynchronous execution context to keep track of anymore
      deferred.resolve(this.tables[lang]);
    }
    return deferred.promise;
  };

  var parts = {};

  function hasPart(name) {
    return Object.prototype.hasOwnProperty.call(parts, name);
  }

  function isStringValid(str) {
    return angular.isString(str) && str !== '';
  }

  function isPartAvailable(name) {
    if (!isStringValid(name)) {
      throw new TypeError('Invalid type of a first argument, a non-empty string expected.');
    }

    return (hasPart(name) && parts[name].isActive);
  }

  function deepExtend(dst, src) {
    for (var property in src) {
      if (src[property] && src[property].constructor &&
        src[property].constructor === Object) {
        dst[property] = dst[property] || {};
        deepExtend(dst[property], src[property]);
      } else {
        dst[property] = src[property];
      }
    }
    return dst;
  }

  function getPrioritizedParts() {
    var prioritizedParts = [];
    for (var part in parts) {
      if (parts[part].isActive) {
        prioritizedParts.push(parts[part]);
      }
    }
    prioritizedParts.sort(function (a, b) {
      return a.priority - b.priority;
    });
    return prioritizedParts;
  }


  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translatePartialLoaderProvider#addPart
   * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
   *
   * @description
   * Registers a new part of the translation table to be loaded once the
   * `angular-translate` gets into runtime phase. It does not actually load any
   * translation data, but only registers a part to be loaded in the future.
   *
   * @param {string} name A name of the part to add
   * @param {int} [priority=0] Sets the load priority of this part.
   *
   * @returns {object} $translatePartialLoaderProvider, so this method is chainable
   * @throws {TypeError} The method could throw a **TypeError** if you pass the param
   * of the wrong type. Please, note that the `name` param has to be a
   * non-empty **string**.
   */
  this.addPart = function (name, priority, urlTemplate) {
    if (!isStringValid(name)) {
      throw new TypeError('Couldn\'t add part, part name has to be a string!');
    }

    if (!hasPart(name)) {
      parts[name] = new Part(name, priority, urlTemplate);
    }
    parts[name].isActive = true;

    return this;
  };

  /**
   * @ngdocs function
   * @name pascalprecht.translate.$translatePartialLoaderProvider#setPart
   * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
   *
   * @description
   * Sets a translation table to the specified part. This method does not make the
   * specified part available, but only avoids loading this part from the server.
   *
   * @param {string} lang A language of the given translation table
   * @param {string} part A name of the target part
   * @param {object} table A translation table to set to the specified part
   *
   * @return {object} $translatePartialLoaderProvider, so this method is chainable
   * @throws {TypeError} The method could throw a **TypeError** if you pass params
   * of the wrong type. Please, note that the `lang` and `part` params have to be a
   * non-empty **string**s and the `table` param has to be an object.
   */
  this.setPart = function (lang, part, table) {
    if (!isStringValid(lang)) {
      throw new TypeError('Couldn\'t set part.`lang` parameter has to be a string!');
    }
    if (!isStringValid(part)) {
      throw new TypeError('Couldn\'t set part.`part` parameter has to be a string!');
    }
    if (typeof table !== 'object' || table === null) {
      throw new TypeError('Couldn\'t set part. `table` parameter has to be an object!');
    }

    if (!hasPart(part)) {
      parts[part] = new Part(part);
      parts[part].isActive = false;
    }

    parts[part].tables[lang] = table;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translatePartialLoaderProvider#deletePart
   * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
   *
   * @description
   * Removes the previously added part of the translation data. So, `angular-translate` will not
   * load it at the startup.
   *
   * @param {string} name A name of the part to delete
   *
   * @returns {object} $translatePartialLoaderProvider, so this method is chainable
   *
   * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
   * type. Please, note that the `name` param has to be a non-empty **string**.
   */
  this.deletePart = function (name) {
    if (!isStringValid(name)) {
      throw new TypeError('Couldn\'t delete part, first arg has to be string.');
    }

    if (hasPart(name)) {
      parts[name].isActive = false;
    }

    return this;
  };


  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translatePartialLoaderProvider#isPartAvailable
   * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
   *
   * @description
   * Checks if the specific part is available. A part becomes available after it was added by the
   * `addPart` method. Available parts would be loaded from the server once the `angular-translate`
   * asks the loader to that.
   *
   * @param {string} name A name of the part to check
   *
   * @returns {boolean} Returns **true** if the part is available now and **false** if not.
   *
   * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
   * type. Please, note that the `name` param has to be a non-empty **string**.
   */
  this.isPartAvailable = isPartAvailable;

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translatePartialLoader
   *
   * @requires $q
   * @requires $http
   * @requires $injector
   * @requires $rootScope
   * @requires $translate
   *
   * @description
   *
   * @param {object} options Options object
   *
   * @throws {TypeError}
   */
  this.$get = ['$rootScope', '$injector', '$q', '$http', '$log',
    function ($rootScope, $injector, $q, $http, $log) {

      /**
       * @ngdoc event
       * @name pascalprecht.translate.$translatePartialLoader#$translatePartialLoaderStructureChanged
       * @eventOf pascalprecht.translate.$translatePartialLoader
       * @eventType broadcast on root scope
       *
       * @description
       * A $translatePartialLoaderStructureChanged event is called when a state of the loader was
       * changed somehow. It could mean either some part is added or some part is deleted. Anyway when
       * you get this event the translation table is not longer current and has to be updated.
       *
       * @param {string} name A name of the part which is a reason why the event was fired
       */

      var service = function (options) {
        if (!isStringValid(options.key)) {
          throw new TypeError('Unable to load data, a key is not a non-empty string.');
        }

        if (!isStringValid(options.urlTemplate) && !angular.isFunction(options.urlTemplate)) {
          throw new TypeError('Unable to load data, a urlTemplate is not a non-empty string or not a function.');
        }

        var errorHandler = options.loadFailureHandler;
        if (errorHandler !== undefined) {
          if (!angular.isString(errorHandler)) {
            throw new Error('Unable to load data, a loadFailureHandler is not a string.');
          } else {
            errorHandler = $injector.get(errorHandler);
          }
        }

        var loaders = [],
          prioritizedParts = getPrioritizedParts();

        angular.forEach(prioritizedParts, function (part) {
          loaders.push(
            part.getTable(options.key, $q, $http, options.$http, options.urlTemplate, errorHandler)
          );
          part.urlTemplate = part.urlTemplate || options.urlTemplate;
        });

        // workaround for #1781
        var structureHasBeenChangedWhileLoading = false;
        var dirtyCheckEventCloser = $rootScope.$on('$translatePartialLoaderStructureChanged', function () {
          structureHasBeenChangedWhileLoading = true;
        });

        return $q.all(loaders)
          .then(function () {
            dirtyCheckEventCloser();
            if (structureHasBeenChangedWhileLoading) {
              if (!options.__retries) {
                // the part structure has been changed while loading (the origin ones)
                // this can happen if an addPart/removePart has been invoked right after a $translate.use(lang)
                // TODO maybe we can optimize this with the actual list of missing parts
                options.__retries = (options.__retries || 0) + 1;
                return service(options);
              } else {
                // the part structure has been changed again while loading (retried one)
                // because this could an infinite loop, this will not load another one again
                $log.warn('The partial loader has detected a multiple structure change (with addPort/removePart) ' +
                  'while loading translations. You should consider using promises of $translate.use(lang) and ' +
                  '$translate.refresh(). Also parts should be added/removed right before an explicit refresh ' +
                  'if possible.');
              }
            }
            var table = {};
            prioritizedParts = getPrioritizedParts();
            angular.forEach(prioritizedParts, function (part) {
              deepExtend(table, part.tables[options.key]);
            });
            return table;
          }, function () {
            dirtyCheckEventCloser();
            return $q.reject(options.key);
          });
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translatePartialLoader#addPart
       * @methodOf pascalprecht.translate.$translatePartialLoader
       *
       * @description
       * Registers a new part of the translation table. This method does not actually perform any xhr
       * requests to get translation data. The new parts will be loaded in order of priority from the server next time
       * `angular-translate` asks the loader to load translations.
       *
       * @param {string} name A name of the part to add
       * @param {int} [priority=0] Sets the load priority of this part.
       *
       * @returns {object} $translatePartialLoader, so this method is chainable
       *
       * @fires {$translatePartialLoaderStructureChanged} The $translatePartialLoaderStructureChanged
       * event would be fired by this method in case the new part affected somehow on the loaders
       * state. This way it means that there are a new translation data available to be loaded from
       * the server.
       *
       * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
       * type. Please, note that the `name` param has to be a non-empty **string**.
       */
      service.addPart = function (name, priority, urlTemplate) {
        if (!isStringValid(name)) {
          throw new TypeError('Couldn\'t add part, first arg has to be a string');
        }

        if (!hasPart(name)) {
          parts[name] = new Part(name, priority, urlTemplate);
          $rootScope.$emit('$translatePartialLoaderStructureChanged', name);
        } else if (!parts[name].isActive) {
          parts[name].isActive = true;
          $rootScope.$emit('$translatePartialLoaderStructureChanged', name);
        }

        return service;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translatePartialLoader#deletePart
       * @methodOf pascalprecht.translate.$translatePartialLoader
       *
       * @description
       * Deletes the previously added part of the translation data. The target part could be deleted
       * either logically or physically. When the data is deleted logically it is not actually deleted
       * from the browser, but the loader marks it as not active and prevents it from affecting on the
       * translations. If the deleted in such way part is added again, the loader will use the
       * previously loaded data rather than loading it from the server once more time. But if the data
       * is deleted physically, the loader will completely remove all information about it. So in case
       * of recycling this part will be loaded from the server again.
       *
       * @param {string} name A name of the part to delete
       * @param {boolean=} [removeData=false] An indicator if the loader has to remove a loaded
       * translation data physically. If the `removeData` if set to **false** the loaded data will not be
       * deleted physically and might be reused in the future to prevent an additional xhr requests.
       *
       * @returns {object} $translatePartialLoader, so this method is chainable
       *
       * @fires {$translatePartialLoaderStructureChanged} The $translatePartialLoaderStructureChanged
       * event would be fired by this method in case a part deletion process affects somehow on the
       * loaders state. This way it means that some part of the translation data is now deprecated and
       * the translation table has to be recompiled with the remaining translation parts.
       *
       * @throws {TypeError} The method could throw a **TypeError** if you pass some param of the
       * wrong type. Please, note that the `name` param has to be a non-empty **string** and
       * the `removeData` param has to be either **undefined** or **boolean**.
       */
      service.deletePart = function (name, removeData) {
        if (!isStringValid(name)) {
          throw new TypeError('Couldn\'t delete part, first arg has to be string');
        }

        if (removeData === undefined) {
          removeData = false;
        } else if (typeof removeData !== 'boolean') {
          throw new TypeError('Invalid type of a second argument, a boolean expected.');
        }

        if (hasPart(name)) {
          var wasActive = parts[name].isActive;
          if (removeData) {
            var $translate = $injector.get('$translate');
            var cache = $translate.loaderCache();
            if (typeof(cache) === 'string') {
              // getting on-demand instance of loader
              cache = $injector.get(cache);
            }
            // Purging items from cache...
            if (typeof(cache) === 'object') {
              angular.forEach(parts[name].tables, function (value, key) {
                cache.remove(parts[name].parseUrl(parts[name].urlTemplate, key));
              });
            }
            delete parts[name];
          } else {
            parts[name].isActive = false;
          }
          if (wasActive) {
            $rootScope.$emit('$translatePartialLoaderStructureChanged', name);
          }
        }

        return service;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translatePartialLoader#isPartLoaded
       * @methodOf pascalprecht.translate.$translatePartialLoader
       *
       * @description
       * Checks if the registered translation part is loaded into the translation table.
       *
       * @param {string} name A name of the part
       * @param {string} lang A key of the language
       *
       * @returns {boolean} Returns **true** if the translation of the part is loaded to the translation table and **false** if not.
       *
       * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
       * type. Please, note that the `name` and `lang` params have to be non-empty **string**.
       */
      service.isPartLoaded = function (name, lang) {
        return angular.isDefined(parts[name]) && angular.isDefined(parts[name].tables[lang]);
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translatePartialLoader#getRegisteredParts
       * @methodOf pascalprecht.translate.$translatePartialLoader
       *
       * @description
       * Gets names of the parts that were added with the `addPart`.
       *
       * @returns {array} Returns array of registered parts, if none were registered then an empty array is returned.
       */
      service.getRegisteredParts = function () {
        var registeredParts = [];
        angular.forEach(parts, function (p) {
          if (p.isActive) {
            registeredParts.push(p.name);
          }
        });
        return registeredParts;
      };


      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translatePartialLoader#isPartAvailable
       * @methodOf pascalprecht.translate.$translatePartialLoader
       *
       * @description
       * Checks if a target translation part is available. The part becomes available just after it was
       * added by the `addPart` method. Part's availability does not mean that it was loaded from the
       * server, but only that it was added to the loader. The available part might be loaded next
       * time the loader is called.
       *
       * @param {string} name A name of the part to delete
       *
       * @returns {boolean} Returns **true** if the part is available now and **false** if not.
       *
       * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
       * type. Please, note that the `name` param has to be a non-empty **string**.
       */
      service.isPartAvailable = isPartAvailable;

      return service;

    }];

}

$translatePartialLoader.displayName = '$translatePartialLoader';
return 'pascalprecht.translate';

}));

},{}],6:[function(require,module,exports){
/*!
 * angular-translate - v2.18.1 - 2018-05-19
 * 
 * Copyright (c) 2018 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

$translateStaticFilesLoader.$inject = ['$q', '$http'];
angular.module('pascalprecht.translate')
/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateStaticFilesLoader
 * @requires $q
 * @requires $http
 *
 * @description
 * Creates a loading function for a typical static file url pattern:
 * "lang-en_US.json", "lang-de_DE.json", etc. Using this builder,
 * the response of these urls must be an object of key-value pairs.
 *
 * @param {object} options Options object, which gets prefix, suffix, key, and fileMap
 */
.factory('$translateStaticFilesLoader', $translateStaticFilesLoader);

function $translateStaticFilesLoader($q, $http) {

  'use strict';

  return function (options) {

    if (!options || (!angular.isArray(options.files) && (!angular.isString(options.prefix) || !angular.isString(options.suffix)))) {
      throw new Error('Couldn\'t load static files, no files and prefix or suffix specified!');
    }

    if (!options.files) {
      options.files = [{
        prefix: options.prefix,
        suffix: options.suffix
      }];
    }

    var load = function (file) {
      if (!file || (!angular.isString(file.prefix) || !angular.isString(file.suffix))) {
        throw new Error('Couldn\'t load static file, no prefix or suffix specified!');
      }

      var fileUrl = [
        file.prefix,
        options.key,
        file.suffix
      ].join('');

      if (angular.isObject(options.fileMap) && options.fileMap[fileUrl]) {
        fileUrl = options.fileMap[fileUrl];
      }

      return $http(angular.extend({
        url: fileUrl,
        method: 'GET'
      }, options.$http))
        .then(function(result) {
          return result.data;
        }, function () {
          return $q.reject(options.key);
        });
    };

    var promises = [],
        length = options.files.length;

    for (var i = 0; i < length; i++) {
      promises.push(load({
        prefix: options.files[i].prefix,
        key: options.key,
        suffix: options.files[i].suffix
      }));
    }

    return $q.all(promises)
      .then(function (data) {
        var length = data.length,
            mergedData = {};

        for (var i = 0; i < length; i++) {
          for (var key in data[i]) {
            mergedData[key] = data[i][key];
          }
        }

        return mergedData;
      });
  };
}

$translateStaticFilesLoader.displayName = '$translateStaticFilesLoader';
return 'pascalprecht.translate';

}));

},{}],7:[function(require,module,exports){
/*!
 * angular-translate - v2.18.1 - 2018-05-19
 * 
 * Copyright (c) 2018 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

/**
 * @ngdoc overview
 * @name pascalprecht.translate
 *
 * @description
 * The main module which holds everything together.
 */
runTranslate.$inject = ['$translate'];
$translate.$inject = ['$STORAGE_KEY', '$windowProvider', '$translateSanitizationProvider', 'pascalprechtTranslateOverrider'];
$translateDefaultInterpolation.$inject = ['$interpolate', '$translateSanitization'];
translateDirective.$inject = ['$translate', '$interpolate', '$compile', '$parse', '$rootScope'];
translateAttrDirective.$inject = ['$translate', '$rootScope'];
translateCloakDirective.$inject = ['$translate', '$rootScope'];
translateFilterFactory.$inject = ['$parse', '$translate'];
$translationCache.$inject = ['$cacheFactory'];
angular.module('pascalprecht.translate', ['ng'])
  .run(runTranslate);

function runTranslate($translate) {

  'use strict';

  var key = $translate.storageKey(),
    storage = $translate.storage();

  var fallbackFromIncorrectStorageValue = function () {
    var preferred = $translate.preferredLanguage();
    if (angular.isString(preferred)) {
      $translate.use(preferred);
      // $translate.use() will also remember the language.
      // So, we don't need to call storage.put() here.
    } else {
      storage.put(key, $translate.use());
    }
  };

  fallbackFromIncorrectStorageValue.displayName = 'fallbackFromIncorrectStorageValue';

  if (storage) {
    if (!storage.get(key)) {
      fallbackFromIncorrectStorageValue();
    } else {
      $translate.use(storage.get(key))['catch'](fallbackFromIncorrectStorageValue);
    }
  } else if (angular.isString($translate.preferredLanguage())) {
    $translate.use($translate.preferredLanguage());
  }
}

runTranslate.displayName = 'runTranslate';

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateSanitizationProvider
 *
 * @description
 *
 * Configurations for $translateSanitization
 */
angular.module('pascalprecht.translate').provider('$translateSanitization', $translateSanitizationProvider);

function $translateSanitizationProvider () {

  'use strict';

  var $sanitize,
      $sce,
      currentStrategy = null, // TODO change to either 'sanitize', 'escape' or ['sanitize', 'escapeParameters'] in 3.0.
      hasConfiguredStrategy = false,
      hasShownNoStrategyConfiguredWarning = false,
      strategies;

  /**
   * Definition of a sanitization strategy function
   * @callback StrategyFunction
   * @param {string|object} value - value to be sanitized (either a string or an interpolated value map)
   * @param {string} mode - either 'text' for a string (translation) or 'params' for the interpolated params
   * @return {string|object}
   */

  /**
   * @ngdoc property
   * @name strategies
   * @propertyOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Following strategies are built-in:
   * <dl>
   *   <dt>sanitize</dt>
   *   <dd>Sanitizes HTML in the translation text using $sanitize</dd>
   *   <dt>escape</dt>
   *   <dd>Escapes HTML in the translation</dd>
   *   <dt>sanitizeParameters</dt>
   *   <dd>Sanitizes HTML in the values of the interpolation parameters using $sanitize</dd>
   *   <dt>escapeParameters</dt>
   *   <dd>Escapes HTML in the values of the interpolation parameters</dd>
   *   <dt>escaped</dt>
   *   <dd>Support legacy strategy name 'escaped' for backwards compatibility (will be removed in 3.0)</dd>
   * </dl>
   *
   */

  strategies = {
    sanitize: function (value, mode/*, context*/) {
      if (mode === 'text') {
        value = htmlSanitizeValue(value);
      }
      return value;
    },
    escape: function (value, mode/*, context*/) {
      if (mode === 'text') {
        value = htmlEscapeValue(value);
      }
      return value;
    },
    sanitizeParameters: function (value, mode/*, context*/) {
      if (mode === 'params') {
        value = mapInterpolationParameters(value, htmlSanitizeValue);
      }
      return value;
    },
    escapeParameters: function (value, mode/*, context*/) {
      if (mode === 'params') {
        value = mapInterpolationParameters(value, htmlEscapeValue);
      }
      return value;
    },
    sce: function (value, mode, context) {
      if (mode === 'text') {
        value = htmlTrustValue(value);
      } else if (mode === 'params') {
        if (context !== 'filter') {
          // do html escape in filter context #1101
          value = mapInterpolationParameters(value, htmlEscapeValue);
        }
      }
      return value;
    },
    sceParameters: function (value, mode/*, context*/) {
      if (mode === 'params') {
        value = mapInterpolationParameters(value, htmlTrustValue);
      }
      return value;
    }
  };
  // Support legacy strategy name 'escaped' for backwards compatibility.
  // TODO should be removed in 3.0
  strategies.escaped = strategies.escapeParameters;

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateSanitizationProvider#addStrategy
   * @methodOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Adds a sanitization strategy to the list of known strategies.
   *
   * @param {string} strategyName - unique key for a strategy
   * @param {StrategyFunction} strategyFunction - strategy function
   * @returns {object} this
   */
  this.addStrategy = function (strategyName, strategyFunction) {
    strategies[strategyName] = strategyFunction;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateSanitizationProvider#removeStrategy
   * @methodOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Removes a sanitization strategy from the list of known strategies.
   *
   * @param {string} strategyName - unique key for a strategy
   * @returns {object} this
   */
  this.removeStrategy = function (strategyName) {
    delete strategies[strategyName];
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateSanitizationProvider#useStrategy
   * @methodOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
   *
   * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
   * @returns {object} this
   */
  this.useStrategy = function (strategy) {
    hasConfiguredStrategy = true;
    currentStrategy = strategy;
    return this;
  };

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translateSanitization
   * @requires $injector
   * @requires $log
   *
   * @description
   * Sanitizes interpolation parameters and translated texts.
   *
   */
  this.$get = ['$injector', '$log', function ($injector, $log) {

    var cachedStrategyMap = {};

    var applyStrategies = function (value, mode, context, selectedStrategies) {
      angular.forEach(selectedStrategies, function (selectedStrategy) {
        if (angular.isFunction(selectedStrategy)) {
          value = selectedStrategy(value, mode, context);
        } else if (angular.isFunction(strategies[selectedStrategy])) {
          value = strategies[selectedStrategy](value, mode, context);
        } else if (angular.isString(strategies[selectedStrategy])) {
          if (!cachedStrategyMap[strategies[selectedStrategy]]) {
            try {
              cachedStrategyMap[strategies[selectedStrategy]] = $injector.get(strategies[selectedStrategy]);
            } catch (e) {
              cachedStrategyMap[strategies[selectedStrategy]] = function() {};
              throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
            }
          }
          value = cachedStrategyMap[strategies[selectedStrategy]](value, mode, context);
        } else {
          throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
        }
      });
      return value;
    };

    // TODO: should be removed in 3.0
    var showNoStrategyConfiguredWarning = function () {
      if (!hasConfiguredStrategy && !hasShownNoStrategyConfiguredWarning) {
        $log.warn('pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details.');
        hasShownNoStrategyConfiguredWarning = true;
      }
    };

    if ($injector.has('$sanitize')) {
      $sanitize = $injector.get('$sanitize');
    }
    if ($injector.has('$sce')) {
      $sce = $injector.get('$sce');
    }

    return {
      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translateSanitization#useStrategy
       * @methodOf pascalprecht.translate.$translateSanitization
       *
       * @description
       * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
       *
       * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
       */
      useStrategy: (function (self) {
        return function (strategy) {
          self.useStrategy(strategy);
        };
      })(this),

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translateSanitization#sanitize
       * @methodOf pascalprecht.translate.$translateSanitization
       *
       * @description
       * Sanitizes a value.
       *
       * @param {string|object} value The value which should be sanitized.
       * @param {string} mode The current sanitization mode, either 'params' or 'text'.
       * @param {string|StrategyFunction|array} [strategy] Optional custom strategy which should be used instead of the currently selected strategy.
       * @param {string} [context] The context of this call: filter, service. Default is service
       * @returns {string|object} sanitized value
       */
      sanitize: function (value, mode, strategy, context) {
        if (!currentStrategy) {
          showNoStrategyConfiguredWarning();
        }

        if (!strategy && strategy !== null) {
          strategy = currentStrategy;
        }

        if (!strategy) {
          return value;
        }

        if (!context) {
          context = 'service';
        }

        var selectedStrategies = angular.isArray(strategy) ? strategy : [strategy];
        return applyStrategies(value, mode, context, selectedStrategies);
      }
    };
  }];

  var htmlEscapeValue = function (value) {
    var element = angular.element('<div></div>');
    element.text(value); // not chainable, see #1044
    return element.html();
  };

  var htmlSanitizeValue = function (value) {
    if (!$sanitize) {
      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as \'escape\'.');
    }
    return $sanitize(value);
  };

  var htmlTrustValue = function (value) {
    if (!$sce) {
      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sce service.');
    }
    return $sce.trustAsHtml(value);
  };

  var mapInterpolationParameters = function (value, iteratee, stack) {
    if (angular.isDate(value)) {
      return value;
    } else if (angular.isObject(value)) {
      var result = angular.isArray(value) ? [] : {};

      if (!stack) {
        stack = [];
      } else {
        if (stack.indexOf(value) > -1) {
          throw new Error('pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object');
        }
      }

      stack.push(value);
      angular.forEach(value, function (propertyValue, propertyKey) {

        /* Skipping function properties. */
        if (angular.isFunction(propertyValue)) {
          return;
        }

        result[propertyKey] = mapInterpolationParameters(propertyValue, iteratee, stack);
      });
      stack.splice(-1, 1); // remove last

      return result;
    } else if (angular.isNumber(value)) {
      return value;
    } else if (value === true || value === false) {
      return value;
    } else if (!angular.isUndefined(value) && value !== null) {
      return iteratee(value);
    } else {
      return value;
    }
  };
}

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateProvider
 * @description
 *
 * $translateProvider allows developers to register translation-tables, asynchronous loaders
 * and similar to configure translation behavior directly inside of a module.
 *
 */
angular.module('pascalprecht.translate')
  .constant('pascalprechtTranslateOverrider', {})
  .provider('$translate', $translate);

function $translate($STORAGE_KEY, $windowProvider, $translateSanitizationProvider, pascalprechtTranslateOverrider) {

  'use strict';

  var $translationTable = {},
    $preferredLanguage,
    $availableLanguageKeys = [],
    $languageKeyAliases,
    $fallbackLanguage,
    $fallbackWasString,
    $uses,
    $nextLang,
    $storageFactory,
    $storageKey = $STORAGE_KEY,
    $storagePrefix,
    $missingTranslationHandlerFactory,
    $interpolationFactory,
    $interpolatorFactories = [],
    $loaderFactory,
    $cloakClassName = 'translate-cloak',
    $loaderOptions,
    $notFoundIndicatorLeft,
    $notFoundIndicatorRight,
    $postCompilingEnabled = false,
    $forceAsyncReloadEnabled = false,
    $nestedObjectDelimeter = '.',
    $isReady = false,
    $keepContent = false,
    loaderCache,
    directivePriority = 0,
    statefulFilter = true,
    postProcessFn,
    uniformLanguageTagResolver = 'default',
    languageTagResolver = {
      'default' : function (tag) {
        return (tag || '').split('-').join('_');
      },
      java : function (tag) {
        var temp = (tag || '').split('-').join('_');
        var parts = temp.split('_');
        return parts.length > 1 ? (parts[0].toLowerCase() + '_' + parts[1].toUpperCase()) : temp;
      },
      bcp47 : function (tag) {
        var temp = (tag || '').split('_').join('-');
        var parts = temp.split('-');

        switch (parts.length) {
          case 1: // language only
            parts[0] = parts[0].toLowerCase();
            break;
          case 2: // language-script or language-region
            parts[0] = parts[0].toLowerCase();
            if (parts[1].length === 4) { // parts[1] is script
              parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
            } else { // parts[1] is region
              parts[1] = parts[1].toUpperCase();
            }
            break;
          case 3: // language-script-region
            parts[0] = parts[0].toLowerCase();
            parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
            parts[2] = parts[2].toUpperCase();
            break;
          default:
            return temp;
        }

        return parts.join('-');
      },
      'iso639-1' : function (tag) {
        var temp = (tag || '').split('_').join('-');
        var parts = temp.split('-');
        return parts[0].toLowerCase();
      }
    };

  var version = '2.18.1';

  // tries to determine the browsers language
  var getFirstBrowserLanguage = function () {

    // internal purpose only
    if (angular.isFunction(pascalprechtTranslateOverrider.getLocale)) {
      return pascalprechtTranslateOverrider.getLocale();
    }

    var nav = $windowProvider.$get().navigator,
      browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
      i,
      language;

    // support for HTML 5.1 "navigator.languages"
    if (angular.isArray(nav.languages)) {
      for (i = 0; i < nav.languages.length; i++) {
        language = nav.languages[i];
        if (language && language.length) {
          return language;
        }
      }
    }

    // support for other well known properties in browsers
    for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
      language = nav[browserLanguagePropertyKeys[i]];
      if (language && language.length) {
        return language;
      }
    }

    return null;
  };
  getFirstBrowserLanguage.displayName = 'angular-translate/service: getFirstBrowserLanguage';

  // tries to determine the browsers locale
  var getLocale = function () {
    var locale = getFirstBrowserLanguage() || '';
    if (languageTagResolver[uniformLanguageTagResolver]) {
      locale = languageTagResolver[uniformLanguageTagResolver](locale);
    }
    return locale;
  };
  getLocale.displayName = 'angular-translate/service: getLocale';

  /**
   * @name indexOf
   * @private
   *
   * @description
   * indexOf polyfill. Kinda sorta.
   *
   * @param {array} array Array to search in.
   * @param {string} searchElement Element to search for.
   *
   * @returns {int} Index of search element.
   */
  var indexOf = function (array, searchElement) {
    for (var i = 0, len = array.length; i < len; i++) {
      if (array[i] === searchElement) {
        return i;
      }
    }
    return -1;
  };

  /**
   * @name trim
   * @private
   *
   * @description
   * trim polyfill
   *
   * @returns {string} The string stripped of whitespace from both ends
   */
  var trim = function () {
    return this.toString().replace(/^\s+|\s+$/g, '');
  };

  /**
   * @name lowercase
   * @private
   *
   * @description
   * Return the lowercase string only if the type is string
   *
   * @returns {string} The string all in lowercase
   */
  var lowercase = function (string) {
    return angular.isString(string) ? string.toLowerCase() : string;
  };

  var negotiateLocale = function (preferred) {
    if (!preferred) {
      return;
    }

    var avail = [],
      locale = lowercase(preferred),
      i = 0,
      n = $availableLanguageKeys.length;

    for (; i < n; i++) {
      avail.push(lowercase($availableLanguageKeys[i]));
    }

    // Check for an exact match in our list of available keys
    i = indexOf(avail, locale);
    if (i > -1) {
      return $availableLanguageKeys[i];
    }

    if ($languageKeyAliases) {
      var alias;
      for (var langKeyAlias in $languageKeyAliases) {
        if ($languageKeyAliases.hasOwnProperty(langKeyAlias)) {
          var hasWildcardKey = false;
          var hasExactKey = Object.prototype.hasOwnProperty.call($languageKeyAliases, langKeyAlias) &&
            lowercase(langKeyAlias) === lowercase(preferred);

          if (langKeyAlias.slice(-1) === '*') {
            hasWildcardKey = lowercase(langKeyAlias.slice(0, -1)) === lowercase(preferred.slice(0, langKeyAlias.length - 1));
          }
          if (hasExactKey || hasWildcardKey) {
            alias = $languageKeyAliases[langKeyAlias];
            if (indexOf(avail, lowercase(alias)) > -1) {
              return alias;
            }
          }
        }
      }
    }

    // Check for a language code without region
    var parts = preferred.split('_');

    if (parts.length > 1 && indexOf(avail, lowercase(parts[0])) > -1) {
      return parts[0];
    }

    // If everything fails, return undefined.
    return;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#translations
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Registers a new translation table for specific language key.
   *
   * To register a translation table for specific language, pass a defined language
   * key as first parameter.
   *
   * <pre>
   *  // register translation table for language: 'de_DE'
   *  $translateProvider.translations('de_DE', {
   *    'GREETING': 'Hallo Welt!'
   *  });
   *
   *  // register another one
   *  $translateProvider.translations('en_US', {
   *    'GREETING': 'Hello world!'
   *  });
   * </pre>
   *
   * When registering multiple translation tables for for the same language key,
   * the actual translation table gets extended. This allows you to define module
   * specific translation which only get added, once a specific module is loaded in
   * your app.
   *
   * Invoking this method with no arguments returns the translation table which was
   * registered with no language key. Invoking it with a language key returns the
   * related translation table.
   *
   * @param {string} langKey A language key.
   * @param {object} translationTable A plain old JavaScript object that represents a translation table.
   *
   */
  var translations = function (langKey, translationTable) {

    if (!langKey && !translationTable) {
      return $translationTable;
    }

    if (langKey && !translationTable) {
      if (angular.isString(langKey)) {
        return $translationTable[langKey];
      }
    } else {
      if (!angular.isObject($translationTable[langKey])) {
        $translationTable[langKey] = {};
      }
      angular.extend($translationTable[langKey], flatObject(translationTable));
    }
    return this;
  };

  this.translations = translations;

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#cloakClassName
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   *
   * Let's you change the class name for `translate-cloak` directive.
   * Default class name is `translate-cloak`.
   *
   * @param {string} name translate-cloak class name
   */
  this.cloakClassName = function (name) {
    if (!name) {
      return $cloakClassName;
    }
    $cloakClassName = name;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#nestedObjectDelimeter
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   *
   * Let's you change the delimiter for namespaced translations.
   * Default delimiter is `.`.
   *
   * @param {string} delimiter namespace separator
   */
  this.nestedObjectDelimeter = function (delimiter) {
    if (!delimiter) {
      return $nestedObjectDelimeter;
    }
    $nestedObjectDelimeter = delimiter;
    return this;
  };

  /**
   * @name flatObject
   * @private
   *
   * @description
   * Flats an object. This function is used to flatten given translation data with
   * namespaces, so they are later accessible via dot notation.
   */
  var flatObject = function (data, path, result, prevKey) {
    var key, keyWithPath, keyWithShortPath, val;

    if (!path) {
      path = [];
    }
    if (!result) {
      result = {};
    }
    for (key in data) {
      if (!Object.prototype.hasOwnProperty.call(data, key)) {
        continue;
      }
      val = data[key];
      if (angular.isObject(val)) {
        flatObject(val, path.concat(key), result, key);
      } else {
        keyWithPath = path.length ? ('' + path.join($nestedObjectDelimeter) + $nestedObjectDelimeter + key) : key;
        if (path.length && key === prevKey) {
          // Create shortcut path (foo.bar == foo.bar.bar)
          keyWithShortPath = '' + path.join($nestedObjectDelimeter);
          // Link it to original path
          result[keyWithShortPath] = '@:' + keyWithPath;
        }
        result[keyWithPath] = val;
      }
    }
    return result;
  };
  flatObject.displayName = 'flatObject';

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#addInterpolation
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Adds interpolation services to angular-translate, so it can manage them.
   *
   * @param {object} factory Interpolation service factory
   */
  this.addInterpolation = function (factory) {
    $interpolatorFactories.push(factory);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useMessageFormatInterpolation
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use interpolation functionality of messageformat.js.
   * This is useful when having high level pluralization and gender selection.
   */
  this.useMessageFormatInterpolation = function () {
    return this.useInterpolation('$translateMessageFormatInterpolation');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useInterpolation
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate which interpolation style to use as default, application-wide.
   * Simply pass a factory/service name. The interpolation service has to implement
   * the correct interface.
   *
   * @param {string} factory Interpolation service name.
   */
  this.useInterpolation = function (factory) {
    $interpolationFactory = factory;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useSanitizeStrategy
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Simply sets a sanitation strategy type.
   *
   * @param {string} value Strategy type.
   */
  this.useSanitizeValueStrategy = function (value) {
    $translateSanitizationProvider.useStrategy(value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#preferredLanguage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells the module which of the registered translation tables to use for translation
   * at initial startup by passing a language key. Similar to `$translateProvider#use`
   * only that it says which language to **prefer**.
   * It is recommended to call this after {@link pascalprecht.translate.$translate#fallbackLanguage fallbackLanguage()}.
   *
   * @param {string} langKey A language key.
   */
  this.preferredLanguage = function (langKey) {
    if (langKey) {
      setupPreferredLanguage(langKey);
      return this;
    }
    return $preferredLanguage;
  };
  var setupPreferredLanguage = function (langKey) {
    if (langKey) {
      $preferredLanguage = langKey;
    }
    return $preferredLanguage;
  };
  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicator
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets an indicator which is used when a translation isn't found. E.g. when
   * setting the indicator as 'X' and one tries to translate a translation id
   * called `NOT_FOUND`, this will result in `X NOT_FOUND X`.
   *
   * Internally this methods sets a left indicator and a right indicator using
   * `$translateProvider.translationNotFoundIndicatorLeft()` and
   * `$translateProvider.translationNotFoundIndicatorRight()`.
   *
   * **Note**: These methods automatically add a whitespace between the indicators
   * and the translation id.
   *
   * @param {string} indicator An indicator, could be any string.
   */
  this.translationNotFoundIndicator = function (indicator) {
    this.translationNotFoundIndicatorLeft(indicator);
    this.translationNotFoundIndicatorRight(indicator);
    return this;
  };

  /**
   * ngdoc function
   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets an indicator which is used when a translation isn't found left to the
   * translation id.
   *
   * @param {string} indicator An indicator.
   */
  this.translationNotFoundIndicatorLeft = function (indicator) {
    if (!indicator) {
      return $notFoundIndicatorLeft;
    }
    $notFoundIndicatorLeft = indicator;
    return this;
  };

  /**
   * ngdoc function
   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets an indicator which is used when a translation isn't found right to the
   * translation id.
   *
   * @param {string} indicator An indicator.
   */
  this.translationNotFoundIndicatorRight = function (indicator) {
    if (!indicator) {
      return $notFoundIndicatorRight;
    }
    $notFoundIndicatorRight = indicator;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#fallbackLanguage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells the module which of the registered translation tables to use when missing translations
   * at initial startup by passing a language key. Similar to `$translateProvider#use`
   * only that it says which language to **fallback**.
   *
   * @param {string||array} langKey A language key.
   *
   */
  this.fallbackLanguage = function (langKey) {
    fallbackStack(langKey);
    return this;
  };

  var fallbackStack = function (langKey) {
    if (langKey) {
      if (angular.isString(langKey)) {
        $fallbackWasString = true;
        $fallbackLanguage = [langKey];
      } else if (angular.isArray(langKey)) {
        $fallbackWasString = false;
        $fallbackLanguage = langKey;
      }
      if (angular.isString($preferredLanguage) && indexOf($fallbackLanguage, $preferredLanguage) < 0) {
        $fallbackLanguage.push($preferredLanguage);
      }

      return this;
    } else {
      if ($fallbackWasString) {
        return $fallbackLanguage[0];
      } else {
        return $fallbackLanguage;
      }
    }
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#use
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Set which translation table to use for translation by given language key. When
   * trying to 'use' a language which isn't provided, it'll throw an error.
   *
   * You actually don't have to use this method since `$translateProvider#preferredLanguage`
   * does the job too.
   *
   * @param {string} langKey A language key.
   */
  this.use = function (langKey) {
    if (langKey) {
      if (!$translationTable[langKey] && (!$loaderFactory)) {
        // only throw an error, when not loading translation data asynchronously
        throw new Error('$translateProvider couldn\'t find translationTable for langKey: \'' + langKey + '\'');
      }
      $uses = langKey;
      return this;
    }
    return $uses;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#resolveClientLocale
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
   *
   * @returns {string} the current client/browser language key
   */
  this.resolveClientLocale = function () {
    return getLocale();
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#storageKey
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells the module which key must represent the choosed language by a user in the storage.
   *
   * @param {string} key A key for the storage.
   */
  var storageKey = function (key) {
    if (!key) {
      if ($storagePrefix) {
        return $storagePrefix + $storageKey;
      }
      return $storageKey;
    }
    $storageKey = key;
    return this;
  };

  this.storageKey = storageKey;

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useUrlLoader
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateUrlLoader` extension service as loader.
   *
   * @param {string} url Url
   * @param {Object=} options Optional configuration object
   */
  this.useUrlLoader = function (url, options) {
    return this.useLoader('$translateUrlLoader', angular.extend({url : url}, options));
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useStaticFilesLoader
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateStaticFilesLoader` extension service as loader.
   *
   * @param {Object=} options Optional configuration object
   */
  this.useStaticFilesLoader = function (options) {
    return this.useLoader('$translateStaticFilesLoader', options);
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useLoader
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use any other service as loader.
   *
   * @param {string} loaderFactory Factory name to use
   * @param {Object=} options Optional configuration object
   */
  this.useLoader = function (loaderFactory, options) {
    $loaderFactory = loaderFactory;
    $loaderOptions = options || {};
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useLocalStorage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateLocalStorage` service as storage layer.
   *
   */
  this.useLocalStorage = function () {
    return this.useStorage('$translateLocalStorage');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useCookieStorage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateCookieStorage` service as storage layer.
   */
  this.useCookieStorage = function () {
    return this.useStorage('$translateCookieStorage');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useStorage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use custom service as storage layer.
   */
  this.useStorage = function (storageFactory) {
    $storageFactory = storageFactory;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#storagePrefix
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets prefix for storage key.
   *
   * @param {string} prefix Storage key prefix
   */
  this.storagePrefix = function (prefix) {
    if (!prefix) {
      return prefix;
    }
    $storagePrefix = prefix;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandlerLog
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use built-in log handler when trying to translate
   * a translation Id which doesn't exist.
   *
   * This is actually a shortcut method for `useMissingTranslationHandler()`.
   *
   */
  this.useMissingTranslationHandlerLog = function () {
    return this.useMissingTranslationHandler('$translateMissingTranslationHandlerLog');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandler
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Expects a factory name which later gets instantiated with `$injector`.
   * This method can be used to tell angular-translate to use a custom
   * missingTranslationHandler. Just build a factory which returns a function
   * and expects a translation id as argument.
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.useMissingTranslationHandler('customHandler');
   *  });
   *
   *  app.factory('customHandler', function (dep1, dep2) {
   *    return function (translationId) {
   *      // something with translationId and dep1 and dep2
   *    };
   *  });
   * </pre>
   *
   * @param {string} factory Factory name
   */
  this.useMissingTranslationHandler = function (factory) {
    $missingTranslationHandlerFactory = factory;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#usePostCompiling
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * If post compiling is enabled, all translated values will be processed
   * again with AngularJS' $compile.
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.usePostCompiling(true);
   *  });
   * </pre>
   *
   * @param {string} factory Factory name
   */
  this.usePostCompiling = function (value) {
    $postCompilingEnabled = !(!value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#forceAsyncReload
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * If force async reload is enabled, async loader will always be called
   * even if $translationTable already contains the language key, adding
   * possible new entries to the $translationTable.
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.forceAsyncReload(true);
   *  });
   * </pre>
   *
   * @param {boolean} value - valid values are true or false
   */
  this.forceAsyncReload = function (value) {
    $forceAsyncReloadEnabled = !(!value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#uniformLanguageTag
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate which language tag should be used as a result when determining
   * the current browser language.
   *
   * This setting must be set before invoking {@link pascalprecht.translate.$translateProvider#methods_determinePreferredLanguage determinePreferredLanguage()}.
   *
   * <pre>
   * $translateProvider
   *   .uniformLanguageTag('bcp47')
   *   .determinePreferredLanguage()
   * </pre>
   *
   * The resolver currently supports:
   * * default
   *     (traditionally: hyphens will be converted into underscores, i.e. en-US => en_US)
   *     en-US => en_US
   *     en_US => en_US
   *     en-us => en_us
   * * java
   *     like default, but the second part will be always in uppercase
   *     en-US => en_US
   *     en_US => en_US
   *     en-us => en_US
   * * BCP 47 (RFC 4646 & 4647)
   *     EN => en
   *     en-US => en-US
   *     en_US => en-US
   *     en-us => en-US
   *     sr-latn => sr-Latn
   *     sr-latn-rs => sr-Latn-RS
   *
   * See also:
   * * http://en.wikipedia.org/wiki/IETF_language_tag
   * * http://www.w3.org/International/core/langtags/
   * * http://tools.ietf.org/html/bcp47
   *
   * @param {string|object} options - options (or standard)
   * @param {string} options.standard - valid values are 'default', 'bcp47', 'java'
   */
  this.uniformLanguageTag = function (options) {

    if (!options) {
      options = {};
    } else if (angular.isString(options)) {
      options = {
        standard : options
      };
    }

    uniformLanguageTagResolver = options.standard;

    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#determinePreferredLanguage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to try to determine on its own which language key
   * to set as preferred language. When `fn` is given, angular-translate uses it
   * to determine a language key, otherwise it uses the built-in `getLocale()`
   * method.
   *
   * The `getLocale()` returns a language key in the format `[lang]_[country]` or
   * `[lang]` depending on what the browser provides.
   *
   * Use this method at your own risk, since not all browsers return a valid
   * locale (see {@link pascalprecht.translate.$translateProvider#methods_uniformLanguageTag uniformLanguageTag()}).
   *
   * @param {Function=} fn Function to determine a browser's locale
   */
  this.determinePreferredLanguage = function (fn) {

    var locale = (fn && angular.isFunction(fn)) ? fn() : getLocale();

    if (!$availableLanguageKeys.length) {
      $preferredLanguage = locale;
    } else {
      $preferredLanguage = negotiateLocale(locale) || locale;
    }

    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#registerAvailableLanguageKeys
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Registers a set of language keys the app will work with. Use this method in
   * combination with
   * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
   * When available languages keys are registered, angular-translate
   * tries to find the best fitting language key depending on the browsers locale,
   * considering your language key convention.
   *
   * @param {object} languageKeys Array of language keys the your app will use
   * @param {object=} aliases Alias map.
   */
  this.registerAvailableLanguageKeys = function (languageKeys, aliases) {
    if (languageKeys) {
      $availableLanguageKeys = languageKeys;
      if (aliases) {
        $languageKeyAliases = aliases;
      }
      return this;
    }
    return $availableLanguageKeys;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useLoaderCache
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Registers a cache for internal $http based loaders.
   * {@link pascalprecht.translate.$translationCache $translationCache}.
   * When false the cache will be disabled (default). When true or undefined
   * the cache will be a default (see $cacheFactory). When an object it will
   * be treat as a cache object itself: the usage is $http({cache: cache})
   *
   * @param {object} cache boolean, string or cache-object
   */
  this.useLoaderCache = function (cache) {
    if (cache === false) {
      // disable cache
      loaderCache = undefined;
    } else if (cache === true) {
      // enable cache using AJS defaults
      loaderCache = true;
    } else if (typeof(cache) === 'undefined') {
      // enable cache using default
      loaderCache = '$translationCache';
    } else if (cache) {
      // enable cache using given one (see $cacheFactory)
      loaderCache = cache;
    }
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#directivePriority
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets the default priority of the translate directive. The standard value is `0`.
   * Calling this function without an argument will return the current value.
   *
   * @param {number} priority for the translate-directive
   */
  this.directivePriority = function (priority) {
    if (priority === undefined) {
      // getter
      return directivePriority;
    } else {
      // setter with chaining
      directivePriority = priority;
      return this;
    }
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#statefulFilter
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Since AngularJS 1.3, filters which are not stateless (depending at the scope)
   * have to explicit define this behavior.
   * Sets whether the translate filter should be stateful or stateless. The standard value is `true`
   * meaning being stateful.
   * Calling this function without an argument will return the current value.
   *
   * @param {boolean} state - defines the state of the filter
   */
  this.statefulFilter = function (state) {
    if (state === undefined) {
      // getter
      return statefulFilter;
    } else {
      // setter with chaining
      statefulFilter = state;
      return this;
    }
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#postProcess
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * The post processor will be intercept right after the translation result. It can modify the result.
   *
   * @param {object} fn Function or service name (string) to be called after the translation value has been set / resolved. The function itself will enrich every value being processed and then continue the normal resolver process
   */
  this.postProcess = function (fn) {
    if (fn) {
      postProcessFn = fn;
    } else {
      postProcessFn = undefined;
    }
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#keepContent
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * If keepContent is set to true than translate directive will always use innerHTML
   * as a default translation
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.keepContent(true);
   *  });
   * </pre>
   *
   * @param {boolean} value - valid values are true or false
   */
  this.keepContent = function (value) {
    $keepContent = !(!value);
    return this;
  };

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translate
   * @requires $interpolate
   * @requires $log
   * @requires $rootScope
   * @requires $q
   *
   * @description
   * The `$translate` service is the actual core of angular-translate. It expects a translation id
   * and optional interpolate parameters to translate contents.
   *
   * <pre>
   *  $translate('HEADLINE_TEXT').then(function (translation) {
   *    $scope.translatedText = translation;
   *  });
   * </pre>
   *
   * @param {string|array} translationId A token which represents a translation id
   *                                     This can be optionally an array of translation ids which
   *                                     results that the function returns an object where each key
   *                                     is the translation id and the value the translation.
   * @param {object=} [interpolateParams={}] An object hash for dynamic values
   * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
   * @param {string=} [defaultTranslationText=undefined] the optional default translation text that is written as
   *                                        as default text in case it is not found in any configured language
   * @param {string=} [forceLanguage=false] A language to be used instead of the current language
   * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
   * @returns {object} promise
   */
  this.$get = ['$log', '$injector', '$rootScope', '$q', function ($log, $injector, $rootScope, $q) {

    var Storage,
      defaultInterpolator = $injector.get($interpolationFactory || '$translateDefaultInterpolation'),
      pendingLoader = false,
      interpolatorHashMap = {},
      langPromises = {},
      fallbackIndex,
      startFallbackIteration;

    var $translate = function (translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy) {
      if (!$uses && $preferredLanguage) {
        $uses = $preferredLanguage;
      }
      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;

      // Check forceLanguage is present
      if (forceLanguage) {
        loadTranslationsIfMissing(forceLanguage);
      }

      // Duck detection: If the first argument is an array, a bunch of translations was requested.
      // The result is an object.
      if (angular.isArray(translationId)) {
        // Inspired by Q.allSettled by Kris Kowal
        // https://github.com/kriskowal/q/blob/b0fa72980717dc202ffc3cbf03b936e10ebbb9d7/q.js#L1553-1563
        // This transforms all promises regardless resolved or rejected
        var translateAll = function (translationIds) {
          var results = {}; // storing the actual results
          var promises = []; // promises to wait for
          // Wraps the promise a) being always resolved and b) storing the link id->value
          var translate = function (translationId) {
            var deferred = $q.defer();
            var regardless = function (value) {
              results[translationId] = value;
              deferred.resolve([translationId, value]);
            };
            // we don't care whether the promise was resolved or rejected; just store the values
            $translate(translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy).then(regardless, regardless);
            return deferred.promise;
          };
          for (var i = 0, c = translationIds.length; i < c; i++) {
            promises.push(translate(translationIds[i]));
          }
          // wait for all (including storing to results)
          return $q.all(promises).then(function () {
            // return the results
            return results;
          });
        };
        return translateAll(translationId);
      }

      var deferred = $q.defer();

      // trim off any whitespace
      if (translationId) {
        translationId = trim.apply(translationId);
      }

      var promiseToWaitFor = (function () {
        var promise = langPromises[uses] || langPromises[$preferredLanguage];

        fallbackIndex = 0;

        if ($storageFactory && !promise) {
          // looks like there's no pending promise for $preferredLanguage or
          // $uses. Maybe there's one pending for a language that comes from
          // storage.
          var langKey = Storage.get($storageKey);
          promise = langPromises[langKey];

          if ($fallbackLanguage && $fallbackLanguage.length) {
            var index = indexOf($fallbackLanguage, langKey);
            // maybe the language from storage is also defined as fallback language
            // we increase the fallback language index to not search in that language
            // as fallback, since it's probably the first used language
            // in that case the index starts after the first element
            fallbackIndex = (index === 0) ? 1 : 0;

            // but we can make sure to ALWAYS fallback to preferred language at least
            if (indexOf($fallbackLanguage, $preferredLanguage) < 0) {
              $fallbackLanguage.push($preferredLanguage);
            }
          }
        }
        return promise;
      }());

      if (!promiseToWaitFor) {
        // no promise to wait for? okay. Then there's no loader registered
        // nor is a one pending for language that comes from storage.
        // We can just translate.
        determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
      } else {
        var promiseResolved = function () {
          // $uses may have changed while waiting
          if (!forceLanguage) {
            uses = $uses;
          }
          determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
        };
        promiseResolved.displayName = 'promiseResolved';

        promiseToWaitFor['finally'](promiseResolved)['catch'](angular.noop); // we don't care about errors here, already handled
      }
      return deferred.promise;
    };

    /**
     * @name applyNotFoundIndicators
     * @private
     *
     * @description
     * Applies not fount indicators to given translation id, if needed.
     * This function gets only executed, if a translation id doesn't exist,
     * which is why a translation id is expected as argument.
     *
     * @param {string} translationId Translation id.
     * @returns {string} Same as given translation id but applied with not found
     * indicators.
     */
    var applyNotFoundIndicators = function (translationId) {
      // applying notFoundIndicators
      if ($notFoundIndicatorLeft) {
        translationId = [$notFoundIndicatorLeft, translationId].join(' ');
      }
      if ($notFoundIndicatorRight) {
        translationId = [translationId, $notFoundIndicatorRight].join(' ');
      }
      return translationId;
    };

    /**
     * @name useLanguage
     * @private
     *
     * @description
     * Makes actual use of a language by setting a given language key as used
     * language and informs registered interpolators to also use the given
     * key as locale.
     *
     * @param {string} key Locale key.
     */
    var useLanguage = function (key) {
      $uses = key;

      // make sure to store new language key before triggering success event
      if ($storageFactory) {
        Storage.put($translate.storageKey(), $uses);
      }

      $rootScope.$emit('$translateChangeSuccess', {language : key});

      // inform default interpolator
      defaultInterpolator.setLocale($uses);

      var eachInterpolator = function (interpolator, id) {
        interpolatorHashMap[id].setLocale($uses);
      };
      eachInterpolator.displayName = 'eachInterpolatorLocaleSetter';

      // inform all others too!
      angular.forEach(interpolatorHashMap, eachInterpolator);
      $rootScope.$emit('$translateChangeEnd', {language : key});
    };

    /**
     * @name loadAsync
     * @private
     *
     * @description
     * Kicks off registered async loader using `$injector` and applies existing
     * loader options. When resolved, it updates translation tables accordingly
     * or rejects with given language key.
     *
     * @param {string} key Language key.
     * @return {Promise} A promise.
     */
    var loadAsync = function (key) {
      if (!key) {
        throw 'No language key specified for loading.';
      }

      var deferred = $q.defer();

      $rootScope.$emit('$translateLoadingStart', {language : key});
      pendingLoader = true;

      var cache = loaderCache;
      if (typeof(cache) === 'string') {
        // getting on-demand instance of loader
        cache = $injector.get(cache);
      }

      var loaderOptions = angular.extend({}, $loaderOptions, {
        key : key,
        $http : angular.extend({}, {
          cache : cache
        }, $loaderOptions.$http)
      });

      var onLoaderSuccess = function (data) {
        var translationTable = {};
        $rootScope.$emit('$translateLoadingSuccess', {language : key});

        if (angular.isArray(data)) {
          angular.forEach(data, function (table) {
            angular.extend(translationTable, flatObject(table));
          });
        } else {
          angular.extend(translationTable, flatObject(data));
        }
        pendingLoader = false;
        deferred.resolve({
          key : key,
          table : translationTable
        });
        $rootScope.$emit('$translateLoadingEnd', {language : key});
      };
      onLoaderSuccess.displayName = 'onLoaderSuccess';

      var onLoaderError = function (key) {
        $rootScope.$emit('$translateLoadingError', {language : key});
        deferred.reject(key);
        $rootScope.$emit('$translateLoadingEnd', {language : key});
      };
      onLoaderError.displayName = 'onLoaderError';

      $injector.get($loaderFactory)(loaderOptions)
        .then(onLoaderSuccess, onLoaderError);

      return deferred.promise;
    };

    if ($storageFactory) {
      Storage = $injector.get($storageFactory);

      if (!Storage.get || !Storage.put) {
        throw new Error('Couldn\'t use storage \'' + $storageFactory + '\', missing get() or put() method!');
      }
    }

    // if we have additional interpolations that were added via
    // $translateProvider.addInterpolation(), we have to map'em
    if ($interpolatorFactories.length) {
      var eachInterpolationFactory = function (interpolatorFactory) {
        var interpolator = $injector.get(interpolatorFactory);
        // setting initial locale for each interpolation service
        interpolator.setLocale($preferredLanguage || $uses);
        // make'em recognizable through id
        interpolatorHashMap[interpolator.getInterpolationIdentifier()] = interpolator;
      };
      eachInterpolationFactory.displayName = 'interpolationFactoryAdder';

      angular.forEach($interpolatorFactories, eachInterpolationFactory);
    }

    /**
     * @name getTranslationTable
     * @private
     *
     * @description
     * Returns a promise that resolves to the translation table
     * or is rejected if an error occurred.
     *
     * @param langKey
     * @returns {Q.promise}
     */
    var getTranslationTable = function (langKey) {
      var deferred = $q.defer();
      if (Object.prototype.hasOwnProperty.call($translationTable, langKey)) {
        deferred.resolve($translationTable[langKey]);
      } else if (langPromises[langKey]) {
        var onResolve = function (data) {
          translations(data.key, data.table);
          deferred.resolve(data.table);
        };
        onResolve.displayName = 'translationTableResolver';
        langPromises[langKey].then(onResolve, deferred.reject);
      } else {
        deferred.reject();
      }
      return deferred.promise;
    };

    /**
     * @name getFallbackTranslation
     * @private
     *
     * @description
     * Returns a promise that will resolve to the translation
     * or be rejected if no translation was found for the language.
     * This function is currently only used for fallback language translation.
     *
     * @param langKey The language to translate to.
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy
     * @returns {Q.promise}
     */
    var getFallbackTranslation = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      var deferred = $q.defer();

      var onResolve = function (translationTable) {
        if (Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
          Interpolator.setLocale(langKey);
          var translation = translationTable[translationId];
          if (translation.substr(0, 2) === '@:') {
            getFallbackTranslation(langKey, translation.substr(2), interpolateParams, Interpolator, sanitizeStrategy)
              .then(deferred.resolve, deferred.reject);
          } else {
            var interpolatedValue = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'service', sanitizeStrategy, translationId);
            interpolatedValue = applyPostProcessing(translationId, translationTable[translationId], interpolatedValue, interpolateParams, langKey);

            deferred.resolve(interpolatedValue);

          }
          Interpolator.setLocale($uses);
        } else {
          deferred.reject();
        }
      };
      onResolve.displayName = 'fallbackTranslationResolver';

      getTranslationTable(langKey).then(onResolve, deferred.reject);

      return deferred.promise;
    };

    /**
     * @name getFallbackTranslationInstant
     * @private
     *
     * @description
     * Returns a translation
     * This function is currently only used for fallback language translation.
     *
     * @param langKey The language to translate to.
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy sanitize strategy override
     *
     * @returns {string} translation
     */
    var getFallbackTranslationInstant = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      var result, translationTable = $translationTable[langKey];

      if (translationTable && Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
        Interpolator.setLocale(langKey);
        result = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'filter', sanitizeStrategy, translationId);
        result = applyPostProcessing(translationId, translationTable[translationId], result, interpolateParams, langKey, sanitizeStrategy);
        // workaround for TrustedValueHolderType
        if (!angular.isString(result) && angular.isFunction(result.$$unwrapTrustedValue)) {
          var result2 = result.$$unwrapTrustedValue();
          if (result2.substr(0, 2) === '@:') {
            return getFallbackTranslationInstant(langKey, result2.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
          }
        } else if (result.substr(0, 2) === '@:') {
          return getFallbackTranslationInstant(langKey, result.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
        }
        Interpolator.setLocale($uses);
      }

      return result;
    };


    /**
     * @name translateByHandler
     * @private
     *
     * Translate by missing translation handler.
     *
     * @param translationId
     * @param interpolateParams
     * @param defaultTranslationText
     * @param sanitizeStrategy sanitize strategy override
     *
     * @returns translation created by $missingTranslationHandler or translationId is $missingTranslationHandler is
     * absent
     */
    var translateByHandler = function (translationId, interpolateParams, defaultTranslationText, sanitizeStrategy) {
      // If we have a handler factory - we might also call it here to determine if it provides
      // a default text for a translationid that can't be found anywhere in our tables
      if ($missingTranslationHandlerFactory) {
        return $injector.get($missingTranslationHandlerFactory)(translationId, $uses, interpolateParams, defaultTranslationText, sanitizeStrategy);
      } else {
        return translationId;
      }
    };

    /**
     * @name resolveForFallbackLanguage
     * @private
     *
     * Recursive helper function for fallbackTranslation that will sequentially look
     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
     *
     * @param fallbackLanguageIndex
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param defaultTranslationText
     * @param sanitizeStrategy
     * @returns {Q.promise} Promise that will resolve to the translation.
     */
    var resolveForFallbackLanguage = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
      var deferred = $q.defer();

      if (fallbackLanguageIndex < $fallbackLanguage.length) {
        var langKey = $fallbackLanguage[fallbackLanguageIndex];
        getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy).then(
          function (data) {
            deferred.resolve(data);
          },
          function () {
            // Look in the next fallback language for a translation.
            // It delays the resolving by passing another promise to resolve.
            return resolveForFallbackLanguage(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy).then(deferred.resolve, deferred.reject);
          }
        );
      } else {
        // No translation found in any fallback language
        // if a default translation text is set in the directive, then return this as a result
        if (defaultTranslationText) {
          deferred.resolve(defaultTranslationText);
        } else {
          var missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);

          // if no default translation is set and an error handler is defined, send it to the handler
          // and then return the result if it isn't undefined
          if ($missingTranslationHandlerFactory && missingTranslationHandlerTranslation) {
            deferred.resolve(missingTranslationHandlerTranslation);
          } else {
            deferred.reject(applyNotFoundIndicators(translationId));
          }
        }
      }
      return deferred.promise;
    };

    /**
     * @name resolveForFallbackLanguageInstant
     * @private
     *
     * Recursive helper function for fallbackTranslation that will sequentially look
     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
     *
     * @param fallbackLanguageIndex
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy
     * @returns {string} translation
     */
    var resolveForFallbackLanguageInstant = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      var result;

      if (fallbackLanguageIndex < $fallbackLanguage.length) {
        var langKey = $fallbackLanguage[fallbackLanguageIndex];
        result = getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy);
        if (!result && result !== '') {
          result = resolveForFallbackLanguageInstant(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator);
        }
      }
      return result;
    };

    /**
     * Translates with the usage of the fallback languages.
     *
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param defaultTranslationText
     * @param sanitizeStrategy
     * @returns {Q.promise} Promise, that resolves to the translation.
     */
    var fallbackTranslation = function (translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
      // Start with the fallbackLanguage with index 0
      return resolveForFallbackLanguage((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy);
    };

    /**
     * Translates with the usage of the fallback languages.
     *
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy
     * @returns {String} translation
     */
    var fallbackTranslationInstant = function (translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      // Start with the fallbackLanguage with index 0
      return resolveForFallbackLanguageInstant((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, sanitizeStrategy);
    };

    var determineTranslation = function (translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy) {

      var deferred = $q.defer();

      var table = uses ? $translationTable[uses] : $translationTable,
        Interpolator = (interpolationId) ? interpolatorHashMap[interpolationId] : defaultInterpolator;

      // if the translation id exists, we can just interpolate it
      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
        var translation = table[translationId];

        // If using link, rerun $translate with linked translationId and return it
        if (translation.substr(0, 2) === '@:') {

          $translate(translation.substr(2), interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy)
            .then(deferred.resolve, deferred.reject);
        } else {
          //
          var resolvedTranslation = Interpolator.interpolate(translation, interpolateParams, 'service', sanitizeStrategy, translationId);
          resolvedTranslation = applyPostProcessing(translationId, translation, resolvedTranslation, interpolateParams, uses);
          deferred.resolve(resolvedTranslation);
        }
      } else {
        var missingTranslationHandlerTranslation;
        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
        if ($missingTranslationHandlerFactory && !pendingLoader) {
          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
        }

        // since we couldn't translate the inital requested translation id,
        // we try it now with one or more fallback languages, if fallback language(s) is
        // configured.
        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
          fallbackTranslation(translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy)
            .then(function (translation) {
              deferred.resolve(translation);
            }, function (_translationId) {
              deferred.reject(applyNotFoundIndicators(_translationId));
            });
        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
          // looks like the requested translation id doesn't exists.
          // Now, if there is a registered handler for missing translations and no
          // asyncLoader is pending, we execute the handler
          if (defaultTranslationText) {
            deferred.resolve(defaultTranslationText);
          } else {
            deferred.resolve(missingTranslationHandlerTranslation);
          }
        } else {
          if (defaultTranslationText) {
            deferred.resolve(defaultTranslationText);
          } else {
            deferred.reject(applyNotFoundIndicators(translationId));
          }
        }
      }
      return deferred.promise;
    };

    var determineTranslationInstant = function (translationId, interpolateParams, interpolationId, uses, sanitizeStrategy) {

      var result, table = uses ? $translationTable[uses] : $translationTable,
        Interpolator = defaultInterpolator;

      // if the interpolation id exists use custom interpolator
      if (interpolatorHashMap && Object.prototype.hasOwnProperty.call(interpolatorHashMap, interpolationId)) {
        Interpolator = interpolatorHashMap[interpolationId];
      }

      // if the translation id exists, we can just interpolate it
      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
        var translation = table[translationId];

        // If using link, rerun $translate with linked translationId and return it
        if (translation.substr(0, 2) === '@:') {
          result = determineTranslationInstant(translation.substr(2), interpolateParams, interpolationId, uses, sanitizeStrategy);
        } else {
          result = Interpolator.interpolate(translation, interpolateParams, 'filter', sanitizeStrategy, translationId);
          result = applyPostProcessing(translationId, translation, result, interpolateParams, uses, sanitizeStrategy);
        }
      } else {
        var missingTranslationHandlerTranslation;
        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
        if ($missingTranslationHandlerFactory && !pendingLoader) {
          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
        }

        // since we couldn't translate the inital requested translation id,
        // we try it now with one or more fallback languages, if fallback language(s) is
        // configured.
        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
          fallbackIndex = 0;
          result = fallbackTranslationInstant(translationId, interpolateParams, Interpolator, sanitizeStrategy);
        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
          // looks like the requested translation id doesn't exists.
          // Now, if there is a registered handler for missing translations and no
          // asyncLoader is pending, we execute the handler
          result = missingTranslationHandlerTranslation;
        } else {
          result = applyNotFoundIndicators(translationId);
        }
      }

      return result;
    };

    var clearNextLangAndPromise = function (key) {
      if ($nextLang === key) {
        $nextLang = undefined;
      }
      langPromises[key] = undefined;
    };

    var applyPostProcessing = function (translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy) {
      var fn = postProcessFn;

      if (fn) {

        if (typeof(fn) === 'string') {
          // getting on-demand instance
          fn = $injector.get(fn);
        }
        if (fn) {
          return fn(translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy);
        }
      }

      return resolvedTranslation;
    };

    var loadTranslationsIfMissing = function (key) {
      if (!$translationTable[key] && $loaderFactory && !langPromises[key]) {
        langPromises[key] = loadAsync(key).then(function (translation) {
          translations(translation.key, translation.table);
          return translation;
        });
      }
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#preferredLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the language key for the preferred language.
     *
     * @param {string} langKey language String or Array to be used as preferredLanguage (changing at runtime)
     *
     * @return {string} preferred language key
     */
    $translate.preferredLanguage = function (langKey) {
      if (langKey) {
        setupPreferredLanguage(langKey);
      }
      return $preferredLanguage;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#cloakClassName
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the configured class name for `translate-cloak` directive.
     *
     * @return {string} cloakClassName
     */
    $translate.cloakClassName = function () {
      return $cloakClassName;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#nestedObjectDelimeter
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the configured delimiter for nested namespaces.
     *
     * @return {string} nestedObjectDelimeter
     */
    $translate.nestedObjectDelimeter = function () {
      return $nestedObjectDelimeter;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#fallbackLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the language key for the fallback languages or sets a new fallback stack.
     * It is recommended to call this before {@link pascalprecht.translate.$translateProvider#preferredLanguage preferredLanguage()}.
     *
     * @param {string=} langKey language String or Array of fallback languages to be used (to change stack at runtime)
     *
     * @return {string||array} fallback language key
     */
    $translate.fallbackLanguage = function (langKey) {
      if (langKey !== undefined && langKey !== null) {
        fallbackStack(langKey);

        // as we might have an async loader initiated and a new translation language might have been defined
        // we need to add the promise to the stack also. So - iterate.
        if ($loaderFactory) {
          if ($fallbackLanguage && $fallbackLanguage.length) {
            for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
              if (!langPromises[$fallbackLanguage[i]]) {
                langPromises[$fallbackLanguage[i]] = loadAsync($fallbackLanguage[i]);
              }
            }
          }
        }
        $translate.use($translate.use());
      }
      if ($fallbackWasString) {
        return $fallbackLanguage[0];
      } else {
        return $fallbackLanguage;
      }

    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#useFallbackLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Sets the first key of the fallback language stack to be used for translation.
     * Therefore all languages in the fallback array BEFORE this key will be skipped!
     *
     * @param {string=} langKey Contains the langKey the iteration shall start with. Set to false if you want to
     * get back to the whole stack
     */
    $translate.useFallbackLanguage = function (langKey) {
      if (langKey !== undefined && langKey !== null) {
        if (!langKey) {
          startFallbackIteration = 0;
        } else {
          var langKeyPosition = indexOf($fallbackLanguage, langKey);
          if (langKeyPosition > -1) {
            startFallbackIteration = langKeyPosition;
          }
        }

      }

    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#proposedLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the language key of language that is currently loaded asynchronously.
     *
     * @return {string} language key
     */
    $translate.proposedLanguage = function () {
      return $nextLang;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#storage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns registered storage.
     *
     * @return {object} Storage
     */
    $translate.storage = function () {
      return Storage;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#negotiateLocale
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns a language key based on available languages and language aliases. If a
     * language key cannot be resolved, returns undefined.
     *
     * If no or a falsy key is given, returns undefined.
     *
     * @param {string} [key] Language key
     * @return {string|undefined} Language key or undefined if no language key is found.
     */
    $translate.negotiateLocale = negotiateLocale;

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#use
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Tells angular-translate which language to use by given language key. This method is
     * used to change language at runtime. It also takes care of storing the language
     * key in a configured store to let your app remember the choosed language.
     *
     * When trying to 'use' a language which isn't available it tries to load it
     * asynchronously with registered loaders.
     *
     * Returns promise object with loaded language file data or string of the currently used language.
     *
     * If no or a falsy key is given it returns the currently used language key.
     * The returned string will be ```undefined``` if setting up $translate hasn't finished.
     * @example
     * $translate.use("en_US").then(function(data){
       *   $scope.text = $translate("HELLO");
       * });
     *
     * @param {string=} key Language key
     * @return {object|string} Promise with loaded language data or the language key if a falsy param was given.
     */
    $translate.use = function (key) {
      if (!key) {
        return $uses;
      }

      var deferred = $q.defer();
      deferred.promise.then(null, angular.noop); // AJS "Possibly unhandled rejection"

      $rootScope.$emit('$translateChangeStart', {language : key});

      // Try to get the aliased language key
      var aliasedKey = negotiateLocale(key);
      // Ensure only registered language keys will be loaded
      if ($availableLanguageKeys.length > 0 && !aliasedKey) {
        return $q.reject(key);
      }

      if (aliasedKey) {
        key = aliasedKey;
      }

      // if there isn't a translation table for the language we've requested,
      // we load it asynchronously
      $nextLang = key;
      if (($forceAsyncReloadEnabled || !$translationTable[key]) && $loaderFactory && !langPromises[key]) {
        langPromises[key] = loadAsync(key).then(function (translation) {
          translations(translation.key, translation.table);
          deferred.resolve(translation.key);
          if ($nextLang === key) {
            useLanguage(translation.key);
          }
          return translation;
        }, function (key) {
          $rootScope.$emit('$translateChangeError', {language : key});
          deferred.reject(key);
          $rootScope.$emit('$translateChangeEnd', {language : key});
          return $q.reject(key);
        });
        langPromises[key]['finally'](function () {
          clearNextLangAndPromise(key);
        })['catch'](angular.noop); // we don't care about errors (clearing)
      } else if (langPromises[key]) {
        // we are already loading this asynchronously
        // resolve our new deferred when the old langPromise is resolved
        langPromises[key].then(function (translation) {
          if ($nextLang === translation.key) {
            useLanguage(translation.key);
          }
          deferred.resolve(translation.key);
          return translation;
        }, function (key) {
          // find first available fallback language if that request has failed
          if (!$uses && $fallbackLanguage && $fallbackLanguage.length > 0 && $fallbackLanguage[0] !== key) {
            return $translate.use($fallbackLanguage[0]).then(deferred.resolve, deferred.reject);
          } else {
            return deferred.reject(key);
          }
        });
      } else {
        deferred.resolve(key);
        useLanguage(key);
      }

      return deferred.promise;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#resolveClientLocale
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
     *
     * @returns {string} the current client/browser language key
     */
    $translate.resolveClientLocale = function () {
      return getLocale();
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#storageKey
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the key for the storage.
     *
     * @return {string} storage key
     */
    $translate.storageKey = function () {
      return storageKey();
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isPostCompilingEnabled
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether post compiling is enabled or not
     *
     * @return {bool} storage key
     */
    $translate.isPostCompilingEnabled = function () {
      return $postCompilingEnabled;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isForceAsyncReloadEnabled
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether force async reload is enabled or not
     *
     * @return {boolean} forceAsyncReload value
     */
    $translate.isForceAsyncReloadEnabled = function () {
      return $forceAsyncReloadEnabled;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isKeepContent
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether keepContent or not
     *
     * @return {boolean} keepContent value
     */
    $translate.isKeepContent = function () {
      return $keepContent;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#refresh
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Refreshes a translation table pointed by the given langKey. If langKey is not specified,
     * the module will drop all existent translation tables and load new version of those which
     * are currently in use.
     *
     * Refresh means that the module will drop target translation table and try to load it again.
     *
     * In case there are no loaders registered the refresh() method will throw an Error.
     *
     * If the module is able to refresh translation tables refresh() method will broadcast
     * $translateRefreshStart and $translateRefreshEnd events.
     *
     * @example
     * // this will drop all currently existent translation tables and reload those which are
     * // currently in use
     * $translate.refresh();
     * // this will refresh a translation table for the en_US language
     * $translate.refresh('en_US');
     *
     * @param {string} langKey A language key of the table, which has to be refreshed
     *
     * @return {promise} Promise, which will be resolved in case a translation tables refreshing
     * process is finished successfully, and reject if not.
     */
    $translate.refresh = function (langKey) {
      if (!$loaderFactory) {
        throw new Error('Couldn\'t refresh translation table, no loader registered!');
      }

      $rootScope.$emit('$translateRefreshStart', {language : langKey});

      var deferred = $q.defer(), updatedLanguages = {};

      //private helper
      function loadNewData(languageKey) {
        var promise = loadAsync(languageKey);
        //update the load promise cache for this language
        langPromises[languageKey] = promise;
        //register a data handler for the promise
        promise.then(function (data) {
            //clear the cache for this language
            $translationTable[languageKey] = {};
            //add the new data for this language
            translations(languageKey, data.table);
            //track that we updated this language
            updatedLanguages[languageKey] = true;
          },
          //handle rejection to appease the $q validation
          angular.noop);
        return promise;
      }

      //set up post-processing
      deferred.promise.then(
        function () {
          for (var key in $translationTable) {
            if ($translationTable.hasOwnProperty(key)) {
              //delete cache entries that were not updated
              if (!(key in updatedLanguages)) {
                delete $translationTable[key];
              }
            }
          }
          if ($uses) {
            useLanguage($uses);
          }
        },
        //handle rejection to appease the $q validation
        angular.noop
      )['finally'](
        function () {
          $rootScope.$emit('$translateRefreshEnd', {language : langKey});
        }
      );

      if (!langKey) {
        // if there's no language key specified we refresh ALL THE THINGS!
        var languagesToReload = $fallbackLanguage && $fallbackLanguage.slice() || [];
        if ($uses && languagesToReload.indexOf($uses) === -1) {
          languagesToReload.push($uses);
        }
        $q.all(languagesToReload.map(loadNewData)).then(deferred.resolve, deferred.reject);

      } else if ($translationTable[langKey]) {
        //just refresh the specified language cache
        loadNewData(langKey).then(deferred.resolve, deferred.reject);

      } else {
        deferred.reject();
      }

      return deferred.promise;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#instant
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns a translation instantly from the internal state of loaded translation. All rules
     * regarding the current language, the preferred language of even fallback languages will be
     * used except any promise handling. If a language was not found, an asynchronous loading
     * will be invoked in the background.
     *
     * @param {string|array} translationId A token which represents a translation id
     *                                     This can be optionally an array of translation ids which
     *                                     results that the function's promise returns an object where
     *                                     each key is the translation id and the value the translation.
     * @param {object=} [interpolateParams={}] Params
     * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
     * @param {string=} [forceLanguage=false] A language to be used instead of the current language
     * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
     *
     * @return {string|object} translation
     */
    $translate.instant = function (translationId, interpolateParams, interpolationId, forceLanguage, sanitizeStrategy) {

      // we don't want to re-negotiate $uses
      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;

      // Detect undefined and null values to shorten the execution and prevent exceptions
      if (translationId === null || angular.isUndefined(translationId)) {
        return translationId;
      }

      // Check forceLanguage is present
      if (forceLanguage) {
        loadTranslationsIfMissing(forceLanguage);
      }

      // Duck detection: If the first argument is an array, a bunch of translations was requested.
      // The result is an object.
      if (angular.isArray(translationId)) {
        var results = {};
        for (var i = 0, c = translationId.length; i < c; i++) {
          results[translationId[i]] = $translate.instant(translationId[i], interpolateParams, interpolationId, forceLanguage, sanitizeStrategy);
        }
        return results;
      }

      // We discarded unacceptable values. So we just need to verify if translationId is empty String
      if (angular.isString(translationId) && translationId.length < 1) {
        return translationId;
      }

      // trim off any whitespace
      if (translationId) {
        translationId = trim.apply(translationId);
      }

      var result, possibleLangKeys = [];
      if ($preferredLanguage) {
        possibleLangKeys.push($preferredLanguage);
      }
      if (uses) {
        possibleLangKeys.push(uses);
      }
      if ($fallbackLanguage && $fallbackLanguage.length) {
        possibleLangKeys = possibleLangKeys.concat($fallbackLanguage);
      }
      for (var j = 0, d = possibleLangKeys.length; j < d; j++) {
        var possibleLangKey = possibleLangKeys[j];
        if ($translationTable[possibleLangKey]) {
          if (typeof $translationTable[possibleLangKey][translationId] !== 'undefined') {
            result = determineTranslationInstant(translationId, interpolateParams, interpolationId, uses, sanitizeStrategy);
          }
        }
        if (typeof result !== 'undefined') {
          break;
        }
      }

      if (!result && result !== '') {
        if ($notFoundIndicatorLeft || $notFoundIndicatorRight) {
          result = applyNotFoundIndicators(translationId);
        } else {
          // Return translation of default interpolator if not found anything.
          result = defaultInterpolator.interpolate(translationId, interpolateParams, 'filter', sanitizeStrategy);

          // looks like the requested translation id doesn't exists.
          // Now, if there is a registered handler for missing translations and no
          // asyncLoader is pending, we execute the handler
          var missingTranslationHandlerTranslation;
          if ($missingTranslationHandlerFactory && !pendingLoader) {
            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
          }

          if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
            result = missingTranslationHandlerTranslation;
          }
        }
      }

      return result;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#versionInfo
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the current version information for the angular-translate library
     *
     * @return {string} angular-translate version
     */
    $translate.versionInfo = function () {
      return version;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#loaderCache
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the defined loaderCache.
     *
     * @return {boolean|string|object} current value of loaderCache
     */
    $translate.loaderCache = function () {
      return loaderCache;
    };

    // internal purpose only
    $translate.directivePriority = function () {
      return directivePriority;
    };

    // internal purpose only
    $translate.statefulFilter = function () {
      return statefulFilter;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isReady
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether the service is "ready" to translate (i.e. loading 1st language).
     *
     * See also {@link pascalprecht.translate.$translate#methods_onReady onReady()}.
     *
     * @return {boolean} current value of ready
     */
    $translate.isReady = function () {
      return $isReady;
    };

    var $onReadyDeferred = $q.defer();
    $onReadyDeferred.promise.then(function () {
      $isReady = true;
    });

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#onReady
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Calls the function provided or resolved the returned promise after the service is "ready" to translate (i.e. loading 1st language).
     *
     * See also {@link pascalprecht.translate.$translate#methods_isReady isReady()}.
     *
     * @param {Function=} fn Function to invoke when service is ready
     * @return {object} Promise resolved when service is ready
     */
    $translate.onReady = function (fn) {
      var deferred = $q.defer();
      if (angular.isFunction(fn)) {
        deferred.promise.then(fn);
      }
      if ($isReady) {
        deferred.resolve();
      } else {
        $onReadyDeferred.promise.then(deferred.resolve);
      }
      return deferred.promise;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#getAvailableLanguageKeys
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * This function simply returns the registered language keys being defined before in the config phase
     * With this, an application can use the array to provide a language selection dropdown or similar
     * without any additional effort
     *
     * @returns {object} returns the list of possibly registered language keys and mapping or null if not defined
     */
    $translate.getAvailableLanguageKeys = function () {
      if ($availableLanguageKeys.length > 0) {
        return $availableLanguageKeys;
      }
      return null;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#getTranslationTable
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns translation table by the given language key.
     *
     * Unless a language is provided it returns a translation table of the current one.
     * Note: If translation dictionary is currently downloading or in progress
     * it will return null.
     *
     * @param {string} langKey A token which represents a translation id
     *
     * @return {object} a copy of angular-translate $translationTable
     */
    $translate.getTranslationTable = function (langKey) {
      langKey = langKey || $translate.use();
      if (langKey && $translationTable[langKey]) {
        return angular.copy($translationTable[langKey]);
      }
      return null;
    };

    // Whenever $translateReady is being fired, this will ensure the state of $isReady
    var globalOnReadyListener = $rootScope.$on('$translateReady', function () {
      $onReadyDeferred.resolve();
      globalOnReadyListener(); // one time only
      globalOnReadyListener = null;
    });
    var globalOnChangeListener = $rootScope.$on('$translateChangeEnd', function () {
      $onReadyDeferred.resolve();
      globalOnChangeListener(); // one time only
      globalOnChangeListener = null;
    });

    if ($loaderFactory) {

      // If at least one async loader is defined and there are no
      // (default) translations available we should try to load them.
      if (angular.equals($translationTable, {})) {
        if ($translate.use()) {
          $translate.use($translate.use());
        }
      }

      // Also, if there are any fallback language registered, we start
      // loading them asynchronously as soon as we can.
      if ($fallbackLanguage && $fallbackLanguage.length) {
        var processAsyncResult = function (translation) {
          translations(translation.key, translation.table);
          $rootScope.$emit('$translateChangeEnd', {language : translation.key});
          return translation;
        };
        for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
          var fallbackLanguageId = $fallbackLanguage[i];
          if ($forceAsyncReloadEnabled || !$translationTable[fallbackLanguageId]) {
            langPromises[fallbackLanguageId] = loadAsync(fallbackLanguageId).then(processAsyncResult);
          }
        }
      }
    } else {
      $rootScope.$emit('$translateReady', {language : $translate.use()});
    }

    return $translate;
  }];
}

$translate.displayName = 'displayName';

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateDefaultInterpolation
 * @requires $interpolate
 *
 * @description
 * Uses angular's `$interpolate` services to interpolate strings against some values.
 *
 * Be aware to configure a proper sanitization strategy.
 *
 * See also:
 * * {@link pascalprecht.translate.$translateSanitization}
 *
 * @return {object} $translateDefaultInterpolation Interpolator service
 */
angular.module('pascalprecht.translate').factory('$translateDefaultInterpolation', $translateDefaultInterpolation);

function $translateDefaultInterpolation ($interpolate, $translateSanitization) {

  'use strict';

  var $translateInterpolator = {},
      $locale,
      $identifier = 'default';

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateDefaultInterpolation#setLocale
   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
   *
   * @description
   * Sets current locale (this is currently not use in this interpolation).
   *
   * @param {string} locale Language key or locale.
   */
  $translateInterpolator.setLocale = function (locale) {
    $locale = locale;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateDefaultInterpolation#getInterpolationIdentifier
   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
   *
   * @description
   * Returns an identifier for this interpolation service.
   *
   * @returns {string} $identifier
   */
  $translateInterpolator.getInterpolationIdentifier = function () {
    return $identifier;
  };

  /**
   * @deprecated will be removed in 3.0
   * @see {@link pascalprecht.translate.$translateSanitization}
   */
  $translateInterpolator.useSanitizeValueStrategy = function (value) {
    $translateSanitization.useStrategy(value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateDefaultInterpolation#interpolate
   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
   *
   * @description
   * Interpolates given value agains given interpolate params using angulars
   * `$interpolate` service.
   *
   * Since AngularJS 1.5, `value` must not be a string but can be anything input.
   *
   * @param {string} value translation
   * @param {object} [interpolationParams={}] interpolation params
   * @param {string} [context=undefined] current context (filter, directive, service)
   * @param {string} [sanitizeStrategy=undefined] sanitize strategy (use default unless set)
   * @param {string} translationId current translationId
   *
   * @returns {string} interpolated string
   */
  $translateInterpolator.interpolate = function (value, interpolationParams, context, sanitizeStrategy, translationId) { // jshint ignore:line
    interpolationParams = interpolationParams || {};
    interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params', sanitizeStrategy, context);

    var interpolatedText;
    if (angular.isNumber(value)) {
      // numbers are safe
      interpolatedText = '' + value;
    } else if (angular.isString(value)) {
      // strings must be interpolated (that's the job here)
      interpolatedText = $interpolate(value)(interpolationParams);
      interpolatedText = $translateSanitization.sanitize(interpolatedText, 'text', sanitizeStrategy, context);
    } else {
      // neither a number or a string, cant interpolate => empty string
      interpolatedText = '';
    }

    return interpolatedText;
  };

  return $translateInterpolator;
}

$translateDefaultInterpolation.displayName = '$translateDefaultInterpolation';

angular.module('pascalprecht.translate').constant('$STORAGE_KEY', 'NG_TRANSLATE_LANG_KEY');

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translate
 * @requires $interpolate,
 * @requires $compile,
 * @requires $parse,
 * @requires $rootScope
 * @restrict AE
 *
 * @description
 * Translates given translation id either through attribute or DOM content.
 * Internally it uses $translate service to translate the translation id. It possible to
 * pass an optional `translate-values` object literal as string into translation id.
 *
 * @param {string=} translate Translation id which could be either string or interpolated string.
 * @param {string=} translate-values Values to pass into translation id. Can be passed as object literal string or interpolated object.
 * @param {string=} translate-attr-ATTR translate Translation id and put it into ATTR attribute.
 * @param {string=} translate-default will be used unless translation was successful
 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
 * @param {boolean=} translate-compile (default true if present) defines locally activation of {@link pascalprecht.translate.$translateProvider#methods_usePostCompiling}
 * @param {boolean=} translate-keep-content (default true if present) defines that in case a KEY could not be translated, that the existing content is left in the innerHTML}
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div ng-controller="TranslateCtrl">

        <pre translate="TRANSLATION_ID"></pre>
        <pre translate>TRANSLATION_ID</pre>
        <pre translate translate-attr-title="TRANSLATION_ID"></pre>
        <pre translate="{{translationId}}"></pre>
        <pre translate>{{translationId}}</pre>
        <pre translate="WITH_VALUES" translate-values="{value: 5}"></pre>
        <pre translate translate-values="{value: 5}">WITH_VALUES</pre>
        <pre translate="WITH_VALUES" translate-values="{{values}}"></pre>
        <pre translate translate-values="{{values}}">WITH_VALUES</pre>
        <pre translate translate-attr-title="WITH_VALUES" translate-values="{{values}}"></pre>
        <pre translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hi"></pre>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}',
          'WITH_CAMEL_CASE_KEY': 'The interpolation key is camel cased: {{camelCaseKey}}'
        }).preferredLanguage('en');

      });

      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
    </file>
    <file name="scenario.js">
      it('should translate', function () {
        inject(function ($rootScope, $compile) {
          $rootScope.translationId = 'TRANSLATION_ID';

          element = $compile('<p translate="TRANSLATION_ID"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate="{{translationId}}"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate>TRANSLATION_ID</p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate>{{translationId}}</p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate translate-attr-title="TRANSLATION_ID"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.attr('title')).toBe('Hello there!');

          element = $compile('<p translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hello"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('The interpolation key is camel cased: Hello');
        });
      });
    </file>
   </example>
 */
.directive('translate', translateDirective);
function translateDirective($translate, $interpolate, $compile, $parse, $rootScope) {

  'use strict';

  /**
   * @name trim
   * @private
   *
   * @description
   * trim polyfill
   *
   * @returns {string} The string stripped of whitespace from both ends
   */
  var trim = function() {
    return this.toString().replace(/^\s+|\s+$/g, '');
  };

  /**
   * @name lowercase
   * @private
   *
   * @description
   * Return the lowercase string only if the type is string
   *
   * @returns {string} The string all in lowercase
   */
  var lowercase = function (string) {
    return angular.isString(string) ? string.toLowerCase() : string;
  };

  return {
    restrict: 'AE',
    scope: true,
    priority: $translate.directivePriority(),
    compile: function (tElement, tAttr) {

      var translateValuesExist = (tAttr.translateValues) ?
        tAttr.translateValues : undefined;

      var translateInterpolation = (tAttr.translateInterpolation) ?
        tAttr.translateInterpolation : undefined;

      var translateSanitizeStrategyExist = (tAttr.translateSanitizeStrategy) ?
        tAttr.translateSanitizeStrategy : undefined;

      var translateValueExist = tElement[0].outerHTML.match(/translate-value-+/i);

      var interpolateRegExp = '^(.*)(' + $interpolate.startSymbol() + '.*' + $interpolate.endSymbol() + ')(.*)',
          watcherRegExp = '^(.*)' + $interpolate.startSymbol() + '(.*)' + $interpolate.endSymbol() + '(.*)';

      return function linkFn(scope, iElement, iAttr) {

        scope.interpolateParams = {};
        scope.preText = '';
        scope.postText = '';
        scope.translateNamespace = getTranslateNamespace(scope);
        var translationIds = {};

        var initInterpolationParams = function (interpolateParams, iAttr, tAttr) {
          // initial setup
          if (iAttr.translateValues) {
            angular.extend(interpolateParams, $parse(iAttr.translateValues)(scope.$parent));
          }
          // initially fetch all attributes if existing and fill the params
          if (translateValueExist) {
            for (var attr in tAttr) {
              if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
                var attributeName = lowercase(attr.substr(14, 1)) + attr.substr(15);
                interpolateParams[attributeName] = tAttr[attr];
              }
            }
          }
        };

        // Ensures any change of the attribute "translate" containing the id will
        // be re-stored to the scope's "translationId".
        // If the attribute has no content, the element's text value (white spaces trimmed off) will be used.
        var observeElementTranslation = function (translationId) {

          // Remove any old watcher
          if (angular.isFunction(observeElementTranslation._unwatchOld)) {
            observeElementTranslation._unwatchOld();
            observeElementTranslation._unwatchOld = undefined;
          }

          if (angular.equals(translationId , '') || !angular.isDefined(translationId)) {
            var iElementText = trim.apply(iElement.text());

            // Resolve translation id by inner html if required
            var interpolateMatches = iElementText.match(interpolateRegExp);
            // Interpolate translation id if required
            if (angular.isArray(interpolateMatches)) {
              scope.preText = interpolateMatches[1];
              scope.postText = interpolateMatches[3];
              translationIds.translate = $interpolate(interpolateMatches[2])(scope.$parent);
              var watcherMatches = iElementText.match(watcherRegExp);
              if (angular.isArray(watcherMatches) && watcherMatches[2] && watcherMatches[2].length) {
                observeElementTranslation._unwatchOld = scope.$watch(watcherMatches[2], function (newValue) {
                  translationIds.translate = newValue;
                  updateTranslations();
                });
              }
            } else {
              // do not assigne the translation id if it is empty.
              translationIds.translate = !iElementText ? undefined : iElementText;
            }
          } else {
            translationIds.translate = translationId;
          }
          updateTranslations();
        };

        var observeAttributeTranslation = function (translateAttr) {
          iAttr.$observe(translateAttr, function (translationId) {
            translationIds[translateAttr] = translationId;
            updateTranslations();
          });
        };

        // initial setup with values
        initInterpolationParams(scope.interpolateParams, iAttr, tAttr);

        var firstAttributeChangedEvent = true;
        iAttr.$observe('translate', function (translationId) {
          if (typeof translationId === 'undefined') {
            // case of element "<translate>xyz</translate>"
            observeElementTranslation('');
          } else {
            // case of regular attribute
            if (translationId !== '' || !firstAttributeChangedEvent) {
              translationIds.translate = translationId;
              updateTranslations();
            }
          }
          firstAttributeChangedEvent = false;
        });

        for (var translateAttr in iAttr) {
          if (iAttr.hasOwnProperty(translateAttr) && translateAttr.substr(0, 13) === 'translateAttr' && translateAttr.length > 13) {
            observeAttributeTranslation(translateAttr);
          }
        }

        iAttr.$observe('translateDefault', function (value) {
          scope.defaultText = value;
          updateTranslations();
        });

        if (translateSanitizeStrategyExist) {
          iAttr.$observe('translateSanitizeStrategy', function (value) {
            scope.sanitizeStrategy = $parse(value)(scope.$parent);
            updateTranslations();
          });
        }

        if (translateValuesExist) {
          iAttr.$observe('translateValues', function (interpolateParams) {
            if (interpolateParams) {
              scope.$parent.$watch(function () {
                angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
              });
            }
          });
        }

        if (translateValueExist) {
          var observeValueAttribute = function (attrName) {
            iAttr.$observe(attrName, function (value) {
              var attributeName = lowercase(attrName.substr(14, 1)) + attrName.substr(15);
              scope.interpolateParams[attributeName] = value;
            });
          };
          for (var attr in iAttr) {
            if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
              observeValueAttribute(attr);
            }
          }
        }

        // Master update function
        var updateTranslations = function () {
          for (var key in translationIds) {
            if (translationIds.hasOwnProperty(key) && translationIds[key] !== undefined) {
              updateTranslation(key, translationIds[key], scope, scope.interpolateParams, scope.defaultText, scope.translateNamespace);
            }
          }
        };

        // Put translation processing function outside loop
        var updateTranslation = function(translateAttr, translationId, scope, interpolateParams, defaultTranslationText, translateNamespace) {
          if (translationId) {
            // if translation id starts with '.' and translateNamespace given, prepend namespace
            if (translateNamespace && translationId.charAt(0) === '.') {
              translationId = translateNamespace + translationId;
            }

            $translate(translationId, interpolateParams, translateInterpolation, defaultTranslationText, scope.translateLanguage, scope.sanitizeStrategy)
              .then(function (translation) {
                applyTranslation(translation, scope, true, translateAttr);
              }, function (translationId) {
                applyTranslation(translationId, scope, false, translateAttr);
              });
          } else {
            // as an empty string cannot be translated, we can solve this using successful=false
            applyTranslation(translationId, scope, false, translateAttr);
          }
        };

        var applyTranslation = function (value, scope, successful, translateAttr) {
          if (!successful) {
            if (typeof scope.defaultText !== 'undefined') {
              value = scope.defaultText;
            }
          }
          if (translateAttr === 'translate') {
            // default translate into innerHTML
            if (successful || (!successful && !$translate.isKeepContent() && typeof iAttr.translateKeepContent === 'undefined')) {
              iElement.empty().append(scope.preText + value + scope.postText);
            }
            var globallyEnabled = $translate.isPostCompilingEnabled();
            var locallyDefined = typeof tAttr.translateCompile !== 'undefined';
            var locallyEnabled = locallyDefined && tAttr.translateCompile !== 'false';
            if ((globallyEnabled && !locallyDefined) || locallyEnabled) {
              $compile(iElement.contents())(scope);
            }
          } else {
            // translate attribute
            var attributeName = iAttr.$attr[translateAttr];
            if (attributeName.substr(0, 5) === 'data-') {
              // ensure html5 data prefix is stripped
              attributeName = attributeName.substr(5);
            }
            attributeName = attributeName.substr(15);
            iElement.attr(attributeName, value);
          }
        };

        if (translateValuesExist || translateValueExist || iAttr.translateDefault) {
          scope.$watch('interpolateParams', updateTranslations, true);
        }

        // Replaced watcher on translateLanguage with event listener
        scope.$on('translateLanguageChanged', updateTranslations);

        // Ensures the text will be refreshed after the current language was changed
        // w/ $translate.use(...)
        var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);

        // ensure translation will be looked up at least one
        if (iElement.text().length) {
          if (iAttr.translate) {
            observeElementTranslation(iAttr.translate);
          } else {
            observeElementTranslation('');
          }
        } else if (iAttr.translate) {
          // ensure attribute will be not skipped
          observeElementTranslation(iAttr.translate);
        }
        updateTranslations();
        scope.$on('$destroy', unbind);
      };
    }
  };
}

/**
 * Returns the scope's namespace.
 * @private
 * @param scope
 * @returns {string}
 */
function getTranslateNamespace(scope) {
  'use strict';
  if (scope.translateNamespace) {
    return scope.translateNamespace;
  }
  if (scope.$parent) {
    return getTranslateNamespace(scope.$parent);
  }
}

translateDirective.displayName = 'translateDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translate-attr
 * @restrict A
 *
 * @description
 * Translates attributes like translate-attr-ATTR, but with an object like ng-class.
 * Internally it uses `translate` service to translate translation id. It possible to
 * pass an optional `translate-values` object literal as string into translation id.
 *
 * @param {string=} translate-attr Object literal mapping attributes to translation ids.
 * @param {string=} translate-values Values to pass into the translation ids. Can be passed as object literal string.
 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div ng-controller="TranslateCtrl">

        <input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{value: 5}" />

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}',
        }).preferredLanguage('en');

      });

      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
    </file>
    <file name="scenario.js">
      it('should translate', function () {
        inject(function ($rootScope, $compile) {
          $rootScope.translationId = 'TRANSLATION_ID';

          element = $compile('<input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{ value: 5 }" />')($rootScope);
          $rootScope.$digest();
          expect(element.attr('placeholder)).toBe('Hello there!');
          expect(element.attr('title)).toBe('The following value is dynamic: 5');
        });
      });
    </file>
   </example>
 */
.directive('translateAttr', translateAttrDirective);
function translateAttrDirective($translate, $rootScope) {

  'use strict';

  return {
    restrict: 'A',
    priority: $translate.directivePriority(),
    link: function linkFn(scope, element, attr) {

      var translateAttr,
          translateValues,
          translateSanitizeStrategy,
          previousAttributes = {};

      // Main update translations function
      var updateTranslations = function () {
        angular.forEach(translateAttr, function (translationId, attributeName) {
          if (!translationId) {
            return;
          }
          previousAttributes[attributeName] = true;

          // if translation id starts with '.' and translateNamespace given, prepend namespace
          if (scope.translateNamespace && translationId.charAt(0) === '.') {
            translationId = scope.translateNamespace + translationId;
          }
          $translate(translationId, translateValues, attr.translateInterpolation, undefined, scope.translateLanguage, translateSanitizeStrategy)
            .then(function (translation) {
              element.attr(attributeName, translation);
            }, function (translationId) {
              element.attr(attributeName, translationId);
            });
        });

        // Removing unused attributes that were previously used
        angular.forEach(previousAttributes, function (flag, attributeName) {
          if (!translateAttr[attributeName]) {
            element.removeAttr(attributeName);
            delete previousAttributes[attributeName];
          }
        });
      };

      // Watch for attribute changes
      watchAttribute(
        scope,
        attr.translateAttr,
        function (newValue) { translateAttr = newValue; },
        updateTranslations
      );
      // Watch for value changes
      watchAttribute(
        scope,
        attr.translateValues,
        function (newValue) { translateValues = newValue; },
        updateTranslations
      );
      // Watch for sanitize strategy changes
      watchAttribute(
        scope,
        attr.translateSanitizeStrategy,
        function (newValue) { translateSanitizeStrategy = newValue; },
        updateTranslations
      );

      if (attr.translateValues) {
        scope.$watch(attr.translateValues, updateTranslations, true);
      }

      // Replaced watcher on translateLanguage with event listener
      scope.$on('translateLanguageChanged', updateTranslations);

      // Ensures the text will be refreshed after the current language was changed
      // w/ $translate.use(...)
      var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);

      updateTranslations();
      scope.$on('$destroy', unbind);
    }
  };
}

function watchAttribute(scope, attribute, valueCallback, changeCallback) {
  'use strict';
  if (!attribute) {
    return;
  }
  if (attribute.substr(0, 2) === '::') {
    attribute = attribute.substr(2);
  } else {
    scope.$watch(attribute, function(newValue) {
      valueCallback(newValue);
      changeCallback();
    }, true);
  }
  valueCallback(scope.$eval(attribute));
}

translateAttrDirective.displayName = 'translateAttrDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translateCloak
 * @requires $translate
 * @restrict A
 *
 * $description
 * Adds a `translate-cloak` class name to the given element where this directive
 * is applied initially and removes it, once a loader has finished loading.
 *
 * This directive can be used to prevent initial flickering when loading translation
 * data asynchronously.
 *
 * The class name is defined in
 * {@link pascalprecht.translate.$translateProvider#cloakClassName $translate.cloakClassName()}.
 *
 * @param {string=} translate-cloak If a translationId is provided, it will be used for showing
 *                                  or hiding the cloak. Basically it relies on the translation
 *                                  resolve.
 */
.directive('translateCloak', translateCloakDirective);

function translateCloakDirective($translate, $rootScope) {

  'use strict';

  return {
    compile : function (tElement) {
      var applyCloak = function (element) {
          element.addClass($translate.cloakClassName());
        },
        removeCloak = function (element) {
          element.removeClass($translate.cloakClassName());
        };
      applyCloak(tElement);

      return function linkFn(scope, iElement, iAttr) {
        //Create bound functions that incorporate the active DOM element.
        var iRemoveCloak = removeCloak.bind(this, iElement), iApplyCloak = applyCloak.bind(this, iElement);
        if (iAttr.translateCloak && iAttr.translateCloak.length) {
          // Register a watcher for the defined translation allowing a fine tuned cloak
          iAttr.$observe('translateCloak', function (translationId) {
            $translate(translationId).then(iRemoveCloak, iApplyCloak);
          });
          $rootScope.$on('$translateChangeSuccess', function () {
            $translate(iAttr.translateCloak).then(iRemoveCloak, iApplyCloak);
          });
        } else {
          $translate.onReady(iRemoveCloak);
        }
      };
    }
  };
}

translateCloakDirective.displayName = 'translateCloakDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translateNamespace
 * @restrict A
 *
 * @description
 * Translates given translation id either through attribute or DOM content.
 * Internally it uses `translate` filter to translate translation id. It is possible to
 * pass an optional `translate-values` object literal as string into translation id.
 *
 * @param {string=} translate namespace name which could be either string or interpolated string.
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div translate-namespace="CONTENT">

        <div>
            <h1 translate>.HEADERS.TITLE</h1>
            <h1 translate>.HEADERS.WELCOME</h1>
        </div>

        <div translate-namespace=".HEADERS">
            <h1 translate>.TITLE</h1>
            <h1 translate>.WELCOME</h1>
        </div>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'CONTENT': {
            'HEADERS': {
                TITLE: 'Title'
            }
          },
          'CONTENT.HEADERS.WELCOME': 'Welcome'
        }).preferredLanguage('en');

      });

    </file>
   </example>
 */
.directive('translateNamespace', translateNamespaceDirective);

function translateNamespaceDirective() {

  'use strict';

  return {
    restrict: 'A',
    scope: true,
    compile: function () {
      return {
        pre: function (scope, iElement, iAttrs) {
          scope.translateNamespace = _getTranslateNamespace(scope);

          if (scope.translateNamespace && iAttrs.translateNamespace.charAt(0) === '.') {
            scope.translateNamespace += iAttrs.translateNamespace;
          } else {
            scope.translateNamespace = iAttrs.translateNamespace;
          }
        }
      };
    }
  };
}

/**
 * Returns the scope's namespace.
 * @private
 * @param scope
 * @returns {string}
 */
function _getTranslateNamespace(scope) {
  'use strict';
  if (scope.translateNamespace) {
    return scope.translateNamespace;
  }
  if (scope.$parent) {
    return _getTranslateNamespace(scope.$parent);
  }
}

translateNamespaceDirective.displayName = 'translateNamespaceDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translateLanguage
 * @restrict A
 *
 * @description
 * Forces the language to the directives in the underlying scope.
 *
 * @param {string=} translate language that will be negotiated.
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div>

        <div>
            <h1 translate>HELLO</h1>
        </div>

        <div translate-language="de">
            <h1 translate>HELLO</h1>
        </div>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider
          .translations('en',{
            'HELLO': 'Hello world!'
          })
          .translations('de',{
            'HELLO': 'Hallo Welt!'
          })
          .preferredLanguage('en');

      });

    </file>
   </example>
 */
.directive('translateLanguage', translateLanguageDirective);

function translateLanguageDirective() {

  'use strict';

  return {
    restrict: 'A',
    scope: true,
    compile: function () {
      return function linkFn(scope, iElement, iAttrs) {

        iAttrs.$observe('translateLanguage', function (newTranslateLanguage) {
          scope.translateLanguage = newTranslateLanguage;
        });

        scope.$watch('translateLanguage', function(){
          scope.$broadcast('translateLanguageChanged');
        });
      };
    }
  };
}

translateLanguageDirective.displayName = 'translateLanguageDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc filter
 * @name pascalprecht.translate.filter:translate
 * @requires $parse
 * @requires pascalprecht.translate.$translate
 * @function
 *
 * @description
 * Uses `$translate` service to translate contents. Accepts interpolate parameters
 * to pass dynamized values though translation.
 *
 * @param {string} translationId A translation id to be translated.
 * @param {*=} interpolateParams Optional object literal (as hash or string) to pass values into translation.
 *
 * @returns {string} Translated text.
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div ng-controller="TranslateCtrl">

        <pre>{{ 'TRANSLATION_ID' | translate }}</pre>
        <pre>{{ translationId | translate }}</pre>
        <pre>{{ 'WITH_VALUES' | translate:'{value: 5}' }}</pre>
        <pre>{{ 'WITH_VALUES' | translate:values }}</pre>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en', {
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}'
        });
        $translateProvider.preferredLanguage('en');

      });

      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
    </file>
   </example>
 */
.filter('translate', translateFilterFactory);

function translateFilterFactory($parse, $translate) {

  'use strict';

  var translateFilter = function (translationId, interpolateParams, interpolation, forceLanguage) {
    if (!angular.isObject(interpolateParams)) {
      var ctx = this || {
        '__SCOPE_IS_NOT_AVAILABLE': 'More info at https://github.com/angular/angular.js/commit/8863b9d04c722b278fa93c5d66ad1e578ad6eb1f'
        };
      interpolateParams = $parse(interpolateParams)(ctx);
    }

    return $translate.instant(translationId, interpolateParams, interpolation, forceLanguage);
  };

  if ($translate.statefulFilter()) {
    translateFilter.$stateful = true;
  }

  return translateFilter;
}

translateFilterFactory.displayName = 'translateFilterFactory';

angular.module('pascalprecht.translate')

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translationCache
 * @requires $cacheFactory
 *
 * @description
 * The first time a translation table is used, it is loaded in the translation cache for quick retrieval. You
 * can load translation tables directly into the cache by consuming the
 * `$translationCache` service directly.
 *
 * @return {object} $cacheFactory object.
 */
  .factory('$translationCache', $translationCache);

function $translationCache($cacheFactory) {

  'use strict';

  return $cacheFactory('translations');
}

$translationCache.displayName = '$translationCache';
return 'pascalprecht.translate';

}));

},{}],8:[function(require,module,exports){
'use strict'

exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}

},{}],9:[function(require,module,exports){
(function (Buffer){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */

'use strict'

var base64 = require('base64-js')
var ieee754 = require('ieee754')

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function () { return 42 } }
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  buf.__proto__ = Buffer.prototype
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

// Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
if (typeof Symbol !== 'undefined' && Symbol.species != null &&
    Buffer[Symbol.species] === Buffer) {
  Object.defineProperty(Buffer, Symbol.species, {
    value: null,
    configurable: true,
    enumerable: false,
    writable: false
  })
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayLike(value)
  }

  if (value == null) {
    throw TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Buffer.prototype.__proto__ = Uint8Array.prototype
Buffer.__proto__ = Uint8Array

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  buf.__proto__ = Buffer.prototype
  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      buf = Buffer.from(buf)
    }
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
        : (firstByte > 0xBF) ? 2
          : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  newBuf.__proto__ = Buffer.prototype
  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (var i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

}).call(this,require("buffer").Buffer)
},{"base64-js":8,"buffer":9,"ieee754":11}],10:[function(require,module,exports){
(function (Buffer){
var clone = (function() {
'use strict';

function _instanceof(obj, type) {
  return type != null && obj instanceof type;
}

var nativeMap;
try {
  nativeMap = Map;
} catch(_) {
  // maybe a reference error because no `Map`. Give it a dummy value that no
  // value will ever be an instanceof.
  nativeMap = function() {};
}

var nativeSet;
try {
  nativeSet = Set;
} catch(_) {
  nativeSet = function() {};
}

var nativePromise;
try {
  nativePromise = Promise;
} catch(_) {
  nativePromise = function() {};
}

/**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/
function clone(parent, circular, depth, prototype, includeNonEnumerable) {
  if (typeof circular === 'object') {
    depth = circular.depth;
    prototype = circular.prototype;
    includeNonEnumerable = circular.includeNonEnumerable;
    circular = circular.circular;
  }
  // maintain two arrays for circular references, where corresponding parents
  // and children have the same index
  var allParents = [];
  var allChildren = [];

  var useBuffer = typeof Buffer != 'undefined';

  if (typeof circular == 'undefined')
    circular = true;

  if (typeof depth == 'undefined')
    depth = Infinity;

  // recurse this function so we don't reset allParents and allChildren
  function _clone(parent, depth) {
    // cloning null always returns null
    if (parent === null)
      return null;

    if (depth === 0)
      return parent;

    var child;
    var proto;
    if (typeof parent != 'object') {
      return parent;
    }

    if (_instanceof(parent, nativeMap)) {
      child = new nativeMap();
    } else if (_instanceof(parent, nativeSet)) {
      child = new nativeSet();
    } else if (_instanceof(parent, nativePromise)) {
      child = new nativePromise(function (resolve, reject) {
        parent.then(function(value) {
          resolve(_clone(value, depth - 1));
        }, function(err) {
          reject(_clone(err, depth - 1));
        });
      });
    } else if (clone.__isArray(parent)) {
      child = [];
    } else if (clone.__isRegExp(parent)) {
      child = new RegExp(parent.source, __getRegExpFlags(parent));
      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
    } else if (clone.__isDate(parent)) {
      child = new Date(parent.getTime());
    } else if (useBuffer && Buffer.isBuffer(parent)) {
      if (Buffer.allocUnsafe) {
        // Node.js >= 4.5.0
        child = Buffer.allocUnsafe(parent.length);
      } else {
        // Older Node.js versions
        child = new Buffer(parent.length);
      }
      parent.copy(child);
      return child;
    } else if (_instanceof(parent, Error)) {
      child = Object.create(parent);
    } else {
      if (typeof prototype == 'undefined') {
        proto = Object.getPrototypeOf(parent);
        child = Object.create(proto);
      }
      else {
        child = Object.create(prototype);
        proto = prototype;
      }
    }

    if (circular) {
      var index = allParents.indexOf(parent);

      if (index != -1) {
        return allChildren[index];
      }
      allParents.push(parent);
      allChildren.push(child);
    }

    if (_instanceof(parent, nativeMap)) {
      parent.forEach(function(value, key) {
        var keyChild = _clone(key, depth - 1);
        var valueChild = _clone(value, depth - 1);
        child.set(keyChild, valueChild);
      });
    }
    if (_instanceof(parent, nativeSet)) {
      parent.forEach(function(value) {
        var entryChild = _clone(value, depth - 1);
        child.add(entryChild);
      });
    }

    for (var i in parent) {
      var attrs;
      if (proto) {
        attrs = Object.getOwnPropertyDescriptor(proto, i);
      }

      if (attrs && attrs.set == null) {
        continue;
      }
      child[i] = _clone(parent[i], depth - 1);
    }

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(parent);
      for (var i = 0; i < symbols.length; i++) {
        // Don't need to worry about cloning a symbol because it is a primitive,
        // like a number or string.
        var symbol = symbols[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
        if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
          continue;
        }
        child[symbol] = _clone(parent[symbol], depth - 1);
        if (!descriptor.enumerable) {
          Object.defineProperty(child, symbol, {
            enumerable: false
          });
        }
      }
    }

    if (includeNonEnumerable) {
      var allPropertyNames = Object.getOwnPropertyNames(parent);
      for (var i = 0; i < allPropertyNames.length; i++) {
        var propertyName = allPropertyNames[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
        if (descriptor && descriptor.enumerable) {
          continue;
        }
        child[propertyName] = _clone(parent[propertyName], depth - 1);
        Object.defineProperty(child, propertyName, {
          enumerable: false
        });
      }
    }

    return child;
  }

  return _clone(parent, depth);
}

/**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */
clone.clonePrototype = function clonePrototype(parent) {
  if (parent === null)
    return null;

  var c = function () {};
  c.prototype = parent;
  return new c();
};

// private utility functions

function __objToStr(o) {
  return Object.prototype.toString.call(o);
}
clone.__objToStr = __objToStr;

function __isDate(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Date]';
}
clone.__isDate = __isDate;

function __isArray(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Array]';
}
clone.__isArray = __isArray;

function __isRegExp(o) {
  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
}
clone.__isRegExp = __isRegExp;

function __getRegExpFlags(re) {
  var flags = '';
  if (re.global) flags += 'g';
  if (re.ignoreCase) flags += 'i';
  if (re.multiline) flags += 'm';
  return flags;
}
clone.__getRegExpFlags = __getRegExpFlags;

return clone;
})();

if (typeof module === 'object' && module.exports) {
  module.exports = clone;
}

}).call(this,require("buffer").Buffer)
},{"buffer":9}],11:[function(require,module,exports){
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

},{}],12:[function(require,module,exports){
/** (CURRENT) DEPARTMENT SERVICE
 *
 *    The current department that the session is
 *     linked to / acting on.
 *
 *    Listens for changes in the AuthService,
 *     then plucks out the data that relates to the
 *     current department.
 *
 *    GOTCHAS / COMPLICATIONS
 *
 *    BE has coupled a `Branding` object with the
 *     Department object on a 1-to-1 basis. When
 *     saving the Department we also need to make
 *     a parallel request to save the Branding,
 *     which (extra confusingly) is actually
 *     bundled into the original Department object
 *     that BE returned to us in the first place.
 *
 *    Life is hard, but then you die. So it's got
 *     that going for it.
 */
DepartmentService.$inject = ['api', 'AuthService'];
function DepartmentService(api, AuthService) {
  var service = this;

  service.getDepartment = getDepartment;
  service.updateDepartment = updateDepartment;
  service.switchDepartment = switchDepartment;
  service.deleteDepartment = deleteDepartment;

  var department = {}; // The active / selected department

  function getDepartment(){
    return AuthService
      .getAuth()
      .then(function(auth){
        cherrypickAuthProperties(auth);
        return department;
      });
  }

  function updateDepartment(updatedDepartmentObject) {
    return api
      .request('/department/update', { issuer: updatedDepartmentObject })
      .then(function(response) {
        cherrypickAuthProperties(response.issuer); // The response is in the "auth" style, use the cherrypicker
        return department;
      });
  }

  function switchDepartment(department_id){
    return api
      .request('/issuer_login/select_department', {
        department_id: department_id,
      }).then(function(response) {
        localStorage.setItem('department', response.issuer.department.id);
        return response;
      });
  }

  function deleteDepartment(department_id){
    return api
      .request('/departments/delete', {
        id: department_id,
      });
  }

  AuthService.on('change', function(auth){
    cherrypickAuthProperties(auth);
  });

  function cherrypickAuthProperties(auth){
    angular.copy(auth.department || {}, department);
  }

}

angular
  .module('app')
  .service('DepartmentService', DepartmentService);

},{}],13:[function(require,module,exports){
/** DEPARTMENTS SERVICE
 *
 *    For accessing the departments that the user
 *     has access to.
 *
 *    Why do we force a refresh of the auth object?
 *     because the creation of departments MAY
 *     affect our Auth state - notably permissions.
 */
DepartmentsService.$inject = ['$rootScope', '$q', 'api', 'AuthService'];
function DepartmentsService($rootScope, $q, api, AuthService) {
  var service = this;

  service.getDepartments = getDepartments;
  service.getDepartment = getDepartment;
  service.upsertDepartment = upsertDepartment;

  function getDepartments(){
    return api
      .request('/departments/all')
      .then(function(response){
        $rootScope.$broadcast('hotjarAndPosthogDepartments', response.departments);
        return response.departments;
      });
  }

  function getDepartment(id){
    if (id === 'new') {
      return $q.resolve({ name: null, url: null, logo: null });
    }
    return api
      .request('/departments/read', { id: id })
      .then(function(response){
        return response.department;
      });
  }

  function upsertDepartment(department) {
    var method = department.id ? '/departments/update' : '/departments/create';
    return api
      .request(method, { department: department })
      .then(function(response) {
        AuthService.refresh(); // See block comment
        return response.department;
      });
  }

}

angular
  .module('app')
  .service('DepartmentsService', DepartmentsService);

},{}],14:[function(require,module,exports){
CertificateMakerController.$inject = ['$q', '$window', '$timeout', '$filter', 'api', 'swalService', 'CertificateService'];
function CertificateMakerController($q, $window, $timeout, $filter, api, swalService, CertificateService) {
  var ctrl = this;

  var urlParams = new URLSearchParams(window.location.search);
  var authorization = urlParams.get('authorization') ? decodeURIComponent(urlParams.get('authorization')) : null;
  var departmentId = urlParams.get('department_id');
  var designId = urlParams.get('design_id');

  localStorage.setItem('department', departmentId);

  localStorage.setItem('authorization', authorization);

  ctrl.data = {
    saving: false,
    design: { // Empty design
      kind: 'certificate',
      id: null,
      attribute_keys: null,
      rasterized_content_url: null,
      encoded_content: null,
      blocks:[],
      background: null,
      orientation: 'landscape',
      size: 'us-letter'
    }
  };

  ctrl.close = close;

  // Initialisation
  if (authorization && designId) {
    ctrl.loading = true;
    CertificateService
      .get(designId)
      .then(function(design){
        ctrl.data.design = angular.copy(design);
        ctrl.loading = false;
      })
      .catch(function(err) {
        doCloseEditor(err.status);
      });
  } else {
    ctrl.loading = false;
  }

  function close(newDesign){
    if (!ctrl.data.saving) {
      if (newDesign) {
        ctrl.data.design = newDesign;
      }
      doCloseEditor(200);
      return true;
    } else {
      return false;
    }
  }

  function doCloseEditor(status) {
    // This relies on the parent destroying the iFrame
    parent.postMessage({ completed: status === 200, status: status, design: ctrl.data.design }, '*');
  }
}

angular
  .module('app')
  .controller('CertificateMakerController', CertificateMakerController);

},{}],15:[function(require,module,exports){
/** FRAMEWORK - APP
 *
 *    The app bundle contains our application logic.
 *    The libraries bundle contains 3rd party scripts and libraries.
 */

require('./app.module.js');
require('../env/ENV.js');

// Shared
require('../shared/_services/api.service.js');
require('../shared/_services/emitter.service.js');
require('../shared/i18n/language.config.js');
require('../shared/i18n/language.service.js');
require('../shared/vendor.factories.js');
require('../shared/tooltip/tooltip.directive.js');
require('../shared/alert/legacySwalService.js');
require('../shared/input-color/input-color.component.js');
require('../shared/animations/animations.js');
require('../shared/fullscreen/fullscreen.component.js');
require('../shared/loading-bar/loading-bar.js');
require('../shared/hotkeys/hotkeys.directive.js');
require('../shared/upload-file/upload-file.directive.js');
require('../shared/fullscreen-upload/fullscreen-upload.directive.js');
require('../shared/attributeFilters.js');
require('../shared/_services/fileSize.service.js');
require('../shared/_services/img.service.js');
require('../shared/_services/analytics.service.js');
require('../shared/_services/attribute.service.js');
require('../shared/no-mobile/no-mobile.component.js');
require('../shared/_services/url.service.js');
require('../shared/validate-email/validate-email.directive.js');
require('../shared/validation/validation.component.js');
require('../shared/alert/alert.service.js');
require('../shared/submit-validate/submit-validate.directive.js');
require('../shared/dropdown/dropdown.component.js');
require('../shared/external-links/external-links.directive.js');
require('../shared/basicFilters.js');
require('../shared/certificate-editor/certificate-editor.directive.js');
require('../shared/_services/certificate.service.js');
require('../shared/fonts/font.service.js');
require('../shared/history/history.factory.js');
require('../shared/certificate/certificate.component.js');
require('../shared/hotkeys/hotkeys.directive.js');
require('../shared/tooltip/tooltip.directive.js');
require('../shared/input-radios/input-radios.component.js');
require('../shared/button-color/button-color.directive.js');
require('../shared/font-menu/font-menu.component.js');
require('../shared/validate-px/validate-px.directive.js');
require('../shared/unsaved-changes/unsaved-changes.directive.js');
require('../shared/_services/flipperFeatures.service.js');
require('../../dashboard.accredible.com/app/_js/department.service.js');
require('../../dashboard.accredible.com/app/_js/departments.service.js');
require('../shared/_services/auth.service.js');

// App
require('./CertificateMaker.controller.js');

/*
  I can update the shared scripts to manage their own dependencies like so:
    require('angular-sanitize');
    angular.module("app").requires.push('ngSanitize');
*/

},{"../../dashboard.accredible.com/app/_js/department.service.js":12,"../../dashboard.accredible.com/app/_js/departments.service.js":13,"../env/ENV.js":17,"../shared/_services/analytics.service.js":18,"../shared/_services/api.service.js":19,"../shared/_services/attribute.service.js":20,"../shared/_services/auth.service.js":21,"../shared/_services/certificate.service.js":22,"../shared/_services/emitter.service.js":24,"../shared/_services/fileSize.service.js":26,"../shared/_services/flipperFeatures.service.js":27,"../shared/_services/img.service.js":28,"../shared/_services/url.service.js":29,"../shared/alert/alert.service.js":31,"../shared/alert/legacySwalService.js":32,"../shared/animations/animations.js":33,"../shared/attributeFilters.js":34,"../shared/basicFilters.js":35,"../shared/button-color/button-color.directive.js":36,"../shared/certificate-editor/certificate-editor.directive.js":37,"../shared/certificate/certificate.component.js":42,"../shared/dropdown/dropdown.component.js":43,"../shared/external-links/external-links.directive.js":44,"../shared/font-menu/font-menu.component.js":45,"../shared/fonts/font.service.js":46,"../shared/fullscreen-upload/fullscreen-upload.directive.js":47,"../shared/fullscreen/fullscreen.component.js":48,"../shared/history/history.factory.js":49,"../shared/hotkeys/hotkeys.directive.js":50,"../shared/i18n/language.config.js":52,"../shared/i18n/language.service.js":54,"../shared/input-color/input-color.component.js":55,"../shared/input-radios/input-radios.component.js":56,"../shared/loading-bar/loading-bar.js":57,"../shared/no-mobile/no-mobile.component.js":59,"../shared/submit-validate/submit-validate.directive.js":60,"../shared/tooltip/tooltip.directive.js":61,"../shared/unsaved-changes/unsaved-changes.directive.js":62,"../shared/upload-file/upload-file.directive.js":63,"../shared/validate-email/validate-email.directive.js":65,"../shared/validate-px/validate-px.directive.js":66,"../shared/validation/validation.component.js":67,"../shared/vendor.factories.js":68,"./CertificateMaker.controller.js":14,"./app.module.js":16}],16:[function(require,module,exports){
angular
  .module('app', [
    'ngSanitize',
    'ngAnimate',
    'ngFileUpload',
    'ui.bootstrap',
  ]);

},{}],17:[function(require,module,exports){
angular
  .module('app')
  .constant('ENV', {
    name:         'qa',
    prefix:       'qa.',
    type:         'development',
    apiEndpoint:  'https://qa.api.accredible.com/',
    apiVersion:   'v1',
    stripeKey:    'pk_test_cAeVkx5DhTMwelsEudggtgxC',
    getSocialId:  'b9584c5e',
    version:      '26.4.0',
    cachebust:    '26.4.0-1793815582994',
    property:     'embed.certificates.design',
    gainsightTagKey: 'AP-EGY1FB9PXTHZ-2-3',

    v2Domains:      {
      dashboard: 'https://qa.v2.dashboard.accredible.com',
      salesCalculator: 'https://qa.calculator.accredible.com',
    }
  });

},{}],18:[function(require,module,exports){
/** ANALYTICS - SERVICE
 *
 *  Track issuer actions:
 *
 *      AnalyticsService.trackEvent('Event -  Description'); // Track a specific event / click on pages
 *
 *  Automatically track page views
 *
 *      If your property is using ui-router then we track additional data about the router state, including errors
 *      If not, then we just track basic information
 *
 *  Angulartics
 *
 *      At the moment, we have disabled angulartics google page tracking (see dashboard.module.js) and are
 *      manually sending google (ga) tracking messages (see trackPage and trackEvent below)
 *
 *  Todo
 *
 *      Figure out how to identify and track other user types (recipient, a.n.other)
 *
 *      Consider simplifying the functionality of angulartics, replacing this:
 *          <a href="" ng-click="addToLinkedin()" analytics-on analytics-event="click" analytics-category="share-button" analytics-label="add-to-linkedin">add to linkedin</a>
 *      ...with:
 *          <a href="" ng-click="addToLinkedin()" analytics>add to linkedin</a>
 */
var clone = require('clone');
AnalyticsService.$inject = ['$rootScope', '$window', '$injector', '$location', 'ENV', 'api'];
function AnalyticsService($rootScope, $window, $injector, $location, ENV, api){
  var service = this;
  service.trackEvent = trackEvent;
  service.trackPage = trackPage;
  service.trackPurchase = trackPurchase;
  service.trackSignup = trackSignup;

  // If we are using ui-router, automatically track page changes
  if($injector.has('$transitions')){
    var $transitions = $injector.get('$transitions');
    $transitions.onSuccess({}, trackRouterSuccess);
    $transitions.onError({}, trackRouterError);
  } else {
    $rootScope.$on('$locationChangeSuccess', trackLocationChange);
  }

  // Track an event
  function trackEvent(description){
    // Track to 3rd party services in production only
    if(ENV.type === 'production'){
      if($window.ga){
        var data = {
          'event': 'custom_' + description,
        };
        $window.dataLayer.push(data);
      }
    }
  }

  // Track a page view
  function trackPage(data){
    // Track page-views to our API in any environment
    api.request('/frontend/log_frontend_analytics', {
      domain: $location.host(),
      env: ENV.name,
      property: ENV.property,
      path: $location.path(),
      data: data,
    });
    // Track to 3rd party services in production only
    if(ENV.type === 'production'){
      if($window.ga){
        $window.ga('send', 'pageview', $location.path());
      }
    }
  }

  // Track a purchase
  function trackPurchase(id, total){
    var data = {
      'transactionId': id,
      'transactionAffiliation': 'ACMS',
      'transactionTotal': total,
      'event': 'successful_purchase',
    };
    if(ENV.type === 'production' && $window.dataLayer){
      $window.dataLayer.push(data);
    } else {
      console.log('Analytics :: Not tracking purchase on this environment. Payload:', data);
    }
  }

  // Track a Signup
  function trackSignup(){
    var data = {
      'event': 'successful_signup',
    };
    if(ENV.type === 'production' && $window.dataLayer){
      $window.dataLayer.push(data);
    } else {
      console.log('Analytics :: Not tracking signup on this environment. Payload:', data);
    }
  }

  // Track a window.location change (non-ui-router)
  function trackLocationChange(event, newUrl, oldUrl){
    trackPage({
      newUrl: newUrl,
      oldUrl: oldUrl,
    });
  }

  // To make sure we don't have any circular references, or deep trees
  var cloneOptions = {
    depth: 5,
    includeNonEnumerable: false,
    circular: true,
  };

  // Track a successful ui-router state change
  function trackRouterSuccess($transition){
    trackPage({
      from: clone($transition.from(), cloneOptions),
      to: clone($transition.to(), cloneOptions),
    });
  }

  // Track an unsuccessful ui-router state change
  function trackRouterError($transition){
    trackPage({
      from: clone($transition.from(), cloneOptions),
      to: clone($transition.to(), cloneOptions),
      error: clone($transition.error(), cloneOptions),
    });
  }

}

AnalyticsServiceRun.$inject = ['AnalyticsService'];
function AnalyticsServiceRun(AnalyticsService){
  // Ensure that the AnalyticsService is instantiated by guaranteeing that it as a dependency of _something_
}

AnalyticsConfig.$inject = ['$injector'];
function AnalyticsConfig($injector){
  // Disable automatic angulartics page tracking, we do our own thing
  if($injector.has('$analyticsProvider')){
    var $analyticsProvider = $injector.get('$analyticsProvider');
    $analyticsProvider.virtualPageviews(false);
    $analyticsProvider.firstPageview(false);
  }
}

angular
  .module('app')
  .config(AnalyticsConfig)
  .service('AnalyticsService', AnalyticsService)
  .run(AnalyticsServiceRun);

},{"clone":10}],19:[function(require,module,exports){
/** (ACCREDIBLE) API
 *
 *    A simple abstraction of the Accredible API
 *
 *    Deals with:
 *      POST and GET Requests to the server
 *        Chained to an authentication routine so that any
 *         early requests wait for authentication to complete
 *      Error Tracking
 *        Something gone wrong?
 *        Errors are logged to an external service
 *
 *    TODO
 *
 *      Cookie Management
 *        Stores authentication cookies
 *        Updates cookies if the API backend requests it
 *        Makes sure invalid cookies are destroyed
 *
 *      Time the requests and pass to our logging service - to dictate API speed improvements
 *      Needs to encompass Authentication and De-Authentication routines
 *      Can Authentication also help define our permissions?
 *      Should this deal with the User object? Or is that a different service? It's pretty tight with Authentication... ponder
 *      Publish an 'authentication' event for other Services to subscribe to (ie: User) - Do at the moment it's required
 *      Use '403 Forbidden' instead of '453 Custom' status code
 *
 *    @author   David "oodavid" King
 */
apiService.$inject = ['$http', '$q', 'ENV', 'emitter'];
function apiService($http, $q, ENV, emitter) {
  var service = this;
  service.getEndpoints = getEndpoints;
  service.getEndpoint = getEndpoint;
  service.getURL = getURL;
  service.addErrorHandler = addErrorHandler;
  service.request = request;
  service.extendedRequest = extendedRequest;
  service.dumpInfo = dumpInfo;
  service.parseErrorsToHtml = parseErrorsToHtml;
  service.parseErrorsToString = parseErrorsToString;

  /** BECOME AN EMITTER
   *
   *    This allows consumers of the API to be notified
   *       of endpoints being triggered, ie:
   *
   *      api.on('/design/create', function(promise){
   *        promise.then().catch().finally();
   *      });
   *
   *    OR
   *
   *      api.one('/design/create', function(promise){
   *        promise.then().catch().finally();
   *      });
   *
   *    See emitter.js for more details
   */
  emitter.addEmitterLogicTo(this);

  /** ENDPOINTS
   *
   *    A comprehensive list of endpoints available to the developer.
   *
   *    The reason for keeping this list is due to the fragmentation
   *     of the authentication tokens. In v1 of the API permissions
   *     are linked to the authentication TYPE, in ADDITION to the
   *     permission flags for the user account.
   *
   *    For the 'auth' column, there are the following values
   *      user_token     - If the user logs in to a Credential (recipient)
   *      issuer_token   - If the user logs in to the Dashboard
   *
   *    Occasionally the API docs request the token be sent in a
   *     HEADER or as a GET parameter. I've made note of these as
   *     I think this is a mistake.
   *
   *    In due course I would like to see v2 adopt a simpler auth
   *     model where there is a single authentication token that
   *     has permissions that can straddle any of the above roles.
   *
   *  VARIABLE SUBSTITUTION
   *
   *    The Backend uses a mix of REST practices, sometimes requiring
   *     the resource id in the URL, and sometimes in the payload.
   *    I have catered for both cases by using variable substition
   *     whereby the API Service will automatically swap out variables
   *     in the endpoint with values from the payload, ie:
   *
   *      '/object/update/<id>' { id: 1234, name: 'new name' }
   *
   *    - becomes -
   *
   *      '/object/update/1234' { name: 'new name' }
   */

  var endpoints = {
    //
    // MULTI-SERVICE AUTHENTICATION
    //
    '/auth/whoami': true,
    '/auth/sign_out': true,
    '/auth/sign_in': true,
    '/user/login/jwt': true, // Should be the same endpoint as above
    '/auth/sign_up': true,
    '/auth/resend_sign_up_email': true,
    '/auth/set_password': true,
    '/auth/send_password_reset_email': true,
    '/auth/reset_password': true,
    '/auth/get_user_detail_from_one_time_token': true,
    //
    // MFA STATUS
    //
    '/security_setting/mfa_status': {
      path: '/issuer/organizations/<id>/security_setting/mfa_status',
      GET: true,
    },
    //
    // PRODUCTS
    //
    '/products/all': {
      path: '/auth/products',
    },
    '/products/validate_domain': true,
    '/products/get': true,
    //
    // ISSUER OR USER AUTHENTICATION
    // ...only the response STRUCTURE defines which is being authenticated... :'(
    //
    '/universal/sso': {
      response: transformGodResponse,
    },
    //
    // ISSUER AUTHENTICATION
    //
    '/issuer_login/whoami': {
      path: '/organization/details',
      response: transformGodResponse,
    },
    '/issuer_login/sign_in': {
      path: '/accounts/issuer_logins/sign_in',
    },
    '/issuer_login/create': {
      path: '/organization/create',
      response: transformGodResponse,
    },
    '/issuer_login/sign_out': {
      path: '/accounts/issuer_logins/sign_out',
      DELETE: true
    },
    '/issuer_login/reset_password': {
      path: '/organization/reset_password_request',
    },
    '/issuer_login/forget_password': {
      path: '/organization/forget_password',
    },
    '/issuer_login/resend_verification_email': {
      path: '/organization/resend_email_verification_code',
    },
    '/issuer_login/select_department': {
      path: '/issuer_login/select_organization',
      payload: function(payload){
        renameProperty(payload, 'department_id', 'organization_id');
      },
      response: transformGodResponse,
    },
    '/issuer_login/update': {
      response: transformGodResponse,
    },
    '/issuer_login/claim_account': {
      response: transformGodResponse,
      payload: function(payload){
        renameProperty(payload, 'department_id', 'org_id');
        renameProperty(payload, 'token', 'key');
      },
    },
    //
    // NEEDS REVIEW (SEE COMMENTS)
    //
    '/department/update': {
      path: '/organization/update',
      response: transformGodResponse,
      // This is ONLY used to set `issuer.sandbox_mode` on the integrations page
      //  let's move this functionality to `/integrations/update_integration`
    },
    //
    // BILLING
    //
    '/billing/all_plans': {
      path: '/stripe/all_plans',
      v2: true,
    },
    '/billing/yearly_report': {
      path: '/organizations/<id>/yearly_report',
      GET: true,
    },
    '/billing/get_billing_summary': {
      path: '/stripe/get_billing_summary',
      v2: true,
    },
    '/billing/create_update_subscription': {
      path: '/stripe/create_update_subscription',
      response: transformGodResponse,
      v2: true,
    },
    '/billing/payment_schedule': {
      path: '/stripe/payment_schedule',
      v2: true,
    },
    '/billing/manage_billing': {
      path: '/stripe/manage_billing',
      v2: true,
      GET: true,
      skipReferrer: true,
    },
    '/billing/update_card': {
      path: '/organization/update_card',
      response: transformGodResponse,
    },
    '/billing/card_detail': {
      path: '/organization/card_detail',
    },
    '/billing/invoices/all': {
      v2: true,
    },
    //
    // BILLING (LEGACY)
    //
    '/billing/legacy/cancel_subscription': {
      path: '/organization/cancel_subscription',
      response: transformGodResponse,
    },
    '/billing/legacy/create_subscription': {
      path: '/organization/create_subscription',
      response: transformGodResponse,
    },
    '/billing/legacy/update_subscription': {
      path: '/organization/update_subscription',
    },
    '/billing/legacy/buy_credit': {
      path: '/organization/buy_credit',
      response: transformGodResponse,
    },
    '/billing/legacy/purchase_history': {
      path: '/stripe/purchase_history',
    },
    //
    // CONTRACTS
    //
    '/contracts/all_contracts': {
      path: '/pricing/get_all_contracts',
    },
    //
    // ANALYTICS
    //
    '/analytics/csv': {
      path: '/organizations/analytics_csv',
    },
    '/analytics/summary': {
      path: '/internal/organization/analytics/marketing_reach',
      GET: true,
    },
    '/analytics/log': {
      path: '/organization/events_log',
    },
    '/analytics/overview': {
      path: '/organization/analytics_extended',
    },
    //
    // CSV
    //
    '/csv/generate': {
      path: '/organization/csv_generation',
    },
    //
    // INTEGRATIONS
    //
    '/integrations/api_key': {
      path: '/organization/api_key',
    },
    //
    // API Settings
    //
    '/api_settings/api_keys': {
      path: '/api_keys',
      GET: true,
    },
    '/api_settings/api_keys/create': {
      path: '/api_keys',
    },
    '/api_settings/api_keys/delete': {
      path: '/api_keys/<id>',
      DELETE: true,
    },

    //
    // TEAM (DEPARTMENT)
    //
    '/team/all': {
      path: '/organization/all_team_members',
      payload: function(payload){
        if(payload.order === 'department_permissions.groups ASC'){
          payload.order = 'organization_permissions.groups ASC';
        }
        if(payload.order === 'department_permissions.groups DESC'){
          payload.order = 'organization_permissions.groups DESC';
        }
      },
    },
    '/team/read': {
      path: '/organization/get_team_member',
    },
    '/team/update': {
      path: '/organization/update_team_member',
    },
    '/team/create': {
      path: '/organization/create_team_member',
    },
    '/team/destroy': {
      path: '/organization/destroy_team_member',
    },
    '/team/resend_invite': {
      path: '/organization/invite_team_member_again',
    },
    '/team/invite_user': false, // Unused
    //
    // NAME CHANGE REQUESTS
    //
    '/name_change_requests/all': {
      path: '/organization/name_change_requests',
    },
    '/name_change_requests/update': {
      path: '/organization/action_name_change_requests',
    },
    '/name_change_request_count': {
      path: '/issuer/organizations/<id>/recipient_name_change_requests/count',
      GET: true,
    },
    //
    // EMAIL SETTINGS
    //
    '/email_settings/send_ses_email': {
      path: '/organization/send_ses_email',
    },
    '/email_settings/confirm_ses_email': {
      path: '/organization/confirm_ses_email',
    },
    '/email_settings/get_settings': {
      path: '/email_setting/get_settings',
    },
    '/email_settings/upsert': {
      path: '/email_setting/upsert',
    },
    '/email_settings/check_from_email_is_confirmed': {
      path: '/email_setting/check_from_email_is_confirmed',
    },
    '/email_settings/confirm_from_email': {
      path: '/email_setting/confirm_from_email',
    },
    '/settings/email/smtp/get': {
      path: '/settings/email/smtp',
      GET: true,
      // mockOn404: function(data) {
      //   return {
      //     smtp_settings: {
      //       enabled: false,
      //       senderName: 'Andrew Bateman',
      //       senderEmail: 'andrew@accredible.com',
      //       username: 'abateman',
      //       password: 'abc',
      //       server: 'smtp.mail.com',
      //       port: 587,
      //       encryption: 'tls'
      //       authentication: 'plain'
      //     }
      //   };
      // }
    },
    '/settings/email/smtp/put': {
      path: '/settings/email/smtp',
      PUT: true,
      // mockOn404: function(data) {
      //   return {
      //     smtp_settings: {
      //       enabled: false,
      //       senderName: 'Andrew Bateman',
      //       senderEmail: 'andrew@accredible.com',
      //       username: 'abateman',
      //       password: 'abc',
      //       server: 'smtp.mail.com',
      //       port: 587,
      //       encryption: 'tls'
      //       authentication: 'plain'
      //     }
      //   };
      // }
    },
    '/settings/email/smtp-test': true,
    // {
    //   mockOn404: function(data) {
    //     return {
    //       status: true
    //     };
    //   }
    // },

    //
    // EMAIL TEMPLATES
    //
    '/email_templates/all': {
      path: '/organization/all_email_templates',
    },
    '/email_templates/template_kinds': true,
    '/email_templates/show': true,
    '/email_templates/update': true,
    '/email_templates/create': true,
    '/email_templates/delete': true,
    '/email_templates/send_preview': true,
    //
    // CREDENTIALS
    //
    '/credentials/request_example': {
      path: '/organization/choose_demo_credential_type',
    },
    '/credentials/all': {
      path: '/organization/all_credential',
    },
    '/credentials/read': {
      path: '/organization/credential/<id>',
      GET: true,
    },
    '/credentials/create': {
      path: '/organization/create_credential',
    },
    '/credentials/update': {
      path: '/organization/update_credential/<id>',
    },
    '/credentials/delete': {
      path: '/delete_credentials',
    },
    '/credentials/get_recipient_sso_link': {
      path: '/organization/get_sso_recipient_link',
    },
    '/credentials/export_as_csv': {
      path: '/organization/export_credentials_csv',
    },
    '/credentials/publish': {
      path: '/organization/publish_credentials',
    },
    '/credentials/download_as_pdf': {
      path: '/organizations/bulk_pdf_download',
    },
    '/credentials/resend_email': {
      path: '/organization/resend_email_credentials',
    },
    '/credentials/change_status': {
      path: '/organization/change_status_credentials',
    },
    '/credentials/move': {
      path: '/organization/change_credentials_group',
    },
    //
    // CERTIFICATE DESIGNS
    //
    '/certificate_designs/all': {
      path: '/organization/all_designs',
    },
    '/certificate_designs/read': {
      path: '/design/<id>',
      GET: true,
    },
    '/certificate_designs/update': {
      path: '/design/update/<id>',
    },
    '/certificate_designs/create': {
      path: '/design/create',
    },
    '/certificate_designs/delete': {
      path: '/design/delete/<id>',
    },
    '/certificate_designs/get_blank_template': {
      path: '/design/get_blank_design',
    },
    '/certificate_designs/public_templates': {
      path: '/organization/static_designs',
    },
    '/design/render_get/<id>': { GET: true },
    '/design/copy_design': false, // Unused
    //
    // GROUPS
    //
    '/groups/all': {
      path: '/organization/all_groups',
    },
    '/groups/read': {
      path: '/groups/show/',
    },
    '/groups/create': {
      path: '/groups',
    },
    '/groups/update': {
      path: '/groups/update/<id>',
    },
    '/groups/delete': {
      path: '/groups/delete/<id>',
    },
    '/groups/compact_list': {
      path: '/organization/all_groups_analytics',
    },
    '/groups/check_group_name_uniqueness': true,
    '/groups/default_settings': {
      path: '/group/default_settings',
    },
    //
    // AUDIT
    //
    '/audit/all': true,
    '/audit/models': true,
    //
    // TAGS
    //
    '/tags/all': true,
    //
    // EMPLOYMENT DIRECTORY
    //
    '/employment_directory/get_settings': true,
    '/employment_directory/upsert': true,
    '/employment_directory/settings': {
      response: function(response){
        renameProperty(response, 'employment_directory.organization_id', 'employment_directory.department_id');
        renameProperty(response, 'employment_directory.organization_name', 'employment_directory.department_name');
      },
    },
    '/employment_directory/<department_id>/profile_search': {
      path: '/directory/<organization_id>/profile_search',
      payload: function(payload){
        renameProperty(payload, 'department_id', 'organization_id');
      },
    },
    '/employment_directory/<department_id>/profile/<id>': {
      path: '/directory/<organization_id>/profile/<id>',
      payload: function(payload){
        renameProperty(payload, 'department_id', 'organization_id');
      },
    },
    //
    // MY PROFILE
    //
    '/my_profile/read': {
      path: '/directory/profile/my_profile',
    },
    '/my_profile/update': {
      path: '/directory/profile/update_profile',
    },
    //
    // VERIFICATION DIRECTORY
    //
    '/verification-directory/get_settings': true,
    '/verification-directory/upsert': true,
    '/verification-directory/settings': {
      response: function(response){
        renameProperty(response, 'verification_directory.organization_name', 'verification_directory.department_name');
      },
      GET: true,
    },
    '/verification-directory/search': true,
    '/organization/directory/<username>': false, // Unused
    //
    // DEMO CREDENTIALS
    //
    '/marketing/create_hubspot_contact': {
      // This is a silly endpoint:
      // a) The API shouldn't expose our infrastructure (hubspot)
      // b) This action is not the job of the FE (it should be a side-effect of another action)
    },
    '/marketing/create_credential': {
      // I dislike the name of this endpoint, what does it do?
    },
    '/marketing/department/public_detail': true,
    '/marketing/department/all_public_groups': true,
    '/marketing/group/public_detail': true,
    //
    // CUSTOM CREDENTIALS (SELF-CERTIFIED CREDENTIALS)
    //
    '/custom_credentials/create': {
      path: '/custom_credential/create',
    },
    '/custom_credentials/show': {
      path: '/custom_credential/show',
    },
    '/custom_credentials/edit': true,
    '/custom_credentials/delete': true,
    '/custom_credentials/credential_id_redirect': true,
    //
    // ORGANIZATIONS
    //
    '/orgs/read': {
      path: '/corporations/show',
      response: function(response){
        renameProperty(response, 'corporation', 'organization');
      },
    },
    '/orgs/update': {
      path: '/corporations/update',
      payload: function(payload){
        renameProperty(payload, 'organization', 'update_corporation_object');
      },
      response: function(response){
        renameProperty(response, 'corporation', 'organization');
      },
    },
    '/organizations/allowance/update': {
      path: '/organizations/<id>/update_allowance',
      PUT: true
    },
    //
    // DEPARTMENTS
    //
    '/departments/all': true,
    '/departments/read': true,
    '/departments/update': true,
    '/departments/create': true,
    '/departments/delete': true,
    //
    // ADMINISTRATORS
    //
    '/administrators/all': true,
    '/administrators/create': true,
    '/administrators/update': true,
    '/administrators/destroy': true,
    '/administrators/resend_invite': {
      path: '/administrators/reinvite',
    },
    //
    // USAGE
    //
    '/usage/get': {
      path: '/corporations/show_department_usage',
    },
    //
    // Utility
    //
    '/utility/is_image': {
      path: '/organization/check_image_link',
    },

    // INTERNAL ENDPOINTS

    // Pathways
    '/internal/pathways/list': { // index
      path: '/internal/pathways',
      GET: true,
      // mockOn404: function(data) {
      //   return {
      //     pathways: []
      //   };
      // }
    },
    '/internal/pathways/get': { // show
      path: '/internal/pathways/<id>',
      GET: true,
    },
    '/internal/pathways/create': { // create
      path: '/internal/pathways',
    },
    '/internal/pathways/update': { // update
      path: '/internal/pathways/<id>',
      PUT: true
    },
    '/internal/pathways/delete': { // update
      path: '/internal/pathways/<id>',
      DELETE: true
    },

    // Collections
    '/internal/collections/list': { // index
      path: '/internal/collections',
      GET: true,
    },
    '/internal/collections/get': { // show
      path: '/internal/collections/<id>',
      GET: true,
    },
    '/internal/collections/create': { // create
      path: '/internal/collections/',
    },
    '/internal/collections/update': { // update
      path: '/internal/collections/<id>',
      PUT: true
    },
    '/internal/collections/delete': { // update
      path: '/internal/collections/<id>',
      DELETE: true
    },
    '/internal/collections/get_recipients': { // recipients
      path: '/internal/collections/<id>/recipients',
      GET: true,
    },
    '/internal/collections/get_recipients_stopped_at': { // recipients_stopped_at
      path: '/internal/collections/<id>/groups/<groupId>/recipients_stopped_at_csv',
      GET: true,
    },

    // Dashboard home screen stats
    '/internal/department_issuance_report': { GET: true },
    '/internal/department_share_feed?feed=<feed>': { GET: true },

    // New analytics
    '/internal/organization/analytics/published_credentials_count': { GET: true },
    '/internal/organization/analytics/credentials_views_count': { GET: true },
    '/internal/organization/analytics/credentials_shared_count': { GET: true },
    '/internal/organization/analytics/published_credentials_chart': { GET: true },
    '/internal/organization/analytics/credentials_views_chart': { GET: true },
    '/internal/organization/analytics/credentials_shared_chart': { GET: true },
    '/internal/organization/analytics/recipient_funnel': { GET: true },
    '/internal/organization/analytics/engagement_events': { GET: true },
    '/internal/organization/analytics/sharing_events': { GET: true },
    // Credential.net collections
    '/internal/departments/get_public_collections': {
      path: '/internal/organizations/<id>/collections',
      GET: true,
    },
    '/internal/collections/get_public': {
      path: '/internal/collections/<id>/public',
      GET: true,
    },
    '/internal/collections/get_user_data': {
      path: '/internal/collections/<id>/user/<username>',
      GET: true,
    },

    //
    //
    // TO REVIEW (BELOW)
    //
    //

    // Public Identity
    '/user/public_identity?username=<username>': true,
    // Utility
    '/typeahead/name_search': true,
    '/get_typeahead_without_auth/name_search': true, // We can search with { collection: 'organizations', query: 'test' } - is this departments or organizations?
    '/typeahead/location_search': true,
    '/directory/get_place_data': true,
    // ...
    // Import Credentials
    '/csv/analyze_csv_data': true,
    '/csv/review_csv_column_map': true,
    '/csv/import_csv': true,
    '/csv/check_import_sheet_progress': true,
    '/csv/evidence_items_field_csv_upload': true,
    // ...
    '/frontend/retrieve_certificate': true,
    '/frontend/log_frontend_analytics': true,
    '/frontend/credential': true,
    '/frontend/credential_id_redirect': true,
    '/frontend/all_grades': { GET: true },
    '/frontend/email': true,
    '/frontend/check_text_for_page': true,
    '/frontend/get_credential_events': true,
    '/frontend/verify_block_transaction': true,
    //'/frontend/branding': { GET: true },
    // Recipient Branding
    '/recipient/settings': { GET: true },
    // User / Recipient Authentication
    '/user/whoami': true,
    '/user/login': true,
    '/user/login/verification_code': true,
    '/user/check_user_verification_login_code': true,
    '/user/logout': true,
    '/user/create': true,
    '/user/update_password': true,
    '/user/forget_password': true,
    '/user/set_new_password': true,
    '/user/get_user_status': true,
    '/user/reset_user_password': true,
    // Other user / recipient endpoints
    '/user/change_email_verification_code': true,
    '/user/change_email': true,
    '/user/update': true,
    '/user/geolocate': { GET: true },
    '/user/make_credentials_public/<id>': true,
    // Attributes
    '/attribute_keys/list': true,
    '/attribute_keys/create': true,
    '/attribute_keys/update': true,
    '/attribute_keys/delete': true,
    // Credential
    '/user/change_name': true,
    '/user/update_credential_privacy': true,
    // Evidence
    '/user/evidence/create': true,
    '/user/evidence/update': true,
    '/user/evidence/delete': true,
    '/user/credentials/reorder_evidence': true,
    // Jobs
    '/internal/job_insights/top_5_companies': true,
    '/internal/job_insights/history': true,
    '/internal/job_insights/search': true,
    // Tracking
    '/analytics/track_link': true,
    '/frontend/store_follow_click': true,
    '/user/linkedin_certificate_shared': true,
    '/user/linkedin_certificate_added': true,
    // ...
    '/user/all_credential': true,
    '/users/add_email_verification_code': true,
    '/users/add_secondary_email': true,
    '/users/delete_secondary_email': true,
    '/users/delete_secondary_email2': true,
    '/user_emails/list_emails': true,
    '/user_emails/change_default_email': true,
    '/users/add_new_email_request': true,
    '/users/resend_verification_email': true,
    '/users/remove_add_email_request':true,
    '/users/login': true,
    '/users/get_credential_pass': { GET: true },
    '/frontend/send_verification_code': true,
    '/frontend/send_user_verification_code': true,
    '/frontend/evidence_insights/<id>': { GET: true },
    // SVG Editor
    '/frontend/convert_svg_to_png': true,
    // ...
    '/group/<id>': true,
    '/group/create': true,
    '/group/update/<id>': true,
    '/group/delete/<id>': true,
    '/group/remove_group': true,
    // ...
    '/role/<id>': true,
    '/role/create': true,
    '/role/update/<id>': true,
    '/role/delete/<id>': true,
    '/role/create_admin_role': true,
    '/role/delete_admin_role': true,
    '/frontend/share_credential_via_email': true,
    '/credential/generate_certificate_pdf': { GET: true },
    '/credential/evidence_item_delete/<id>': true,
    '/credential/directory/notified': { PATCH: true },
    // Various S3 Policies
    '/s3_policy/': true,
    '/s3_policy/templates/': true,
    '/s3_policy/organizations/': true,
    '/s3_policy/evidence/': true,
    // Verify endpoints
    '/verify/verify_credential': true,
    '/frontend/verify_chainpoint_chp_json': { GET: true },
    // Recipient Wallet
    '/user_wallet/get_all_public_credentials': true,
    // Coursefinder
    '/course_finder/search_courses': true, // We're passing `organizations: [...]` - does this make sense now?
    '/credential-net/meta_tags/search': { GET: true },
    // Home
    '/issuer/organizations/setup_status': {
      path: '/issuer/organizations/<id>/setup_status',
      GET: true,
    },
    // FlipperFeatures
    '/issuer/organizations/get_flipper_features': {
      path: '/issuer/organizations/<id>/features',
      GET: true,
    },
    // Campaigns SMS
    '/issuer/organizations/get_sms_configuration': {
      path: '/issuer/organizations/<id>/sms_configuration',
      GET: true,
    },
    '/issuer/organizations/sms_configuration': {
      path: '/issuer/organizations/<id>/sms_configuration'
    }
  };

  /** TRANSFORMS
   *
   *    For development purposes
   *
   *    1 - Allows us to map a NEW endpoint to an OLD endpoint, ie:
   *        `/issuer_login/select_department` is replaced with `/issuer_login/select_organization`
   *    2 - Allows us to transform the payload, ie:
   *        `{ department_id: 2842 }` becomes `{ organization_id: 2842 }`
   *    3 - Allows us to transform the response, ie:
   *        `{ organization: { id: 2842 .... } }` becomes `{ department: { id: 2842 .... } }`
   *
   *    This way we can:
   *      Test our work without demanding immediate changes from BE
   *      Update the FE codebase to use the new nomenclature
   *      Build up a complete todo-list for BE changes
   */

  // TRANSFORMS :: Helper :: Mutates a property
  function renameProperty(data, from, to) {
    var value = _.get(data, from);
    _.set(data, to, value);
    _.unset(data, from);
  }

  // TRANSFORMS :: Shared logic
  function transformGodResponse(response) {
    // Handle normal response
    if (response.issuer) {
      renameProperty(response, 'issuer.department.pricing', 'issuer.pricing');
    }
    // Handle extended response
    if (response.data && response.data.issuer) {
      renameProperty(response.data, 'issuer.department.pricing', 'issuer.pricing');
    }
  }

  /** ADD ERROR HANDLER
   *
   *    The consumer can set
   */
  var errorHandlers = {
    // '401': [ callback, callback ]
  };
  function addErrorHandler(code, callback) {
    if (!errorHandlers[code]) {
      errorHandlers[code] = []; // Instantiate the array if needed
    }
    errorHandlers[code].push(callback);
  }
  function triggerErrorHandlers(err, endpoint) {
    var callbacks = errorHandlers[err.status]; // eg, status=401
    if (callbacks) {
      for (var c = 0, cl = callbacks.length; c < cl; c++) {
        callbacks[c](err, endpoint);
      }
    }
  }

  /** GET URL
   *
   *    Returns the fully expanded URL for an API path
   *    Use sparingly! api.request is probably what you need!
   *
   *      Usage:
   *        api.getURL('/credential/generate_certificate_pdf');
   *
   *    This can also modify the url by replacing variables
   *       available on the {data} object, ie:
   *
   *      /endpoint/<id>
   *      /endpoint/1234
   */
  function getURL(path, data, v2) {
    path = path.replace(/<([^>]*)>/g, function(match, p1, offset, string) {
      if (data[p1]) {
        var value = data[p1]; // Reference the value, because we're about to...
        delete data[p1]; // Remove the variable from the data, it should not be part of the payload
        return encodeURIComponent(value);
      }
      return match;
    });
    var version = v2 ? 'v2' : ENV.apiVersion;
    return ENV.apiEndpoint + version + path;
  }

  /** REQUEST
   *
   *    Uses and returns a PROMISE that:
   *      Waits for initial authentication before being called
   *      Builds up a $http POST or GET request to the server
   *      Deals with common error responses.
   *
   *    Usage:
   *      api.request('/frontend/retrieve_certificate', { email: 'email@eacmf.com' })
   *        .then().catch().finally();
   *
   *      api.extendedRequest('/frontend/retrieve_certificate', { email: 'email@eacmf.com' })
   *        .then().catch().finally();
   *
   *      What is api.extendedRequest ?
   *
   *          The `returnExtendedResponse` argument forces the Service
   *           to reply with the FULL XHR object. Most of the time we
   *           DON'T want to do this as we're just interested in the
   *           response payload. However, sometimes we DO want access
   *           to the `status` and `statusText` properties.
   *
   *          In order to force the consumer code to be more readable
   *           with regards to `returnExtendedResponse` I have
   *           abstracted the parameter into two methods:
   *
   *              api.request
   *              api.extendedRequest
   */
  function requestSubroutine(path, data, returnExtendedResponse) {
    var deferred = $q.defer();
    // Trigger listeners, passing the promise
    service.trigger(path, deferred.promise);
    // I've wrapped the logic in a function so I can bail after rejecting or resolving the promise
    (function() {
      // The endpoint must be valid
      var endpointPath = path;
      if (path.indexOf('/s3_policy/') === 0) {
        endpointPath = path.split('?')[0];
      }

      if (!endpoints[endpointPath]) {
        console.warn('API > ' + path + ' is not a valid endpoint, aborting');
        deferred.reject();
        return false;
      }
      var endpoint = angular.copy(endpoints[endpointPath]);
      // TRANSFORM :: PATH
      if(endpoint.path){
        info('API > Transforming path');
        info('  %c'+path, 'font-weight:bold;');
        info('  %c'+endpoint.path, 'font-weight:bold;');
        path = endpoint.path;
      }
      endpoint.path = path; // Add a copy of the path to the endpoint for reference
      // TRANSFORM :: PAYLOAD
      if(endpoint.payload){
        var newData = angular.copy(data);
        endpoint.payload(newData);
        info('API > Transforming payload for %c'+path, 'font-weight:bold;');
        info('  ', angular.copy(data));
        info('  ', angular.copy(newData));
        data = newData;
      }
      // Build the config object
      var config = {
        method: 'POST',
        url: getURL(path, data, endpoint.v2),
        data: (data || {})
      };
      // Add authorization headers
      if (localStorage.getItem('authorization')) {
        config.headers = {
          'Authorization': localStorage.getItem('authorization'),
          'ACCREDIBLE-DEPARTMENT-ID': localStorage.getItem('department')
        };
      }
      // Add referrer to data (unless skipped)
      if (!endpoint.skipReferrer) {
        config.data['referrer'] = location.host;
      }
      // Special cases
      if (endpoint.GET === true || endpoint.PUT === true || endpoint.PATCH === true || endpoint.DELETE === true) {
        config.method = endpoint.GET ? 'GET' : endpoint.PUT ? 'PUT' : endpoint.PATCH ? 'PATCH' : 'DELETE';
        if (endpoint.GET === true) {
          config.params = config.data;
          delete config.data;
        } else if (endpoint.DELETE) {
          // We don't need the data
          delete config.data;
        }
      }
      // Make the request
      $http(config)
        .then(function(response) {
          if (!returnExtendedResponse) {
            response = response.data; // Most of the time we just need the response.data
          } else {
            // ...but sometimes we allow the full object to be returned, ie: { data: ..., status: 200, statusText: 'OK' }
          }
          // TRANSFORM :: RESPONSE
          if(endpoint.response){
            var newResponse = angular.copy(response);
            endpoint.response(newResponse);
            info('API > Transforming response from %c'+path, 'font-weight:bold;');
            info('  ', angular.copy(response));
            info('  ', angular.copy(newResponse));
            response = newResponse;
          }
          // Return
          deferred.resolve(response);
        })
        .catch(function(err) {
          if (err.status === 429) { // Message that rate limiting has occurred
            alert('Due to high demand, your request could not be processed.');
          } else if (err.status === 404 && endpoint.mockOn404) { // TRANSFORM :: MOCK
            var mockResponse = angular.copy(endpoint.mockOn404(data));
            info('API > Using MOCK response due to 404 from server');
            info('  ', angular.copy(mockResponse));
            deferred.resolve(mockResponse);
            return;
          }
          // Custom error handler?
          triggerErrorHandlers(err, endpoint);
          // Reject
          deferred.reject(err);
        });
    })();
    // Return the promise
    return deferred.promise;
  }
  function request(path, data) {
    return requestSubroutine(path, data, false);
  }
  function extendedRequest(path, data) {
    return requestSubroutine(path, data, true);
  }

  /** DUMP ENDPOINT INFO (UTILITY FUNCTION)
   *
   *    Dumps endpoint information to the console
   *
   *    I've added a bunch of aliases for this method so
   *     you shouldn't have any trouble remembering it.
   *    It loops through ALL endpoints to find anything
   *     that matches your search query, ie:
   *
   *      api.dumpInfo('/frontend/retrieve_certificate');
   *      api.info('certificate');
   *      api.help('/frontend');
   *      api.dump('search');
   *
   *    Alternatively pass nothing to see every endpoint
   *
   *      api.help();
   */
  function dumpInfo(search) {
    log('%c  API INFO  ', 'background-color:#ed143d;color:#FFFFFF;');
    angular.forEach(endpoints, function(endpoint, path) {
      // Does it match?
      if (search && path.indexOf(search) === -1) {
        return;
      }
      // Path
      if (search) {
        var a = path.indexOf(search);
        var b = a + search.length;
        var str = '%c' + path.slice(0, a) + '%c' + path.slice(a, b) + '%c' + path.slice(b);
        log(str, 'font-weight:bold;', 'font-weight:bold;background-color:#ff9632;', 'font-weight:bold;');
      } else {
        log('%c' + path, 'font-weight:bold;');
      }
      // Auth
      if (endpoint.auth) {
        log('    Auth:  ' + endpoint.auth);
      }
    });
  }

  // Getters
  function getEndpoints() {
    return endpoints;
  }
  function getEndpoint(path) {
    return endpoints[path];
  }

  // Error Parsing
  // The BE can return a string, an array of strings, an indexed object containing strings, OR an indexed object containing an array of strings.
  // This is the least readable bit of code I will write today. FML
  function parseErrorsToArray(errors, withoutKeys){
    var errorsArray = [];
    if(angular.isArray(errors.data.errors)){
      // An array of strings
      errorsArray = errors.data.errors;
    } else if(angular.isObject(errors.data.errors)){
      // An indexed object...
      angular.forEach(errors.data.errors, function(error, key){
        if(angular.isArray(error)){
          // ...containing an array
          angular.forEach(error, function(err){
            if (withoutKeys) {
              errorsArray.push(err);
            } else {
              errorsArray.push(key+': '+err);
            }
          });
        } else if(angular.isString(error)){
          // ...containing a string
          if (withoutKeys) {
            errorsArray.push(error);
          } else {
            errorsArray.push(key+': '+error);
          }
        }
      });
    } else if(angular.isString(errors.data.errors)){
      // Just a string
      errorsArray.push(errors.data.errors);
    }
    return errorsArray;
  }
  function parseErrorsToHtml(errors, withoutKeys){
    var errorsArray = parseErrorsToArray(errors, withoutKeys);
    return '<p>'+errorsArray.join('</p><p>')+'</p>';
  }
  function parseErrorsToString(errors, withoutKeys){
    var errorsArray = parseErrorsToArray(errors, withoutKeys);
    return errorsArray.join('\n');
  }

  // Util :: Logging
  function info(){
    if(ENV.type !== 'production'){
      //console.info.apply(console, arguments);
    }
  }
  function log(){
    if(ENV.type !== 'production'){
      console.log.apply(console, arguments);
    }
  }

}

angular
  .module('app')
  .service('api', apiService);


},{}],20:[function(require,module,exports){
/** ATTRIBUTES :: SERVICE
 *
 *  Deals with CRUD operations on Attributes.
 *
 *  @author  David "oodavid" King
 */

attributeService.$inject = ['$q', '$injector', '_', 'api', 'AnalyticsService'];
function attributeService($q, $injector, _, api, AnalyticsService){
  var service = this;
  service.getValidTypes = getValidTypes;
  service.isNameDuplicate = isNameDuplicate;
  service.isNameNonAlpha = isNameNonAlpha;
  service.isNameValidChars = isNameValidChars;
  service.isNameValid = isNameValid;
  service.isNameReserved = isNameReserved;
  service.nameToKey = nameToKey;
  service.getAttributesList = getAttributesList;
  service.getNestedAttributes = getNestedAttributes;
  service.tagsToAttributes = tagsToAttributes;
  service.tagsToAngular = tagsToAngular;
  service.upsert = doUpsert;
  service.delete = doDelete;
  service.parse = parse;

  // The swalService an optional dependency
  var swalService;
  if ($injector.has('swalService')) {
    swalService = $injector.get('swalService');
  } else {
    swalService = {
      showAlert: angular.noop
    };
  }

  /** CACHE
   *
   *      Keep a cache of attributes for quick reference
   *       and two-way-binding fun.
   *
   *      "Dot Notation" is a simple way of keeping our
   *       data clean, allowing the issuer to add anything
   *       as a custom attribute.
   *
   *      This is pre-seeded with defaults.
   *
   *      IMPORTANT NOTE
   *
   *          Default attributes have their `name` translated,
   *           see: attributeFilters.js
   */
  var attributes = [
    // Issuer Defaults
    { parent: 'issuer', key: 'name', type: 'text', },
    // Group Defaults
    { parent: 'group', key: 'course_name', type: 'text', },
    { parent: 'group', key: 'course_description', type: 'text', },
    // Credential Defaults
    { parent: 'credential', key: 'id', type: 'text', help: 'The Accredible ID of the Credential' },
    { parent: 'credential', key: 'license_id', type: 'text', help: 'The Unique ID your organization uses to reference the Credential' },
    { parent: 'credential', key: 'issued_on', type: 'date', },
    { parent: 'credential', key: 'expired_on', type: 'date', },
    { parent: 'credential', key: 'grade', type: 'text', },
    { parent: 'credential', key: 'url', type: 'text', },
    { parent: 'credential', key: 'uuid', type: 'text', },
    // Recipient Defaults
    { parent: 'recipient', key: 'id', type: 'text', help: 'The Unique ID your organization uses to reference the Recipient' },
    { parent: 'recipient', key: 'name', type: 'text', },
    { parent: 'recipient', key: 'email', type: 'email', },
    // These will likely be useful for sending email logic, but are more confusing than not on screens like the design editor
    // { parent: 'credential', key: 'private',                       type: 'boolean', },
    // { parent: 'credential', key: 'complete',                      type: 'boolean', },
    // { parent: 'credential', key: 'allow_supplemental_evidence',   type: 'boolean', },


    // Attributes
    //  ... are dynamic, and look like this:
    // { id: '123', name: 'My Attribute', parent: 'custom', key: 'my_attribute', type: 'text', },
  ];
  // Generate the tags
  angular.forEach(attributes, function(attribute) {
    attribute.tagName = attribute.parent + '.' + attribute.key;
    attribute.tag = '[' + attribute.tagName + ']';
  });

  /** VALID TYPES (FOR CUSTOM ATTRIBUTES*)
   *
   *      The BE allows us to store ANYTHING as the `type`
   *       so we do validation on the FE. We can add new
   *       types as we see fit.
   *
   *      * The DEFAULT attributes don't get validated, which
   *         means they can use undocumented types such as
   *         boolean etc.
   */
  var validTypes = {
    text: 'Text',
    date: 'Date',
    email: 'Email',
    image: 'Image',
    // boolean: 'True/False', // Be careful when reactivating this, FALSEY values are often omitted when submitting via forms
    // url:     'Web Address / URL',
    // number:  'Number',
  };

  function getValidTypes() {
    return validTypes;
  }

  /** SERIALIZERS
   *
   *  This service automatically handles some object serialization.
   *   The BE cannot use `type` as a key due to some Rails conflict,
   *   however I feel that it's the correct key. Furthermore, BE
   *   does NOT store the tokenised version of the attribute. We
   *   do that locally. Example:
   *
   *      Backend Structure
   *          {
   *              id:   123,
   *              name: 'My Custom Attribute',
   *              kind: 'text',
   *          }
   *
   *      Frontend Structure
   *          {
   *              id:      123,
   *              name:    'My Custom Attribute!',
   *              parent:  'custom',
   *              key:     'my_custom_attribute',
   *              type:    'text',
   *              tagName: 'custom.my_custom_attribute',
   *              tag:     '[custom.my_custom_attribute]',
   *          }
   *
   *  NOTES ABOUT KEY GENERATION / VALIDATION
   *
   *      I decided to follow the same conventions as Salesforce as to
   *       what constitutes "valid". That is:
   *
   *          Can contain only underscores and alphanumeric characters
   *          Must begin with a letter
   *          Not include spaces
   *          Not end with an underscore
   *          Not contain two consecutive underscore
   *
   *      You can generate a valid key by passing a string to nameToKey.
   *      Read more about the Salesforce logic here:
   *
   *          https://help.salesforce.com/articleView?id=adding_fields.htm&type=0
   */
  // Converts from `...My Custom Attribute!!` to `my_custom_attribute`
  function nameToKey(name) {
    if (name) {
      var key = name;
      key = key.toLowerCase(); // Drop caps
      key = key.replace(/[^a-z0-9_]+/gi, '_'); // Replace non alphanumerics and _
      key = key.replace(/_+/gi, "_"); // only one _ is left
      key = key.replace(/^[0-9_]+/gi, '_'); // Remove any leading numerics and _
      key = _.trim(key, '_'); // Trim remaining _
      return key;
    }
    return false;
  }
  // Parse for use on FE
  function parse(beAttribute) {
    var attribute = angular.copy(beAttribute);
    attribute.key = nameToKey(attribute.name);
    attribute.type = attribute.kind;
    attribute.parent = 'custom';
    attribute.tagName = attribute.parent + '.' + attribute.key;
    attribute.tag = '[' + attribute.tagName + ']';
    // Validate the type
    if (!validTypes[attribute.type]) {
      attribute.type = 'text'; // Convert to text if it's invalid
      attribute.draft = true;
    }
    // Tidy
    delete attribute.kind;
    // Done
    return attribute;
  }
  // Serialize for storage on BE
  function serialize(attribute) {
    var beAttribute = angular.copy(attribute);
    beAttribute.kind = beAttribute.type;
    // Done
    return beAttribute;
  }

  /** VALIDATOR
   *
   *      This is a "soft" validator, that can run on the FE using known,
   *       cached data. However the BE still may reject the changes on
   *       other grounds (such as having more up-to-date information).
   *
   *      Usage
   *
   *          isNameValid('My Custom Attribute');
   *          isNameValid('My Custom Attribute', 123); // Where 123 is the id of the attribute being modified. Required for the "duplicate key" check to not collide with itself
   */
  function isNameNonAlpha(name) {
    if (!name.match(/[a-z]/i)) {
      return true;
    }
  }

  function isNameValidChars(name) {
    if (name.match(/[^a-z0-9\-\_\ ]/i)) {
      return true;
    }
  }

  function isNameDuplicate(name, id) {
    var key = nameToKey(name);
    var index = _.findIndex(attributes, function(attribute) {
      return attribute.parent == 'custom' // We're only interested in `custom` attributes
        &&
        attribute.key == key // Matching this key
        &&
        attribute.id != id; // But not matching yourself
    });
    if (index !== -1) {
      return true;
    }
  }

  function isNameReserved(name) {
    var blacklist = ['name', 'student name', 'student_name', 'student email', 'email', 'student_email', 'forename', 'surname', 'issue_date', 'issued_date', 'issued_on', 'expired_on', 'expiry_date', 'grade', 'reference', 'referee_name', 'evidence_description', 'evidence_url'];
    var index = _.findIndex(blacklist, function(item) {
      return item == name.toLowerCase();
    });
    if (index !== -1) {
      return true;
    }
  }

  // Runs all validators
  function isNameValid(name, id) {
    return !(isNameNonAlpha(name) && isNameValidChars(name) && isNameDuplicate(name, id) && isNameReserved(name));
  }

  /** GET ATTRIBUTES
   *
   *      Returns a promise for attributes
   *
   *      Only talks to the API once
   */
  var getAttributesPromise;

  function getAttributesList(forceRetrieval, mode) {
    if (!getAttributesPromise || forceRetrieval) {
      getAttributesPromise = api.request('/attribute_keys/list', {mode: mode || 'full'})
        .then(function(response) {
          // Clear the cache of OLD custom credential attributes
          _.remove(attributes, function(attribute) {
            return attribute.parent == 'custom';
          });
          // Add these new custom attributes (creating or updating as needed)
          for (var al = response.attribute_keys.length, a = 0; a < al; a++) {
            var attribute = parse(response.attribute_keys[a]);
            attributes.push(attribute);
          }
          // And return
          return attributes;
        });
    }
    // Return the promise (which may have been resolved already)
    return getAttributesPromise;
  }

  /** GET NESTED ATTRIBUTES
   *
   *      Returns a promise for nested attributes
   *
   *      NB: This object DOES NOT UPDATE when the attributes
   *       array updates. I could create a $rootScope watcher
   *       but at the time of writing I wasn't sure that this
   *       was needed...
   */
  function getNestedAttributes(forceRetrieval) {
    return getAttributesList(forceRetrieval)
      .then(function(response) {
        var nestedAttributes = {};
        for (var al = response.length, a = 0; a < al; a++) {
          var attribute = response[a];
          if (!nestedAttributes[attribute.parent]) {
            nestedAttributes[attribute.parent] = [];
          }
          nestedAttributes[attribute.parent].push(attribute);
        }
        return nestedAttributes;
      });
  }

  /** STRING HELPER :: TAGS TO ATTRIBUTES
   *
   *   Given a string, containing [parent.key] tags, this method
   *    returns an array of related attributes
   */
  function tagsToAttributes(string) {
    var result = [];
    string.replace(/\[([0-9a-z_]+)\.([0-9a-z_]+)\]/ig, function(match, parent, key) {
      var index = _.findIndex(attributes, function(attribute) {
        return attribute.parent == parent && attribute.key == key;
      });
      if (index !== -1) {
        result.push(attributes[index]);
      }
    });
    return result;
  }

  /** STRING HELPER :: TAGS TO ANGULAR
   *
   *   Given a string, this replaces attributes like [course_name]
   *    or [123] to an angular template like {{ credential.course_name }}.
   *
   *   Must cater for the different attribute types (dates)
   */
  function tagsToAngular(string, credentialData, noCurlies) {
    // Look for named, or numerical attributes
    return string.replace(/\[([0-9a-z_]+)\.([0-9a-z_]+)\]/ig, function(match, parent, key) {
      // Build up the angular template
      var tmpl;
      if (parent == 'credential') {
        tmpl = 'data.' + key; // CREDENTIAL data is available at the root level (credential.id)
      } else {
        tmpl = 'data.' + parent + '.' + key; // All other data is available in its own object (recipient.name or custom.log etc.)
      }
      // If we have credential data, then we can infer a custom type from that
      var type = 'text';
      if (parent == 'custom' && credentialData && credentialData.custom_type && credentialData.custom_type[key]) {
        type = credentialData.custom_type[key];
      } else {
        // Otherwise, we can look in the known attributes (ie: defaults)
        var index = _.findIndex(attributes, function(attribute) {
          return attribute.parent == parent && attribute.key == key;
        });
        if (index !== -1) {
          var attribute = attributes[index];
          type = attribute.type;
        }
      }
      // Is it a date?
      if (type == 'date') {
        tmpl += ' | date:(block.date_format ? block.date_format : \'longDate\')';
      }
      // Return
      if (noCurlies) {
        return tmpl;
      }
      return '{{ ' + tmpl + ' }}';
    });
  }

  /** UPSERT
   *
   *      Creates -OR- Updates Attributes
   *
   *      In the presence of an id, we assume it's an Update
   *       without an id, assume Create.
   */
  function doUpsert(attribute, suppressAlerts) {
    var attribute = serialize(attribute);
    return $q(function(resolve, reject) {
      // Can only update custom attributes
      if (attribute.id && attribute.parent != 'custom') {
        if (!suppressAlerts) {
          swalService.showAlert('upsertAttributeFailure', 'Cannot update default attributes');
        }
        reject('Cannot update default attributes');
        return;
      }
      // Validate the attribute name
      if (!isNameValid(attribute.name, attribute.id)) {
        if (!suppressAlerts) {
          swalService.showAlert('upsertAttributeFailure', 'Attribute name is not valid');
        }
        reject('Attribute name is not valid');
        return;
      }
      // Update or Create?
      var method = '/attribute_keys/' + (attribute.id ? 'update' : 'create');
      api.request(method, {
          attribute_key: attribute
        })
        .then(function(response) {
          // Massage
          var attribute = parse(response.attribute_key);
          // Update the cache
          var index = _.findIndex(attributes, {
            'id': attribute.id
          });
          if (index === -1) {
            attributes.push(attribute);
          } else {
            attributes[index] = attribute;
          }

          AnalyticsService.trackEvent('Attributes > Created or Updated Attribute');

          // Notify
          if (!suppressAlerts) {
            swalService.showAlert('upsertAttributeSuccess');
          }
          resolve(attribute);
        })
        .catch(function(err) {
          // Notify
          if (err.status == 422) {
            if (!suppressAlerts) {
              swalService.showAlert('upsertAttributeDuplicate');
            }
          } else {
            if (!suppressAlerts) {
              swalService.showAlert('upsertAttributeFailure');
            }
          }
          reject(err);
        });
    });
  }

  /** DELETE
   *
   *      Deletes an Attribute
   */
  function doDelete(attribute) {
    return $q(function(resolve, reject) {
      api.request('/attribute_keys/delete', {
          id: attribute.id,
        })
        .then(function(response) {
          // Update the cache
          var index = _.findIndex(attributes, {
            'id': attribute.id
          });
          if (index !== -1) {
            attributes.splice(index, 1);
          }
          AnalyticsService.trackEvent('Attributes > Deleted Attribute');
          // Notify
          swalService.showAlert('deleteAttributeSuccess');
          resolve(response);
        })
        .catch(function(err) {
          // Notify
          swalService.showAlert('deleteAttributeFailure');
          reject(err);
        });
    });
  }

}

angular
  .module('app')
  .service('attributeService', attributeService);

},{}],21:[function(require,module,exports){
/** AUTH SERVICE :: ISSUER ONLY
 *
 *    Deals with authentication (of Issuers)
 *
 *    This Service is an emitter. It emits a single event
 *     `change` whenever the auth object changes.
 *
 *      AuthService.on('change', function(auth){ console.log(auth); });
 *        OR
 *      AuthService.one('change', function(auth){ console.log(auth); });
 *
 *    See emitter.js for more details
 *
 *    IMPORTANT NOTES
 *
 *      The values exposed by this service (department,
 *       user, permissions etc.) are LEGACY. Please don't
 *       access these values directly as they will be
 *       removed in due course. Instead use these services:
 *
 *          OrganizationService
 *          DepartmentService
 *          UserService
 *          PermissionsService
 *          FeaturesService
 *
 *    IMPORTANT NOTES
 *
 *      We have different Authentication systems for each
 *       property, or each user "type"... Someday this might
 *       be updated, but sadly no time soon. When that day
 *       comes around, we should merge AuthService and
 *       AuthService into simply AuthService.
 *
 *    NOMENCLATURE
 *
 *      The terms USER and ISSUER-LOGIN are used interchangably
 *       by our API. As are ISSUERS and ORGANIZATIONS.
 *
 *    @author  David "oodavid" King
 */
AuthService.$inject = ['api', '$rootScope', '$q', 'emitter', 'ENV'];
function AuthService(api, $rootScope, $q, emitter, ENV) {
  var service = this;
  service.getAuth = getAuth;
  service.injectAuthentication = injectAuthentication;
  service.authenticateWithEmailAndPassword = authenticateWithEmailAndPassword;
  service.authenticateWithJWT = authenticateWithJWT;
  service.authenticateWithInviteToken = authenticateWithInviteToken;
  service.refresh = refresh;
  service.reset = reset;
  service.logout = logout;
  service.register = register;
  service.resendVerificationEmail = resendVerificationEmail;
  service.sendPasswordResetEmail = sendPasswordResetEmail;
  service.passwordReset = passwordReset;
  service.setPassword = setPassword;

  service.verificationToken = null;

  var auth = {};

  // Become an emitter
  emitter.addEmitterLogicTo(service);

  function storeAuthorization(response) {
    var authorizationHeader = response.headers ? (response.headers('accredible-authorization') || response.headers('authorization')) : null;
    if (authorizationHeader) {
      localStorage.setItem('authorization', authorizationHeader);
    }
  }

  function removeAuthorization() {
    localStorage.removeItem('authorization');
  }

  // Updates the auth object
  function setAuthObject(issuer) {
    if (issuer) {
      // Update auth object
      angular.copy(issuer, auth);

      if (issuer.user) {
        $rootScope.$broadcast('hotjarAndPosthogIssuer', auth);
      }

      if (issuer.department) {
        localStorage.setItem('department', auth.department.id);
      } else {
        localStorage.removeItem('department');
      }

      service.trigger('change', auth);
    }
  }

  function setVerificationToken(response) {
    if (!localStorage.getItem('authorization')) {
      service.verificationToken = null;
      if (response.data && response.data.issuer) {
        service.verificationToken = response.data.issuer.verification_token;
      }
    }
  }

  /** SESSION / FETCH ISSUER / SIGN IN / AUTHENTICATION / LOGIN
   *
   *    Fetch Issuer Returns the auth object. It will make a request
   *     to the API to convert our local authorization into a { auth }
   *     object if / when appropriate.
   *
   *    We allow Issuers to sign in using a number of
   *     mechanisms, this is to reduce friction as much
   *     as possible and give the Issuers a smooth
   *     User-Experience.
   *
   *  STRUCTURAL LOGIC
   *
   *    The following API endpoints all respond with the authorization
   *     and { auth } object, they also dictate the current session,
   *     hence we use common success and error callbacks.
   *
   *        /issuer/whoami
   *        /issuer/login
   *        /issuer/login/jwt
   */

  // Reusable promise for getAuth. This prevents multiple calls to `/issuer_login/whoami`
  var getAuthPromise = false;

  function injectAuthentication(authorization) {
    if (authorization) {
      localStorage.setItem('authorization', authorization);
    }
    // Calls refresh rather than getAuth as we want to force the user data to be retrieved
    return refresh();
  }

  function getAuthSignInHandler(resolve) {
    return function(response) {
      storeAuthorization(response);
      setVerificationToken(response);
      return getAuth()
        .then(function() {
          resolve(auth);
        });
    };
  }

  function getAndStoreAuthHandler(resolve) {
    return function(response) {
      storeAuthorization(response);
      setAuthObject(response.data.issuer);
      resolve(auth);
    };
  }

  // Returns a handler to deal with a successful auth response, which returns the { auth } object
  function getAuthResolveHandler(resolve) {
    return function(response) {
      setAuthObject(response.issuer);
      resolve(auth);
    };
  }

  // Returns a handler to deal with a failed auth response, clearing the session and local issuer data
  function getAuthRejectHandler(reject) {
    return function(err) {
      reset();
      reject(err);
    };
  }

  // Resets the Service
  function reset() {
    getAuthPromise = false;
    removeAuthorization();
    setAuthObject({});
  }

  // Logs the user out
  function logout() {
    var promise = api.request('/issuer_login/sign_out');
    reset(); // We must reset `after` the API request, so that the token is available to the API service
    return promise;
  }

  // Returns a promise for an { auth } object. Request the { auth } object from the API if necessary. Never rejects.
  function getAuth() {
    if(!getAuthPromise){
      getAuthPromise = $q(function(resolve, reject) {
        // If we have no local data, but we DO have a token, ask the API for an { auth } object
        if (angular.equals(auth, {}) && localStorage.getItem('authorization')) {
          api
            .request('/issuer_login/whoami')
            .then(getAuthResolveHandler(resolve), getAuthRejectHandler(resolve)); // By passing `resolve` to both handlers, this never rejects.
        } else {
          resolve(auth); // Otherwise return a pointer to the variable (it may be updated later)
        }
      });
    }
    return getAuthPromise;
  }

  // Forces a refresh of the auth object. Use sparingly. Never Rejects
  function refresh() {
    return $q(function(resolve, reject) {
      api
        .request('/issuer_login/whoami')
        .then(getAuthResolveHandler(resolve), getAuthRejectHandler(resolve)); // By passing `resolve` to both handlers, this never rejects.
    });
  }

  // Authenticate using email and password
  function authenticateWithEmailAndPassword(email, password) {
    // Make sure there isn't an unresolved auth promise
    getAuthPromise = false;
    return $q(function(resolve, reject) {
      api
        .extendedRequest('/issuer_login/sign_in', {
          email: email,
          password: password,
        })
        .then(getAuthSignInHandler(resolve), getAuthRejectHandler(reject));
    });
  }

  // Authenticate using a single-use JSON Web Token - used by Rails Admin, the sign-up email and in the Canvas LMS integration
  function authenticateWithJWT(jwt) {
    return $q(function(resolve, reject) {
        api
          .extendedRequest('/universal/sso', {
            key: jwt,
            object: 'issuer',
          })
          .then(getAndStoreAuthHandler(resolve), getAuthRejectHandler(reject));
      });
  }

  // Team member/Admin invite - via email
  // Authenticate with an invite token - used to save password for new team member
  function authenticateWithInviteToken(token, department_id, password){
    return $q(function(resolve, reject) {
      api
        .extendedRequest('/issuer_login/claim_account', {
          token: token,
          department_id: department_id,
          password: password
        })
        .then(getAndStoreAuthHandler(resolve), getAuthRejectHandler(reject));
    });
  }

  // Sign up - create new issuer -> generates email
  // Creates a new login
  function register(new_issuer_object){
    return $q(function(resolve, reject) {
      api
        .request('/issuer_login/create', {
          'issuer': new_issuer_object,
        })
        .then(getAuthResolveHandler(resolve), getAuthRejectHandler(reject));
    });
  }

  // Resends the registration email
  function resendVerificationEmail(verificationToken) {
    return api
      .request('/issuer_login/resend_verification_email', { verification_token: verificationToken });
  }

  // Sends a password reset email
  function sendPasswordResetEmail(email, captcha) {
    return api
      .request('/issuer_login/forget_password', {
        email: email,
        recaptcha_response: captcha
      });
  }

  // Resets the issuers password
  function passwordReset(reset_token, password) {
    return api
      .request('/issuer_login/reset_password', {
        reset_token: reset_token,
        password: password,
      });
  }

  // Sets the (new) issuers password
  function setPassword(newPassword) {
    return api
      .request('/issuer_login/update', {
        login_issuer_params: {
          password: newPassword
        }
      });
  }

  /** LEGACY :: GOD OBJECT HANDLING
   *
   *    There are a number of endpoints that return the same
   *     "God Object" as these authentication requests.
   *
   *    While this AuthService isn't concerned with any of
   *     this data, there are a number of other services
   *     that depend on the AuthService for this data.
   *
   *    Here we listen for endpoints that are known to
   *     return this object; we update our cache appropriately.
   */
  api.on('/issuer_login/select_department', handleExternalData);
  api.on('/issuer_login/update', handleExternalData);
  api.on('/department/update', handleExternalData);
  api.on('/billing/legacy/create_subscription', handleExternalData);
  api.on('/billing/legacy/buy_credit', handleExternalData);
  api.on('/billing/update_card', handleExternalData);
  api.on('/billing/legacy/cancel_subscription', handleExternalData);
  api.on('/billing/create_update_subscription', handleExternalData);
  function handleExternalData(promise){
    promise
      .then(function(response){
        setAuthObject(response.issuer);
      })
      .catch()
      .finally();
  }
}

angular
  .module('app')
  .service('AuthService', AuthService);

/*

// How to use

// Get the current issuer
AuthService
  .getAuth()
  .then(function(issuer){
    // console.log('logged in with', issuer);
  });

// Login with email and password
AuthService
  .authenticateWithEmailAndPassword('david+41@accredible.com', 'darwin99')
  .then(function(issuer){
    // console.log('logged in with', issuer);
  });

// Login with a JWT
var jwt = {};
AuthService.
  authenticateWithJWT(jwt)
  .then(function(issuer){
    // console.log('logged in with', issuer);
  });

// Creating an account
var new_issuer_object = {"contact_last_name":"King","password":"darwin99","name":"DKCLa","url":"http://oodavid.com","email":"david+"+Math.round(Math.random()*10000)+"@oodavid.com","phone_number":"07939273963","api_agreement_sign":true,"contact_first_name":"David","found_accredible":"Google","sandbox_mode":false};
AuthService
  .register(new_issuer_object)
  .then(function(issuer){
    // console.log('logged in with', issuer);
  });

// Logout
AuthService
  .logout()
  .then(function(){
    // console.log('logged out');
  });

// Resend the verification email
AuthService
  .resendVerificationEmail()
  .then(function(){
    // console.log('sent');
  });

// Request a password reset email
AuthService
  .sendPasswordResetEmail('david+41@accredible.com')
  .then(function(){
    // console.log('sent');
  });

// Reset the password
AuthService
  .passwordReset('password_reset_token', 'darwin99')
  .then(function(issuer){
    // console.log('logged in with', issuer);
  });


// I expect this to emit events

*/

},{}],22:[function(require,module,exports){
CertificateService.$inject = ['$q', 'api', 'swalService', 'AnalyticsService'];
function CertificateService($q, api, swalService, AnalyticsService){
  var service = this;
  service.upsert = upsert;
  service.get = get;
  service.destroy = destroy;
  service.getBlankDesign = getBlankDesign;
  service.getDesigns = getDesigns;

  // Upserts a design
  function upsert(design){
    // design = clean(design); // Clean the object - TODO: Is this needed?
    // Update or Insert?

    var escapedCharacters = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      '\'': '&#39;',
      '/': '&#x2F;'
    };

    var escapedName = String(design.name).replace(/[&<>"'\/]/g, function (s) {
      return escapedCharacters[s];
    });

    var designEscaped = angular.copy(design);
    designEscaped.name = escapedName;

    if (design.id) {
      // Update
      return api
        .request('/certificate_designs/update', { design: designEscaped, id: design.id })
        .then(function(response){
          return response.design;
        });
    } else {
      // Insert
      return api
        .request('/certificate_designs/create', { design: designEscaped })
        .then(function(response){
          return response.design;
        });
    }
  }

  // Returns a design
  function get(idObjectOrFalsey) {
    if(!idObjectOrFalsey){
      // Return a blank design
      return getBlankDesign();
    } else {
      // Request the design from backend. When given a design object, this ensures the latest version is used
      var id = angular.isObject(idObjectOrFalsey) ? idObjectOrFalsey.id : idObjectOrFalsey;
      return api
        .request('/certificate_designs/read', { id: id })
        .then(function(response) {
          return response.design;
        });
    }
  }

  // Deletes a design
  function destroy(idOrDesign) {
    var id = angular.isObject(idOrDesign) ? idOrDesign.id : idOrDesign; // Be flexible with input
    return $q(function(resolve, reject){
      api
        .request('/certificate_designs/delete', { id: id })
        .then(function(response){
          AnalyticsService.trackEvent('Designs > Delete Design');
          resolve();
        })
        .catch(function(err){
          if(err.status === 404){
            resolve(); // The design didn't exist (it was probably already deleted)
          } else {
            swalService.showAlert('certificateDesignInUse');
            reject(err); // The design is still in use
          }
        });
    });
  }

  // Returns a blank design object (possibly from cache, for speed)
  var blankDesign;
  function getBlankDesign() {
    if(blankDesign){
      return $q.resolve(angular.copy(blankDesign)); // From cache
    } else {
      return api
        .request('/certificate_designs/get_blank_template')
        .then(function(response) {
          blankDesign = response.design; // Cache
          return angular.copy(blankDesign);
        });
    }
  }

  // Returns designs for the issuer, or the publically available templates, depending on payload
  function getDesigns(payload, showTemplates) {
    if(showTemplates){
      return api.request('/certificate_designs/public_templates', payload);
    } else {
      return api.request('/certificate_designs/all', payload);
    }
  }

  //
  // SHAME
  //
  // This method makes sure that any additional values or properties don't exist on the design object
  // Artefacts MAY exist from bad FE logic, or bad BE serialization. Who knows!
  //
  function clean(design) {
    var copiedDesign = angular.copy(design); // Don't pollute the original
    var newDesign = {
      'id': copiedDesign.id,
      'svg': copiedDesign.svg,
      'blocks': copiedDesign.blocks,
      'background': copiedDesign.background,
      'name': copiedDesign.name,
      'size': copiedDesign.size || 'us-letter',
      'orientation': copiedDesign.orientation || 'landscape',
      'background_bleeds': copiedDesign.background_bleeds || false,
    };
    if (copiedDesign.blocks && copiedDesign.blocks.length > 0) {
      for (var i = copiedDesign.blocks.length - 1; i >= 0; i--) {
        newDesign.blocks.push(copiedDesign.blocks[i]);
      }
    }
    if (copiedDesign.custom_attributes && copiedDesign.custom_attributes.length > 0) {
      newDesign.custom_attributes = copiedDesign.custom_attributes;
    }
    return newDesign;
  }

}

angular
  .module('app')
  .service('CertificateService', CertificateService);

},{}],23:[function(require,module,exports){
/** EMAIL : VALIDATOR
 *
 *    A superior regex to the built-in angularjs validator
 *
 *      http://stackoverflow.com/a/28431112/1122851
 *      http://blog.gerv.net/2011/05/html5_email_address_regexp/
 *
 *    emailService.isValid('david@oodavid.com');
 *    emailService.parse('david@oodavid.com');
 *
 *    @author   David "oodavid" King
 */
require('./url.service.js');

emailService.$inject = ['urlService'];

function emailService(urlService) {
  var service = this;
  service.isValid = isValid;
  service.parse = parse;
  var regexEmail = /^[a-z0-9.!#$%&’*+/=?^_`{|}'~-]+@[a-z0-9](?:[a-z0-9-]{0,253}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,253}[a-z0-9])?)*$/i;

  // Returns bool if an email is valid
  function isValid(value) {
    return !value || regexEmail.test(value);
  }

  // Parses an email address
  function parse(email) {
    if (isValid(email)) {
      var tmp = email.split('@');
      if (tmp.length == 2 && tmp[0].length && tmp[1].length) {
        return {
          local: tmp[0],
          domain: urlService.parse('http://' + tmp[1]),
        };
      }
    }
  }
}

angular
  .module('app')
  .service('emailService', emailService);

},{"./url.service.js":29}],24:[function(require,module,exports){
/** EMITTER - SERVICE
 *
 *      The emitter service allows any object to become an emitter.
 *
 *      Usage:
 *
 *          var o = function(){
 *            emitter.addEmitterLogicTo(this);
 *            setInterval(function(){
 *              this.trigger('someEvent', 1, 2, 3);
 *            }, 1000);
 *            return this;
 *          }();
 *
 *          o.on('someEvent', function(a, b, c){
 *            console.log('triggered every time', a, b, c);
 *          });
 *          o.one('someEvent', function(a, b, c){
 *            console.log('triggered once', a, b, c);
 *          });
 *          o.on('*', function(a, b, c){
 *            console.log('catch-all listener', a, b, c);
 *          });
 *
 *      Notes:
 *
 *          I'm not completely happy with the method naming here.
 *           `addEmitterLogicTo` feels clunky. I'd like to use
 *           prototypical inheritance, but it doesn't gel with our
 *           existing AngularJS code.
 *
 *      @author   David 'oodavid' King
 */
emitterService.$inject = [];
function emitterService(){
  var service = this;
  service.addEmitterLogicTo = addEmitterLogicTo;
  function addEmitterLogicTo(obj) {
    obj.on = on;
    obj.off = off;
    obj.one = one;
    obj.trigger = trigger;
    //
    var callbacks = {};
    var id = 0;
    function on(name, callback) {
      id++;
      if (!callbacks[name]) {
        callbacks[name] = {};
      }
      callbacks[name][id] = callback;
      return {
        name: name,
        id: id
      };
    }
    function off(task) {
      delete callbacks[task.name][task.id];
    }
    // Applies a self-removing callback
    function one(name, callback) {
      var task = on(name, function() {
        callback.apply(this, arguments);
        off(task);
      });
      return task;
    }
    function trigger(name /* all additional arguments are passed to the callback */ ) {
      // Convert the arguments {object} into an array that we can use with `apply`
      var args = [];
      for (var i = 1, il = arguments.length; i < il; i++) { // I'm intentionally skipping the first argument, which is `name`
        args.push(arguments[i]);
      }
      // Trigger callbacks
      angular.forEach(callbacks[name], function(callback){
        callback.apply(this, args);
      });
      // ...and any catch-all listeners
      angular.forEach(callbacks['*'], function(callback){
        callback.apply(this, args);
      });
    }
  }
}

angular.module('app')
  .service('emitter', emitterService);

},{}],25:[function(require,module,exports){
encodeService.$inject = [];
function encodeService(){
  var service = this;
  service.encode = encode;

  var encodeChars = {
    '<': '&lt;',
    '>': '&gt;'
  };
  function encode(string){
    string += ''; // Coerce to string
    return string.replace(/[<>]/g, function(char){
      return encodeChars[char] || char;
    });
  }

}

angular
  .module('app')
  .service('encodeService', encodeService);

},{}],26:[function(require,module,exports){
/** FILE SIZE - SERVICE
 *
 *    A simple service that can juggle between human and
 *     machine file-sizes
 *
 *    Usage:
 *
 *      var bytes    = fileSize.parse('5.1 Mb'); // 5242880
 *      var bytes    = fileSize.parse('100kb');  // 102400
 *      var readable = fileSize.human(5242880);  // '5.0 Mb'
 *      var readable = fileSize.human(12345678); // '11.8 Mb'
 *
 *    @author   David "oodavid" King
 */
fileSizeService.$inject = [];
function fileSizeService(){
  var service = this;
  service.parse = parse;
  service.human = human;

  var units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  // Parse a string into bytes
  function parse(string) {
    string = string.toLowerCase();
    var num = parseFloat(string, 10);
    if (num == string) {
      return Math.round(num);
    }
    for (var u = 0, ul = units.length; u < ul; u++) {
      num *= 1024;
      if (string.indexOf(units[u].toLowerCase()) !== -1) {
        return Math.round(num);
      }
    }
  }
  // Convert bytes into a string
  function human(bytes) {
    var i = -1;
    do {
      bytes = bytes / 1024;
      i++;
    } while (bytes > 1024);
    return Math.max(bytes, 0.1).toFixed(1) + ' ' + units[i];
  }
}

angular.module('app')
  .service('fileSize', fileSizeService);

},{}],27:[function(require,module,exports){
/** FLIPPER FEATURES SERVICE */
FlipperFeaturesService.$inject = ['$q', 'api', 'emitter'];
function FlipperFeaturesService($q, api, emitter) {
  var service = this;
  service.getFlipperFeatures = getFlipperFeatures;

  var flipperFeatures;

  // Become an emitter
  emitter.addEmitterLogicTo(service);

  function getFlipperFeatures(id) {
    return $q(function(resolve) {
      if (!flipperFeatures) {
        api
          .request('/issuer/organizations/get_flipper_features', { id: id })
          .then(function(response) {
            flipperFeatures = response.features;

            service.trigger('change', flipperFeatures);

            resolve(flipperFeatures);
          });
      } else {
        resolve(flipperFeatures);
      }
    });
  }
}

angular
  .module('app')
  .service('FlipperFeaturesService', FlipperFeaturesService);

},{}],28:[function(require,module,exports){
/** IMG - SERVICE
 *
 *    A simple service that can be used to parse image URLs.
 *
 *    Usage:
 *
 *      img.parse('https://s3.amazonaws.com/accredible-api-templates/1517397678529.png')
 *        .then(function(data){
 *          console.log(data);
 *        });
 *
 *    @author   David "oodavid" King
 */
imgService.$inject = ['$q'];
function imgService($q){
  var service = this;
  service.parse = parse;
  // Loads an image and returns details about it
  function parse(src){
    var deferred = $q.defer();
    var img = new Image();
    img.onload = function(){
      deferred.resolve({
        width: this.naturalWidth,
        height: this.naturalHeight,
        src: src,
        ext: src.split('.').pop().toLowerCase(),
      });
      delete img;
    }
    img.error = function(){
      deferred.reject();
      delete img;
    }
    img.src = src;
    return deferred.promise;
  }
}

angular.module('app')
  .service('imgService', imgService);

},{}],29:[function(require,module,exports){
/** URL - SERVICE
 *
 *    A simple service that can be used to parse URLs.
 *
 *    Includes logic that breaks up querystring hashstring
 *     into {key:value} objects - see "query" property
 *      Modified from this answer:
 *        http://stackoverflow.com/a/8486188/1122851
 *
 *    https://mathiasbynens.be/demo/url-regex
 *    https://gist.github.com/dperini/729294
 *
 *    Usage:
 *
 *      urlService.isValid('http://website.com:1234/path/?search=test#hash');
 *      urlService.parse('http://website.com:1234/path/?search=test#hash');
 *
 *    @author   David "oodavid" King
 */

var internalDomains = [
  'accredible.com',
  'credential.net',
  'badge.design',
  'coursefinder.io',
];

urlService.$inject = ['$location'];
function urlService($location){
  var service = this;
  service.isValid = isValid;
  service.parse = parse;
  // Create a re-usable DOM element for parsing
  var parser = document.createElement('a');
  // Validates an URL
  // gruber v2
  // var regexUrl = /^((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))$/i;
  // krijnhoetmer
  // var regexUrl = /^(^|[\s.:;?\-\]<\(])(https?:\/\/[-\w;/?:@&=+$\|\_.!~*\|'()\[\]%#,☺]+[\w/#](\(\))?)(?=$|[\s',\|\(\).:;?\-\[\]>\)])$/i;
  // diegoperini
  var regexUrl = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;
  function isValid(value){
    return !value || regexUrl.test(value);
  }
  // Parse a string into an URL
  function parse(href) {
    parser.href = href;
    // Pull values from our `parser` as it get's reused
    return {
      href: parser.href, // => "http://website.com:1234/path/?search=test#hash"
      protocol: parser.protocol, // => "http:"
      hostname: parser.hostname, // => "website.com"
      port: parser.port, // => "1234"
      pathname: parser.pathname, // => "/path/"
      search: parser.search, // => "?search=test"
      hash: parser.hash, // => "#hash"
      host: parser.host, // => "website.com:1234"
      query: getQuery(), // => { "search": "test" } :: This automatically uses the search or hash string containing the ?=&= structure
      external: isExternal(), // boolean
    };
  }
  // Add the curent domain as "internal"
  internalDomains.push($location.host());
  // Tests if the url is to an external site
  var tmp = [];
  for(var d=0,dl=internalDomains.length; d<dl; d++){
    var domain = internalDomains[d];
    tmp.push('^'+domain+'$');   // Exact match
    tmp.push('\\.'+domain+'$'); // ...plus subdomains
  }
  var regexInternal = new RegExp('('+tmp.join('|')+')', 'i');
  function isExternal(){
    if(parser.hostname && !regexInternal.test(parser.hostname)){
      return true;
    }
    return false;
  }
  // Looks for query-like values in the search or hash, then parses them into a {key:value} object
  function getQuery() {
    var encoded = false;
    var query = {};
    // Try the search, then the hash
    if (parser.search && parser.search.length > 1) {
      encoded = parser.search.substr(1);
    } else if (parser.hash) {
      // Look for a query
      var pos = parser.hash.indexOf('?');
      if (pos !== -1) {
        encoded = parser.hash.substr(pos + 1);
      } else {
        // ...it might be encoded
        pos = parser.hash.indexOf('%3F');
        if (pos !== -1) {
          encoded = parser.hash.substr(pos + 3);
        }
      }
    }
    // Parse the encoded query
    if (encoded) {
      encoded.split('&').forEach(function(part) {
        if (!part) {
          return;
        }
        part = part.split('+').join(' '); // replace every + with space, regexp-free version
        var eq = part.indexOf('=');
        var key = eq > -1 ? part.substr(0, eq) : part;
        var val = eq > -1 ? decodeURIComponent(part.substr(eq + 1)) : '';
        var from = key.indexOf('[');
        if (from == -1) {
          query[decodeURIComponent(key)] = val;
        } else {
          var to = key.indexOf(']');
          var index = decodeURIComponent(key.substring(from + 1, to));
          key = decodeURIComponent(key.substring(0, from));
          if (!query[key]) {
            query[key] = [];
          }
          if (!index) {
            query[key].push(val);
          } else {
            query[key][index] = val;
          }
        }
      });
    }
    // Lovely
    return query;
  }
}

angular
  .module('app')
  .service('urlService', urlService);

},{}],30:[function(require,module,exports){
uuidv4Service.$inject = [];
function uuidv4Service(){
  var service = this;
  service.generate = generate;

  var crypto = window.crypto || window.msCrypto; // For IE 11 compatibility
  function generate() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, function(c) {
      return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
    });
  }
}

angular
  .module('app')
  .service('uuidv4', uuidv4Service);

},{}],31:[function(require,module,exports){
/** ALERT SERVICE 2 :: PROMISES
 *
 *      We expose 3 alert types:
 *          alert        Shows a message with `ok`
 *          confirm      Shows a message with `cancel` and `ok`
 *          loading      Shows a loading spinner with `cancel`
 *          progress     Shows a progress-bar with `cancel`
 *          confirmWithCheckbox Shows a message with checkboxes that must be checked before 'ok' is enabled
 *
 *      Each type can use any of these styles:
 *          success, error, warning, info, question
 *
 *      The Progress Bar
 *          By default, the loading bar is "magic", it uses the
 *           same logic as `angular-loading-bar` to create an
 *           animated loading bar that never quite completes.
 *          However there is a method that allows you to manually
 *           update the progress bar and message. I have included
 *           logic here that guesses the ETA of the progress
 *           based on the time elapsed and progress percentage.
 *
 *      UI ROUTER
 *          This service prevents the user from navigating away
 *           from a route when an alert is visible. The old
 *           implementation allowed the user to move through
 *           their history (back and forward) buttons, but any
 *           visible alerts would remain visible, and callback
 *           logic would be bound to some non-existent view.
 *
 *      NOTES
 *          The alert service is NOT designed to work with
 *           more complex modals, with <forms> and the like.
 *          Consider a form using with submit-validate, this would
 *           need to layer an alert ON TOP of the modal when
 *           the form contains errors.
 *
 *      REFERENCES
 *          https://github.com/dwmkerr/angular-modal-service
 *          https://limonte.github.io/sweetalert2/
 *
 *      @author   David "oodavid" King
 */

alertService.$inject = ['$q', '$interval', '$injector', '$sce', '$timeout', '$filter'];
function alertService($q, $interval, $injector, $sce, $timeout, $filter) {
  var service = this;

  // Data
  service.data = {
    visible: false,
    title: false, // String OR false
    trustedContent: false, // Do we trust the content HTML?
    content: false, // HTML string OR false
    loading: false, // Spinner?
    progress: false, // Object OR false
    ok: false, // OK text
    triggerOk: triggerOk, // Method
    cancel: false, // Cancel text
    triggerCancel: triggerCancel, // Method
    triggerCheckCheckboxes: setAllCheckboxesChecked, // Method
    checkboxes: [],
    allCheckboxesChecked: false,
  };

  // Methods
  service.close = close;
  service.open = open;
  service.setProgress = setProgress;

  // Helper Methods (abstract to `open`)
  service.alert = alert;
  service.confirm = confirm;
  service.agree = agree;
  service.confirmWithCheckbox = confirmWithCheckbox;
  service.loading = loading;
  service.progress = progress;
  service.warning = warning;
  service.success = success;
  service.info = info;

  var translate = $filter('translate');

  function alert(title, content, width) {
    return open({
      title: title,
      content: content,
      ok: true,
      width: width,
    });
  }

  function confirm(title, content, ok, cancel, width) {
    return open({
      title: title,
      content: content,
      ok: ok == null ? true : ok,
      cancel: cancel == null ? true : cancel,
      width: width,
    });
  }

  function agree(title, content, ok, width) {
    return open({
      title: title,
      content: content,
      ok: ok == null ? true : ok,
      cancel: false,
      width: width,
    });
  }

  function confirmWithCheckbox(title, content, ok, cancel, width, checkboxData) {
    return open({
      title: title,
      content: content,
      ok: ok == null ? true : ok,
      cancel: cancel == null ? true : cancel,
      width: width,
      checkboxes: checkboxData,
    });
  }

  function loading(title, content) {
    return open({
      title: title,
      content: content,
      loading: true,
      cancel: true,
    });
  }

  function progress(title, content) {
    return open({
      title: title,
      content: content,
      loading: true,
      progress: true,
      cancel: true,
    });
  }

  function selectiveTranslate(string) {
    if (!string) {
      return string;
    }
    return (string.indexOf('@:') === 0 ? translate(string.substring(2)) : string).replace(/(?:\r\n|\r|\n)/g, '<br>');
  }

  function expand(validationErrors) {
    var output = '';
    validationErrors.forEach(function(item) {
      var message = '';
      if (item.key === 'minlength') {
        message = translate('validation.not-enough-chars');
      } else if (item.key === 'maxlength') {
        message = translate('validation.too-many-chars');
      } else {
        message = translate('validation.' + item.key, item.translateValues);
      }
      output += '<span>' + item.label + ' - ' + message + '</span><br>';
    });
    return output;
  }

  function warning(title, content, zIndex) {
    return open({
      title: selectiveTranslate(title),
      content: $.isArray(content) ? expand(content) : selectiveTranslate(content),
      infoType: 'warning',
      ok: translate('ok'),
      width: 400,
      zIndex: zIndex,
    });
  }

  function success(title, content) {
    return open({
      title: selectiveTranslate(title),
      content: selectiveTranslate(content),
      infoType: 'success',
      ok: translate('ok'),
      width: 400
    });
  }

  function info(title, content, cancel, cancelAction) {
    return open({
      title: selectiveTranslate(title),
      content: selectiveTranslate(content),
      infoType: 'info',
      cancel: cancelAction ? selectiveTranslate(cancel) : translate('cancel'),
      ok: translate('ok'),
      cancelAction: cancelAction,
      width: 400
    });
  }

  /** MODAL MANAGEMENT
   *
   *      The `alert`, `confirm`, `loading` and `progress`
   *       methods simply abstract to this method.
   */

  var resolve; // The alertService is a singleton, so
  var reject; //  we only keep one resolve and reject

  function open(options) {
    service.data.visible = true;
    service.data.title = options.title || false;
    service.data.trustedContent = options.trustedContent || false;
    service.data.content = parseContent(options.content);
    service.data.ok = (options.ok === true) ? 'ok' : (options.ok || false);
    service.data.cancel = (options.cancel === true) ? 'cancel' : (options.cancel || false);
    service.data.loading = options.loading || false;
    service.data.width = Number.isInteger(options.width) ? options.width + 'px' : 'none';
    service.data.infoType = options.infoType || false;
    service.data.cancelAction = options.cancelAction || false;
    service.data.checkboxes = options.checkboxes || [];
    service.data.zIndex = options.zIndex || null;
    setAllCheckboxesChecked();

    if (options.progress) {
      showProgressBar();
    } else {
      hideProgressBar();
    }
    return $q(function(myResolve, myReject) {
      resolve = function () {
        return myResolve();
      };
      reject = function () {
        return myReject();
      };
    });
  }

  function close() {
    service.data.visible = false;
    stopFakeProgress();
  }

  function triggerOk() {
    close();
    resolve('user pressed ok');
  }

  function triggerCancel() {
    close();
    if (service.data.cancelAction) {
      service.data.cancelAction();
    }
    reject('user pressed cancel');
  }
  /** PARSE CONTENT
   *
   *  We want HTML <p>Message</p>
   *  But may be given simple strings or an array of strings
   */
  function parseContent(content){
    var html = false;
    //
    if(angular.isArray(content)){
      // If the content is an array of strings process each line
      if (!angular.isObject(content[0])) {
        html = '';
        angular.forEach(content, function(line){
          html += toParagraph(line);
        });
        // If the content is an array of objects
      } else if (angular.isObject(content[0])) {
        angular.forEach(content, function(el){
          html += toParagraph(el.content);
        });
      }
    }
    //
    if(angular.isString(content)){
      html = toParagraph(content);
    }
    // Do we have something to return?
    if(html){
      // Do we trust the HTML?
      if(service.data.trustedContent){
        html = $sce.trustAsHtml(html);
      }
    }
    return html;
  }
  var hasOpeningTag = /\s*^<[a-z][\s\S]*>/i; // Checks for an opening tag
  function toParagraph(string){
    if(!hasOpeningTag.test(string)){
      string = '<p>'+string+'</p>';
    }
    return string;
  }
  /** PROGRESS
   *
   *      The progress bar can run "magically" or manually
   *
   *      Fake Progress
   *          The logic on incrementFakeProgress() is taken from
   *           the angular-loading-bar library, it's useful.
   */
  var progressStartTime;

  function hideProgressBar() {
    service.data.progress = false;
    stopFakeProgress();
  }

  function showProgressBar() {
    progressStartTime = false;
    service.data.progress = {
      value: null,
      total: null,
      pct: null,
      eta: null,
    };
    startFakeProgress();
  }

  function setProgress(value, total) {
    if (!service.data.progress) {
      service.data.progress = {}; // What does this signify? The consumer may have used `alertService.alert()` followed by `alertService.setProgress(3, 10)`. Assume they now want a progress bar
    }
    stopFakeProgress();
    service.data.progress.value = value;
    service.data.progress.total = total;
    service.data.progress.pct = service.data.progress.value / service.data.progress.total;
    // Calculate the eta
    if (value > 0 && total > 0) {
      // Once we have our first value, we can start the clock, the next pass will have the estimate
      if (!progressStartTime) {
        progressStartTime = Date.now();
        return;
      }
      var remaining = total - value;
      var elapsedMs = Date.now() - progressStartTime;
      var remainingMs = (elapsedMs / value) * remaining;
      // Humanize!
      var seconds = Math.round(remainingMs / 1000);
      var minutes = Math.floor(seconds / 60);
      seconds = seconds % 60;
      if(seconds){
        seconds = seconds === 1 ? '1 second' : seconds + ' seconds';
      }
      if(minutes){
        minutes = minutes === 1 ? '1 minute' : minutes + ' minute';
      }
      service.data.progress.eta = minutes ? 'About ' + minutes + ' and ' + seconds + ' remaining' : 'About ' + seconds + ' remaining';
    }
  }
  // Fake progress
  var fakeProgressInterval;
  var fakeProgress;

  function startFakeProgress() {
    stopFakeProgress();
    fakeProgress = 0;
    fakeProgressInterval = $interval(function() {
      incrementFakeProgress();
      service.data.progress.pct = fakeProgress;
    }, 200);
  }

  function stopFakeProgress() {
    if (fakeProgressInterval) {
      $interval.cancel(fakeProgressInterval);
    }
  }

  function incrementFakeProgress() {
    if (fakeProgress >= 1) {
      return;
    }
    var rnd = 0;
    var stat = fakeProgress;
    if (stat >= 0 && stat < 0.25) {
      rnd = (Math.random() * (5 - 3 + 1) + 3) / 100; // Start out between 3 - 6% increments
    } else if (stat >= 0.25 && stat < 0.65) {
      rnd = (Math.random() * 3) / 100; // increment between 0 - 3%
    } else if (stat >= 0.65 && stat < 0.9) {
      rnd = (Math.random() * 2) / 100; // increment between 0 - 2%
    } else if (stat >= 0.9 && stat < 0.99) {
      rnd = 0.005; // finally, increment it .5 %
    } else {
      rnd = 0; // after 99%, don't increment:
    }
    fakeProgress += rnd;
  }

  function setAllCheckboxesChecked() {
    if (service.data.checkboxes.length > 0) {
      service.data.allCheckboxesChecked = !service.data.checkboxes.some(function(checkbox) {
        return checkbox.value !== true;
      });
    } else {
      service.data.allCheckboxesChecked = false;
    }
  }

  /** UI ROUTER
   *
   *      If we are using ui-router, prevent
   *       redirects if there is a visible alert
   */
  if ($injector.has('$transitions') && $injector.has('$state') && $injector.has('ENV')) {
    var $transitions = $injector.get('$transitions');
    $transitions.onStart({}, function($transition) {
      // The transitions service has a bug; it sometimes triggers an event from and to the same page.
      if ($transition.from().name == $transition.to().name) {
        return;
      }
      // Don't transition when visible
      if (service.data.visible) {
        return false;
      }
    });
  }
}

var accAlertComponent = {
  controller: accAlertComponentController,
  templateUrl: '/shared/alert/alert.html',
};
accAlertComponentController.$inject = ['alertService', '$scope', '$element', '$injector'];
function accAlertComponentController(alertService, $scope, $element, $injector){
  var ctrl = this;
  ctrl.data = alertService.data;
  ctrl.data.$element = $element;
  ctrl.$onDestroy = onDestroy;

  // If required, manage the focus
  var modalIsolator = null;
  if ($injector.has('FocusManagerService')) {
    $scope.data = ctrl.data; // This is needed so that the ModalIsolator instance can watch $scope.data.visible
    var focusManagerService = $injector.get('FocusManagerService');
    modalIsolator = new focusManagerService.ModalIsolator($scope, $element); // To stop tabbing out of the modal
  }

  function onDestroy() {
    if (modalIsolator) {
      modalIsolator.cleanUp();
      modalIsolator = null;
    }
  }
}

angular
  .module('app')
  .service('alertService', alertService)
  .component('accAlert', accAlertComponent);

},{}],32:[function(require,module,exports){
/** SWEET ALERT SERVICE
 *
 *    @author   Ryan Booth
 */
angular
.module('app')
.factory('swalService', ['$timeout', '$window', '$filter', function($timeout, $window, $filter) {
  // SCROLL DOWN TO ADD / VIEW ALERT MESSAGES
  var swal = $window.swal;

  //so we can translate strings
  var translate = $filter('translate');

  // public methods
  var alertService = {
    showAlert: function(alertKey, errorCode) {
      alertHash[alertKey](errorCode);
    },
    confirm: function(message, callback, title, buttonText, buttonColor, cancelText, closeOnConfirm) {
      $timeout(function() {
        swal({
            title: title ? title : "Are you sure?",
            text: message,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: buttonColor ? buttonColor : "#37BDB1",
            cancelButtonText: cancelText ? cancelText : "Cancel",
            confirmButtonText: buttonText ? buttonText : "Confirm",
            closeOnConfirm: closeOnConfirm !== undefined ? closeOnConfirm : false
          },
          callback
        );
      });
      // See supportError for callback format
    },
    error: error,
  };

  // ACTION ALERTS
  function supportError(title, errorCode) {
    var message = translate('SUPPORT_ERROR_MESSAGE');
    if (errorCode) {
      message = message + "\n\n Error info: " + errorCode;
    }

    $timeout(function() {
      swal({
        title: title,
        text: message,
        type: 'error',
        showCancelButton: true,
        confirmButtonColor: "#37BDB1",
        confirmButtonText: translate('SUPPORT_ERROR_REFRESH'),
        cancelButtonText: translate('SUPPORT_ERROR_EMAIL_SUPPORT'),
        cancelButtonColor: "#d1d1d1",
        closeOnConfirm: true
      }, function(isConfirm) {
        if (isConfirm) {
          $window.location.reload();
        } else {
          $window.location = 'https://help.accredible.com/kb-tickets/new';
        }
      });
    });
  }

  function trigger(title, message, triggeredFunction) {
    $timeout(function() {
      swal({
        title: title,
        text: message,
        type: 'error',
        confirmButtonColor: "#37BDB1"
      }, triggeredFunction);
    });
  }

  // MESSAGE ALERTS
  function success(title, message) {
    $timeout(function() {
      swal({
        title: title,
        text: message,
        type: 'success',
        confirmButtonColor: "#37BDB1",
      });
    });
  }

  function error(title, message) {
    $timeout(function() {
      swal({
        title: title,
        text: message,
        type: 'error',
        allowOutsideClick: true
      });
    });
  }

  function warning(title, message) {
    $timeout(function() {
      swal(title, message, 'warning');
    });
  }

  function info(title, message) {
    $timeout(function() {
      swal(title, message, 'info');
    });
  }

  function genericAlert(title, message, type) {
    $timeout(function() {
      swal({
        title: title,
        text: message,
        type: type,
        confirmButtonColor: "#37BDB1"
      });
    });
  }

  //
  // Store alert messages here
  //
  var alertHash = {
    // Common Auth Errors
    authRequired: function(_) {
      error(
        translate('auth.not_signed_in_title'),
        translate('auth.not_signed_in_message')
      );
    },
    authForgottenPasswordEmailError: function(){
      error(
        translate('auth.forgotten_password_email_error_title'),
        translate('auth.forgotten_password_email_error_message')
      );
    },





    // next new error code is 012
    unknownFailure: function(errorCode) {
      supportError(
        translate('UNKNOWN_FAILURE_MESSAGE'),
        errorCode
      );
    },
    unauthorizedEditError: function(_) {
      error(
        translate('UNAUTHORIZED_HEADER'),
        translate('UNAUTHORIZED_MESSAGE')
      );
    },
    userMustLogin: function(_) {
      error(
        translate('USER_MUST_LOGIN_HEADER'),
        translate('USER_MUST_LOGIN_MESSAGE')
      );
    },
    registrationSuccess: function() {
      success(
        translate('REGISTRATION_ACCOUNT_CREATED'),
        translate('REGISTRATION_ACCOUNT_CREATED_MESSAGE')
      );
    },
    registrationError: function() {
      error(
        translate('REGISTRATION_FAILED')
      );
    },
    resendRegistrationSuccess: function() {
      success(
        translate('REGISTRATION_RESEND_TITLE'),
        translate('REGISTRATION_ACCOUNT_CREATED_MESSAGE')
      );
    },
    resendRegistrationError: function() {
      error(
        translate('REGISTRATION_RESEND_FAILED')
      );
    },
    signInError: function() {
      error(
        translate('LOGIN_FAILED'),
        translate('LOGIN_FAILED_MESSAGE')
      );
    },
    resetPasswordRequestError: function() {
      error(
        translate('PASSWORD_RESET_REQUEST_FAILED'),
        translate('PASSWORD_RESET_REQUEST_FAILED_MESSAGE')
      );
    },
    resetPasswordError: function() {
      error(
        translate('PASSWORD_RESET_FAILED'),
        translate('PASSWORD_RESET_FAILED_MESSAGE')
      );
    },
    /*
    signinFailure: function(_) {
      error(
        translate('CREDENTIAL_LOGIN_SIGN_IN_FAILED'),
        translate('CREDENTIAL_LOGIN_SIGN_IN_FAILED_CHECK_EMAIL')
      );
    },
    */
    credentialTokenFailure: function(_) {
      error(
        translate('CREDENTIAL_TOKEN_FAILURE_HEADER'),
        translate('CREDENTIAL_TOKEN_FAILURE_MESSAGE')
      );
    },
    // Evidence
    upsertEvidenceSuccess: function(errorCode) {
      success(
        translate('SUCCESS'),
        translate('UPSERT_EVIDENCE_SUCCESS_MESSAGE')
      );
    },
    upsertEvidenceFailure: function(errorCode) {
      supportError(
        translate('UPSERT_EVIDENCE_FAILURE_MESSAGE'),
        errorCode
      );
    },
    upsertEvidenceInvalid: function() {
      info(
        translate('UPSERT_EVIDENCE_FAILURE_INVALID_FILE_TYPE')
      );
    },
    deleteEvidenceFailure: function(errorCode) {
      supportError(
        translate('DELETE_EVIDENCE_FAILURE_MESSAGE'),
        errorCode
      );
    },
    deleteEvidenceSuccess: function(_) {
      success(
        translate('DELETE_EVIDENCE_SUCCESS_HEADER'),
        translate('DELETE_EVIDENCE_SUCCESS_MESSAGE')
      );
    },
    savePasswordSuccess: function(_) {
      success(
        translate('USER_SAVE_PASSWORD_SUCCESS_PASSWORD_SAVED'),
        translate('USER_SAVE_PASSWORD_SUCCESS_LOGIN_NEXT_TIME')
      );
    },
    savePasswordFailure: function(errorCode) {
      supportError(
        translate('SAVE_PASSWORD_FAILURE_MESSAGE'),
        errorCode
      );
    },
    shareEmailSuccess: function() {
      success(
        translate('EMAIL_SHARE_SUCCESS_TITLE'),
        translate('EMAIL_SHARE_SUCCESS_MESSAGE')
      );
    },
    contactSuccess: function(_) {
      genericAlert(
        "Thank you for your email",
        "We'll be in touch within 2 working days.",
        "success"
      );
    },
    contactFailure: function(_) {
      genericAlert(
        "Error with email",
        "Please check the form. If the problem persists, try support@accredible.com.",
        "error"
      );
    },
    signOutSuccess: function(_) {
      success(
        translate('SIGN_OUT_SUCCESS_MESSAGE'),
        ""
      );
    },
    resetEmailSuccess: function(_) {
      info(
        translate('RESET_EMAIL_SUCCESS_HEADER'),
        translate('RESET_EMAIL_SUCESS_MESSAGE')
      );
    },
    resetEmailFailure: function(_) {
      error(
        translate('RESET_EMAIL_FAILURE_HEADER'),
        translate('RESET_EMAIL_FAILURE_MESSAGE')
      );
    },
    resetPasswordSuccess: function(_) {
      success(
        translate('RESET_PASSWORD_SUCCESS_HEADER'),
        translate('RESET_PASSWORD_SUCCESS_MESSAGE')
      );
    },
    issuerResetTokenExpired: function(_) {
      error(
        "Please sign in",
        "You have been signed out for your security. Please sign in again."
      );
    },
    issuerResetTokenWrong: function(_) {
      error(
        "Token incorrect",
        "Sorry, but your reset password token is incorrect. Click below to request another token."
      );
    },
    issuerLoginFailure: function(_) {
      error(
        "Sign in failed",
        "Please check your email and password."
      );
    },
    issuerLoginThrottled: function(_) {
      error(
        "Too many incorrect sign in attempts",
        "Please try again in 1 minute."
      );
    },
    issuerSignUpFailure: function(errorCode) {
      error(
        "Error during sign up",
        "Details: \n" + errorCode
      );
    },
    issuerSignUpFailureEmailTaken: function() {
      error(
        "Email already used",
        "This email address is already connected to an account on Accredible."
      );
    },
    issuerPaymentFailure: function(errorCode) {
      error(
        "Error saving payment details",
        "Details: \n" + errorCode
      );
    },
    issuerMustLogin: function(_) {
      error(
        "Not signed in",
        "You may have been signed out for your security. Please sign in again."
      );
    },
    issuerCredentialsDeletedSuccess: function(numCredentials) {
      success(
        "Credentials deleted",
        (numCredentials || "The selected") + " Credentials were deleted."
      );
    },
    issuerCredentialsExpiredSuccess: function(numCredentials) {
      success(
        "Credentials expired",
        (numCredentials || "The selected") + " Credentials have been marked as expired."
      );
    },
    issuerPublishFailureCredits: function() {
      error(
        "Could not Publish Credentials",
        "This action takes you above your plan limit.\n\nGo to Billing to upgrade your plan."
      );
    },
    issuerPublishFailureGeneral: function(errorCode) {
      supportError(
        "Error publishing Credential",
        errorCode
      );
    },
    issuerPublishSuccess: function(publishResponse) {
      var title;
      var message;
      var published = publishResponse.published_count;
      var not_published = publishResponse.input_count - publishResponse.published_count;
      var sending_email = publishResponse.sending_email;
      // Published
      if (published == 1) {
        title = "Credential Published";
        message = "1 Credential has been published.";
      } else {
        title = "Credentials Published";
        message = published + " Credentials have been published.";
      }
      // Email sending is optional at an account level
      if (sending_email) {
        message += "\nAn email will be sent to the recipients now.";
      } else {
        message += "\nAn email will not be sent based on your settings.";
      }
      // Unpublished
      if (not_published == 1) {
        message += "\n\nPlease note that 1 Credential has not been published.";
      } else if (not_published > 1) {
        message += "\n\nPlease note that " + not_published + " Credentials have not been published.";
      }
      // And done
      success(
        title,
        message
      );
    },
    issuerSaveTeamMemberCreated: function() {
      success(
        "Team Member Created"
      );
    },
    issuerSaveTeamMemberSuccess: function() {
      success(
        "Team Member Updated"
      );
    },
    issuerSaveTeamMemberError: function(message) {
      error(
        "Could not save Team Member",
        message
      );
    },
    issuerDeleteTeamMemberError: function() {
      error(
        "Could not delete Team Member"
      );
    },
    issuerResendEmailSuccess: function() {
      success(
        "Invitation Email Re-sent"
      );
    },
    issuerResendEmailError: function() {
      success(
        "Could not re-send Invitation Email"
      );
    },
    issuerResendFailure: function(errorCode) {
      supportError(
        "Error sending emails",
        errorCode
      );
    },
    issuerResendSuccess: function(numCredentials) {
      success(
        "Credential email re-sent",
        (numCredentials || "The selected") + " Credential recipients will be getting an email soon."
      );
    },
    issuerSettingsSuccess: function(_) {
      success(
        "Account Updated",
        "Your account settings have been updated."
      );
    },
    issuerNameChangesSettingsSuccess: function(_) {
      success(
        "Settings Updated",
        "Your Name Change Requests Settings have been updated."
      );
    },
    issuerUploadProcessingError: function(_) {
      error(
        "Upload Failed",
        "There has been an issue processing your spreadsheet, our developers have been notified.\n\nYour CSV file has been saved to our system for analysis.",
        "success"
      );
    },
    issuerDeleteCredentialsFailure: function(errorCode) {
      supportError(
        "Error deleting Credentials",
        errorCode
      );
    },
    issuerExpireCredentialsFailure: function(errorCode) {
      supportError(
        "Error expiring Credentials",
        errorCode
      );
    },
    issuerDeleteEvidenceFailure: function(errorCode) {
      supportError(
        "Error deleting learner evidence",
        errorCode
      );
    },
    requestTimeout: function(_) {
      error(
        translate('REQUEST_TIMEOUT_HEADER'),
        translate('REQUEST_TIMEOUT_MESSAGE')
      );
    },
    issuerGetSSOLinkErrorTryLater: function() {
      error(
        "Could not retrieve Recipient Link at this time",
        "Please try again later"
      );
    },
    // Attributes
    upsertAttributeSuccess: function() {
      success(
        "Attribute saved successfully"
      );
    },
    upsertAttributeDuplicate: function() {
      error(
        "This attribute already exists."
      );
    },
    upsertAttributeFailure: function(message) {
      error(
        "Error saving attribute.",
        message
      );
    },
    deleteAttributeSuccess: function(_) {
      success(
        "Attribute deleted"
      );
    },
    deleteAttributeFailure: function(errorCode) {
      error(
        "Error deleting attribute",
        errorCode
      );
    },
    // Payments
    buyCreditsSuccess: function() {
      success(
        "Purchase successful",
        "Your recipient allowance has been updated."
      );
    },
    updateSubscriptionSuccess: function(_) {
      success(
        "Payment plan updated",
        "Your plan has been changed."
      );
    },
    updateSubscriptionError: function(err) {
      error(
        "Payment plan error",
        err
      );
    },
    updateCardSuccess: function(_) {
      success(
        "Payment details updated",
        "Your card has been saved for future purchases."
      );
    },
    updateCardError: function(err) {
      error(
        "Payment details were not updated",
        err
      );
    },
    createSubscriptionSuccess: function(_) {
      genericAlert(
        "Payment plan registered",
        "Thank you for setting up automatic payments! You can check your account status on this page at any time.",
        "success"
      );
    },
    paymentError: function(err) {
      error(
        "Payment Error",
        err
      );
    },
    subscriptionCancelled: function(_) {
      success(
        "Payment plan cancelled",
        "Your automatic payment plan has been cancelled. You will not be charged again."
      );
    },
    subscriptionCancelledError: function(errorCode) {
      supportError(
        "Error during cancellation",
        errorCode
      );
    },
    // Employment Directory
    employmentDirectorySavedSuccess: function() {
      success(
        "Settings saved successfully",
        "We will be in touch with you once we have reviewed your settings. It may take a few minutes for your changes to take effect."
      );
    },
    // Name change requests
    nameChangeApproveSuccess: function(){
      success(
        "Name Change Requests Approved"
      );
    },
    nameChangeApproveError: function(err){
      error(
        "Name Change Requests were not Approved",
        err
      );
    },
    nameChangeDenySuccess: function(){
      success(
        "Name Change Requests Denied"
      );
    },
    nameChangeDenyError: function(err){
      error(
        "Name Change Requests were not Denied",
        err
      );
    },


    verifySenderEmailSent: function(_) {
      success(
        "Verification email sent",
        "Please check your inbox and follow the instructions to verify your email address.\n\nOnce verified, your Accredible emails will be sent from this address."
      );
    },
    issuerBulkCSVDownloadSuccess: function(emailAddress) {
      success(
        "CSV Generating",
        "After a few minutes " + (emailAddress || "you") + " will receive an email with the CSV file for these Credentials."
      );
    },
    issuerVerificationEmailResent: function(_) {
      success(
        "Verification email resent",
        "Please check your email and follow the link to verify your email address."
      );
    },
    issuerVerificationEmailSuccess: function(_) {
      success(
        "Email Verified"
      );
    },
    issuerVerificationEmailFailure: function(_) {
      error(
        "Try Refreshing the page",
        "If you're not logged in automatically, click 'Resend verification email' to try again."
      );
    },
    cardUpdateSuccess: function(_) {
      genericAlert(
        "New Card Added",
        "Thank you. That card will be charged from now on.",
        "success"
      );
    },
    cardUpdateFailure: function(errorCode) {
      supportError(
        "Error saving card",
        errorCode
      );
    },
    emailAlreadyInUseError: function() {
      error(
        "Email Already in Use",
        "The email address you're trying to use is already in use on Accredible. Please use another email address."
      );
    },
    /*
    uploadImageFailure: function (errorCode) {
      error(
        "That file is not an image",
        errorCode
      );
    },
    employerEmailTaken: function(_) {
      error(
        "Email taken",
        "An account with that email already exists. Please login below if the account is yours."
      );
    },
    employerInvalidToken: function(_) {
      error(
        "Expired Login",
        "Please log back in to your employer account."
      );
    },
    loadMessagesFailure: function (errorCode) {
      supportError(
        "Error retrieving messages",
        errorCode
      );
    },
    sendMessageFailure: function(_) {
      error(
        "Error sending message",
        "Please try again, or copy your message and refresh the page."
      );
    },
    messageBlockedFailure: function(_) {
      error(
        "Messaging blocked",
        "Sorry, this user has blocked incoming messages."
      );
    },
    profileUserInvalidToken: function(_) {
      error(
        "Not Signed In",
        "Sign in to view your messages."
      );
    },
    profileUserNeedsLogin: function(_) {
      error(
        "Not Signed In",
        "Sign in to edit your profile."
      );
    },
    */
    // General / Utility
    formInvalid: function(_) {
      warning(
        translate('FORM_INVALID_PLEASE_CHECK_FORM'),
        translate('FORM_INVALID_REQUIRED')
      );
    },
    // Groups
    newGroupSuccess: function() {
      success(
        "New Group Created",
        "You must add a Certificate Design or Badge Design to the Group before adding Credentials."
      );
    },
    groupSaveSuccess: function() {
      success(
        "Group Saved"
      );
    },
    groupSaveSuccessNeedsDesign: function() {
      success(
        "Group Saved",
        "You must add a Certificate Design or Badge Design to the Group before adding Credentials."
      );
    },
    groupSaveFailure: function() {
      supportError(
        "Error saving Group"
      );
    },
    groupNameUpdateSuccess: function() {
      success(
        "Name updated"
      );
    },
    groupDuplicatesError: function() {
      error(
        " \"Allow Duplicates\" cannot be unchecked, there are already duplicates in the group"
      );
    },
    // Generalised Design Editor
    designDownloadFailure: function() {
      error(
        "Sorry, we could not generate your Badge Design"
      );
    },
    // Certificate Designs
    certificateDesignUpdateFailure: function(errorCode) {
      supportError(
        "Error Saving Certificate Design",
        errorCode
      );
    },
    certificateDesignNeedsNameError: function() {
      info(
        "Name your Certificate Design",
        "Your new Design needs a name, in order to find and edit it later."
      );
    },
    certificateDesignMobileDesignRemoved: function() {
      success(
        "Optional Mobile Design removed"
      );
    },
    certificateDesignNameUpdateSuccess: function() {
      success(
        "Name updated"
      );
    },
    certificateDesignMissing: function() {
      supportError(
        "Design missing",
        "The design you attempted to delete no longer exists."
      );
    },
    certificateDesignInUse: function() {
      error(
        "This design is still in use",
        "Please remove this design from the groups using it before deleting it."
      );
    },
    // Badge Designs
    badgeDesignUpdateSuccess: function() {
      success(
        "Badge Design Updated"
      );
    },
    badgeDesignUpdateFailure: function(errorCode) {
      supportError(
        "Error Saving Badge Design",
        errorCode
      );
    },
    badgeDesignNeedsNameError: function() {
      info(
        "Name your Badge Design",
        "Your new Design needs a name, in order to find and edit it later."
      );
    },
    badgeMakerUpdateFailure: function() {
      error(
        "Error Saving Badge Design"
      );
    },
    // Group :: Email Templates
    groupEmailUpdateSuccess: function() {
      success(
        "Email Templates Updated"
      );
    },
    duplicateIssuerUserFailure: function() {
      error(
        "Email already in use",
        "That email already has a dashboard account. They either exist within your organization already or within another organization. " +
        "Try using a different email or deleting the other account first."
      );
    },
    inviteIssuerUserSuccess: function() {
      success(
        "Invite sent",
        "They should receive the email in the next few minutes."
      );
    },
    inviteIssuerUserFailure: function() {
      supportError(
        "Error sending invite"
      );
    },
    issuerLoginDeleteSuccess: function() {
      success(
        "User Deleted"
      );
    },
    issuerLoginDeleteFailure: function() {
      supportError(
        "Error deleting user"
      );
    },
    issuerLoginAccountUpdateSuccess: function() {
      success(
        "Account Updated"
      );
    },
    issuerLoginAccountUpdateFailure: function() {
      supportError(
        "Error updating account"
      );
    },
    // User Permissions
    missingPermissions: function(errorCode) {
      error(
        "Access Denied",
        "You do not have permission to " + errorCode + ". Ask your administrator if you need this permission."
      );
    },
    // Permission Groups
    permissionGroupCreateSuccess: function() {
      success(
        "Permission Group Created"
      );
    },
    permissionGroupCreateFailure: function() {
      supportError(
        "Error creating Permission Group"
      );
    },
    permissionGroupDuplicateNameError: function() {
      error(
        "Duplicate name",
        "A Permission Group with that name already exists. Please change the name and try again."
      );
    },
    permissionGroupDeleteSuccess: function() {
      success(
        "Permission Group Deleted"
      );
    },
    permissionGroupDeleteFailure: function() {
      supportError(
        "Error deleting Permission Group"
      );
    },
    permissionGroupUpdateSuccess: function() {
      success(
        "Permission Group Saved"
      );
    },
    permissionGroupSaveFailure: function() {
      supportError(
        "Error saving Permission Group"
      );
    },
    // Send Preview
    sendPreviewSuccess: function(email) {
      success(
        "Example Credential Sent",
        "Check " + email + " for your example Credential."
      );
    },
    sendPreviewFailure: function() {
      error(
        "Error sending preview"
      );
    },
    editCredentialSuccess: function() {
      success(
        "Credential Updated"
      );
    },
    editCredentialInvalid: function(errorCode) {
      error(
        'Error saving Credential',
        errorCode
      );
    },
    editCredentialExpiryInvalid: function() {
      warning(
        'To update this credential\'s expiry date you must purchase more credits.'
      );
    },
    editCredentialGradeInvalid: function() {
      error(
        'Credential could not be updated',
        'The grade supplied must be a percentage (0 to 100).'
      );
    },
    editCredentialFailure: function() {
      supportError(
        "Error saving Credential"
      );
    },
    // Email Settings and Templates
    updateEmailSettingsSuccess: function() {
      success('Email Settings Saved');
    },
    updateEmailSettingsFailure: function() {
      error('Error Saving Email Settings');
    },
    upsertEmailTemplateSuccess: function() {
      success('Email Template Saved');
    },
    upsertEmailTemplateFailure: function() {
      error('Error Saving Email Template');
    },
    deleteEmailTemplateSuccess: function() {
      success('Email Template Deleted');
    },
    deleteEmailTemplateFailure: function() {
      error('Error Deleting Email Template');
    },
    resetEmailTemplateSuccess: function() {
      success('Email Template Reset');
    },
    resetEmailTemplateFailure: function() {
      error('Error Resetting Email Template');
    },
    previewEmailSentSuccess: function() {
      success('Email Preview Sent');
    },
    previewEmailSentFailure: function() {
      error('Error Sending Preview Email');
    },

    checkVerificationCodeError: function() {
      error(
        translate('CHECK_VERIFICATION_CODE_HEADER'),
        translate('CHECK_VERIFICATION_CODE_MESSAGE')
      );
    },
    checkVerificationCodeExpired: function() {
      error(
        translate('CHECK_VERIFICATION_CODE_EXPIRED_HEADER'),
        translate('CHECK_VERIFICATION_CODE_EXPIRED_MESSAGE')
      );
    },
    nameChangeSuccess: function() {
      success(
        translate('NAME_CHANGE_SUCCESS_HEADER'),
        translate('NAME_CHANGE_SUCCESS_MESSAGE')
      );
    },
    nameChangeRequestSuccess: function() {
      success(
        translate('NAME_CHANGE_REQUEST_SUCESS_HEADER'),
        translate('NAME_CHANGE_REQUEST_SUCESS_MESSAGE')
      );
    },
    nameChangeStillPending: function() {
      $timeout(function() {
        swal({
          title: translate('NAME_CHANGE_PENDING_TITLE'),
          text: translate('NAME_CHANGE_PENDING_TEXT'),
          type: 'info',
          showCancelButton: true,
          confirmButtonColor: "#37BDB1",
          confirmButtonText: translate('NAME_CHANGE_PENDING_OK'),
          cancelButtonText: translate('SUPPORT_ERROR_EMAIL_SUPPORT'),
          cancelButtonColor: "#d1d1d1",
          closeOnConfirm: true
        }, function(isConfirm) {
          if (isConfirm) {
            // do nothing
          } else {
            $window.location = 'http://help.accredible.com/hc/' + translate('HELP_CODE') + '/requests/new';
          }
        });
      });
    },
    nameChangeError: function(errorCode) {
      supportError(
        translate('ERROR_SENDING_NAME_CHANGE'),
        errorCode
      );
    },
    privacyChangeSuccess: function() {
      success(
        translate('PRIVACY_CHANGE_SUCCESS_HEADER'),
        translate('PRIVACY_CHANGE_SUCCESS_MESSAGE')
      );
    },
    privacyChangeError: function(errorCode) {
      supportError(
        translate('PRIVACY_CHANGE_ERROR_HEADER'),
        errorCode
      );
    },
    ssoEmailChange: function() {
      error(
        translate('SSO_EMAIL_CHANGE_ERROR_HEADER'),
        translate('SSO_EMAIL_CHANGE_ERROR_MESSAGE')
      );
    },
    errorSendingEmailChange: function(errorCode) {
      supportError(
        translate('ERROR_SENDING_NAME_CHANGE'),
        errorCode
      );
    },
    emailChangeSuccess: function() {
      success(
        translate('RECIPIENT_CHANGE_EMAIL_SUCCESS_HEADER'),
        translate('RECIPIENT_CHANGE_EMAIL_SUCCESS_MESSAGE')
      );
    },
    emailChangeCodeError: function() {
      error(
        translate('RECIPIENT_CHANGE_EMAIL_CODE_ERROR_HEADER'),
        translate('RECIPIENT_CHANGE_EMAIL_CODE_ERROR_MESSAGE')
      );
    },
    emailChangeCodeExpired: function() {
      error(
        translate('RECIPIENT_CHANGE_EMAIL_CODE_EXPIRED_HEADER'),
        translate('RECIPIENT_CHANGE_EMAIL_CODE_EXPIRED_MESSAGE')
      );
    },
    retrieveCertificatesSuccess: function() {
      success(
        translate('RETRIEVE_CERTIFICATES_SUCCESS_HEADER'),
        translate('RETRIEVE_CERTIFICATES_SUCCESS_MESSAGE')
      );
    },
    retrieveCertificatesEmailError: function() {
      error(
        translate('RETRIEVE_CERTIFICATES_EMAIL_ERROR_HEADER'),
        translate('RETRIEVE_CERTIFICATES_EMAIL_ERROR_MESSAGE')
      );
    },
    retrieveCertificatesError: function(errorCode) {
      supportError(
        translate('RETRIEVE_CERTIFICATES_ERROR_MESSAGE'),
        errorCode
      );
    },
    exportAnalyticsSuccess: function(email) {
      success(
        'Export successful',
        'An email will be sent to ' + email + ' with the file attached.'
      );
    },
    exportAnalyticsError: function(errorCode) {
      supportError(
        'Analytics export error',
        errorCode
      );
    },
    fileTooLargeError: function(size) {
      error(
        translate('FILE_TOO_LARGE'),
        translate('MAXIMUM_FILE_SIZE', {
          size: size
        })
      );
    },
    fileUploadError: function() {
      error(
        translate('FILE_UPLOAD_ERROR')
      );
    },
    urlRedirect: function(url) {
      $timeout(function() {
        swal({
          title: 'Login Failed',
          text: 'We could not log you in with those details, you can click OK return to: ' + url + '\n Only proceed if you trust the URL.',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: "#37BDB1",
          confirmButtonText: 'Proceed',
          cancelButtonText: 'Cancel',
          cancelButtonColor: "#d1d1d1",
          closeOnConfirm: true
        }, function(isConfirm) {
          if (isConfirm) {
            // this URL is sanitized to avoid script injection.
            var sanitizedURL = $window.sanitizeUrl(url);
            $window.location = sanitizedURL;
          } else {
            // do nothing
          }
        });
      });
    },
    // API Keys and settings
    createApiKeySuccess: function() {
      success(
        'New API key created',
        'Your new API key is now ready to use.');
    },
    createApiKeyError: function() {
      error(
        'Error creating API key',
        'Please try again.'
      );
    },
    deleteApiKeySuccess: function() {
      success('API key Deleted');
    },
    deleteApiKeyError: function() {
      error(
        'Error deleting API key',
        'Please try again.'
      );
    },
    /*
    issuerSESEmailTaken: function( ) {
      error(
        "Email already used",
        "The email address you entered is already in use by another Accredible account."
      );
    },
    */
  };

  return alertService;
}]);

},{}],33:[function(require,module,exports){
function slideAnimation(){
  var duration = 300;
  return {
    // ng-view, ng-include, ng-switch, ng-if, ng-repeat
    enter: function(element, doneFn) {
      jQuery(element).hide().slideDown(duration, doneFn);
    },
    leave: function(element, doneFn) {
      jQuery(element).slideUp(duration, doneFn);
    },
    // ng-class (which includes: ng-show, ng-hide)
    addClass: function(element, classesToAdd, doneFn) {
      if(classesToAdd && classesToAdd.indexOf('ng-hide') !== -1){
        jQuery(element).slideUp(duration, doneFn);
      } else {
        doneFn();
      }
    },
    removeClass: function(element, classesToRemove, doneFn) {
      if(classesToRemove && classesToRemove.indexOf('ng-hide') !== -1){
        jQuery(element).hide().slideDown(duration, doneFn);
      } else {
        doneFn();
      }
    },
  };
}

function fadeAnimation(){
  var duration = 400;
  return {
    // ng-view, ng-include, ng-switch, ng-if, ng-repeat
    enter: function(element, doneFn) {
      jQuery(element).hide().fadeIn(duration, doneFn);
    },
    leave: function(element, doneFn) {
      jQuery(element).fadeOut(duration, doneFn);
    },
    // ng-class (which includes: ng-show, ng-hide)
    addClass: function(element, classesToAdd, doneFn) {
      if(classesToAdd && classesToAdd.indexOf('ng-hide') !== -1){
        jQuery(element).fadeOut(duration, doneFn);
      } else {
        doneFn();
      }
    },
    removeClass: function(element, classesToRemove, doneFn) {
      if(classesToRemove && classesToRemove.indexOf('ng-hide') !== -1){
        jQuery(element).hide().fadeIn(duration, doneFn);
      } else {
        doneFn();
      }
    },
  };
}

animationConfig.$inject = ['$animateProvider'];
function animationConfig($animateProvider){
  // Only animate elements with `animate` in the class, this gives us a performance boost:
  //   https://www.bennadel.com/blog/2935-enable-animations-explicitly-for-a-performance-boost-in-angularjs.htm
  $animateProvider.classNameFilter(/animate/i);
}

angular
  .module('app')
  .animation('.animate-slide', [slideAnimation])
  .animation('.animate-fade', [fadeAnimation])
  .config(animationConfig);

},{}],34:[function(require,module,exports){
/** ATTRIBUTE FILTERS
 *
 *    Utility filter that helps render attribute names,
 *     noting the following edge-case:
 *
 *        Default attributes have translated names (see `en.json` etc.)
 *        Custom attributes have user-defined names
 *
 *    @author   David "oodavid" King
 */
angular.module("app")
  // Returns the attribute name if available, or pipes the tag through the translation system
  .filter("attributeName", ["$filter", function($filter) {
    return function(attribute) {
      return attribute.name || $filter('translate')(attribute.tag);
    };
  }]);

},{}],35:[function(require,module,exports){
/** BASIC FILTERS
 *
 *    These filters can be used for any number of common formatting
 *     requirements such as:
 *
 *        Highlighting search strings
 *        Getting permalink URL from a { credential } object
 *        Capitalizing strings
 *
 *    @author   David 'oodavid' King
 */
require('./_services/encode.service.js');

angular
  .module('app')
  // Returns a the URL for a Certificate PDF
  .filter('certficatePdfUrl', ['api', function(api) {
    return function(credential) {
      return api.getURL('/credential/generate_certificate_pdf?credential_id=' + credential.id + '&mode=pdf&key=' + credential.private_key);
    };
  }])
  // Returns a the URL for a Certificate PDF - at print quality
  .filter('certficatePdfPrintUrl', ['api', function(api) {
    return function(credential) {
      return api.getURL('/credential/generate_certificate_pdf?credential_id=' + credential.id + '&mode=print&key=' + credential.private_key);
    };
  }])
  // Returns a the URL for a Baked Badge Image
  .filter('bakedBadgeUrl', ['api', function(api) {
    return function(credential) {
      return api.getURL('/credential/generate_baked_badge?credential_id=' + credential.id + '&key=' + credential.private_key);
    };
  }])
  // Returns the URL for a Credential Recipient Page
  .filter('credentialRecipientUrl', ['ENV', function(ENV) {
    return function(credential) {
      if (credential.url && ENV.type === 'production') {
        return credential.url;
      } else {
        // var domain = 'https://www.credential.net/'; // Production environment
        // if (credential && credential.issuer && credential.issuer.whitelisted_domain) {
        //   domain = credential.issuer.whitelisted_domain; // Whitelabel URL takes precedence
        // } else if (ENV.name !== 'production') {
        //   domain = 'https://'+ENV.name+'.credential.net/'; // Test environment
        // }
        var domain;
        if (credential && credential.issuer && credential.issuer.whitelisted_domain) {
          domain = credential.issuer.whitelisted_domain; // Whitelabel URL takes precedence
        } else {
          domain = 'https://' + (ENV.prefix === '' ? 'www.' : ENV.prefix) + 'credential.net/'; // Domain is based on environment
        }
        var slug = (credential.uuid || credential.encoded_id || credential.id); // Always use the encoded_id, but fallback to the numerical id for belts and braces
        var key = credential.private ? '?key=' + credential.private_key : '';
        return domain + slug + key;
      }
    };
  }])
  // Returns the URL for a Verification Directory
  .filter('directoryUrl', ['ENV', function(ENV) {
    return function(username) {
      var domain = 'https://' + ENV.prefix + 'directory.credential.net/';
      return domain + username;
    };
  }])
  // Returns the URL for a Credential Embed Page
  .filter('credentialEmbedUrl', ['$filter', 'urlService', function($filter, urlService) {
    return function(credential) {
      // Grab the normal Recipient URL
      var recipientUrl = $filter('credentialRecipientUrl')(credential);
      // Prepend with '/embed'
      var link = urlService.parse(recipientUrl);
      // This little '/' dance is because IE parses URLs differently - do'h!
      recipientUrl = recipientUrl.replace(link.pathname, (link.pathname.indexOf('/') === 0 ? '/' : '') + 'embed' + (link.pathname.indexOf('/') !== 0 ? '/' : '') + link.pathname);
      return recipientUrl;
    };
  }])
  // Returns a human URL by stripping out the https://www. part
  .filter('humanUrl', function(){
    return function(string){
      if(string){
        return string.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '');
      }
    };
  })
  // Highlights search matches on a string
  .filter('highlight', ['encodeService', '$sce', function(encodeService, $sce) {
    return function(input, highlight) {
      if (input) {
        input = encodeService.encode(input);
        if (highlight) {
          highlight = encodeService.encode(highlight);
          // Clean the highlight string for regex use - http://stackoverflow.com/a/3561711/1122851
          var clean = highlight.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
          var regex = new RegExp('(' + clean + ')', 'gi');
          var result = input.replace(regex, '<mark>$1</mark>');
          return $sce.getTrustedHtml(result);
        }
        return $sce.getTrustedHtml(input);
      }
      return $sce.getTrustedHtml('');
    };
  }])
  // Capitalizes the first letter in a sentence - http://codepen.io/WinterJoey/pen/sfFaK
  .filter('capitalize', function() {
    return function(input) {
      return (!!input) ? input.replace(/([^\W_]+[^\s-]*) */g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1);
      }) : '';
    };
  })
  // Converts newline to break
  .filter('nl2br', ['encodeService', '$sce', function(encodeService, $sce) {
    return function(input) {
      if (input) {
        input = encodeService.encode(input); // Don't trust the input
        input = input.replace(/\n\r?/g, '<br />'); // Replace newlines with <br>
        return $sce.getTrustedHtml(input); // Trust our new <br> characters
      }
      return;
    };
  }])
  // Converts an object into an array. Useful for using an object with ng-repeat, sort and filter - https://github.com/petebacondarwin/angular-toArrayFilter/blob/master/toArrayFilter.js
  .filter('toArray', function() {
    return function(obj, addKey) {
      if (!angular.isObject(obj)) return obj;
      if (addKey === false) {
        return Object.keys(obj).map(function(key) {
          return obj[key];
        });
      } else {
        return Object.keys(obj).map(function(key) {
          var value = obj[key];
          return angular.isObject(value) ?
            Object.defineProperty(value, '$key', {
              enumerable: false,
              value: key
            }) : {
              $key: key,
              $value: value
            };
        });
      }
    };
  })
  // Trust the HTML, but strip unsafe content (injection etc)
  .filter('trustedHtml', ['$sce', function($sce) {
    return function(input) {
      return $sce.getTrustedHtml(input);
    };
  }])
  // Trust the resource
  .filter('trustedResource', ['$sce', function($sce) {
    return function(url) {
      return $sce.trustAsResourceUrl(url);
    };
  }])
  // Parses a date, in the given format
  .filter('parseDate', ['$filter', function($filter) {
    return function(dateString, inputFormat, outputFormat, invalidString) {
      if (dateString) {
        var day;
        var month;
        var year;
        var regex = /(\d+)\D+(\d+)\D+(\d+)/;
        var m = regex.exec(dateString);
        if (!m) {
          return invalidString || 'Invalid Format';
        }
        switch (inputFormat) {
          case 'DD/MM/YYYY':
            day = m[1];
            month = m[2];
            year = m[3];
            break;
          case 'MM/DD/YYYY':
            day = m[2];
            month = m[1];
            year = m[3];
            break;
          case 'YYYY/MM/DD':
            day = m[3];
            month = m[2];
            year = m[1];
            break;
        }
        if(year && year.length == 2){
          year = 20+year; // 18 = 2018
        }
        var date = new Date(+year, (+month - 1), +day, 12, 0, 0);
        if (date && date.getTime()) {
          return $filter('date')(date, (outputFormat || 'mediumDate'));
        } else {
          return invalidString || 'Invalid Format';
        }
      }
    };
  }])
  // Returns the recipient group page url for a given group
  .filter('groupPageLink', ['ENV', function (ENV) {
    return function (group) {
      var url = 'https://';
      url += (ENV.prefix === '' ? 'www.' : ENV.prefix);
      return url + 'credential.net/group/' + group.id;
    };
  }])
  // Replace spaces with underscores
  .filter('spacesToUnderscores', function () {
    return function (input) {
        return input.replace(/ /g, '_');
    };
  })
  // Replace underscores with spaces
  .filter('underscoresToSpaces', function () {
    return function (input) {
        return input.replace(/_/g, ' ');
    };
  })
  // Absolute (positive) value
  .filter('absolute', function() {
    return function(num) {
      return Math.abs(num);
    };
  })
  // Break on dot
  .filter('breakOnDot', function () {
    return function (input) {
        return input.replace(/\./g, '.<wbr>');
    };
  })
  // Replace all but last 4 characters with '*' cap length at 16 characters
  .filter('mask', function() {
  return function(input) {
    if (input.length > 16) {
      return input.replace(/[\w ](?=[\w ]{4})/g, '*').substring(input.length - 16);
    } else {
      return input.replace(/[\w ](?=[\w ]{4})/g, '*');
    }
  };
});

},{"./_services/encode.service.js":25}],36:[function(require,module,exports){
/** BUTTON COLOR DIRECTIVE
 *
 *    <button type="button" button-color palette="suggestedColors" ng-model="myColor" class="button small">&nbsp;</button>
 *
 *  Styling - _form.scss
 *
 *    @author   David "oodavid" King
 */
angular.module('app')
  .directive('buttonColor', ['$timeout', function($timeout) {
    var update = function(scope, element, color) {
      $timeout(function(){
        $(element).css('background-color', color.toHexString());
        if(scope.onColorMove){
          scope.onColorMove({
            $event: {
              color: color.toHexString(),
            }
          });
        }
      });
    };
    // The directive
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        ngModel: '=',
        palette: '<?',
        onColorMove: '&?',
      },
      link: function(scope, element, attrs, ngModelCtrl) {
        var destroyed = false;
        $(element).spectrum({
          color: '#000',
          showButtons: false,
          showInitial: true,
          // Allow manual input
          preferredFormat: 'hex',
          showInput: true,
          // Palette
          showPalette: false, // Don't show palette of selected colours
          showSelectionPalette: true,
          hideAfterPaletteSelect: true,
          // Events
          move: function(color) {
            update(scope, element, color);
          },
          change: function(color) {
            if (!destroyed) { // To prevent ngModelCtrl.$setViewValue being called after destroy
              update(scope, element, color);
              ngModelCtrl.$setViewValue(color.toHexString());
            }
          },
          beforeShow: function(color) {
            var value = ngModelCtrl.$viewValue || ngModelCtrl.$modelValue;
            $(element).spectrum('option', 'palette', scope.palette || []);
            $(element).spectrum('set', value);
          },
        });
        element.on('$destroy', function() {
          destroyed = true;
          $(element).spectrum('destroy');
        });
        $(element).on('dragstop.spectrum', function(e, color) {
          ngModelCtrl.$setViewValue(color.toHexString());
        });
        ngModelCtrl.$render = function() {
          $(element).css('background-color', ngModelCtrl.$viewValue);
        };
      },
    };
  }]);

},{}],37:[function(require,module,exports){
/** CERTIFICATE EDITOR DIRECTIVE
 *
 *  In your view
 *     <certificate-editor></certificate-editor>
 *
 */


// This SHOULD be better
// This is a quick refactor and didn't want to spend time updating $scope to $ctrl
// Sorry.
require('./directives/autoRemoveAttributesDirective.js');
require('./directives/certificateScaleTextDirective.js');
require('./directives/draggableDirective.js');
require('./directives/resizableDirective.js');

// Preload the template so we don't get any delay
certificateEditorDirectivePreload.$inject = ['$templateCache', '$http'];
function certificateEditorDirectivePreload($templateCache, $http){
  $http.get('/shared/certificate-editor/certificate-editor.html', { cache: $templateCache });
}

// Component
certificateEditorDirective.$inject = [];
function certificateEditorDirective() {
  return {
    restrict: 'E', // Element only
    templateUrl: '/shared/certificate-editor/certificate-editor.html',
    controller: certificateEditorComponentController,
    scope: {
      design: '<',
      onClose: '&'
    }
  };
}
// ...original controller (largely unchanged)
certificateEditorComponentController.$inject = ['$scope', '$timeout', '$window', '$q', '$element', 'CertificateService', 'swalService', 'AnalyticsService', 'fontService', '$uibModal', 'HistoryFactory', 'certificateDimensions', '_', 'attributeService', 'languageService'];
function certificateEditorComponentController($scope, $timeout, $window, $q, $element, CertificateService, swalService, AnalyticsService, fontService, $uibModal, HistoryFactory, certificateDimensions, _, attributeService, languageService) {

  // This is used to allow errorless external embedding
  $scope.authorized = !!(localStorage.getItem('authorization'));

  // Push a dummy state to represent the editor pop-up in the browser history
  $window.history.pushState({ editor: true }, 'Certificate Editor');
  // When that state is popped, run the editor close functionality
  $window.onpopstate = function() {
    var closed = $scope.doClose();
    if (!closed) {
      $window.history.pushState({ editor: true }, 'Certificate Editor'); // Put the dummy state back
    }
  };

  $scope.inputRadiosOptions = [
    { value: 'us-letter', title: 'US-Letter' },
    { value: 'a4', title: 'A4' },
    { value: 'a8', title: 'A8', dataCy: 'a8' }
  ];

  // $scope.design - see Directive scope
  var savedDesign = $scope.design.id ? $scope.design : null; // This gets updated when we save, meaning we can respond with the actual design, when closing
  $scope.isDefault = !$scope.design.id; // Flag dictating whether we're editing a NEW design. Not sure what this does actually.
  $scope.sharedData = {
    selectedBlock: false, // Pointer to the currently active block
    isEditing: false, // Are we editing the selected block?
  };

  $scope.certificateElement = document.querySelector('.certificate-editable');
  // Selected block is handled with this variable to show pixels in the UI but send % to the BE when necessary (text blocks)
  $scope.selectedBlock = {
    element: null,
    isTextBlock: false,
    height : 0,
    width: 0,
    minHeight: 1,
    minWidth: 1,
  };

  $scope.checkTextBlockSize = function(block) {
    if (!block.image_height) {
      $scope.selectedBlock.height = null;
    }
  };

  // The default font
  var defaultColor = '#000000';
  var defaultFont = 'Source Sans Pro';
  var defaultFontWeight = 400;

  // Languages
  $scope.languagesOptions = getLanguagesOptions(Object.values(languageService.getLanguages()));

  /** PARSE DESIGN FROM BACKEND
   *
   *      In order to simplify the "stack" order of the designs
   *       we've decided to no-longer use z-index, but rely on
   *       natural DOM order. This solves a number of problems
   *       that are rather subtle, but thoroughly annoying.
   *
   *      Anyhow, we pre-parse the design to "apply" any z-index
   *       values, how do we do this?
   *          blocks: [
   *              { id: 1, z_index: null },
   *              { id: 2, z_index: null },
   *              { id: 3, z_index: 5 },
   *              { id: 4, z_index: 2 },
   *              { id: 5, z_index: null },
   *              { id: 6, z_index: 0 },
   *              { id: 7, z_index: -3 },
   *              { id: 8, z_index: -3 },
   *              { id: 9, z_index: -3 },
   *          ]
   *      Must become
   *          blocks: [
   *              { id: 1, z_index: null },
   *              { id: 2, z_index: null },
   *              { id: 5, z_index: null },
   *              { id: 7, z_index: -3 },
   *              { id: 8, z_index: -3 },
   *              { id: 9, z_index: -3 },
   *              { id: 6, z_index: 0 },
   *              { id: 4, z_index: 2 },
   *              { id: 3, z_index: 5 },
   *          ]
   *
   *      We also remove any `mobile` blocks
   *
   *      We also need to make sure that all blocks have a font
   *       default value, do that now.
   */
  var parseDesignFromBackend = function() {
    $scope.design.blocks.sort(function(a, b) {
      // Z-Indexes (even with zero, or negative values) must bubble to the top
      var zA = a.hasOwnProperty('z_index') ? a.z_index : false;
      var zB = b.hasOwnProperty('z_index') ? b.z_index : false;
      if (zA !== false || zB !== false && zA != zB) {
        return zA - zB;
      }
      // Otherwise, use id-order
      return a.id - b.id;
    });
    // Used colors
    var colors = {};
    // Remove all `mobile` blocks
    _.remove($scope.design.blocks, { mobile: true });
    $scope.hasQRCode = false;
    // Loop
    for (var b = 0, bl = $scope.design.blocks.length; b < bl; b++) {
      $scope.design.blocks[b]['block_index'] = b;
      var block = $scope.design.blocks[b];
      // Remove the redundant `z-index` and `mobile` values
      delete block.z_index;
      // Apply the default font and font_weight if needed
      if (block.hasOwnProperty('model')) {
        block.font = block.font || defaultFont;
        block.color = block.color || defaultColor;
        var weight = block.font_weight || (block.bold ? 700 : defaultFontWeight);
        block.font_weight = fontService.getNearestWeight(block.font, weight);
        if (!block.image_width){
          block.image_width = (100-(parseFloat(block.left || 0)))+'%';
          delete block.align;
        }
      }
      if (block.qr_code) {
        $scope.hasQRCode = true;
      }
      // Store the color
      colors[block.color] = true;
    }
    // Update the color picker to use these colors
    localStorage.setItem('spectrum.acms', Object.keys(colors).join(',')); // See: inputColorDirective
  };
  parseDesignFromBackend();

  // This is the opposite
  var getDesignPayload = function() {
    // Don't pollute local variables
    var design = angular.copy($scope.design);
    // Loop
    var z = 1;
    angular.forEach(design.blocks, function(block) {
      // Apply z_index values
      //  eventually the BE will not save blocks as seperate objects
      //  and will simply store the entire design as a JSON object, which
      //  will render the need for z_index completely redundant.
      block.z_index = z;
      z++;
    });
    // Return the clean design
    return design;
  };

  // This tracks the user's bleed preference, and starts unset
  var bleedState = null;

  /** HISTORY
   *
   *    Track the design object, and the "state" object
   *
   *    This is closely related to the "unsaved changes"
   *     logic, when triggering undo and redo, we want to:
   *
   *    @author David "oodavid" King
   */
  var History = new HistoryFactory($scope.design, $scope.sharedData);
  $scope.canUndo = History.canUndo;
  $scope.canRedo = History.canRedo;
  function doAction(action) {
    action();
    repairSelectedBlockPointer();
    checkDesktopBackgroundSize(true, true);
    // Reinstate historical bleed state
    bleedState = $scope.design.background_bleeds;
    // Check for QR code
    $scope.hasQRCode = false;
    for (var i = $scope.design.blocks.length - 1; i >= 0; i--) {
      if ($scope.design.blocks[i].qr_code) {
        $scope.hasQRCode = true;
        break;
      }
    }
  }
  $scope.undoAction = function() {
    doAction(History.undo);
  };
  $scope.redoAction = function() {
    doAction(History.redo);
  };
  $scope.pushState = function() {
    History.save(); // Saves the current state to the history object
  };

  /** SAVE
   *
   *    The save function still needs refactoring, it's messy
   *     (and elsewhere), however we need a canSave method.
   *
   *    @author David "oodavid" King
   */
  var saveTime = History.timestamp; // The timestamp for the edit that we have saved (see the save routine for this)
  $scope.canSave = function() {
    return History.timestamp != saveTime;  // If the time that we saved is different to the current History
  };

  /** UNSAVED CHANGES
   *
   *    This (small) hack was to replace the broken unsaved-changes
   *     logic with a fully functional, tested and de-coupled
   *     custom Directive named unsaved-changes.
   *
   *    Take a peek at design_editor.html to see that we have
   *     created a (hidden) form, that registers to the scope as
   *     formCtrl. We access that form controller here and set
   *     the $dirty or $pristine property on the form by watching
   *     the $scope.canSave() method above.
   *
   *    If this returns true, then we make the form $dirty, which
   *     by virtue of our custom unsaved-changes Directive
   *     deals with the blocking confirm / modal.
   *
   *    @author David "oodavid" King
   */
  $scope.formBuster = {}; // A MEGA hacky way of gaining access to the form controller. Have mercy
  $scope.$watch($scope.canSave, function(newVal) {
    // Make sure the formCtrl has registered to the scope
    if ($scope.formBuster && $scope.formBuster.formCtrl) {
      // If it's truthy, make the form $dirty
      if (newVal) {
        $scope.formBuster.formCtrl.$setDirty();
      } else {
        $scope.formBuster.formCtrl.$setPristine();
      }
    }
  });

  function tidyUpHistoryState() {
    // Remove the dummy state if it's still there
    if ($window.history.state && $window.history.state.editor) {
      $window.onpopstate = null;
      $window.history.back();
    }
  }

  // When we click "close", review the unsaved changes
  $scope.doClose = function(){
    // Make sure the formCtrl has registered to the scope
    if ($scope.formBuster && $scope.formBuster.formCtrl) {
      var formScope = angular.element($scope.formBuster.formCtrl.$$element[0]).scope();
      var canClose = formScope.unsavedChangesCanClose();
      if (canClose) {
        var expressionHandler = $scope.onClose();
        expressionHandler($scope.design); // Manually trigger the function passing $scope.design as the only argument
        tidyUpHistoryState();
        return true;
      }
      return false;
    }
    tidyUpHistoryState();
    return true;
  };

  var replaceDesign = function(design, dontSaveChanges) { // dontSaveChanges is used here to allow the bleed setting to be deferred to checkDesktopBackgroundSize
    if (!$scope.design.id && design.id){
      $scope.design.id = design.id;
    }
    $scope.design.size = design.size;
    $scope.design.orientation = design.orientation;
    if (!dontSaveChanges) {
      $scope.design.background_bleeds = design.background_bleeds;
    }
    $scope.design.background = design.background;
    $scope.design.blocks = design.blocks;
    $scope.design.custom_attributes = design.custom_attributes;
    parseDesignFromBackend();
    if (!dontSaveChanges) {
      $scope.pushState();
    }
    $scope.isDefault = false;
  };

  /** SIDEBAR HANDLING
   *
   *    @author Andrew Bateman
   */

  // Start with existing designs visible
  $scope.currentTab = $scope.authorized ? 'myDesigns' : 'document';
  $scope.showSummary = true;
  $scope.showSidebarMain = true;

  $scope.activateTab = function(tab) {
    $scope.currentTab = tab;
    $scope.showSummary = true;
    $timeout(function() {
      $scope.showSidebarMain = true;
    });
  };

  $scope.sidebarColumns = 2;
  $scope.columnSwitching = false;
  $scope.displayColumns = function(count) {
    if (count !== $scope.sidebarColumns) {
      $scope.columnSwitching = true;
      $scope.sidebarColumns = count;
      $timeout(function() {
        $scope.columnSwitching = false;
      });
    }
  };

  function setLanguageDescription(designs) {
    return designs.map(function(design) {
      var language = languageService.getLanguageFromCodeNoDefault(design.language);
      if(language) {
        design.languageDescription = language.description;
      }
      return design;
    });
  }

  function getLanguagesOptions(languages) {
    var options = [];
    languages.forEach(function (language){
        language.languageDescription = getLanguageFullDescription(language);
        options.push(language);
    });

    return options.sort( function(lang1, lang2) {
      return lang1.languageDescription > lang2.languageDescription ? 1 : -1; });
  }
  function getLanguageFullDescription(language) {
    return language.description.concat(language.value !== 'en' && language.value !== 'en-gb' ? ' - ' + language.name : '');
  }

  function categorizeDesigns(designs) {
    var categorizedDesigns = {
      'total': designs.length,
      'a4': {
        landscape: [],
        portrait: []
      },
      'a8': {
        landscape: [],
        portrait: []
      },
      'us-letter': {
        landscape: [],
        portrait: []
      }
    };
    designs.forEach(function(design) {
      categorizedDesigns[design.size][design.orientation].push(design);
    });
    return categorizedDesigns;
  }

  $scope.existingDesigns = {};
  $scope.templateDesigns = {};

  $scope.displayPageSize = 10;
  function loadDesigns(designs, showTemplates) {
    designs.loading = true;
    return CertificateService
      .getDesigns({
        page_size: 1000, // Get all designs
        page: '',
        design_identifier: '', // Fulltext search
        kind: 'certificate' // Only show certificate designs
      }, showTemplates)
      .then(function (response) {
        designs.loading = false;
        response.designs = setLanguageDescription(response.designs);
        designs.designs = categorizeDesigns(response.designs);
        if (showTemplates) {
          designs.attributes = ['a4', 'a8', 'us-letter', 'landscape', 'portrait'];
        } else {
          designs.metadata = response.meta;
        }
      });
  }

  $scope.designInfo = function(design) {
    return design.name;
  };

  function selectDesigns(size, orientation, designs) {
    var filteredDesigns = designs.designs[size][orientation];
    designs.current_page = 1;
    designs.total_pages = Math.ceil(filteredDesigns.length / $scope.displayPageSize);
    designs.size = size;
    designs.orientation = orientation;
    $scope.showSummary = false;
    return filteredDesigns;
  }

  $scope.selectTemplates = function(size, orientation) {
    $scope.filteredTemplateDesigns = selectDesigns(size, orientation, $scope.templateDesigns);
    $scope.selectTemplatePage(1);
  };

  $scope.selectExistingDesigns = function(size, orientation) {
    $scope.filteredExistingDesigns = selectDesigns(size, orientation, $scope.existingDesigns);
  };

  $scope.selectExistingPage = function(pageNumber) {
    $scope.existingDesigns.current_page = pageNumber;
    $scope.existingDesignsFrom = (pageNumber - 1) * $scope.displayPageSize;
  };

  if ($scope.authorized) {
    $q.all([loadDesigns($scope.existingDesigns, false), loadDesigns($scope.templateDesigns, true)])
      .then(function(){
        if ($scope.existingDesigns.designs.total === 0) {
          $scope.currentTab = 'templates';
          $scope.showSummary = true;
        }
      });
  }

  $scope.selectTemplatePage = function(pageNumber) {
    $scope.templateDesigns.current_page = pageNumber;
    $scope.templateDesignsFrom = (pageNumber - 1) * $scope.displayPageSize;
  };

  $scope.selectDesign = function(design) {
    var copiedDesign = angular.copy(design);
    delete copiedDesign.id;
    replaceDesign(copiedDesign, true); // true is used here to defer setting the bleed to checkDesktopBackgroundSize
    checkDesktopBackgroundSize();
  };
  //

  /** BLOCK SELECTION & EDITING
   *
   *    Deals with the currently selected block, and whether
   *     we're editing the selected block.
   *
   *    If these methods are triggered with an $event, we assume
   *     the user has clicked the UI; we then save the change to
   *     the History object for undo/redo and stop propagation.
   *
   *    @author David "oodavid" King
   */

  // Deselect all blocks
  $scope.deselectBlock = function($event) {
    // Remove dimensions info from all blocks
    $scope.certificateElement.querySelectorAll("div[class*='certificate-block']").forEach(function(element) {
      element.querySelector('.resize-dimensions').innerText = '';
    });
    if ($scope.selectedBlock.element) {
      //Stop to observe element for resizing action.
      resizeObserver.unobserve($scope.selectedBlock.element);
      $scope.selectedBlock.element = null;
    }

    // Do the deselect
    if ($scope.sharedData.selectedBlock) {
      $scope.sharedData.selectedBlock.selected = false;
      $scope.sharedData.selectedBlock.edit = false;
      // If this came from a user event, don't propagate
      if ($event && $event.stopImmediatePropagation){
        $event.stopImmediatePropagation();
      }
    }
    $scope.sharedData.selectedBlock = null;
    $scope.sharedData.isEditing = false;
    return false;
  };

  /**
   * When adding a block and trying to call this method right after, a timeout is needed because when doing $scope.selectedBlock.element = document.querySelector....
   * we need to wait for this element to be drawn in the DOM
   */
  $scope.selectBlock = function(block, $event) {
    // If the block is different...
    if (block !== $scope.sharedData.selectedBlock) {
      $scope.deselectBlock();
      $scope.selectedBlock.element = document.querySelector('.block-index-'+ block.block_index);
      $scope.selectedBlock.isTextBlock = !!block.font;
      $scope.sharedData.selectedBlock = block;
      $scope.sharedData.selectedBlock.selected = true;

      if ($event && $event.currentTarget) {
        if ($scope.selectedBlock.isTextBlock) {
          $scope.selectedBlock.width = $event.currentTarget.offsetWidth;
          $scope.selectedBlock.height = $event.currentTarget.offsetHeight;
        }
      }
      updateAvailableFontWeights();

      // If this came from a user event...
      if ($event) {
        $scope.pushState(); // Save the history so that the user can "undo" the selection change
      }
    }

    // If this came from a user event...
    if ($event && $event.stopImmediatePropagation) {
      $event.stopImmediatePropagation(); // Don't propagate
    }

    // Start to observe if the element is resized
    resizeObserver.observe($scope.selectedBlock.element);
  };

  // This observer will trigger when the observable element is resized
  var resizeObserver = new ResizeObserver(function() {
    $scope.$apply(function() {
      showDimensions($scope.selectedBlock.element, false);
    });
  });

  var showDimensions = function(element, isTextBlock) {
    if (isTextBlock) {
      element.querySelector('.resize-dimensions').innerText = $scope.selectedBlock.width + ' x ' + ($scope.selectedBlock.height || $scope.selectedBlock.minHeight);
    } else {
      element.querySelector('.resize-dimensions').innerText = element.offsetWidth + ' x ' + element.offsetHeight;
    }
  };

  // Turns on "isEditing"
  $scope.editBlock = function(block, $event) {
    $scope.selectBlock(block);
    if (!block.custom_image_attribute) {
      $scope.sharedData.isEditing = true;
      $scope.sharedData.selectedBlock.edit = true;
    }
    // If this came from a user event...
    if ($event && $event.stopImmediatePropagation) {
      $event.stopImmediatePropagation(); // Don't propagate
    }
    return false;
  };

  // Clones a block, selects it
  $scope.cloneAndSelectBlock = function(block, $event) {
    var clone = $scope.cloneBlock(block);
    // Select and return the block
    $timeout(function () {
      $scope.selectBlock(clone);
    });
    // If this came from a user event...
    if ($event && $event.stopImmediatePropagation) {
      $event.stopImmediatePropagation(); // Don't propagate
    }
    return false;
  };

  // When the History restores the "state" object, `selectedBlock` becomes an invalid reference, this manually repairs it
  var repairSelectedBlockPointer = function() {
    if ($scope.sharedData.selectedBlock) {
      var block = _.find($scope.design.blocks, function(block) {
        return angular.equals(block, $scope.sharedData.selectedBlock);
      });
      $scope.selectBlock(block);
    } else {
      $scope.deselectBlock();
    }
  };

  // Tells us if a particular block has a date attribute present
  $scope.blockHasDateAttribute = function(block) {
    if ($scope.sharedData.selectedBlock && ($scope.sharedData.selectedBlock.hasOwnProperty('model'))) {
      var attributes = attributeService.tagsToAttributes(block.model);
      for (var i = attributes.length - 1; i >= 0; i--) {
        if (attributes[i].type == 'date') {
          return true;
        }
      }
      return false;
    }
  };

  /** BLOCK UTILITES
   *
   *    These utility functions can be used by the block actions,
   *     or other parts of the controller. They do NOT add the
   *     change to the History object, it expects the consumer
   *     function to deal with that.
   *
   *    @author David "oodavid" King
   */
  // Returns the index of the previous block
  var getPrevIndex = function(block) {
    var i = $scope.design.blocks.indexOf(block);
    for (var b = (i - 1); b >= 0; b--) {
      return b;
    }
    return -1;
  };

  // Returns the index of the next block
  var getNextIndex = function(block) {
    var i = $scope.design.blocks.indexOf(block);
    for (var b = (i + 1), bl = $scope.design.blocks.length; b < bl; b++) {
      return b;
    }
    return -1;
  };

  /** BLOCK ACTIONS
   *
   *    These are the main actions that can be applied to blocks
   *     triggering them adds the change to the History object.
   *
   *    @author David "oodavid" King
   *    @author Jake Ford
   *    @author Ryan Booth
   */

  var rememberedScaling;
  function recycleScaling(block) {
    rememberedScaling = block.scale_to_fit;
    block.scale_to_fit = null;
    $timeout(function() {
      block.scale_to_fit = rememberedScaling;
      rememberedScaling = null;
    });
  }

  $scope.selectFont = function(newFont) {
    $scope.sharedData.selectedBlock.font = newFont.name;
    fontService.loadDesignFonts($scope.design);
    $scope.sharedData.selectedBlock.font_weight = fontService.getNearestWeight(newFont.name, $scope.sharedData.selectedBlock.font_weight);
    updateAvailableFontWeights();
    recycleScaling($scope.sharedData.selectedBlock);
    $scope.pushState();
  };

  $scope.changeWeight = function(block) {
    if (block) {
      // The change of block.font_weight is handled by the UI dropdown
      recycleScaling(block);
      $scope.pushState();
    }
  };

  $scope.italicize = function(block) {
    if (block) {
      block.italic = !block.italic;
      recycleScaling(block);
      $scope.pushState();
    }
  };

  $scope.underline = function(block) {
    if (block) {
      block.underline = !block.underline;
      recycleScaling(block);
      $scope.pushState();
    }
  };

  $scope.align = function(block, align) {
    if (block) {
      block.align = align;
      recycleScaling(block);
      $scope.pushState();
    }
  };

  $scope.verticalAlign = function(block, align) {
    if (block) {
      block.vertical_align = align;
      recycleScaling(block);
      $scope.pushState();
    }
  };

  $scope.toggleUppercase = function(block) {
    if (block) {
      block.uppercase = !block.uppercase;
      recycleScaling(block);
      $scope.pushState();
    }
  };

  $scope.startingChangeFontSize = function(block) {
    if (block) {
      rememberedScaling = block.scale_to_fit;
      block.scale_to_fit = null;
    }
  };

  $scope.stoppingChangeFontSize = function(block) {
    if (block) {
      block.scale_to_fit = rememberedScaling;
      rememberedScaling = null;
      $scope.pushState();
    }
  };

  $scope.toggledScaling = function(block) {
    if (block) {
      // The checkbox handles the toggling of block.scale_to_fit
      $scope.pushState();
    } else {
      // Undo the toggle - this should never be called
      block.scale_to_fit = !block.scale_to_fit;
    }
  };

  $scope.toggledAutoResize = function(block) {
    var element = $scope.selectedBlock.element;
    var parentElement = element.parentElement;
    var fivePctInPixelsWidth = Math.round(5 * parentElement.offsetWidth / 100);
    var fivePctInPixelsHeight = Math.round(5 * parentElement.offsetHeight / 100);
    //if checking auto resize
    if( $scope.selectedBlock.height !== null) {
      $scope.selectedBlock.height = null;
      block.image_height = null;
      block.vertical_align = null;
      // We check if current width is lower than 5% converted to pixels
      if (element.offsetWidth < fivePctInPixelsWidth) {
        $scope.selectedBlock.width = fivePctInPixelsWidth;
        block.image_width = '5%';
      }
      // Now the width and height cannot be lower than 5% converted to pixels
      $scope.selectedBlock.minHeight = fivePctInPixelsHeight;
      $scope.selectedBlock.minWidth = fivePctInPixelsWidth;

      $scope.pushState();
      return;
    }

    // Set manually the closest value equivalent to 5%, which was the height used when creating a new text block
    $scope.selectedBlock.height = fivePctInPixelsHeight;
    block.image_height = ((fivePctInPixelsHeight * 100) / parentElement.offsetHeight) +'%';
    $scope.selectedBlock.minHeight = 1;
    $scope.selectedBlock.minWidth = 1;

    $scope.pushState();
  };

  $scope.setHeightFromInput = function (block) {
    var minHeight = 1;
    $scope.selectedBlock.minHeight = minHeight;

    // Set the height to selectedTextBlock.height or minHeight
    var height = $scope.selectedBlock.height ? $scope.selectedBlock.height : minHeight;
    $scope.selectedBlock.height = height;

    // Calculate height as a percentage of certificate height
    block.image_height = ((height * 100) / $scope.certificateElement.offsetHeight).toFixed(3) + '%';

    $scope.pushState();
  };

  $scope.setWidthFromInput = function (block) {
    // Find the block element by class name
    var blockClassName = '.block-index-' + block.block_index;
    var blockElement = document.querySelector(blockClassName);
    var parentElement = blockElement.parentElement;

    var minWidth = 1;

    // update minWidth based on parent width if height is not selected
    if (!$scope.selectedBlock.height) {
      minWidth = Math.round((5 * parentElement.offsetWidth) / 100);
    }

    // Set the width and minWidth
    var width = $scope.selectedBlock.width ? $scope.selectedBlock.width : minWidth;
    $scope.selectedBlock.minWidth = minWidth;
    $scope.selectedBlock.width = width;

    // Calculate width as a percentage of certificate width
    block.image_width = ((width * 100) / $scope.certificateElement.offsetWidth).toFixed(3) + '%';

    $scope.pushState();
  };


  $scope.canMoveForward = function(block) {
    return (getNextIndex(block) !== -1);
  };
  $scope.moveForward = function(block) {
    if (block) {
      var fromIndex = $scope.design.blocks.indexOf(block);
      var toIndex = getNextIndex(block);
      if (fromIndex !== -1 && toIndex !== -1) {
        $scope.design.blocks[fromIndex] = $scope.design.blocks[toIndex];
        $scope.design.blocks[toIndex] = block;
      }
      $scope.pushState();
    }
  };

  $scope.canMoveBackward = function(block) {
    return (getPrevIndex(block) !== -1);
  };
  $scope.moveBackward = function(block) {
    if (block) {
      var fromIndex = $scope.design.blocks.indexOf(block);
      var toIndex = getPrevIndex(block);
      if (fromIndex !== -1 && toIndex !== -1) {
        $scope.design.blocks[fromIndex] = $scope.design.blocks[toIndex];
        $scope.design.blocks[toIndex] = block;
      }
      $scope.pushState();
    }
  };

  $scope.repairCentering = function(block) {
    if (block) {
      delete block.center;
      if (!block.image_width) {
        block.image_width = '15%';
      }
      $scope.pushState();
    }
  };

  $scope.deleteBlock = function(block) {
    if (block == $scope.sharedData.selectedBlock) {
      $scope.deselectBlock();
    }
    $scope.pushState();
    $scope.design.blocks.splice(block.block_index, 1);
    if (block.qr_code) {
      $scope.hasQRCode = false;
    }
    $scope.design.blocks.forEach(function(block, index) {
      block.block_index = index;
    });
  };

  $scope.cloneBlock = function(block) {
    if (block) {
      var clone = angular.copy(block);
      clone.block_index = $scope.design.blocks.length;
      delete clone.selected;
      delete clone.edit;
      clone.top = plusPercent(clone.top); // Nudge down
      $scope.design.blocks.push(clone);
      $scope.pushState();
      return clone;
    }
  };

  $scope.setDesktopBg = function(fileUrl) {
    $scope.design.background = fileUrl;
    checkDesktopBackgroundSize();
    $scope.pushState();
  };

  $scope.addTextBlock = function(value) {
    //Calculate the closest % value equivalent to 30px, which was the height used when a new text block was created
    var image_height = Math.round(30 * 100 / $scope.certificateElement.offsetHeight) + '%';
    var block = {
      'top': '5%',
      'left': '0%',
      'model': value,
      'font': defaultFont,
      'font_weight': defaultFontWeight,
      'color': defaultColor,
      'font_size': '16px',
      'image_width': '15%',
      'image_height': image_height,
      'scale_to_fit': false,
      'block_index': $scope.design.blocks.length,
      'vertical_align': 'center'
    };
    $scope.design.blocks.push(block);
    // Select and return the block
    $timeout(function () {
      // select the block after it is added to the DOM
      $scope.selectBlock(block);
    });
    $scope.pushState();
    return block;
  };

  $scope.addImageBlock = function(fileUrl) {
    // Create and select the block
    if (fileUrl) {
      var block = {
        'top': '0%',
        'left': '0%',
        'image_url': fileUrl,
        'block_index': $scope.design.blocks.length,
      };
      $scope.design.blocks.push(block);
      // Select and return the block
      $timeout(function () {
        // select the block after it is added to the DOM
        $scope.selectBlock(block);
      });
      $scope.pushState();
      return block;
    }
  };

  $scope.addQRCodeBlock = function() {
    // Create and select the block
    var block = {
      'top': '0%',
      'left': '0%',
      'image_width': '128px', // These pixel values get monkey patched into percentages
      'image_height': '128px', // ...see editor-image-monkey-patch
      'pixel_width': 128,  // The 'pixel_width' and 'pixel_height' values keep a record of the pixel size
      'pixel_height': 128, // of the QR Code so that it can be maintained if the document dimensions change
      'qr_code': true,
      'background_color': '#FFFFFF',
      'foreground_color': '#000000',
      'contrast': 21,
      'block_index': $scope.design.blocks.length,
    };
    $scope.design.blocks.push(block);
    // Select and return the block
    $timeout(function () {
      // select the block after it is added to the DOM
      $scope.selectBlock(block);
    });
    $scope.pushState();
    $scope.hasQRCode = true;
    return block;
  };

  $scope.lineStyles = [
    'dotted',
    'dashed',
    'solid',
    'double',
    'groove',
    'ridge',
    'inset',
    'outset'
  ];

  $scope.addLineBlock = function(orientation) {
    var block = {
      'top': '0',
      'left': '0%',
      'color': defaultColor,
      'line_width': '2px',
      'line_style': 'solid',
      'orientation': orientation,
      'image_width': orientation === 'horizontal' ? '50%' : '3%',
      'image_height': orientation === 'horizontal' ? '3%' : '50%',
      'block_index': $scope.design.blocks.length,
    };
    $scope.design.blocks.push(block);
    // Select and return the block
    $timeout(function () {
      // select the block after it is added to the DOM
      $scope.selectBlock(block);
    });
    $scope.pushState();
    return block;
  };

  $scope.addImageAttributeBlock = function(attributeTag, imageWidth, imageHeight, altText) {
    // Create and select the block
    if (attributeTag) {
      var block = {
        'top': '0%',
        'left': '0%',
        'image_width': imageWidth, // These pixel values get monkey patched into percentages
        'image_height': imageHeight, // ...see editor-image-monkey-patch
        'custom_image_attribute': attributeTag,
        'block_index': $scope.design.blocks.length,
        'alt_text': altText,
      };
      $scope.design.blocks.push(block);
      // Select and return the block
      $timeout(function () {
        // select the block after it is added to the DOM
        $scope.selectBlock(block);
      });
      $scope.pushState();
      return block;
    }
  };

  $scope.addAttributeTag = function(attributeTag) {
    // Do we have a text block selected?
    var block = $scope.sharedData.selectedBlock;
    if (block && block.hasOwnProperty('model')) {
      // Modify the selected block
      block.model += ' ' + attributeTag;
      $scope.pushState();
    } else {
      // Nope? Create one
      return $scope.addTextBlock(attributeTag);
    }
  };

  $scope.setPaper = function(size, orientation) {
    // Set the paper size and orientation, if necessary
    if (size != $scope.design.size || $scope.design.orientation != orientation) {
      $scope.design.size = size;
      $scope.design.orientation = orientation;
      checkDesktopBackgroundSize(true);
      $scope.pushState();
    }
  };

  $scope.toggledBleeds = function() {
    // The checkbox toggles design.background_bleeds
    bleedState = $scope.design.background_bleeds;
    $scope.pushState();
  };

  $scope.bgIsPrintResolution = false; // This gets set to true if the background is correct for printing

  function checkDesktopBackgroundSize(dontSaveChanges, dontSetBleeds) {
    // Check if the background image is "print quality", and thus has a bleed area
    if ($scope.design.background) {
      var printDimensions = certificateDimensions.getDimensions($scope.design.size, $scope.design.orientation, 'print');
      if (printDimensions) {
        var img = new Image();
        img.onload = function() {
          var sameAspectRatio = this.width / printDimensions.width === this.height / printDimensions.height;
          if (this.width >= printDimensions.width && this.height >= printDimensions.height && sameAspectRatio) {
            // If unset, initialise bleedState to what is set on the design
            if (bleedState === null) {
              bleedState = $scope.design.background_bleeds;
            }
            // Correct size? Show bleed
            if (!dontSetBleeds) {
              $scope.design.background_bleeds = bleedState;
            }
            $scope.bgIsPrintResolution = true;
          } else if (this.width > 0.7 * printDimensions.width || this.height == 0.7 * printDimensions.height) {
            // It's High-Rez, but not good enough
            $scope.design.background_bleeds = false;
            $scope.bgIsPrintResolution = false;
          } else {
            // Incorrect size? No bleed
            $scope.design.background_bleeds = false;
            $scope.bgIsPrintResolution = false;
          }
          if (!dontSaveChanges) {
            $scope.pushState();
          }
          // Timeout for async digest
          $timeout(function() {});
        };
        img.src = $scope.design.background;
      }
    } else {
      // No image, no bleeds
      $scope.design.background_bleeds = false;
      if (!dontSaveChanges) {
        $scope.pushState();
      }
    }
  }

  // Default the paper size and orientation (belts and braces)
  var size = $scope.design.size || 'us-letter';
  var orientation = $scope.design.orientation || 'landscape';
  $scope.setPaper(size, orientation);
  checkDesktopBackgroundSize(true);

  /** ATTRIBUTES
   *
   *    Deals with the following two methods
   *
   *        Is the attribute in use?
   *        Add the attribute to the design
   *
   *    @author David "oodavid" King
   */
  $scope.attributeInUse = function(attribute) {
    for (var b = 0, bl = $scope.design.blocks.length; b < bl; b++) {
      var block = $scope.design.blocks[b];
      // Check text blocks
      if (block.model) {
        if (block.model.indexOf(attribute.tag) > -1) {
          return true;
        }
      }
      // Check images
      if (block.custom_image_attribute) {
        if (block.custom_image_attribute == attribute.tag) {
          return true;
        }
      }
    }
    return false;
  };

  var imageDimensionModal;
  $scope.selectAttribute = function(attribute) {
    if (attribute.type == 'image') {
      // The popup wants to know the stage dimensions, and a sensible initial size
      $scope.stage_width = $('#certificate-editor-body .certificate').width();
      $scope.stage_height = $('#certificate-editor-body .certificate').height();
      // Pass an object as primitive values are copied to the modal scope
      $scope.modalImageDimentions = {
        image_width: 240,
        image_height: 120,
        alt_text: '',
      };
      $scope.attribute = attribute;
      // Open a modal to allow the user to select the image size
      imageDimensionModal = $uibModal.open({
        animation: true,
        windowClass: 'bs-to-dialog',
        templateUrl: '/app/_modals/imageDimensionModal.html',
        scope: $scope,
      });
    } else {
      $scope.addAttributeTag(attribute.tag);
    }
  };

  $scope.addImageAttributeBlockFromModal = function() {
    $scope.addImageAttributeBlock($scope.attribute.tag, $scope.modalImageDimentions.image_width + 'px', $scope.modalImageDimentions.image_height + 'px', $scope.modalImageDimentions.alt_text);
    imageDimensionModal.close();
  };

  // Attribute list functionality - derived from the select-attribute directive

  $scope.attributeGroups;

  if ($scope.authorized) {
    // Read the attributes from the service
    attributeService
      .getNestedAttributes()
        .then(function(myAttributes) {
          $scope.attributeGroups = myAttributes;
      });
  }

  // QR Code Support

  $scope.contrastThreshold = 5;
  $scope.contrastGuaranteedThreshold = 10;

  // Utilities
  function luminanace(r, g, b) {
    var a = [r, g, b].map(function (v) {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow( (v + 0.055) / 1.055, 2.4 );
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
  }

  function contrast(rgb1, rgb2) {
    return (luminanace(rgb1[0], rgb1[1], rgb1[2]) + 0.05) / (luminanace(rgb2[0], rgb2[1], rgb2[2]) + 0.05);
  }

  function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? [
      parseInt(result[1], 16),
      parseInt(result[2], 16),
      parseInt(result[3], 16)
     ] : null;
  }

  // Render color change without saving the model
  $scope.onQRCodeColorUpdate = function($event, layer){
    if (layer) {
      $scope.sharedData.selectedBlock[layer + '_color'] = $event.color;
    }
    $scope.sharedData.selectedBlock.contrast = contrast(hexToRgb($scope.sharedData.selectedBlock.background_color), hexToRgb($scope.sharedData.selectedBlock.foreground_color));
  };

  // Maintain QR Code size if document dimensions are changed
  $scope.onDocumentChange = function() {
    $timeout(function() { // Delay until next digest cycle
      if ($scope.hasQRCode) {
        var qrCodeBlock = _.find($scope.design.blocks, function(block) {
          return block.qr_code;
        });
        var certificate = $element.find('.certificate-editable');
        var widthPct = ((qrCodeBlock.pixel_width / certificate.width()) * 100).toFixed(3) + '%';
        var heightPct = ((qrCodeBlock.pixel_height / certificate.height()) * 100).toFixed(3) + '%';
        qrCodeBlock.image_width = widthPct;
        qrCodeBlock.image_height = heightPct;
        certificate.trigger('documentChange'); // Used by resizableDirective
      }
      checkDesktopBackgroundSize();
      $scope.pushState();
    });
  };

  /** _    _                 _            _____                                  _
   * | |  | |               | |          |  __ \                                | |
   * | |__| | ___ _ __ ___  | |__   ___  | |  | |_ __ __ _  __ _  ___  _ __  ___| |
   * |  __  |/ _ \ '__/ _ \ | '_ \ / _ \ | |  | | '__/ _` |/ _` |/ _ \| '_ \/ __| |
   * | |  | |  __/ | |  __/ | |_) |  __/ | |__| | | | (_| | (_| | (_) | | | \__ \_|
   * |_|  |_|\___|_|  \___| |_.__/ \___| |_____/|_|  \__,_|\__, |\___/|_| |_|___(_)
   *                                                        __/ |
   *                                                       |___/
   *
   *  I'm pretty happy with the refactored code above.
   *
   *  The code below has barely been touched in my review.
   *
   *  In due course the entire Controller will be refactored, with the above logic
   *   acting as a solid foundation.
   *
   *  @author   David "oodavid" King
   */



  /** COLOR SELECTOR OVERRIDE
   *
   *   Wrote in a wrapper that can be styled, but then clicking behaviour
   *    becomes a little wonky. Need this hacky little thing to ensure it
   *    works OK.
   *
   *   @author Jake Ford
   */
  $scope.getTextColor = function() {
    if ($scope.sharedData.selectedBlock.color && $scope.sharedData.selectedBlock.color.length === 7) {
      return String($scope.sharedData.selectedBlock.color);
    }
    return '#404040';
  };

  // Load the certificate fonts
  fontService.loadDesignFonts($scope.design);

  // Default credential data
  $scope.credential = {
    'name': 'Example Course Name',
    'recipient': {
      'name': 'John Doe',
    },
    'issued_on': new Date(),
    'group': {
      'design': $scope.design,
    },
  };

  // Keyboard shortcuts
  angular.element('body').bind('keydown', function($event) {
    // Digest the logic so our scope updates
    $scope.$apply(function() {
      // ESC = Deselect
      if ($event.which === 27) {
        $scope.deselectBlock();
        $event.preventDefault();
        $event.stopImmediatePropagation();
      }
      // All other shortcuts shouldn't occur if an input or textarea is focussed
      if (!document.activeElement || (document.activeElement.tagName !== 'INPUT' && document.activeElement.tagName !== 'TEXTAREA')) {
        // Backspace / Delete = Delete
        if ($event.which === 8 || $event.which === 46) {
          if ($scope.sharedData.selectedBlock && !$scope.sharedData.isEditing) {
            $scope.deleteBlock($scope.sharedData.selectedBlock);
            $event.preventDefault();
            $event.stopImmediatePropagation();
          }
        }
        // Left = Nudge
        else if ($event.which === 37 && $scope.sharedData.selectedBlock && !$scope.sharedData.isEditing) {
          $scope.sharedData.selectedBlock.left = minusPercent($scope.sharedData.selectedBlock.left);
          $event.preventDefault();
          $event.stopImmediatePropagation();
        }
        // Right = Nudge
        else if ($event.which === 39 && $scope.sharedData.selectedBlock && !$scope.sharedData.isEditing) {
          $scope.sharedData.selectedBlock.left = plusPercent($scope.sharedData.selectedBlock.left);
          $event.preventDefault();
          $event.stopImmediatePropagation();
        }
        // Up = Nudge
        else if ($event.which === 38 && $scope.sharedData.selectedBlock && !$scope.sharedData.isEditing) {
          $scope.sharedData.selectedBlock.top = minusPercent($scope.sharedData.selectedBlock.top);
          $event.preventDefault();
          $event.stopImmediatePropagation();
        }
        // Down = Nudge
        else if ($event.which === 40 && $scope.sharedData.selectedBlock && !$scope.sharedData.isEditing) {
          $scope.sharedData.selectedBlock.top = plusPercent($scope.sharedData.selectedBlock.top);
          $event.preventDefault();
          $event.stopImmediatePropagation();
        }
        // Open Bracket [ = Select Custom Attribute (openAttributeSelector doesn't exist, hence disabled)
        /*
        else if ($event.which === 219 && $scope.sharedData.selectedBlock && $scope.sharedData.isEditing && $scope.sharedData.selectedBlock.model) {
            $scope.openAttributeSelector($event);
            $event.preventDefault();
            $event.stopImmediatePropagation();
        }
        */
      }
    });
  });

  /** SAVE
   *
   */
  var confirmThenSave = function(formCtrl) {
    swalService.confirm(
      'This template is used by ' + $scope.design.credentials_count + ' existing credential' + ($scope.design.credentials_count != 1 ? 's' : '') + '. Saving now will change the certificate appearance for ' + ($scope.design.credentials_count != 1 ? 'those credentials' : 'this credential') + '.',
      function(confirmed) {
        if (confirmed) {
          nowSave(formCtrl);
        } else {
          formCtrl.$submitted = false;
        }
      },
      'Change Existing Credential' + ($scope.design.credentials_count != 1 ? 's' : '') + '?',
      'Update design',
      '#4fba6a',
      'Cancel',
      true
    );
  };
  var nowSave = function(formCtrl) {
    var design = getDesignPayload();
    // And save
    CertificateService
      .upsert(design)
      .then(function(response) {
        AnalyticsService.trackEvent('Certificate Design Editor > Design Saved');
        // Update the local object
        replaceDesign(response);
        savedDesign = response;
        // Update the time we saved, based on the History object
        saveTime = History.timestamp;
        // Close the editor
        // #shame taken from the close function
        // var formScope = angular.element($scope.formBuster.formCtrl.$$element[0]).scope();
        var expressionHandler = $scope.onClose();
        expressionHandler(savedDesign); // Manually trigger the function passing formCtrl as the only argument
      })
      .catch(function(err) {
        swalService.showAlert('certificateDesignUpdateFailure');
      })
      .finally(function(){
        formCtrl.$setPristine();
      });
  };

  $scope.saveDesign = function(formCtrl) {
    $scope.deselectBlock();
    if (!$scope.design.name) {
      swalService.showAlert('certificateDesignNeedsNameError');
      formCtrl.$submitted = false;
    } else {
      // Confirm the effects on existing credentials
      if ($scope.design.credentials_count > 0){
        confirmThenSave(formCtrl);
      } else {
        nowSave(formCtrl);
      }
    }
  };

  $scope.getDesktopBgImageScreenSize = function() {
    var size = $scope.design.size || 'us-letter';
    var orientation = $scope.design.orientation || 'landscape';
    var screen = certificateDimensions.getDimensions(size, orientation, 'screen');
    return screen.width + ' x ' + screen.height + ' pixels';
  };
  $scope.getDesktopBgImagePrintSize = function() {
    var size = $scope.design.size || 'us-letter';
    var orientation = $scope.design.orientation || 'landscape';
    var print = certificateDimensions.getDimensions(size, orientation, 'print');
    return print.width + ' x ' + print.height + ' pixels';
  };

  function minusPercent(input) {
    var percent = parseFloat(input);
    // Largest editor paper size is 297mm. At 96 DPI, that's 1122.5px.
    // Therefore each single 1% is 11.2px.
    // Therefore Nudging by 0.1 nudges by 1.12px.
    percent = percent - 0.1;
    if (percent < 0) {
      return '0%';
    } else {
      return percent.toString() + '%';
    }
  }

  function plusPercent(input) {
    var percent = parseFloat(input);
    // Largest editor paper size is 297mm. At 96 DPI, that's 1122.5px.
    // Therefore each single 1% is 11.2px.
    // Therefore Nudging by 0.1 nudges by 1.12px.
    percent = percent + 0.1;
    if (percent > 100) {
      return '100%';
    } else {
      return percent.toString() + '%';
    }
  }

  // Font weights
  $scope.allFontWeights = fontService.getWeights(); // { 100: 'Thin', 200: 'Extra Light' ... }
  $scope.availableFontWeights = []; // [300, 400, 600] - for the selected font
  function updateAvailableFontWeights(){
    if ($scope.sharedData.selectedBlock.font){
      $scope.availableFontWeights = $scope.fonts[$scope.sharedData.selectedBlock.font].weights.filter(function(weight) {
        return Number.isInteger(weight);
      });
    }
  }

  // Font Families that are available to the issuer
  $scope.fonts = fontService.getFonts();

  // Render color changes without saving the model
  $scope.onColorChange = function($event){
    $scope.sharedData.selectedBlock.color = $event.color;
  };

  // Date object
  $scope.exampleDate = new Date();

}

angular
  .module('app')
  .directive('certificateEditor', certificateEditorDirective)
  .run(certificateEditorDirectivePreload);

},{"./directives/autoRemoveAttributesDirective.js":38,"./directives/certificateScaleTextDirective.js":39,"./directives/draggableDirective.js":40,"./directives/resizableDirective.js":41}],38:[function(require,module,exports){
/** AUTO REMOVE ATTRIBUTES
 *
 *    Hitting BACKSPACE or DELETE on the [ or ] characters
 *     will remove the entire [attribute] block from the input.
 *
 *      <textarea auto-remove-attributes>
 *        you can delete [this_attribute] simply enough!
 *      </textarea>
 *
 *  @author  David "oodavid" King
 */
(function() {
  angular
    .module('app')
    .directive('autoRemoveAttributes', ['$timeout', function($timeout) {
      return {
        require: 'ngModel',
        link: function(scope, element, attrs) {
          element.bind("keydown keypress", function($event) {
            // Backspace or Delete
            if ($event.which === 8 || $event.which === 46) {
              // This should only work when we're removing a single character (ie, not an extended selection!)
              if ($event.target.selectionStart === $event.target.selectionEnd) {
                // Assume we have nothing to do
                var start = false;
                var end = false;
                // Grab the caret position and char
                var value = $event.target.value;
                var left = $event.target.selectionStart - ($event.which === 8 ? 1 : 0); // Nudge left when using Backspace
                var right = left + 1;
                var char = value[left];
                // If it's a [ or ] then we can try and match the [attribute]
                if (char === '[') {
                  // Scan right for a matching [
                  for (var i = right, vl = value.length; i < vl; i++) {
                    if (value[i] == ']') {
                      start = left;
                      end = i + 1;
                      break;
                    }
                  }
                } else if (char === ']') {
                  // Scan left for a matching [
                  for (var i = left; i >= 0; i--) {
                    if (value[i] == '[') {
                      start = i;
                      end = right;
                      break;
                    }
                  }
                }
                // Did we get a match?
                if (start !== false && end !== false) {
                  // Validate the [attribute] string
                  var string = value.slice(start, end);
                  var regex = /^[\[\]\w_]*$/i; // Matches all valid chars in an [attribute] string
                  if (string.match(regex)) {
                    // Removing the [attribute] might empty the string, that needs a different approach
                    if (string === value) {
                      $event.target.value = ""; // Clear the value
                    } else {
                      $event.target.value = value.slice(0, start) + value.slice(end); // Clip the value and angular model
                    }
                    scope.block.model = $event.target.value;
                    // Make sure this gets digested
                    $timeout(function() {
                      // Restore the cursor position on the next digest - but only if we have something to focus on
                      if ($event.target.value.length) {
                        $event.target.setSelectionRange(start, start);
                      }
                    }, 0);
                    // Cancel normal behaviours
                    $event.preventDefault();
                    $event.stopImmediatePropagation();
                  }
                }
              }
            }
          });
        }
      };
    }]);
})();

},{}],39:[function(require,module,exports){
/** CERTIFICATE SCALE TEXT
 *
 *
 *
 *  @author  Andrew Bateman
 */
(function() {
  angular
    .module('app')
    .directive('certificateScaleText', ['$interpolate', '$timeout', '$compile', function($interpolate, $timeout, $compile) {
      return {
        restrict : 'A',
        priority : 1,
        terminal : true,
        link: function(scope, element, attr) {
          // Render text to DOM
          $compile(element, null, 1)(scope);
          // Get text to measure - '{' and '}' are removed to prevent XSS
          var text = $interpolate(element.text().replace(/{/g, '').replace(/}/g, ''))(scope);
          // Create canvas
          var canvas = document.createElement('canvas');
          var context = canvas.getContext('2d');
          // Get containing certificate
          var certificate = element.closest('.certificate-editable');
          // Prevent observer firing before initial adjustment
          var initialised = false;
          // Get initial enabled value
          var enabled = attr.certificateScaleText === 'true';
          function adjustFontSize() {
            // Remove any existing font-size styling from the element
            element.css('font-size', '');
            if (enabled) {
              // Get containing block width
              var container = element.closest('.certificate-block');
              var containerWidth = container.width();
              // Get the current pixel font size
              var pixelFontSize = parseFloat(getComputedStyle(container[0]).fontSize);
              // Get current font weight and family
              var fontWeight = element.css('font-weight');
              var fontFamily = element.css('font-family');
              var fontSize = pixelFontSize;
              // Find first font-size that will fit containing block width
              context.font = fontWeight + ' ' + fontSize + 'px ' + fontFamily;
              while (context.measureText(text).width > containerWidth)
              {
                fontSize = fontSize - 1;
                context.font = fontWeight + ' ' + fontSize + 'px ' + fontFamily;
              }
              // Apply calculated font-size, if necessary
              if (fontSize < pixelFontSize) {
                element.css('font-size', fontSize + 'px');
              }
            }
            // Must be initialised now
            initialised = true;
          }
          attr.$observe('certificateScaleText', function(newValue) {
            enabled = (newValue === 'true');
            if (initialised) {
              adjustFontSize();
            }
          });
          certificate.on('change', function(event, el) {
            // Only adjust if the contained element was the one that was changed
            if (el && $.contains(el, element[0])) { // el comes from the resizableDirective. If it isn't present the change was raised by something else and should be ignored
              adjustFontSize();
            }
          });
          $timeout(adjustFontSize);
        }
      };
    }]);
})();

},{}],40:[function(require,module,exports){
/** DRAGGABLE
 *
 *    While we're using jQueryUI.draggable, I've had to add some
 *       additional logic to deal with snapping / smart-guides.
 *
 *    Features:
 *      User can drag any block
 *      Dragging is contained within the parent / <certificate>
 *      Snapping / Smart-Guides
 *
 *    Used by the <certificate> editor.
 *
 *  @author  David "oodavid" King
 */
(function() {
  angular.module('app')
    .directive('draggable', function() {
      var tolerance = 3;

      // Returns the position (as a percentage)
      var getPositionPct = function(jElement, ui) {
        var parentWidth = jElement.parent().width();
        var parentHeight = jElement.parent().height();
        return {
          left: (ui.position.left / parentWidth) * 100,
          top: (ui.position.top / parentHeight) * 100,
        };
      };

      // Contains a list of coordinates we can snap to, and the elements that use that space
      var snap = {
        x: {}, // Each coordinate can contain a number of blocks,
        y: {}, // ...like so:: { '150': [ block1, block2 ] }
      };

      var addSnap = function(axis, value, block) {
        value = Math.round(value); // This makes the snapping more visually reliable when we consider the juggling of px and %
        if (!snap[axis][value]) {
          snap[axis][value] = [];
        }
        if (block) {
          snap[axis][value].push(block);
        }
      };

      var generateSnapGrid = function(jElement) {
        // Reset the object
        snap.x = {};
        snap.y = {};
        // Add the center point
        var centerStageX = jElement.parent().width() / 2;
        var centerStageY = jElement.parent().height() / 2;
        addSnap('x', centerStageX);
        addSnap('y', centerStageY);
        // Loop the siblings, and add their coordinates
        var blocks = jElement.parent().find('.certificate-block:visible').not(jElement); // All visible blocks, excluding the active one
        for (var b = 0, bl = blocks.length; b < bl; b++) {
          var block = $(blocks[b]);
          var pos = block.position();
          addSnap('y', pos.top, block); // Top
          addSnap('y', (pos.top + (block.height() / 2)), block); // Middle
          addSnap('y', (pos.top + block.height()), block); // Bottom
          // HACK - if the element has the insane "center" property applied, then we can't rely on the left, middle and right properties
          if (block.css('left') == '0px' && block.css('right') == '0px') {
            addSnap('x', centerStageX, block); // But we do know they're centered ...so we can add them to the "stage" array
          } else {
            addSnap('x', pos.left, block); // Left
            addSnap('x', (pos.left + (block.width() / 2)), block); // Middle
            addSnap('x', (pos.left + block.width()), block); // Right
          }
        }
      };
      // Clears all snap styles
      var clearSnapStyles = function(jElement) {
        jElement.parent().find('.snapToThis').removeClass('snapToThis');
        jElement.parent().find('.guide-x').hide();
        jElement.parent().find('.guide-y').hide();
      };

      // Snaps the element to our snap guides on either the x or y axis
      var snapOnAxis = function(jElement, ui, axis) {
        var prop = (axis == 'x' ? 'left' : 'top');
        var elDimension = (axis == 'x' ? jElement.width() : jElement.height());
        var closest = {
          distance: tolerance, // The distance
          value: null, // The "left" or "top" value
          snapKey: null, // The Key, something like 150 (pixels)
        };
        for (var snapKey in snap[axis]) {
          if (snap[axis].hasOwnProperty(snapKey)) {
            var dist;
            // Middle
            dist = Math.round(Math.abs(ui.position[prop] + (elDimension / 2) - snapKey));
            if (dist < closest.distance + 0.1) { // Why do we use +0.1? To make "middle" override "left" or "right"
              closest.distance = dist;
              closest.snapKey = snapKey;
              closest.value = snapKey - (elDimension / 2);
            }
            // Top / Left
            dist = Math.round(Math.abs(ui.position[prop] - snapKey));
            if (dist < closest.distance) {
              closest.distance = dist;
              closest.snapKey = snapKey;
              closest.value = snapKey;
            }
            // Bottom / Right
            dist = Math.round(Math.abs(ui.position[prop] + elDimension - snapKey));
            if (dist < closest.distance) {
              closest.distance = dist;
              closest.snapKey = snapKey;
              closest.value = snapKey - elDimension;
            }
          }
        }
        if (closest.snapKey && closest.value) {
          ui.position[prop] = closest.value;
          jElement.parent().find('.guide-' + axis).show().css(prop, (closest.snapKey - 1) + 'px');
          var blocks = snap[axis][closest.snapKey];
          for (var b = 0, bl = blocks.length; b < bl; b++) {
            blocks[b].addClass('snapToThis');
          }
        }
      };

      // DRY
      var addDraggable = function(scope, jElement, attrs) {
        jElement.draggable({
          cursor: 'move',
          containment: jElement.closest('.certificate-editable'),
          axis: scope.block.center ? 'y' : false,
          start: function(event, ui) {
            generateSnapGrid(jElement);
            scope.$apply(function() {
              scope.selectBlock(scope.block, event);
            });
          },
          drag: function(event, ui) {
            // Clear any highlighted elements
            clearSnapStyles(jElement);
            // Snap on x and y
            snapOnAxis(jElement, ui, 'x');
            snapOnAxis(jElement, ui, 'y');
            // Display the position
            var pos = getPositionPct(jElement, ui);
            var x = pos.left.toFixed(2);
            var y = pos.top.toFixed(2);
            jElement.find('.drag-position').text(x + ', ' + y);
          },
          stop: function(event, ui) {
            // Clear any highlighted elements
            clearSnapStyles(jElement);
            //
            scope.$apply(function() {
              var pos = getPositionPct(jElement, ui);
              scope.block.top = pos.top.toFixed(3) + '%';
              scope.block.left = pos.left.toFixed(3) + '%';
              if (attrs.onChange) {
                scope.$eval(attrs.onChange);
              }
              // Hide the position
              jElement.find('.drag-position').text('');
            });
          }
        });
      };

      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          // Be draggable
          addDraggable(scope, element, attrs);
          // Erm... if the centring changes, reset the draggable?
          scope.$watch(function() {
            return scope.block.center;
          }, function(newVal, oldVal) {
            if (newVal !== oldVal) {
              element.draggable('destroy');
              addDraggable(scope, element, attrs);
            }
          });
        }
      };
    });
})();

},{}],41:[function(require,module,exports){
/** RESIZABLE
 *
 *    Used by the <certificate> editor.
 *
 *  @author  Ryan Booth
 *  @author  David "oodavid" King - documentation, tweaks and monkey patch
 */
(function() {

  angular.module('app')
    .directive('resizable', [function() {
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          var minSize = getMinSize(scope, attrs.designSize);
          elementResizable(scope, element, attrs, minSize);

          if (scope.block.qr_code) {
            var certificate = element.closest('.certificate-editable');
            certificate.on('documentChange', function() {
              var minSize = getMinSize(scope, attrs.designSize);
              $('.block-index-' + scope.block.block_index).resizable('option', {
                minWidth: minSize,
                minHeight: minSize
              });
              adjustDimensions(scope, element, attrs, 128, 128);
            });
          }
        }
      };
    }]);

  /** MONKEY PATCH!
   *
   *    OK, so we have a requirement for the editor to
   *     always have the width and height defined for
   *     <img> tags, so that we can correctly scale them
   *
   *    Because attribute driven images render a <div>,
   *     this now deals with that edge-case.
   *
   *  @author  David "oodavid" King
   */
  angular.module('app')
    .directive('editorImageMonkeyPatch', ['$timeout', function($timeout) {
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          if (element[0].nodeName == 'IMG') {
            element.bind('load', function() {
              adjustDimensions(scope, element, attrs, element.width(), element.height(), 'monkey-patch');
            });
          } else {
            $timeout(function() {
              adjustDimensions(scope, element, attrs, element.width(), element.height(), 'monkey-patch');
            }, 0);
          }
        }
      };
    }]);

  /**
   * At the moment, minimum size is only applicable for QRCode blocks
   */
  function getMinSize(scope, designSize) {
    if (scope.block.qr_code) {
      return designSize === 'a8' ? 105 : 60;
    }
    return null;
  }

  function elementResizable(scope, element, attrs, minSize) {
    return element.resizable({
      containment: element.closest('.certificate-editable'),
      aspectRatio: attrs.aspectRatio === 'true',
      resize: function() {
        // If we are resizing a textBlock we set the height and width on the aux variable selectedBlock
        if(!!scope.block.font) {
          scope.$parent.selectedBlock.width = Math.round(element.width());
          scope.$parent.selectedBlock.height = Math.round(element.height());
        }
      },
      stop: function(event, ui) {
        // Apply the changes
        adjustDimensions(scope, element, attrs, ui.size.width, ui.size.height, 'user-resize');
      },
      minWidth: minSize,
      minHeight: minSize
    });
  }

  function adjustDimensions(scope, element, attrs, width, height, mode) {
    // If we're monkey-patching, don't do anything if we already have a percentage width or height
    if (mode == 'monkey-patch') {
      if (scope.block && scope.block && scope.block.image_width && scope.block.image_width.indexOf('%') !== -1) {
        return;
      }
    }

    // Calculate, and apply the width and height... as percentages
    var parentWidth = element.closest('.certificate-editable').width();
    var parentHeight = element.closest('.certificate-editable').height();
    var widthPct = ((width / parentWidth) * 100).toFixed(3) + '%';
    var heightPct = ((height / parentHeight) * 100).toFixed(3) + '%';

    scope.block.image_width = widthPct;
    if (scope.block.custom_image_attribute || scope.block.qr_code || (scope.block.line_width && scope.block.orientation === 'vertical')) {
      scope.block.image_height = heightPct;
    } else if (scope.block.line_width && scope.block.orientation === 'horizontal') {
      scope.block.image_height = '3%';
    } else {
      delete scope.block.image_height;
    }

    if (scope.block.line_width && scope.block.orientation === 'vertical') {
      scope.block.image_width = '3%';
    }

    var minQRSize = null;
    if (scope.block.qr_code) {
      minQRSize = attrs.designSize === 'a8' ? 105 : 60;
      scope.block.pixel_width = width < minQRSize ? minQRSize : width;
      scope.block.pixel_height = height < minQRSize ? minQRSize : height;
    }

    if (!!scope.block.font) {
      // We don't allow values lower than 1px, so we calculate its % compared to the parent height and width
      enforceMinimumDimensions(1, scope, widthPct, heightPct, parentWidth, parentHeight);
    } else if (scope.block.qr_code) {
      // We don't allow values lower than 105px/60px, so we calculate its % compared to the parent height and width
      enforceMinimumDimensions(minQRSize, scope, widthPct, heightPct, parentWidth, parentHeight);
    }

    // If the user resized the element (rather than programmatically), then we should trigger onChange
    if (mode == 'user-resize' && attrs.onChange) {
      scope.$eval(attrs.onChange);
      element.trigger('change', element); // Used by certificateScaleText directive
    }

    scope.$apply();
  }

  function enforceMinimumDimensions(minSize, scope, widthPct, heightPct, parentWidth, parentHeight) {
    var minWidthPct = minSize * 100 / parentWidth;
    var minHeightPct = minSize * 100 / parentHeight;

    scope.block.image_width = widthPct;
    if (parseInt(widthPct) < minWidthPct) {
      scope.block.image_width = minWidthPct + '%';
    }

    scope.block.image_height = heightPct;
    if (parseInt(heightPct) < minHeightPct) {
      scope.block.image_height = minHeightPct + '%';
    }
  }
})();

},{}],42:[function(require,module,exports){
/** CERTIFICATE
 *
 *    Outputs a certificate
 *
 *          <certificate                design="credential.group.certificate_design"></certificate>
 *          <certificate                design="credential.group.certificate_design" data="credential"></certificate>
 *          <certificate class="square" design="credential.group.certificate_design" data="credential"></certificate>
 *
 *      CSS Note
 *
 *          To render this correctly, be sure to use _certificate.scss
 *           which is available as part of our CSS framework.
 *
 *      Dependencies
 *
 *          This requires the fontService, that will dynamically load
 *           any required fonts.
 *
 *      Generally...
 *
 *          Note that this file also outputs various filters and has a
 *           secondary directive that compiles strings with [attributes]
 *
 *    @author   David "oodavid" King
 */
(function() {
  // Properly escapes user input
  function escapeHtml(unsafe) {
    return unsafe
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
  // Escapes AngularJS templates like {{ constructor.constructor('alert(2)')() }}
  function escapeAngularTemplates(string){
    return string
      .replace('{{', '{​{')  // What you can't see in the replacement string is a `ZWSP` (zero-width space) character between the braces
      .replace('}}', '}​}'); // You can get a ZWSP character by running this in Chrome: `copy(String.fromCodePoint(0x200B))`
  }
  // Call this function and pass in the name of the font you want to check for availability.
  function isFontAvailable(fontName) {
    var failSafes = ['serif', 'sans-serif', 'cursive', 'monospace'];
    if (failSafes.indexOf(fontName.toLowerCase()) > -1) {
      return document.fonts.check('1em ' + fontName); // Didn't use this generally as this always seems to return true, but here it's all we've got
    }
    // creating our in-memory Canvas element where the magic happens
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    // the text whose final pixel size I want to measure
    var text = 'abcdefghijklmnopqrstuvwxyz0123456789';
    // specifying the baseline font
    context.font = '72px monospace';
    // checking the size of the baseline text
    var baselineSize = context.measureText(text).width;
    // specifying the font whose existence we want to check
    context.font = '72px ' + fontName + ', monospace';
    // checking the size of the font we want to check
    var newSize = context.measureText(text).width;
    // removing the Canvas element we created
    canvas = null;
    if (newSize == baselineSize) {
      return false;
    } else {
      return true;
    }
  }
  // Our directives, filters and services
  angular.module('app')
    // Our <certificate> custom directive
    .directive('certificate', ['fontService', 'certificateResponsivity', function(fontService, certificateResponsivity) {
      return {
        restrict: 'E',
        replace: true,
        scope: {
          design: '=?',
          data: '=?'
        },
        templateUrl: '/shared/certificate/certificate.html',
        link: function(scope, element, attrs) {
          // Notify the responsive service
          certificateResponsivity.watch(element);
          scope.$on('$destroy', function() {
            certificateResponsivity.unwatch(element);
          });
          // Load the fonts when ready, or the design changes
          scope.$watch('design', function(newval, oldval) {
            if (newval) {
              fontService.loadDesignFonts(newval);
              certificateResponsivity.resize(element);
            }
          });
        }
      };
    }])
    // Resposive service
    .service('certificateResponsivity', ['_', '$window', function(_, $window) {
      var service = this;
      service.watch = watch;
      service.unwatch = unwatch;
      service.resize = resize;
      // Adds / Removes elements from the watch list, to be resized when the window is adjusted
      var elements = [];
      function watch(element){
        elements.push(element);
      }
      function unwatch(element){
        _.remove(elements, function(o) {
          return o === element;
        });
      }
      // Resizes an element
      function resize(element){
        var container = angular.element(element);
        var cert = container.find('.certificate-inner');
        // Print-mode is not responsive
        if(container.hasClass('print')){
          return;
        }
        // Read the original dimensions
        var originalWidth = cert.width();
        var originalHeight = cert.height();
        if(!originalWidth || !originalHeight){
          return; // Nothing to do
        }
        // Container width
        var containerSize;
        if(container.attr('size')){
          // Use the attribute
          containerSize = container.attr('size');
        } else {
          // Get the "natural" size of the container
          container.css({
            'width': '',
            'height': '',
            'margin': '',
          });
          containerSize = container.parent().width();
        }
        // Defaults
        var width = 100;
        var height = 100;
        var scale = 1;
        var marginTopBottom = 0;
        var marginLeftRight = 0;
        // Render as a square?
        var isSquare = container.hasClass('square') || (originalHeight > originalWidth); // Optional class. Landscape is always rendered square
        // Rendering logic
        if(isSquare){
          if(originalHeight > originalWidth){
            // Portrait
            scale = containerSize / originalHeight;
            width = originalWidth * scale;
            height = containerSize;
            marginLeftRight = (containerSize - width) / 2;
          } else {
            // Landscape
            scale = containerSize / originalWidth;
            width = containerSize;
            height = (originalHeight * scale);
            marginTopBottom = (containerSize - height) / 2;
          }
        } else {
          // Full-width
          scale = containerSize / originalWidth;
          width = containerSize;
          height = originalHeight * scale;
        }
        // Now render
        cert.css({
          'transform': 'scale('+scale+')'
        });
        container.css({
          'width': width+'px',
          'height': height+'px',
          'margin': marginTopBottom+'px '+marginLeftRight+'px',
        });
      }
      // Listens for the window being resized
      var throttledCertificateResize = _.throttle(CertificateResize, 200, { leading: false, trailing: true });
      angular.element($window).on('resize focus', throttledCertificateResize);
      function CertificateResize(){
        angular.forEach(elements, function(el){
          resize(el);
        });
      }
    }])
    // A filter that converts "123px" into "123em" (for fonts)
    .filter('convertFontSizeToEm', function() {
      return function(value) {
        if (value && value.indexOf('px') !== -1) {
          return value.replace('px', 'em');
        }
        return value;
      };
    })
    // A filter that converts "123px" into "123" (for font size dropdown)
    .filter('convertFontSizeToNumber', function() {
      return function(value) {
        if (value && value.indexOf('px') !== -1) {
          return value.replace('px', '');
        }
        return value;
      };
    })
    // Filter that converts a font name into a font-family
    .filter('toFontFamily', ['fontService', function(fontService) {
      var fonts = fontService.getFonts({ allOrganizations: true });
      return function(fontName) {
        if (fonts[fontName]) {
          return fonts[fontName].family;
        }
      };
    }])
    // Filter that replaces attributes like [course_name] with angular variables {{ credential.course_name }}
    .filter('parseAttributes', ['attributeService', function(attributeService) {
      return function(value, data) {
        return attributeService.tagsToAngular(value, data);
      };
    }])
    // A [compile-attributes] directive - converts 'hello [recipient.name]' into 'hello {{ data.recipient.name }}' with variations when there is no data
    .directive('compileAttributes', ['$compile', 'attributeService', '$timeout', '$interval', 'fontService', function($compile, attributeService, $timeout, $interval, fontService) {
      var compiler = function() {
        return {
          post: function(scope, element, attrs) {
            // Escape any malicious code from the input
            var original = escapeAngularTemplates(attrs.compileAttributes);
            // Replace [custom.attributes] with {{ angular }}
            var angular = attributeService.tagsToAngular(original, scope.data);
            // Escape for rendering
            original = escapeHtml(original);
            angular  = escapeHtml(angular);
            // And output
            var template = '<span ng-if="data">' + angular + '</span>';
            template += '<span ng-if="!data">' + original + '</span>';
            element.html($compile(template)(scope));
            var standalone = $('body').hasClass('standalone'); // Look on body tag for 'standalone' class
            // Scaling
            if (attrs.scaling === 'true') {
              element.css('visibility', 'hidden');
              var container = element.parent();
              $timeout(function() { // Delay until next digest cycle
                var containerWidth = container.width();
                var text = element.text();
                var canvas = document.createElement('canvas');
                var context = canvas.getContext('2d');
                var fontWeight = element.css('font-weight');
                var fontFamily = element.css('font-family');
                var fontName = fontFamily.split(',')[0].replace(/^"(.*)"$/, '$1');
                var applyScaling = function() {
                  var computedStyle = getComputedStyle(container[0]);
                  var originalFontSize = parseFloat(computedStyle.fontSize);
                  var fontSize = originalFontSize;
                  context.font = fontWeight + ' ' + fontSize + 'px ' + fontFamily;
                  while (context.measureText(text).width > containerWidth)
                  {
                    fontSize = fontSize - 1;
                    context.font = fontWeight + ' ' + fontSize + 'px ' + fontFamily;
                  }
                  if (fontSize < originalFontSize) {
                    element.css('font-size', Math.floor(fontSize) + 'px');
                  }
                  element.css('visibility', 'visible');
                  if (standalone) {
                    element.trigger('scaledText');
                  }
                };
                if (isFontAvailable(fontName)) {
                  // Scale immediately
                  applyScaling();
                } else {
                  // Wait until font has actually loaded
                  var scaled = false;
                  var interval = $interval(function(count) {
                    if (isFontAvailable(fontName)) {
                      applyScaling();
                      scaled = true;
                    }
                    if (scaled || count >= 9) { // Belt and braces
                      $interval.cancel(interval);
                      if (!scaled) {
                        element.css('visibility', 'visible');
                        if (standalone) {
                          element.trigger('scaledText');
                        }
                      }
                    }
                  }, 200, 10); // Keep trying for 200 * 10 = 2000 (2 seconds)
                }
              });
            }
          }
        };
      };
      return {
        restrict: 'A',
        compile: compiler
      };
    }])
    // A [compile-src-attribute] directive - converts `[custom.logo]` into `ng-src={{ data.custom.logo }}""`
    .directive('compileSrcAttribute', ['$compile', 'attributeService', function($compile, attributeService) {
      return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
          var ngSrc = escapeHtml(attributeService.tagsToAngular(attrs.compileSrcAttribute, scope.data, true));
          element.attr('ng-src', '{{' + ngSrc + '}}'); // Add the dynamic SRC
          element.attr('ng-if', ngSrc); // Only show if we have data
          element.removeAttr('compile-src-attribute'); // Remove the attribute to prevent infinite loop
          element.removeAttr('data-compile-src-attribute'); // ...same with data- prefix
          $compile(element)(scope);
        }
      };
    }])
    // A [compile-qr-code] directive - renders QR Code SVG
    .directive('compileQrCode', ['$timeout', 'QRCode', function($timeout, QRCode) {
      return {
        restrict: 'A',
        scope: {
          block: '=',
          data: '='
        },
        link: function link(scope, element, attrs) {
          if (scope.data.url) {
            $timeout(function() { // Delay until next digest cycle to ensure dimensions are correct
              var svg = QRCode.generateSVG(scope.data.url, {
                ecclevel: 'M', // 'L', 'M', 'Q' and 'H'
                fillcolor: scope.block.background_color,
                textcolor: scope.block.foreground_color,
                margin: 4,
                modulesize: 8
              });
              element.append(svg);
            });
          }
        }
      };
    }])
    // An information utility
    .service('certificateDimensions', [function() {
      var dimensions = {
        'a4': {
          landscape: {
            screen: {
              width: 1123,
              height: 794
            },
            print: {
              width: 3626,
              height: 2598
            },
          },
          portrait: {
            screen: {
              width: 794,
              height: 1123
            },
            print: {
              width: 2598,
              height: 3626
            },
          },
        },
        'a8': {
          landscape: {
            screen: {
              width: 280,
              height: 197
            },
            print: {
              width: 874,
              height: 614
            },
          },
          portrait: {
            screen: {
              width: 197,
              height: 280
            },
            print: {
              width: 614,
              height: 874
            },
          },
        },
        'us-letter': {
          landscape: {
            screen: {
              width: 1056,
              height: 816
            },
            print: {
              width: 3418,
              height: 2668
            },
          },
          portrait: {
            screen: {
              width: 816,
              height: 1056
            },
            print: {
              width: 2668,
              height: 3418
            },
          },
        },
      };
      this.getDimensions = function(paperSize, orientation, media) {
        if (dimensions[paperSize] && dimensions[paperSize][orientation] && dimensions[paperSize][orientation][media]) {
          return dimensions[paperSize][orientation][media];
        }
        return false;
      };
    }]);
})();

                // var fontStatus = fontService.getStatus(fontName);
                // if (window.location.hostname.endsWith('standalone.credential.net')) {
                //   containerWidth = containerWidth * fontStatus.correction;
                // }

                // var originalTextWidth = context.measureText(text).width;

                // var finalTextWidth = context.measureText(text).width;

                // if (!loaded) {
                //   element.text(fontName + ' did not load');
                // }

                // element.attr('log',
                //   'text = ' + text +
                //   ', containerWidth = ' + containerWidth +
                //   'px, fontWeight = ' + fontWeight +
                //   ', fontFamily = ' + fontFamily +
                //   ', originalFontSize = ' + originalFontSize +
                //   'px, originalTextWidth = ' + originalTextWidth +
                //   'px, finalTextWidth = ' + finalTextWidth || 'not set' +
                //   'px, usedFont = ' + usedFont
                // );
                // container.css('visibility', 'visible');

},{}],43:[function(require,module,exports){
/** DROPDOWN
 *
 *   <dropdown close="close">
 *     <dropdown-button>Open The Dropdown</dropdown-button>
 *     <dropdown-content>Any content</dropdown-content>
 *   </dropdown>
 *
 *   'close' is optional and provides access to close.hide which can be called to close the menu
 *   'pop-up' is optional and defaults to false
 *   'on-show' optional function that runs as the menu is shown
 *
 */

require('../../shared/_services/uuidv4.service.js');

// Dropdown Container - logic
var dropdownComponent = {
  bindings: {
    close: '<?',
    onClose: '&',
    onShow: '&',
    focusId: '@?',
    label: '@?',
    haspopup: '@?',
    selectedBlock: '=?'
  },
  controller: dropdownComponentController,
};
dropdownComponentController.$inject = ['$element', '$scope', '$timeout', '$injector', 'uuidv4'];
function dropdownComponentController($element, $scope, $timeout, $injector, uuidv4) {
  var ctrl = this;

  ctrl.$postLink = postLink;
  ctrl.isVisible = false;
  ctrl.toggleVisibility = toggleVisibility;
  ctrl.tabInto = tabInto;
  ctrl.$onInit = onInit;

  ctrl.dropdownId = uuidv4.generate();

  var focusManager;
  var adjacentFoci;
  var usingFocusManager = $injector.has('FocusManagerService');
  if (usingFocusManager) {
    focusManager = $injector.get('FocusManagerService');
  }

  function onInit() {
    if (ctrl.close) {
      ctrl.close.hide = hide;
    }
  }

  $scope.$on('$destroy', function () {
    if (ctrl.onClose) {
      ctrl.onClose({ block: ctrl.selectedBlock });
    }
    angular.element(document).off('click', bodyClick);
    angular.element(document).off('keydown', handleKeydown);
    angular.element(document).off('scroll', handleScroll);
    angular.element(window).off('resize', handleResize);
    $element.find('dropdown-content')[0].removeEventListener('blur', checkFocus, true);
  });

  var toggleLocked = false; // To prevent click recursion
  // Toggle visibility
  function toggleVisibility(event) {
    if (toggleLocked) {
      return;
    }
    var innerButton = $element.find('dropdown-button > div [ng-click]');
    if (innerButton.length > 0) { // Ignore toggle if button content has it's own click handler
      event.preventDefault();
      event.stopImmediatePropagation();
      toggleLocked = true;
      innerButton.click();
      $timeout(function() {
        toggleLocked = false;
      }, 2000);
      return;
    }
    if (!tabbedInto) {
      $element.find('dropdown-button > div').blur(); // Hide visual tab cursor
    }
    if (ctrl.isVisible) {
      hide();
    } else {
      show();
    }
  }

  var tabbedInto = false;
  // Tab into menu
  function tabInto(event) {
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      // If there is an embedded button (ng-click) and enter or space has been pressed, click on that. This is used by the responsive menu component
      var embeddedButton = $element.find('dropdown-button > div [ng-click]');
      if (embeddedButton.length > 0) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.stopImmediatePropagation();
          event.preventDefault();
          $timeout(function () { // Delay to next digest cycle
            embeddedButton.click();
          });
        }
      } else {
        event.stopImmediatePropagation();
        event.preventDefault();
        tabbedInto = true;
        toggleVisibility();
      }
    }
  }

  // Hide and Show
  var popUp = false;
  function hide() {
    if (ctrl.isVisible) { // Hide is called externally, so this saves unnecessary processing
      if (ctrl.onClose) {
        ctrl.onClose({ block: ctrl.selectedBlock });
      }
      ctrl.isVisible = false;
      tabbedInto = false;
      popUp = false;
      if (usingFocusManager) {
        var dropdownButton = $element.find('dropdown-button > div');
        dropdownButton.attr('aria-expanded', 'false');
      }
    }
  }
  function show() {
    if (ctrl.onShow) {
      ctrl.onShow({ block: ctrl.selectedBlock  });
    }
    // If required, get adjacent focussable elements
    if (usingFocusManager) {
      var dropdownButton = $element.find('dropdown-button > div');
      dropdownButton.attr('aria-expanded', 'true');
      adjacentFoci = focusManager.getAdjacentFoci(dropdownButton);
    }
    // Calculate whether to pop up or drop down
    var buttonHeight = $element.find('dropdown-button').height();
    var availableHeightAbove = $element.offset().top - angular.element(window).scrollTop();
    var availableHeightBelow = window.innerHeight - (availableHeightAbove + buttonHeight + window.innerHeight*.08);
    popUp = availableHeightAbove > availableHeightBelow;
    ctrl.offset = popUp ? buttonHeight + 'px' : 'auto';
    ctrl.maxHeight = ((popUp ? availableHeightAbove : availableHeightBelow) - 8) + 'px';
    ctrl.isVisible = true;
    scrollToSelection();
  }

  // Utility
  function hideAndDigest() {
    $timeout(hide);
  }

  function checkFocus(event) {
    if (event.relatedTarget && !$.contains($element.find('dropdown-content')[0], event.relatedTarget)) {
      hideAndDigest();
    }
  }

  // When the event target accepts text-input, we don't trigger "close"
  var inputNodes = /textarea|input|select/i;

  // Add and remove global event listeners...
  function postLink() {
    angular.element(document).on('click', bodyClick);
    angular.element(document).on('keydown', handleKeydown);
    angular.element(document).on('scroll', handleScroll);
    angular.element(window).on('resize', handleResize);
    $element.find('dropdown-content')[0].addEventListener('blur', checkFocus, true);
    // addEventListener with 'true' because, as blur doesn't bubble, we're attaching to the event capturing phase.
    // If we need to support IE, we'll need to use 'focusin' as it doesn't support event capturing
    // See https://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
    if (usingFocusManager) { // If using the focus manager, make the div directly within the <dropdown-button> focussable
      var dropdownButton = $element.find('dropdown-button > div');
      dropdownButton.attr('role', 'button');
      dropdownButton.attr('tabindex', '0');
      if (ctrl.haspopup !== 'false') {
        dropdownButton.attr('aria-haspopup', ctrl.haspopup || 'true');
        dropdownButton.attr('aria-expanded', 'false');
        dropdownButton.attr('aria-controls', ctrl.dropdownId);
      }
    }
  }

  // Hide the content when clicking the page, or a link within the dropdown content
  function bodyClick(e) {
    $timeout(function(){
      var element = $element[0];
      var content = $element.find('dropdown-content')[0];
      if (!$.contains(element, e.target)) {
        hideAndDigest(); // The user clicked outside the element
      } else {
        if($.contains(content, e.target)) {
          // The click target was a link or an element inside a link
          if (
            e.target.nodeName.toLowerCase() === 'a'
            || angular.element(e.target).parent().prop('nodeName').toLowerCase() === 'a'
            || angular.element(e.target).parent().parent().prop('nodeName').toLowerCase() === 'a'
          ) {
            hideAndDigest(); // They clicked a link within the content
          }
        }
      }
    });
  }

  // Keyboard navigation - up and down cursor tracking requires 'role="menuitem"' or 'role="option"' attaching to each active element in the menu
  function handleKeydown(event) {
    if (ctrl.isVisible) {
      if (event.target.isContentEditable || inputNodes.test(event.target.nodeName)) {
        return; // Don't close if the target is "text-accepting"
      }
      var activeElement = document.activeElement;
      var content = $element.find('dropdown-content')[0];
      if ($.contains(content, activeElement)) { // Focus in menu content
        switch (event.which) {
          case 9:
            // Tab, if tabbing out of menu, set focus
            event.stopImmediatePropagation();
            event.preventDefault();
            hideAndDigest();
            if (adjacentFoci) {
              if (event.shiftKey) {
                adjacentFoci.previous.focus();
              } else {
                adjacentFoci.next.focus();
              }
            }
            break;
          case 27:
            // Hide, if tapping ESC
            hideAndDigest();
            // if ($.contains(content, activeElement)) { // Focus in menu content
              $element.find('dropdown-button > div').focus(); // Show visual tab cursor
            // } else {
            //   $element.find('dropdown-button > div').blur(); // Hide visual tab cursor
            // }
            break;
          case 32:
            // Select, if pressing SPACE
            event.stopImmediatePropagation();
            event.preventDefault();
            var $activeElement = $(activeElement);
            var url = $activeElement.attr('href');
            // It's not sufficient just to click on the active element
            if (url) {
              if (url.indexOf('mailto:') === 0) {
                window.location = url;
              } else {
                window.open(url, $activeElement.attr('target'));
              }
            } else {
              $activeElement.click();
            }
            break;
          case 38:
            // Up arrow
            focusMenuItem(event, 'previous');
            break;
          case 40:
            // Down arrow
            focusMenuItem(event, 'next');
            break;
        }
      } else {
        hideAndDigest();
      }
    }
  }

  // This is used to prevent menu keyboard and scrolling interaction
  // that would the cause browser to scroll and annoyingly close the menu
  var menuInteraction = false;
  function handleScroll(event) {
    if (menuInteraction) {
      event.preventDefault();
      event.stopImmediatePropagation();
      menuInteraction = false;
    } else {
      if (ctrl.isVisible) {
        hideAndDigest();
      }
    }
  }

  function handleResize() {
    if (ctrl.isVisible) {
      hideAndDigest();
    }
  }

  // Close when routing
  if ($injector.has('$transitions')) {
    var $transitions = $injector.get('$transitions');
    $transitions.onSuccess({}, function($transition) {
      hide();
    });
  }

  // Menu item <a> tags require the role "menuitem" or "option"
  var menuItems = [];

  // Scroll to selection - requires the 'selected' class to be added to a <dropdown-content> element
  function scrollToSelection() {
    $timeout(function() {
      var selection = $element.find('.selected');
      var contentDiv = $element.find('dropdown-content > div');
      menuItems = contentDiv.find('[role="menuitem"],[role="option"]:not([disabled])');
      contentDiv.on('scroll', function() {
        menuInteraction = true;
      });
      if (selection.length > 0) {
        var topPos = selection[0].offsetTop;
        contentDiv.scrollTop(topPos);
      }
      // If tabbing, set highlight to selection
      if (tabbedInto) {
        var link;
        if (selection.length > 0) {
          link = selection.find('a');
        } else {
          var links = contentDiv.find('a[href]:visible');
          link = links.first();
        }
        link.focus();
      }
    });
  }

  // Focus on the required menu item
  function focusMenuItem(event, direction) {
    if (menuItems.length > 0) {
      event.preventDefault();
      event.stopImmediatePropagation();
      var focusIndex = 0;
      var activeElement = document.activeElement;
      var content = $element.find('dropdown-content')[0];
      var focussedItem;
      if ($.contains(content, activeElement)) {
        focussedItem = activeElement;
      } else {
        focussedItem = $element.find('.selected > a')[0];
      }
      for (var itemIndex = 0; itemIndex < menuItems.length; itemIndex++) {
        if (menuItems[itemIndex] === focussedItem) {
          focusIndex = itemIndex;
          break;
        }
      }
      if (direction === 'previous') {
        if (focusIndex > 0) {
          focusIndex--;
        }
      } else if (direction === 'next') {
        if ($.contains(content, activeElement) && focusIndex < menuItems.length - 1) {
          focusIndex++;
        }
      }
      menuItems[focusIndex].focus();
      menuInteraction = true;
    }
  }
}

// Dropdown Button - toggle the visibility
var dropdownButtonComponent = {
  require: {
    dropdown: '^dropdown',
  },
  transclude: true,
  template: '<div ng-click="$ctrl.dropdown.toggleVisibility($event)" ng-keydown="$ctrl.dropdown.tabInto($event)" ng-attr-focus-id="{{ $ctrl.dropdown.focusId }}" ng-transclude></div>',
};

// Dropdown Content - simply obeys the state of the component
var dropdownContentComponent = {
  require: {
    dropdown: '^dropdown',
  },
  transclude: true,
  template: '<div ng-attr-id="{{ $ctrl.dropdown.dropdownId }}" class="animate-slide" ng-if="$ctrl.dropdown.isVisible" ng-style="{ \'max-height\': $ctrl.dropdown.maxHeight, bottom: $ctrl.dropdown.offset }" ng-transclude role="group" ng-attr-aria-label="{{ $ctrl.dropdown.label }}"></div>',
};

angular
  .module('app')
  .component('dropdown', dropdownComponent)
  .component('dropdownButton', dropdownButtonComponent)
  .component('dropdownContent', dropdownContentComponent);

},{"../../shared/_services/uuidv4.service.js":30}],44:[function(require,module,exports){
/** Links - DIRECTIVE
 *
 *  For all external links:
 *    Protects against tabnapping
 *    Opens in a new tab
 *    Tracks clicks
 *
 *    @author   David "oodavid" King
 */
require('../_services/url.service.js');
linkTrackingDirective.$inject = ['$location', 'api', 'urlService'];
function linkTrackingDirective($location, api, urlService){

  function linkTrackingDirectiveLink(scope, element, attrs) {
    // Protect against tabnapping, open external links in a new tab
    element.bind('click mousedown contextmenu', function(/* event */){
      var link = urlService.parse(element[0].href);
      if(link.external){
        element.attr('rel', 'noopener noreferrer');
        element.attr('target', '_blank');
      }
    });
    // Track clicks
    element.bind('click', function(/* event */) {
      var link = urlService.parse(element[0].href);
      if(link.external){
        var payload = {
          from: $location.absUrl(),
          to: link.href,
          html: getLinkHtml(element),
          aad: link.query.aad,
        };
        api
          .request('/analytics/track_link', payload)
          .catch(function(){});
      }
    });
  }

  function getLinkHtml(element){
    return element
            .html() // Text
            .replace(/^\s+|\s+$/g, '') // ..trimmed
            .substring(0, 256); // ...truncated
  }

  return {
    restrict: 'E',
    link: linkTrackingDirectiveLink,
  };
}

angular
  .module('app')
  .directive('a', linkTrackingDirective);

},{"../_services/url.service.js":29}],45:[function(require,module,exports){
/** FONT MENU
 *
 *   <font-menu ng-model="fontName" fonts="fonts" select-action="selectFont"></font-menu>
 *
 *   @author Andrew Bateman
 */
var fontMenuComponent = {
  controller: fontMenuComponentController,
  bindings: {
    ngModel: '<',
    fonts: '<',
    selectAction: '<'
  },
  templateUrl: '/shared/font-menu/font-menu.html',
};

fontMenuComponentController.$inject = [];
function fontMenuComponentController() {
  var ctrl = this;
}

angular
  .module('app')
  .component('fontMenu', fontMenuComponent);

},{}],46:[function(require,module,exports){
/** FONT SERVICE
 *
 *    Used for:
 *      Loading fonts related to <certificate> elements
 *      Listing all fonts available to the user
 *
 *    To my chagrin the <credential> designs assume that there
 *     is a default font on the <body> of the page, namely:
 *      "Source Sans Pro"
 *     ...so we must *always* load that, just in case. Pah.
 *
 *    A note about "custom" fonts, we expect these fonts to
 *       be available locally, we manually inject the font
 *       into the <head> with multiple font variations for
 *       decent browser support, read more here:
 *      http://www.456bereastreet.com/archive/201012/font-face_tip_define_font-weight_and_font-style_to_keep_your_css_simple/
 *
 *    ...need to convert "custom" fonts to other formats?
 *      https://transfonter.org/
 *
 *    @author   David "oodavid" King
 */
fontService.$inject = ['_', '$window', '$injector', '$q', '$timeout', 'ENV'];
function fontService(_, $window, $injector, $q, $timeout, ENV) {
  var service = this;
  service.loadFont = loadFont;
  service.loadCredentialFonts = loadCredentialFonts;
  service.loadDesignFonts = loadDesignFonts;
  service.getFonts = getFonts;
  service.getWeights = getWeights;
  service.getNearestWeight = getNearestWeight;
  service.getCssImportString = getCssImportString;
  service.getStatus = getStatus;
  service.whenFontLoaded = whenFontLoaded;
  service.hasItalicWeight = hasItalicWeight;

  var weights = {
    100: 'Thin',
    200: 'Extra Light',
    300: 'Light',
    400: 'Normal',
    500: 'Medium',
    600: 'Semi Bold',
    700: 'Bold',
    800: 'Extra Bold',
    900: 'Black',
  };

  function weightAsNumber(weight) {
    if (Number.isInteger(weight)) { // Already a number
      return weight;
    }
    if (isNaN(weight)) { // Not a number as a string, i.e. 'Normal', 'Bold', etc
      var weightNumber = 400; // Default to 'Normal'
      $.each(weights, function(key, value) {
        if (value.toLowerCase() === weight) {
          weightNumber = key;
        }
      });
      return weightNumber;
    } else { // Is a number as a string
      return parseInt(weight);
    }
  }

  var host = '';
  if ($window.location.hostname === 'localhost') {
    host = 'localhost:1337';
  } else {
    host = $window.location.host;
  }

  var defaultFont = 'Source Sans Pro';

  // All available fonts
  // ...those which have been loaded already get an additional "loaded:true" flag
  var fonts = {
    'Acto':                 { type: 'custom', weights: [300, 400, 500, 600, 700],                                                                                             fallback: 'sans-serif', organization: 411 },
    'Actor':                { type: 'google', weights: [400],                                                                                                                 fallback: 'sans-serif' },
    'Acid Grotesk':         { type: 'custom', weights: [300, 400, 500, 700],                                                                                                  fallback: 'sans-serif', organization: 95324},
    'Aeonik Mono':          { type: 'custom', weights: [300, 400, 500, 600],                                                                                                  fallback: 'sans-serif', organization: 258344},
    'Alegreya SC':          { type: 'google', weights: [400, '400i', 500, '500i', 700, '700i'],                                                                               fallback: 'serif' },
    'Aleo':                 { type: 'google', weights: [300, '300i', 400, '400i', 700, '700i'],                                                                               fallback: 'serif' },
    'Allura':               { type: 'google', weights: [400],                                                                                                                 fallback: 'cursive' },
    'Anton':                { type: 'google', weights: [400],                                                                                                                 fallback: 'sans-serif' },
    'Antonio':              { type: 'custom', weights: [300, 400, 700],                                                                                                       fallback: 'sans-serif' },
    'Archivo':              { type: 'google', weights: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'], fallback: 'sans-serif' },
    'Arial':                { type: 'system', weights: [400, '400i', 700, '700i'],                                                                                            fallback: '\'Helvetica Neue\', Helvetica, sans-serif' },
    'Asap':                 { type: 'google', weights: [400, '400i', 500, '500i', 600, '600i', 700, '700i'],                                                                  fallback: 'sans-serif' },
    'Atkinson Hyperlegible':{ type: 'google', weights: [200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i'],                           fallback: 'sans-serif' },
    'Avenir Next':          { type: 'custom', weights: [200, '200i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i'],                                        fallback: 'sans-serif', organization: 1566 },
    'Barlow':               { type: 'google', weights: [200, '200i', 300, '300i', 400, '400i', 700, '700i'],                                                                  fallback: 'sans-serif' },
    'Bebas Neue':           { type: 'google', weights: [400],                                                                                                                 fallback: 'sans-serif' },
    'Big Shoulders':        { type: 'google', weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],                                                                         fallback: 'sans-serif' },
    'Bilbo Swash Caps':     { type: 'google', weights: [400],                                                                                                                 fallback: 'cursive' },
    'Bitter':               { type: 'google', weights: [200, '200i', 400, '400i', 600, '600i', 700, '700i'],                                                                  fallback: 'serif' },
    'Brandon Grotesque':    { type: 'custom', weights: [400, 600, 700],                                                                                                       fallback: 'sans-serif' },
    'Bree Serif':           { type: 'google', weights: [400],                                                                                                                 fallback: 'serif' },
    'British Council Sans': { type: 'custom', weights: [400, 700],                                                                                                            fallback: 'sans-serif', organization: 30 },
    'British Council Sans Headline': { type: 'custom', weights: [400],                                                                                                        fallback: 'sans-serif', organization: 30 },
    'Cairo':                { type: 'google', weights: [200, 300, 400, 500, 600, 700, 800, 900],                                                                              fallback: 'sans-serif' },
    'Caveat':               { type: 'google', weights: [400, '400i', 600, '600i', 700, '700i'],                                                                               fallback: 'sans-serif' },
    'Cinzel':               { type: 'google', weights: [400, 700],                                                                                                            fallback: 'serif' },
    'Centra No.1':          { type: 'custom', weights: [100, 400, 500],                                                                                                       fallback: 'sans-serif', organization: 13203 },
    'Charm':                { type: 'google', weights: [400, 700],                                                                                                            fallback: 'cursive' },
    'Chivo':                { type: 'google', weights: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'], fallback: 'sans-serif' },
    'Cormorant Garamond':   { type: 'google', weights: [400, '400i', 600, '600i', 700, '700i'],                                                                               fallback: 'serif' },
    'Cormorant SC':         { type: 'google', weights: [400, '400i', 600, '600i', 700, '700i'],                                                                               fallback: 'serif' },
    'Crimson Text':         { type: 'google', weights: [400, '400i', 600, '600i', 700, '700i'],                                                                               fallback: 'serif' },
    'Dancing Script':       { type: 'google', weights: [400, 700],                                                                                                            fallback: 'cursive' },
    'D-DIN Pro':            { type: 'custom', weights: [400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],                                        fallback: 'sans-serif', organization: 7631 },
    'DM Sans':              { type: 'google', weights: [400, '400i', 500, '500i', 700, '700i'],                                                                               fallback: 'sans-serif' },
    'DM Serif Display':     { type: 'google', weights: [400, '400i'],                                                                                                         fallback: 'serif' },
    'Domine':               { type: 'google', weights: [400, 700],                                                                                                            fallback: 'serif' },
    'EB Garamond':          { type: 'google', weights: [400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i'],                                                     fallback: 'serif' },
    'Encode Sans':          { type: 'google', weights: [300, 400, 600, 700, 800],                                                                                             fallback: 'serif' },
    'Epilogue':             { type: 'google', weights: [400, '400i', 500, '500i', 600, '600i', 700, '700i'],                                                                  fallback: 'sans-serif' },
    'EverydaySans':         { type: 'custom', weights: [300, '300i', 400, '400i', 500, '500i', 700, '700i', 900, '900i'],                                                     fallback: 'sans-serif', organization: 162237 },
    'Felipa':               { type: 'google', weights: [400],                                                                                                                 fallback: 'cursive' },
    'Figtree':              { type: 'google', weights: [300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],                           fallback: 'sans-serif' },
    'Fira Mono':            { type: 'google', weights: [400, 500, 700],                                                                                                       fallback: 'monospace' },
    'Fira Sans':            { type: 'google', weights: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'], fallback: 'serif' },
    'Georgia':              { type: 'system', weights: [400, '400i', 700, '700i'],                                                                                            fallback: '\'Times New Roman\', Times, serif' },
    'Glacial Indifference': { type: 'custom', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'sans-serif', organization: 7631 },
    'Gotham':               { type: 'custom', weights: [200, '200i', 300, '300i', 400, '400i', 500, '500i', 700, '700i', 800, '800i'],                                        fallback: 'sans-serif', organization: 675 },
    'Graphik':              { type: 'custom', weights: [400],                                                                                                                 fallback: 'sans-serif', organization: 13203 },
    'Great Vibes':          { type: 'google', weights: [400],                                                                                                                 fallback: 'cursive' },
    'GT Pressura Mono':     { type: 'custom', weights: [400, 700],                                                                                                            fallback: 'sans-serif', organization: 23259 },
    'Heebo':                { type: 'google', weights: [400, '400i', 600, '600i', 700, '700i'],                                                                               fallback: 'sans-serif' },
    'IBM Plex Sans':        { type: 'google', weights: [300, '300i', 400, '400i', 600, '600i', 700, '700i'],                                                                  fallback: 'sans-serif' },
    'IBM Plex Serif':       { type: 'google', weights: [300, '300i', 400, '400i', 600, '600i', 700, '700i'],                                                                  fallback: 'serif' },
    'IM Fell Great Primer': { type: 'google', weights: [400, '400i'],                                                                                                         fallback: 'serif' },
    'Indie Flower':         { type: 'google', weights: [400, 700],                                                                                                            fallback: 'cursive' },
    'Inter':                { type: 'google', weights: [200, '200i', 300, '300i', 400, '400i', 700, '700i'],                                                                  fallback: 'sans-serif' },
    'Josefin Sans':         { type: 'google', weights: [400, '400i', 600, '600i'],                                                                                            fallback: 'sans-serif' },
    'Jost':                 { type: 'google', weights: [300, '300i', 400, '400i', 600, '600i', 700, '700i'],                                                                  fallback: 'sans-serif' },
    'Lato':                 { type: 'google', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'sans-serif' },
    'Larken':               { type: 'custom', weights: [300, 700],                                                                                                            fallback: 'serif', organization: 147411},
    'Libre Baskerville':    { type: 'google', weights: [400, '400i', 700],                                                                                                    fallback: 'serif' },
    'Libre Caslon Text':    { type: 'google', weights: [400, '400i', 700],                                                                                                    fallback: 'serif' },
    'Lora':                 { type: 'google', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'serif' },
    'Manrope':              { type: 'google', weights: [200, 300, 400, 500, 600, 700, 800],                                                                                   fallback: 'sans-serif' },
    'Manufacturing Consent':{ type: 'google', weights: [400],                                                                                                                 fallback: 'cursive' },
    'Merriweather':         { type: 'google', weights: [300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],                           fallback: 'serif' },
    'Monospace':            { type: 'system', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'monospace' },
    'Montserrat':           { type: 'google', weights: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'], fallback: 'sans-serif' },
    'Museo':                { type: 'custom', weights: [100, 300, 500, 700, 900],                                                                                             fallback: 'serif', organization: 4173 },
    'Neue Rational Condensed Bold': { type: 'custom', weights: [700],                                                                                                         fallback: 'sans-serif', organization: [{id: 7110, environment: 'eu-production'}] },
    'Newsreader':           { type: 'google', weights: [200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i'],                           fallback: 'serif' },
    'Noto Sans':            { type: 'google', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'sans-serif' },
    'Noto Sans JP':         { type: 'google', weights: [100, 300, 400, 500, 700, 900],                                                                                        fallback: 'sans-serif' },
    'Noto Sans SC':         { type: 'google', weights: [100, 300, 400, 500, 700, 900],                                                                                        fallback: 'sans-serif' },
    'Noto Serif':           { type: 'google', weights: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'], fallback: 'serif' },
    'Noto Serif JP':        { type: 'google', weights: [200, 300, 400, 500, 600, 700, 900],                                                                                   fallback: 'serif' },
    'Nunito':               { type: 'google', weights: [200, '200i', 300, '300i', 400, '400i', 700, '700i'],                                                                  fallback: 'sans-serif' },
    'Nunito Sans':          { type: 'google', weights: [200, '200i', 300, '300i', 400, '400i', 700, '700i'],                                                                  fallback: 'sans-serif' },
    'Open Sans':            { type: 'google', weights: [300, '300i', 400, '400i', 700],                                                                                       fallback: 'sans-serif' },
    'Open Sauce Sans':      { type: 'custom', weights: [300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],                           fallback: 'sans-serif', organization: 147411},
    'Oswald':               { type: 'google', weights: [400],                                                                                                                 fallback: 'sans-serif' },
    'Outfit':               { type: 'google', weights: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'], fallback: 'sans-serif' },
    'Overpass':             { type: 'google', weights: [300, '300i', 400, '400i', 600, '600i', 700, '700i'],                                                                  fallback: 'sans-serif' },
    'Pinyon Script':        { type: 'google', weights: [400, 700],                                                                                                            fallback: 'cursive' },
    'Plain Black Wide':     { type: 'custom', weights: [400],                                                                                                                 fallback: 'cursive' },
    'Playball':             { type: 'google', weights: [400],                                                                                                                 fallback: 'cursive' },
    'Playfair Display':     { type: 'google', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'serif' },
    'Playfair Display SC':  { type: 'google', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'serif' },
    'Plus Jakarta Sans':    { type: 'google', weights: [200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i'],                           fallback: 'sans-serif' },
    'Poppins':              { type: 'google', weights: [300, '300i', 400, '400i', 700, '700i'],                                                                               fallback: 'sans-serif' },
    'PPFormula':            { type: 'custom', weights: [500],                                                                                                                 fallback: 'sans-serif', organization: 34765 },
    'PPMori':               { type: 'custom', weights: [400],                                                                                                                 fallback: 'sans-serif', organization: 23259 },
    'PP Right Grotesk':     { type: 'custom', weights: [500, 700],                                                                                                            fallback: 'sans-serif', organization: [{id: 37, environment: 'production_eu'}] },
    'PP Telegraf':          { type: 'custom', weights: [400, 500, 600, 800],                                                                                                  fallback: 'sans-serif', organization: 13672 },
    'PT Sans':              { type: 'google', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'sans-serif' },
    'PT Serif':             { type: 'google', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'serif' },
    'Public Sans':          { type: 'google', weights: [200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i'],                           fallback: 'sans-serif' },
    'Qualtrics Grotesque':  { type: 'custom', weights: [200, 300, 400, 700],                                                                                                  fallback: 'sans-serif' },
    'Questrial':            { type: 'custom', weights: [400],                                                                                                                 fallback: 'sans-serif' },
    'Rajdhani':             { type: 'google', weights: [300, 400, 500, 600, 700],                                                                                             fallback: 'sans-serif' },
    'Raleway':              { type: 'google', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'sans-serif' },
    'Roboto':               { type: 'google', weights: [300, '300i', 400, '400i', 700, '700i'],                                                                               fallback: 'sans-serif' },
    'Roboto Condensed':     { type: 'google', weights: [300, '300i', 400, '400i', 700, '700i'],                                                                               fallback: 'sans-serif' },
    'Roboto Slab':          { type: 'google', weights: [400, '400i', 600, '600i', 700, '700i'],                                                                               fallback: 'serif' },
    'Sacramento':           { type: 'google', weights: [400],                                                                                                                 fallback: 'cursive' },
    'sans-serif':           { type: 'system', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'sans-serif' },
    'Sherman Sans':         { type: 'custom', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'sans-serif', organization: 89366 },
    'Sherman Serif':        { type: 'custom', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'serif', organization: 89366 },
    'Skillsoft Sans':       { type: 'custom', weights: [400, '400i', 500, '500i', 700, '700i'],                                                                               fallback: 'sans-serif', organization: [{id: 3, environment: 'sandbox'}, {id: 8, environment: 'eu-production'}, {id: 29298, environment: 'production'}] },
    'Skillsoft Text':       { type: 'custom', weights: [300, '300i', 400, '400i', 500, '500i', 700, '700i', 900, '900i'],                                                     fallback: 'sans-serif', organization: [{id: 3, environment: 'sandbox'}, {id: 8, environment: 'eu-production'}, {id: 29298, environment: 'production'}] },
    'Source Code Pro':      { type: 'google', weights: [200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'],              fallback: 'monospace' },
    'Source Sans Pro':      { type: 'google', weights: [300, '300i', 400, '400i', 600, '600i', 700, '700i'],                                                                  fallback: 'sans-serif' },
    'Spectral':             { type: 'google', weights: [200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i'],                           fallback: 'serif' },
    'Syne':                 { type: 'google', weights: [400, 500, 600, 700, 800],                                                                                             fallback: 'sans-serif' },
    'Tangerine':            { type: 'google', weights: [400, 700],                                                                                                            fallback: 'cursive'},
    'Times New Roman':      { type: 'system', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'Times, Baskerville, Georgia, serif' },
    'Titillium Web':        { type: 'google', weights: [200, '200i', 300, '300i', 400, '400i', 700, '700i'],                                                                  fallback: 'sans-serif' },
    'TWK Lausanne':         { type: 'custom', weights: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'], fallback: 'sans-serif', organization: 258344 },
    'UnifrakturMaguntia':   { type: 'google', weights: [400],                                                                                                                 fallback: 'cursive' },
    'Urbanist':             { type: 'google', weights: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'], fallback: 'sans-serif' },
    'Varela Round':         { type: 'google', weights: [400],                                                                                                                 fallback: 'sans-serif' },
    'Verdana':              { type: 'system', weights: [400, '400i', 700, '700i'],                                                                                            fallback: 'Geneva, sans-serif' },
    'Work Sans':            { type: 'google', weights: [100, '100i', 200, '200i', 300, '300i', 400, '400i', 500, '500i', 600, '600i', 700, '700i', 800, '800i', 900, '900i'], fallback: 'sans-serif' },
  };
  /*
    Consider adding these system font families
    NB: BE might need to install these fonts on the server

      "'Bookman Old Style', serif",
      "Courier, monospace",
      "'Courier New', Courier, monospace",
      "Impact, Charcoal, sans-serif",
      "'Lucida Console', Monaco, monospace",
      "'Lucida Sans Unicode', 'Lucida Grande', sans-serif",
      "'Palatino Linotype', 'Book Antiqua', Palatino, serif;",
      "Tahoma, Geneva, sans-serif",
      "'Times New Roman', Times, serif",
      "'Trebuchet MS', Helvetica, sans-serif",
      "Verdana, Geneva, sans-serif",
  */

  // Add the "name" as a property
  // Add the "family" as a property (combines the fallback and the fontName)
  // Add the "googleFamily" for each - this is the string that google fonts uses to identify the font
  function updateFonts(){
    _(fonts).forEach(function(font, fontName) {
      font.name = fontName;
      font.family = "'" + fontName + "'" + (font.fallback ? (', ' + font.fallback) : '');
      if (font.type == 'google') {
        font.googleFamily = fontName.replace(/\s/g, '+') + ':' + font.weights.join(',') + ':latin,latin-ext';
      }
    });
  }
  updateFonts();

  function getStatus(fontName) {
    return fonts[fontName] || {};
  }

  // Loads a single font, if we haven't already
  function loadFont(fontName){
    var font;
    fontName = fontName.trim();
    // Google fonts
    if (fonts[fontName] && fonts[fontName].type === 'google' && !fonts[fontName].loaded) {
      font = fonts[fontName];
      $('head').prepend('<link href="https://fonts.googleapis.com/css?family=' + fontName.replace(/\s/g, '+') + ':' + font.weights.join(',') + '&display=block" rel="stylesheet">');
      font.loaded = true;
    }
    // Custom fonts
    if (fonts[fontName] && fonts[fontName].type === 'custom' && !fonts[fontName].loaded) {
      font = fonts[fontName];
      $('head').prepend('<style type="text/css">' + getCssImportString(fontName, font.weights) + '</style>');
      font.loaded = true;
    }
    // System fonts
    if (fonts[fontName] && fonts[fontName].type === 'system' && !fonts[fontName].loaded) {
      // Just assume it's there
      font = fonts[fontName];
      font.loaded = true;
    }
  }

  // Loads all fonts used in a credential
  function loadCredentialFonts(credential) {
    if (credential.group && credential.group.certificate_design) {
      loadDesignFonts(credential.group.certificate_design);
    }
  }

  // Load all fonts used in a design
  function loadDesignFonts(design) {
    if (design && design.blocks) {
      for (var bl = design.blocks.length, b = 0; b < bl; b++) {
        if (design.blocks[b].font) {
          loadFont(design.blocks[b].font);
        }
      }
    }
    // See block comment
    loadFont(defaultFont);
  }

  // Whether a font restricted to an organization should be available to the given organization.
  // Supports the legacy format (a single organization id) as well as the environment-scoped format
  // (an array of `{ id, environment }` objects), where the font is only available when both the id
  // and the current environment match - ids are not unique across environments since each
  // environment uses a different database.
  function isOrganizationAllowed(organization, organizationId) {
    // Environment-scoped format
    if (Array.isArray(organization)) {
      return organization.some(function(org) {
        return org.id === organizationId && org.environment === ENV.name;
      });
    }
    // Legacy format: a single organization id
    return organization === organizationId;
  }

  // Returns all available fonts
  function getFonts(opts) {
    opts = opts || {};
    var tmpFonts = angular.copy(fonts);
    // Unless we explicitly choose not to...
    if(!opts.allOrganizations){
      // ...remove any fonts that belong to a different organization
      var organizationId = 0;
      if ($injector.has('OrganizationService')) {
        var OrganizationService = $injector.get('OrganizationService');
        var organization = OrganizationService.getOrganizationImmediate();
        if(organization && organization.id){
          organizationId = organization.id;
        }
      }
      angular.forEach(tmpFonts, function(font, id){
        if(font.organization && !isOrganizationAllowed(font.organization, organizationId)){
          delete tmpFonts[id];
        }
      });
    }
    // Filter by type?
    if(opts.type){
      angular.forEach(tmpFonts, function(font, id){
        if(font.type && font.type !== opts.type){
          delete tmpFonts[id];
        }
      });
    }
    // Include specific, desired fonts
    if(opts.include){
      var font = angular.copy(fonts[opts.include]);
      tmpFonts[opts.include] = font;
    }
    // And return
    return tmpFonts;
  }

  // Returns the weights map
  function getWeights() {
    return weights;
  }

  // Returns the nearest weight for a font (defaulting to `400`)
  // ...useful when chaning the font to a family that has different available weights
  function getNearestWeight(fontName, currentWeight){
    if(!fonts[fontName]){
      fontName = defaultFont; // Fallback
    }
    currentWeight = parseInt(currentWeight, 10);
    var availableWeights = fonts[fontName].weights;
    var minDistance = 900;
    var closestWeight = 400; // The default `normal` value
    angular.forEach(availableWeights, function(value){
      if(Math.abs(value - currentWeight) < minDistance){
        minDistance = Math.abs(value - parseInt(currentWeight));
        closestWeight = value;
      }
    });
    return closestWeight;
  }

  // Returns a CSS @import string, ie:
  //  @import url('https://fonts.googleapis.com/css?family=Roboto:400,100,100italic,300,300italic,400italic,500,500italic,700,700italic,900,900italic');
  function getCssImportString(fontName, fontVariantsArray){
    var font = fonts[fontName];
    if(font){
      if(font.type === 'google'){
        return '@import url(\'https://fonts.googleapis.com/css?family='+encodeURIComponent(fontName)+':'+fontVariantsArray.join(',')+'\');';
      } else if(font.type === 'custom'){
        var cssImportString = '';
        for (var v=0, vl=fontVariantsArray.length; v<vl; v++) {
          var fontVariant = fontVariantsArray[v];
          var fontStyle = fontVariant.toString().includes('i') ? 'italic' : 'normal';
          var fontWeight = fontVariant.toString().replace('i', '');
          // Default to dashboard.accredible.com as the source of custom fonts if the font service is being used outside of a dashboard instance
          var accessibleHost = host.includes('dashboard.accredible.com') ? host : host.includes('localhost') ? 'localhost:1337' : 'dashboard.accredible.com';
          cssImportString +=
            "@font-face {\n" +
            "font-family: \"" + fontName + "\";\n" +
            "font-weight: " + fontWeight + ";\n" +
            "font-style: " + fontStyle + ";\n" +
            "src: url('//" + accessibleHost + "/shared/fonts/" + fontName + "/" + fontName + " - " + fontVariant + ".woff2') format('woff2'),\n" +
            "     url('//" + accessibleHost + "/shared/fonts/" + fontName + "/" + fontName + " - " + fontVariant + ".woff') format('woff'),\n" +
            "     url('//" + accessibleHost + "/shared/fonts/" + fontName + "/" + fontName + " - " + fontVariant + ".ttf') format('truetype'),\n" +
            "     url('//" + accessibleHost + "/shared/fonts/" + fontName + "/" + fontName + " - " + fontVariant + ".svg#svgFontfontName') format('svg'),\n" +
            "}";
          cssImportString += v < vl - 1 ? '\n' : '';
        }
        return cssImportString;
      }
    }
  }

  // Mechanism for checking if a font has loaded and then doing something if it has
  var loadedFonts = {};
  // Assume system fonts are already loaded
  _(fonts).forEach(function(font, fontName) {
    if (font.type === 'system') {
      font.weights.forEach(function(weight) {
        var style = typeof weight == 'number' ? 'normal' : 'talic'; // Italic font weights end in an 'i' so adding 'talic' results in 'italic'
        loadedFonts[fontName + weight + style] = true;
      });
    }
  });

  // Remove quotes from string
  function unquote(string) {
    return string.replace(/\"/g, '');
  }

  var checklist = []; // The list of (font) family, weight, style and actions items for the fonts that are required to have loaded
  var checkCount = 0; // The number of times left to check that a font has loaded
  var checkTimeout = null; // The timeout reference

  // Remove loaded fonts from the checklist, firing the actions as we go
  function checkFontsLoaded() {
    var unloadedChecklist = [];
    checklist.forEach(function(listItem) {
      var fontLoaded = false;
      var iterator = document.fonts.values();
      var fontFace;
      // eslint-disable-next-line no-cond-assign
      while (fontFace = iterator.next().value) {
        var listItemWeight = parseInt(listItem.weight);
        // The test here uses fontFace.weight == listItemWeight, rather than fontFace.weight === listItemWeight as Chrome returns fontFace.weight as a string of the number not the number itself
        if (unquote(fontFace.family) === listItem.family && (fontFace.weight == listItemWeight || (!isNaN(listItemWeight) && fontFace.weight === weights[listItemWeight].toLowerCase())) && fontFace.style === listItem.style && fontFace.status === 'loaded') {
          fontLoaded = true;
          break;
        }
      }
      if (fontLoaded) {
        loadedFonts[listItem.family + listItem.weight + listItem.style] = true;
        listItem.actions.forEach(function(action) {
          action();
        });
      } else {
        unloadedChecklist.push(listItem);
      }
    });
    if (unloadedChecklist.length === 0) {
      checkCount = 0;
    } else {
      checkCount--;
    }
    checklist = unloadedChecklist;
  }

  // Schedule the next check for 100 milliseconds time
  function scheduleCheckFontsLoaded() {
    return $timeout(checkFontsUntilLoaded, 100);
  }

  // Check the fonts loaded and reschedule if there are any retries (checkCount) left
  function checkFontsUntilLoaded() {
    checkFontsLoaded();
    if (checkCount > 0) {
      checkTimeout = scheduleCheckFontsLoaded();
    } else if (checklist.length > 0) {
      console.warn('Failed to load fonts:', checklist.map(function(font) {
        return font.family + ':' + font.weight + ':' + font.style;
      }));
    }
  }

  // Check to see if font family has a particular italic weight
  function hasItalicWeight(fontFamily, fontWeight) {
    return fonts[fontFamily].weights.indexOf(fontWeight + 'i') > -1;
  }

  function whenFontLoaded(family, weight, style, action) { // action cannot be null
    family = unquote(family);
    weight = weightAsNumber(weight);
    if (loadedFonts[family + weight + style]) { // Already loaded
      action();
    } else {
      if (style === 'italic' && !hasItalicWeight(family, weight)) {
        style = 'normal';
      }
      // Is the font already being checked
      var beingChecked = false;
      checklist.forEach(function(listItem) {
        if (listItem.family === family && listItem.weight === weight && listItem.style === style) {
          // It is...
          beingChecked = true;
          // Store action
          listItem.actions.push(action);
        }
      });
      if (!beingChecked) {
        // Not being checked, so add it to the list
        checklist.push({ family: family, weight: weight, style: style, actions: [action] });
      }
      checkCount = 20;
      if (checkTimeout) {
        $timeout.cancel(checkTimeout); // Cancel any pending check
      }
      checkFontsUntilLoaded();
    }
  }
}

angular
  .module('app')
  .service('fontService', fontService);

},{}],47:[function(require,module,exports){
fullscreenUploadDirective.$inject = ['$compile'];
function fullscreenUploadDirective($compile){
  return {
    restrict: 'A',
    link: fullscreenUploadDirectiveLink,
    controller: fullscreenUploadDirectiveController,
    controllerAs: '$upload',
  };

  // When linked, we check the component and add visual aids
  function fullscreenUploadDirectiveLink(scope, element, attrs) {
    // Make sure the correct attributes are set on the element - we don't want to use $compile as this can mess up other components
    if(!attrs['ngfDrop'] || attrs['ngfDrop'] !== '$upload.handleFullscreenUpload($file)'){
      console.warn('[fullscreen-upload] - please add this attribute to the body:\nngf-drop="$upload.handleFullscreenUpload($file)"');
    }
    if(!attrs['ngfDropDisabled'] || attrs['ngfDropDisabled'] !== '$upload.fullscreenUploadDisabled'){
      console.warn('[fullscreen-upload] - please add this attribute to the body:\nngf-drop-disabled="$upload.fullscreenUploadDisabled"');
    }
    // Append our visual aid
    var linkFn = $compile('<div id="fullscreen-upload-dragover"><div><div translate="drop-to-upload"></div></div></div>');
    var content = linkFn(scope);
    element.append(content);
  }
}

// Our controller
fullscreenUploadDirectiveController.$inject = [];
function fullscreenUploadDirectiveController() {
  var ctrl = this;
  ctrl.handleFullscreenUpload = handleFullscreenUpload;
  ctrl.setListener = setListener;
  ctrl.unsetListener = unsetListener;
  ctrl.fullscreenUploadDisabled = true;
  // Passes the file to the listener
  function handleFullscreenUpload($file){
    if(listener){
      listener($file);
    }
  }
  // Listener
  var listener;
  function setListener(callback){
    listener = callback;
    ctrl.fullscreenUploadDisabled = false;
  }
  function unsetListener(callback){
    if(listener == callback){
      listener = null;
      ctrl.fullscreenUploadDisabled = true;
    }
  }
}

angular
  .module('app')
  .directive('fullscreenUpload', fullscreenUploadDirective);

},{}],48:[function(require,module,exports){
/** FULLSCREEN COMPONENT
 *
 *    A full-screen container element
 *    Adds scroll blocking to the body when visible
 *
 *    <fullscreen>your content</fullscreen>
 *
 */
var fullscreenComponent = {
  controller: fullscreenComponentController,
  transclude: true,
  template: '<div ng-transclude></div>',
};

fullscreenComponentController.$inject = [];
function fullscreenComponentController() {
  var ctrl = this;
  // Toggle <body> class when created and destroyed
  ctrl.$onInit = function(){
    $('body').addClass('fullscreen-active');
  }
  ctrl.$onDestroy = function(){
    $('body').removeClass('fullscreen-active');
  }
}

angular
  .module('app')
  .component('fullscreen', fullscreenComponent);

},{}],49:[function(require,module,exports){
/** HISTORY FACTORY
 *
 *    Instantiate with any number of objects or arrays, make changes
 *     and access undo and redo logic, like so:
 *
 *      var obj = { hello: 'world' };
 *      var arr = [ 'a', 'b', 'c', ];
 *      var objHistory = new HistoryFactory(obj, arr, ...);
 *
 *    @author   David "oodavid" King (Factory refactor)
 *    @author   Ryan Booth (original Service)
 *
 *    https://youtu.be/z0uwB-Zetos
 *
 *    TODO
 *      Is there any benefit to making this run work ONCE per digest..?
 *          Is this a timesaver? A performance improvement?
 *        $rootScope.$watch(function(){ ...Runs once per digest... });
 */
HistoryFactory.$inject = ['_', 'emitter'];
function HistoryFactory(_, emitter){
  return function() {
    var factory = this;

    // Public properties and methods
    factory.timestamp = null; // The timestamp for the current history
    factory.canUndo = canUndo;
    factory.canRedo = canRedo;
    factory.save = save;
    factory.restoreSnapshot = restoreSnapshot;
    factory.undo = undo;
    factory.redo = redo;

    // This is an emitter
    emitter.addEmitterLogicTo(factory);

    // Private
    var subjects = arguments; // We can track multiple objects or arrays
    var history = []; // Each call to "save" makes a copy of every subject on the history
    var currentIndex = 0; // The "current" position on the history stack

    // Begin by saving the current state
    save();

    function canUndo(){
      return currentIndex > 0;
    }

    function canRedo(){
      return currentIndex < history.length - 1;
    }

    function save(){
      var snapshot = {
        timestamp: Date.now(), // The save time
        subjects: [], // Will contains a copy of each of the subjects that we instantiated with
      };
      for(var a = 0, al = subjects.length; a < al; a++){
        snapshot.subjects.push(angular.copy(subjects[a]));
      }
      if(history[currentIndex] && _.isEqual(history[currentIndex].subjects, snapshot.subjects)){
        return; // Do nothing if the new snapshot is the same as the current snapshot
      }
      if(canRedo()){
        history = history.slice(0, currentIndex + 1); // Since we can "redo" we must overwrite that timeline (consider Back To The Future: Part II)
      }
      factory.timestamp = snapshot.timestamp; // Store the time
      history.push(snapshot);
      currentIndex = history.length - 1;
      factory.trigger('save');
    }

    function restoreSnapshot(indexDiff){
      currentIndex += indexDiff;
      var snapshot = history[currentIndex];
      factory.timestamp = snapshot.timestamp; // Update the timestamp
      for(var s = 0, sl = snapshot.subjects.length; s < sl; s++){
        if(snapshot.subjects[s] !== subjects[s]){
          angular.copy(snapshot.subjects[s], subjects[s]);
        }
      }
      factory.trigger('restoreSnapshot');
    }

    function undo(){
      if(canUndo()){
        restoreSnapshot(-1);
        factory.trigger('undo');
      }
    }

    function redo(){
      if(canRedo()){
        restoreSnapshot(+1);
        factory.trigger('redo');
      }
    }

  };
}

angular
  .module('app')
  .factory('HistoryFactory', HistoryFactory);

},{}],50:[function(require,module,exports){
/** Hot Keys - DIRECTIVE
 *
 *    Adds hotkey shortcuts that triggers a "click" event
 *     on elements. Automatically appends the shortcut to
 *     the [tooltip] value (if the element has one)
 *
 *    Doesn't fire when triggered on text-accepting inputs
 *
 *    Example
 *      <button ng-click="alert('saved');" hotkeys="CMD+S">...</button>
 *      <a href="/index.html" hotkeys="CMD+A">...</a>
 *      <a ui-sref="issuer.dashboard" hotkeys="CMD+H">...</a>
 *
 *    Patterns
 *      CMD+SHIFT+A
 *      CMD+S
 *      UP
 *      SHIFT+UP
 *      CMD+ALT+SHIFT+UP
 *
 *    Notes
 *      Use CMD, never CTRL or META
 *      Use ENTER, never RETURN
 *      Use PLUS and MINUS, never + or -
 *
 *    @author   David "oodavid" King
 */
hotkeysDirective.$inject = ['$document'];
function hotkeysDirective($document){
  // All active hotkey elements
  var hotkeys = {};
  // On mac we render ⌘, on everything else we render CTRL
  var cmd = 'CTRL';
  if (navigator.userAgent.indexOf('Mac OS X') !== -1) {
    cmd = '⌘';
  }
  // Map KeyCodes to named keys
  var keyMap = {
    8: 'DEL',
    9: 'TAB',
    13: 'ENTER',
    16: 'SHIFT',
    17: 'CMD',
    18: 'ALT',
    20: 'CAPSLOCK',
    27: 'ESC',
    32: 'SPACE',
    33: 'PAGEUP',
    34: 'PAGEDOWN',
    35: 'END',
    36: 'HOME',
    37: 'LEFT',
    38: 'UP',
    39: 'RIGHT',
    40: 'DOWN',
    45: 'INS',
    46: 'DEL',
    91: 'CMD',
    93: 'CMD',
    187: 'PLUS',
    189: 'MINUS',
    219: '[',
    221: ']',
    224: 'CMD'
  };
  // When the event target accepts text-input, we don't trigger hotkeys
  var inputNodes = /textarea|input|select/i;
  // Customises the hotkey for the platform - CMD becomes ⌘ or CTRL
  var hotkeyStringToHuman = function(hotkeyString) {
    return hotkeyString.replace(/cmd/gi, cmd).toUpperCase();
  };
  // Returns the same combo string every time (by using sort) - this is for internal comparison, not display
  var hotkeyArrayToCombo = function(hotkeyArray) {
    var tmp = hotkeyArray.sort();
    return tmp.join('+').toUpperCase();
  };
  var hotkeyStringToCombo = function(hotkeyString) {
    return hotkeyArrayToCombo(hotkeyString.split('+'));
  };
  // Pulls out the current META, ALT, CTRL, CMD and SHIFT states, as well as the key
  var setKeysByEvent = function(e) {
    // The key being used - either a special character, or an alphanumeric
    var key = false;
    if (keyMap[e.keyCode]) {
      key = keyMap[e.keyCode];
    } else if ((e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode >= 97 && e.keyCode <= 122) || (e.keyCode >= 48 && e.keyCode <= 57)) {
      key = String.fromCharCode(e.which).toUpperCase();
    }
    // Create an array of all active keys
    var keys = [];
    if (e.shiftKey) {
      keys.push('SHIFT');
    }
    if (e.metaKey || e.ctrlKey) {
      keys.push('CMD');
    }
    if (e.altKey) {
      keys.push('ALT');
    }
    if (keys.indexOf(key) === -1) {
      keys.push(key);
    }
    // Build a combo
    var combo = (e.type === 'keydown') ? hotkeyArrayToCombo(keys) : false;
    // Don't fire if the target is "text-accepting"
    if (e.target.isContentEditable || inputNodes.test(e.target.nodeName)) {
      return;
    }
    // Trigger events
    if (e.type === 'keydown') {
      angular.forEach(hotkeys, function(hotkey) {
        if (hotkey.combo === combo) {
          hotkey.element.triggerHandler('mousedown'); // This is the proper
          hotkey.element.triggerHandler('mouseup'); // order of events
          hotkey.element.triggerHandler('click'); // for a natural click
          e.preventDefault(); // Reserve the combo for our app
        }
      });
    }
  };
  // Listeners
  $document.bind('keydown', setKeysByEvent);
  $document.bind('keyup', setKeysByEvent);
  // Elements with the hotkeys attribute are added to the watch list
  var link = function(scope, element, attrs) {
    // Grab the hotkey combo
    var hotkey = attrs.hotkeys;
    var combo = hotkeyStringToCombo(hotkey);
    var human = hotkeyStringToHuman(hotkey);
    // Make sure it's available
    if (hotkeys[combo]) {
      console.warn('HOTKEYS > The hotkey ' + hotkey + ' is already in use by', hotkeys[combo].element[0]);
      return;
    }
    // Add the hotkey, remove when destroyed
    hotkeys[combo] = {
      element: element,
      combo: combo
    };
    element.on('$destroy', function() {
      delete hotkeys[combo];
    });
    // Update the tooltip
    var tooltip = (attrs.tooltip ? attrs.tooltip + ', ' : '') + human;
    // Changed this from attrs.$set('tooltip', tooltip) as the tooltips were not showing in the UI
    attrs.$set('tooltip', tooltip);
  };
  // Attribute only Directive
  return {
    restrict: 'A',
    link: link
  };
}

angular
  .module('app')
  .directive('hotkeys', hotkeysDirective);

},{}],51:[function(require,module,exports){
// This is written by Juri Strumpflohner
// https://github.com/juristr/angular-translate-loader-pluggable
// It is available on npm, but the version (1.3.1) of the library on there is written in TypeScript
// with an angular include that was causing 'WARNING: Tried to load angular more than once.' to be
// shown in the browser. Hence this file.

function translatePluggableLoaderProvider() {
  'use strict';

  var loaders = [];
  var translationTable = {};

  this.useLoader = function (loaderName, options) {
    loaders.push({
      name: loaderName,
      options: options
    });
    return this;
  };

  this.translations = function (language, translations) {
    translationTable[language] = angular.extend({}, translationTable[language], translations);
    return this;
  };

  this.$get = ['$q', '$injector', function ($q, $injector) {
    return function (options) {
      var deferred = $q.defer();

      var loaderInstances = [];

      // lookup in translation table
      loaderInstances.push(function () {
        var deferred = $q.defer();
        deferred.resolve(translationTable[options.key]);
        return deferred.promise;
      }());

      // lookup in loaders
      for (var i = 0; i < loaders.length; i++) {
        var loader = loaders[i];

        // get the loader and resolve it, passing in the required options
        var loaderPromise = $injector.get(loader.name)(angular.extend(options, loader.options));
        loaderInstances.push(loaderPromise);
      }

      $q.all(loaderInstances)
        .then(function (loaders) {
          var result;
          for (var i = 0; i < loaders.length; i++) {
            result = angular.extend({}, result, loaders[i]);
          }
          deferred.resolve(result);
        });

      return deferred.promise;
    };
  }];
}

angular
  .module('pascalprecht.translate')
  .provider('translatePluggableLoader', translatePluggableLoaderProvider);

},{}],52:[function(require,module,exports){
// Module Dependencies
require('angular-translate');
require('angular-translate-loader-static-files');
require('angular-translate-loader-partial');
require('angular-dynamic-locale');
require('./angular-translate-loader-pluggable.js'); // For multiple dictionary support
require('angular-translate-handler-log'); // For debugging
angular.module('app').requires.push('pascalprecht.translate');
angular.module('app').requires.push('tmh.dynamicLocale');

// Constants
require('./language.constants.js');

languageConfig.$inject = ['ENV', 'LANGUAGES', '$translateProvider', 'tmhDynamicLocaleProvider', 'translatePluggableLoaderProvider'];
function languageConfig(ENV, LANGUAGES, $translateProvider, tmhDynamicLocaleProvider, translatePluggableLoaderProvider) {
  // Massage the LANGUAGES into valid format
  var languageKeys = Object.keys(LANGUAGES);
  var languageMaps = {};
  angular.forEach(languageKeys, function(key){
    languageMaps[key+'-*'] = key; // glob-like catch-all
  });
  // Add wildcard to default to 'en' in case the browser language is not found
  // https://github.com/angular-translate/angular-translate/issues/1501
  languageMaps['*'] = 'en';
  // Path to our locale (angular)
  tmhDynamicLocaleProvider.localeLocationPattern('/shared/i18n/data/{{locale}}.js');
  tmhDynamicLocaleProvider.defaultLocale('en');
  // Path to our translations (app)
  // https://angular-translate.github.io/docs/#/guide/12_asynchronous-loading
  //$translatePartialLoaderProvider.addPart('main');
  /**
   * $translateProvider only allows a single loader at a time
   * Using pluggable loader to allow apps to add translation loaders
   * for partials without destroying previous configuration
   */
  // https://stackoverflow.com/questions/35272213/angular-translate-multiple-json-files
  $translateProvider
    .useLoader('translatePluggableLoader')
    .useSanitizeValueStrategy('escape')
    .uniformLanguageTag('bcp47') // Converts en_US, en-US, EN-us etc. to en-us
    .registerAvailableLanguageKeys(languageKeys, languageMaps)
    .fallbackLanguage('en')
    .determinePreferredLanguage();
  // Load the main dictionary
  translatePluggableLoaderProvider.useLoader('$translateStaticFilesLoader', {
    prefix: '/shared/i18n/data/',
    suffix: '.json?' + ENV.cachebust // these don't go through our decorator :(
  });
  // For debugging
  $translateProvider.useMissingTranslationHandlerLog();
}

angular
  .module('app')
  .config(languageConfig);

},{"./angular-translate-loader-pluggable.js":51,"./language.constants.js":53,"angular-dynamic-locale":1,"angular-translate":7,"angular-translate-handler-log":4,"angular-translate-loader-partial":5,"angular-translate-loader-static-files":6}],53:[function(require,module,exports){
angular
  .module('app')
  .constant('LANGUAGES', {
    ar: {
      value: 'ar',
      name: 'عربى',
      description: 'Arabic (General)',
    },
    cs: {
      value: 'cs',
      name: 'Česky',
      description: 'Czech',
    },
    da: {
      value: 'da',
      name: 'Dansk',
      description: 'Danish',
    },
    de: {
      value: 'de',
      name: 'Deutsch',
      description: 'German'
    },
    el: {
      value: 'el',
      name: 'Νέα Ελληνικά',
      description: 'Greek',
    },
    en: {
      value: 'en',
      name: 'English (US)',
      description: 'English (US)',
    },
    'en-gb': {
      value: 'en-gb',
      name: 'English (UK)',
      description: 'English (UK)',
    },
    es: {
      value: 'es',
      name: 'Español',
      description: 'Spanish',
    },
    'es-419': {
      value: 'es-419',
      name: 'Español (Latinoamérica)',
      description: 'Spanish (Latin America)'
    },
    fi: {
      value: 'fi',
      name: 'Suomalainen',
      description: 'Finnish',
    },
    fr: {
      value: 'fr',
      name: 'Français',
      description: 'French',
    },
    he: {
      value: 'he',
      name: 'עברית',
      description: 'Hebrew',
    },
    hi: {
      value: 'hi',
      name: 'हिन्दी',
      description: 'Hindi',
    },
    hr: {
      value: 'hr',
      name: 'Hrvatski',
      description: 'Croatian',
    },
    hu: {
      value: 'hu',
      name: 'Magyar',
      description: 'Hungarian',
    },
    id: {
      value: 'id',
      name: 'Bahasa Indonesia',
      description: 'Indonesian',
    },
    it: {
      value: 'it',
      name: 'Italiano',
      description: 'Italian',
    },
    ja: {
      value: 'ja',
      name: '日本語',
      description: 'Japanese',
    },
    ko: {
      value: 'ko',
      name: '한국어',
      description: 'Korean',
    },
    ms: {
      value: 'ms',
      name: 'Malay',
      description: 'Malay',
    },
    nb: {
      value: 'nb',
      name: 'Norsk Bokmål',
      description: 'Norwegian',
    },
    nl: {
      value: 'nl',
      name: 'Nederlands',
      description: 'Dutch',
    },
    pl: {
      value: 'pl',
      name: 'Polski',
      description: 'Polish',
    },
    'pt-br': {
      value: 'pt-br',
      name: 'Português (Brasil)',
      description: 'Portuguese (Brazil)',
    },
    'pt-pt': {
      value: 'pt-pt',
      name: 'Português (Portugal)',
      description: 'Portuguese (Portugal)'
    },
    ro: {
      value: 'ro',
      name: 'Română',
      description: 'Romanian',
    },
    ru: {
      value: 'ru',
      name: 'Русский',
      description: 'Russian',
    },
    sk: {
      value: 'sk',
      name: 'Slovenský',
      description: 'Slovak'
    },
    sl: {
      value: 'sl',
      name: 'Slovenščina',
      description: 'Slovenian',
    },
    sv: {
      value: 'sv',
      name: 'Svenska',
      description: 'Swedish',
    },
    th: {
      value: 'th',
      name: 'ไทย',
      description: 'Thai',
    },
    tr: {
      value: 'tr',
      name: 'Türk',
      description: 'Turkish',
    },
    vi: {
      value: 'vi',
      name: 'Việtnam',
      description: 'Vietnamese',
    },
    'zh-cn': {
      value: 'zh-cn',
      name: '简体中文',
      description: 'Simplified Chinese'
    },
    'zh-tw': {
      value: 'zh-tw',
      name: '繁體中文',
      description: 'Traditional Chinese',
    },
    'zh-hant-tw': {
      value: 'zh-hant-tw',
      name: '繁體中文（台灣）',
      description: 'Traditional Chinese (Taiwan)',
    },
    // This version of Norwegian isn't selectable from Chrome or Safari, but is from Firefox
    // and so is hidden from the language select but still available via browser language code (no)
    no: {
      value: 'no',
      name: 'Norsk',
      description: 'Norwegian',
      hidden: true,
    },
  });

},{}],54:[function(require,module,exports){
/** LANGUAGE - SERVICE
 *
 *      Change the language used for locale and translations
 *      Get a list of available languages
 *      Convert a language string into a two letter code, ie: `en_UK` => `en`
 *
 *  A VERY IMPORTANT NOTE
 *
 *      Before my time, the angular ngLocale files were manually copied to
 *       a project directory. I do not know the rationale for this decision.
 *
 *      If you upgrade angular, or have issues with locale, consider reviewing
 *       these files:
 *
 *          ./data/en.js
 *          ./data/xx.js
 *
 *      You can find the locales here (don't forget to use correct branch)
 *
 *          https://github.com/angular/angular.js/tree/master/src/ngLocale
 *
 *  @author   David "oodavid" King
 */
languageService.$inject = ['LANGUAGES', '$translate', 'tmhDynamicLocale', '$injector'];
function languageService(LANGUAGES, $translate, tmhDynamicLocale, $injector){
  var service = this;
  service.getTwoLetterCode = getTwoLetterCode;
  service.setLocale = setLocale;
  service.getLocale = getLocale;
  service.getLanguages = getLanguages;
  service.getLanguageFromCode = getLanguageFromCode;
  service.getLanguageFromCodeNoDefault = getLanguageFromCodeNoDefault;
  service.setABDatepickerLocale = setABDatepickerLocale;
  // 2-Letter Codes
  var codes = Object.keys(LANGUAGES);
  // Converts a language to a twoLetterCode
  //   Uses `substring` to convert 'en_US' into 'en' and 'es_es' into 'es' etc.
  function getTwoLetterCode(language) {
    var twoLetterCode = (language || 'en').substring(0, 2);
    if (codes.indexOf(twoLetterCode) === -1) {
      twoLetterCode = 'en'; // Default to 'en'
    }
    return twoLetterCode;
  }
  // Set the locale
  function setLocale(language) {
    var twoLetterCode = getTwoLetterCode(language);
    $translate.use(twoLetterCode); // This is immediate
    setABDatepickerLocale(twoLetterCode); // This is immediate
    return tmhDynamicLocale.set(twoLetterCode); // This returns a promise
  }
  // Return the current locale
  function getLocale(){
    return $translate.use();
  }
  // Returns the available languages
  function getLanguages() {
    return LANGUAGES;
  }
  // Converts a language code to a name
  function getLanguageFromCode(twoLetterCode){
    return LANGUAGES[twoLetterCode] || LANGUAGES['en'];
  }

  function getLanguageFromCodeNoDefault(twoLetterCode){
      return LANGUAGES[twoLetterCode];
  }
  // Resets the ab-datepicker locale
  function setABDatepickerLocale(twoLetterCode){
    // If ab-datepicker module is included and loaded, then this is set.
    if ($injector.has('inputDateAccessibleDirective')) {
      Date.dp_locales = undefined;
      $('#datepicker-language').remove();
      var imported = document.createElement('script');
      imported.id = 'datepicker-language';
      imported.src = '../shared/i18n/data/ab-datepicker/' + twoLetterCode + '.min.js';
      document.head.appendChild(imported);
    }
  }
}

languageServiceRun.$inject = ['$rootScope', 'languageService', 'tmhDynamicLocale'];
function languageServiceRun($rootScope, languageService, tmhDynamicLocale){
  // When the language changes...
  $rootScope.$on('$translateLoadingSuccess', handleLanguageChange);
  $rootScope.$on('$translateChangeSuccess', handleLanguageChange);
  // Make sure our locale matches it! (ie: dates etc.)
  function handleLanguageChange(event, config){
    var twoLetterCode = languageService.getTwoLetterCode(config.language);
    languageService.setABDatepickerLocale(twoLetterCode);
    tmhDynamicLocale.set(twoLetterCode);
  }
}

angular
  .module('app')
  .service('languageService', languageService)
  .run(languageServiceRun);

},{}],55:[function(require,module,exports){
/** INPUT COLOR COMPONENT
 *
 *    <input-color ng-model="myColor"></input-color>
 *    <input-color ng-model="myColor" ng-required="true"></input-color>
 *    <input-color ng-model="myColor" ng-disabled="true"></input-color>
 *
 *  Styling - _form.scss
 *
 *    @author   David "oodavid" King
 */
var inputColorComponent = {
  controller: inputColorComponentController,
  bindings: {
    ngModel: '<',
    ngRequired: '<?',
    ngDisabled: '<?',
  },
  require: {
    ngModelCtrl: "ngModel"
  },
  templateUrl: '/shared/input-color/input-color.html',
};

inputColorComponentController.$inject = ['$element'];
function inputColorComponentController($element) {
  var ctrl = this;

  ctrl.fakeModel = null; // We want to let the user manually input values
  var fakeModelHex = null; // ...but we parse them into hex values, we need to track changes here!

  ctrl.$onInit = function(){
    $element.find('button').spectrum({
      color: "#000",
      showButtons: false,
      // Allow manual input
      preferredFormat: "hex",
      showInput: true,
      // Palette
      showPalette: true,
      showSelectionPalette: true,
      hideAfterPaletteSelect: true,
      palette: [],
      selectionPalette: [], // Want to set the palette value? Do it manually: localStorage.setItem('spectrum.acms', '#abcdef,#123456');
      localStorageKey: "spectrum.acms",
      // Events
      move: function(color) {
        ctrl.ngModelCtrl.$setViewValue(color.toHexString());
        ctrl.fakeModel = color.toHexString();
        fakeModelHex = color.toHexString();
      },
      beforeShow: function(color) {
        var value = ctrl.ngModel;
        $element.find('button').spectrum("set", value);
        // Alignment fix (nudge)
        angular.element('.sp-container').css({
          'margin-top': '0',
          'margin-left': '0'
        });
      },
      show: function(color) {
        // Alignment fix (nudge)
        angular.element('.sp-container').css({
          'margin-top': '-1px',
          'margin-left': '-1px'
        });
      },
    });
  };

  ctrl.$onChanges = function(changes){
    if(changes.ngModel && changes.ngModel.currentValue != fakeModelHex){
      ctrl.fakeModel = changes.ngModel.currentValue;
    }
  }

  ctrl.$onDestroy = function () {
    $element.find('button').spectrum("destroy");
  };

  ctrl.onInputChange = function(){
    if(ctrl.fakeModel){
      $element.find('button').spectrum('set', ctrl.fakeModel);
      var color = $element.find('button').spectrum('get');
      ctrl.ngModelCtrl.$setViewValue(color.toHexString());
      fakeModelHex = color.toHexString();
    } else {
      ctrl.ngModelCtrl.$setViewValue('');
    }
  }
}

angular
  .module('app')
  .component('inputColor', inputColorComponent);

},{}],56:[function(require,module,exports){
/** INPUT RADIOS COMPONENT
 *
 *    var listOptions = [
 *      { value: 1,     title: 'First', },
 *      { value: 'key', title: 'Second', },
 *      { value: 3,     title: 'Third <em>...place?</em>', },
 *    ];
 *    ...OR...
 *    var listOptions = [ 'First', 'Second', 'Third' ];
 *
 *    <input-radios ng-model="myTest" options="listOptions"></input-radios>
 *    <input-radios ng-model="myTest" options="listOptions" ng-required="true"></input-radios>
 *    <input-radios ng-model="myTest" options="listOptions" ng-disabled="true"></input-radios>
 *
 *    Notes
 *
 *      This is flexible in the objects it will accept.
 *
 *      The `value` is taken from `value` or `id`. These are equivilent:
 *
 *        { value: 123,     title: 'First', },
 *        { id:    123,     title: 'First', },
 *
 *      The `title` is taken from `title`, `name` or `html`. These are equivilent:
 *
 *        { value: 123,     title: 'First', },
 *        { value: 123,     name:  'First', },
 *        { value: 123,     html:  'First', },
 *
 *      ...and any variation thereof
 *
 *    @author   Andrew Bateman
 *    @author   David "oodavid" King (review)
 */
var inputRadiosComponent = {
  controller: inputRadiosComponentController,
  bindings: {
    ngModel: '<',
    options: '<',
    ngDisabled: '<?',
    ngRequired: '<?',
  },
  require: {
    ngModelCtrl: 'ngModel',
  },
  templateUrl: '/shared/input-radios/input-radios.html',
};

inputRadiosComponentController.$inject = [];
function inputRadiosComponentController() {
  var ctrl = this;
  ctrl.select = select;
  ctrl.selected = selected;

  ctrl.$onInit = function() {
    handleOptionsChange();
  }

  ctrl.$onChanges = function(changes){
    if(changes.options){
      handleOptionsChange();
    }
  };

  // Massages the options into a simple format we can use
  function handleOptionsChange(){
    if(!ctrl.options){
      return;
    }
    // Don't dirty the original object
    ctrl.options = angular.copy(ctrl.options);
    // Massage arrays into objects
    if(typeof ctrl.options[0] !== 'object'){
      var tmp = [];
      for(var o=0,ol=ctrl.options.length; o<ol; o++){
        tmp.push({
          value: ctrl.options[o],
          title: ctrl.options[o],
        });
      }
      ctrl.options = tmp;
    } else {
      // Massage into { value, title }
      for(var o=0,ol=ctrl.options.length; o<ol; o++){
        var option = angular.copy(ctrl.options[o]);
        option.title = getFirstProperty(option, ['title', 'name', 'html']); // any defined "title" property is used
        option.value = getFirstProperty(option, ['value', 'id', 'title']);  // any defined "value" property is used, falling back to the title
        // Replace with a simple object
        ctrl.options[o] = {
          title: option.title,
          value: option.value,
        };
      }
    }
  }

  // Selects the option
  function select(option){
    ctrl.ngModelCtrl.$setViewValue(option.value);
  }

  // Returns boolean if the option is selected
  function selected(option) {
    return option.value === ctrl.ngModelCtrl.$viewValue;
  }

  // UTILITY - returns the first property, allows for `null` as long as the key is defined
  function getFirstProperty(object, props){
    for(var p=0,pl=props.length; p<pl; p++){
      var prop = props[p];
      if(object.hasOwnProperty(prop)){
        return object[prop];
      }
    }
  }
}

angular
  .module('app')
  .component('inputRadios', inputRadiosComponent);

},{}],57:[function(require,module,exports){
/** LOADING BAR
 *
 *  This is just an abstraction of pace.js, with config
 *
 *  It's NOT Angular specific, rather it just listens to
 *   to various exposed events (AJAX, Routine etc.) and
 *   renders the loading-bar.
 */
paceOptions = {
  restartOnRequestAfter: 200,
  ajax: {
    trackMethods: ['POST', 'GET'],
    trackWebSockets: false,
    ignoreURLs: [
      'rs.fullstory.com',
      'esp.aptrinsic.com',
      'ws.zoominfo.com',
      'analytics.google.com',
      'i.clarity.ms',
    ]
  }
};
require('./pace.min.js');

},{"./pace.min.js":58}],58:[function(require,module,exports){
/*! pace 1.0.0 */
(function(){var a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X=[].slice,Y={}.hasOwnProperty,Z=function(a,b){function c(){this.constructor=a}for(var d in b)Y.call(b,d)&&(a[d]=b[d]);return c.prototype=b.prototype,a.prototype=new c,a.__super__=b.prototype,a},$=[].indexOf||function(a){for(var b=0,c=this.length;c>b;b++)if(b in this&&this[b]===a)return b;return-1};for(u={catchupTime:100,initialRate:.03,minTime:250,ghostTime:100,maxProgressPerFrame:20,easeFactor:1.25,startOnPageLoad:!0,restartOnPushState:!0,restartOnRequestAfter:500,target:"body",elements:{checkInterval:100,selectors:["body"]},eventLag:{minSamples:10,sampleCount:3,lagThreshold:3},ajax:{trackMethods:["GET"],trackWebSockets:!0,ignoreURLs:[]}},C=function(){var a;return null!=(a="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance.now():void 0)?a:+new Date},E=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||window.msRequestAnimationFrame,t=window.cancelAnimationFrame||window.mozCancelAnimationFrame,null==E&&(E=function(a){return setTimeout(a,50)},t=function(a){return clearTimeout(a)}),G=function(a){var b,c;return b=C(),(c=function(){var d;return d=C()-b,d>=33?(b=C(),a(d,function(){return E(c)})):setTimeout(c,33-d)})()},F=function(){var a,b,c;return c=arguments[0],b=arguments[1],a=3<=arguments.length?X.call(arguments,2):[],"function"==typeof c[b]?c[b].apply(c,a):c[b]},v=function(){var a,b,c,d,e,f,g;for(b=arguments[0],d=2<=arguments.length?X.call(arguments,1):[],f=0,g=d.length;g>f;f++)if(c=d[f])for(a in c)Y.call(c,a)&&(e=c[a],null!=b[a]&&"object"==typeof b[a]&&null!=e&&"object"==typeof e?v(b[a],e):b[a]=e);return b},q=function(a){var b,c,d,e,f;for(c=b=0,e=0,f=a.length;f>e;e++)d=a[e],c+=Math.abs(d),b++;return c/b},x=function(a,b){var c,d,e;if(null==a&&(a="options"),null==b&&(b=!0),e=document.querySelector("[data-pace-"+a+"]")){if(c=e.getAttribute("data-pace-"+a),!b)return c;try{return JSON.parse(c)}catch(f){return d=f,"undefined"!=typeof console&&null!==console?console.error("Error parsing inline pace options",d):void 0}}},g=function(){function a(){}return a.prototype.on=function(a,b,c,d){var e;return null==d&&(d=!1),null==this.bindings&&(this.bindings={}),null==(e=this.bindings)[a]&&(e[a]=[]),this.bindings[a].push({handler:b,ctx:c,once:d})},a.prototype.once=function(a,b,c){return this.on(a,b,c,!0)},a.prototype.off=function(a,b){var c,d,e;if(null!=(null!=(d=this.bindings)?d[a]:void 0)){if(null==b)return delete this.bindings[a];for(c=0,e=[];c<this.bindings[a].length;)e.push(this.bindings[a][c].handler===b?this.bindings[a].splice(c,1):c++);return e}},a.prototype.trigger=function(){var a,b,c,d,e,f,g,h,i;if(c=arguments[0],a=2<=arguments.length?X.call(arguments,1):[],null!=(g=this.bindings)?g[c]:void 0){for(e=0,i=[];e<this.bindings[c].length;)h=this.bindings[c][e],d=h.handler,b=h.ctx,f=h.once,d.apply(null!=b?b:this,a),i.push(f?this.bindings[c].splice(e,1):e++);return i}},a}(),j=window.Pace||{},window.Pace=j,v(j,g.prototype),D=j.options=v({},u,window.paceOptions,x()),U=["ajax","document","eventLag","elements"],Q=0,S=U.length;S>Q;Q++)K=U[Q],D[K]===!0&&(D[K]=u[K]);i=function(a){function b(){return V=b.__super__.constructor.apply(this,arguments)}return Z(b,a),b}(Error),b=function(){function a(){this.progress=0}return a.prototype.getElement=function(){var a;if(null==this.el){if(a=document.querySelector(D.target),!a)throw new i;this.el=document.createElement("div"),this.el.className="pace pace-active",document.body.className=document.body.className.replace(/pace-done/g,""),document.body.className+=" pace-running",this.el.innerHTML='<div class="pace-progress">\n  <div class="pace-progress-inner"></div>\n</div>\n<div class="pace-activity"></div>',null!=a.firstChild?a.insertBefore(this.el,a.firstChild):a.appendChild(this.el)}return this.el},a.prototype.finish=function(){var a;return a=this.getElement(),a.className=a.className.replace("pace-active",""),a.className+=" pace-inactive",document.body.className=document.body.className.replace("pace-running",""),document.body.className+=" pace-done"},a.prototype.update=function(a){return this.progress=a,this.render()},a.prototype.destroy=function(){try{this.getElement().parentNode.removeChild(this.getElement())}catch(a){i=a}return this.el=void 0},a.prototype.render=function(){var a,b,c,d,e,f,g;if(null==document.querySelector(D.target))return!1;for(a=this.getElement(),d="translate3d("+this.progress+"%, 0, 0)",g=["webkitTransform","msTransform","transform"],e=0,f=g.length;f>e;e++)b=g[e],a.children[0].style[b]=d;return(!this.lastRenderedProgress||this.lastRenderedProgress|0!==this.progress|0)&&(a.children[0].setAttribute("data-progress-text",""+(0|this.progress)+"%"),this.progress>=100?c="99":(c=this.progress<10?"0":"",c+=0|this.progress),a.children[0].setAttribute("data-progress",""+c)),this.lastRenderedProgress=this.progress},a.prototype.done=function(){return this.progress>=100},a}(),h=function(){function a(){this.bindings={}}return a.prototype.trigger=function(a,b){var c,d,e,f,g;if(null!=this.bindings[a]){for(f=this.bindings[a],g=[],d=0,e=f.length;e>d;d++)c=f[d],g.push(c.call(this,b));return g}},a.prototype.on=function(a,b){var c;return null==(c=this.bindings)[a]&&(c[a]=[]),this.bindings[a].push(b)},a}(),P=window.XMLHttpRequest,O=window.XDomainRequest,N=window.WebSocket,w=function(a,b){var c,d,e,f;f=[];for(d in b.prototype)try{e=b.prototype[d],f.push(null==a[d]&&"function"!=typeof e?a[d]=e:void 0)}catch(g){c=g}return f},A=[],j.ignore=function(){var a,b,c;return b=arguments[0],a=2<=arguments.length?X.call(arguments,1):[],A.unshift("ignore"),c=b.apply(null,a),A.shift(),c},j.track=function(){var a,b,c;return b=arguments[0],a=2<=arguments.length?X.call(arguments,1):[],A.unshift("track"),c=b.apply(null,a),A.shift(),c},J=function(a){var b;if(null==a&&(a="GET"),"track"===A[0])return"force";if(!A.length&&D.ajax){if("socket"===a&&D.ajax.trackWebSockets)return!0;if(b=a.toUpperCase(),$.call(D.ajax.trackMethods,b)>=0)return!0}return!1},k=function(a){function b(){var a,c=this;b.__super__.constructor.apply(this,arguments),a=function(a){var b;return b=a.open,a.open=function(d,e){return J(d)&&c.trigger("request",{type:d,url:e,request:a}),b.apply(a,arguments)}},window.XMLHttpRequest=function(b){var c;return c=new P(b),a(c),c};try{w(window.XMLHttpRequest,P)}catch(d){}if(null!=O){window.XDomainRequest=function(){var b;return b=new O,a(b),b};try{w(window.XDomainRequest,O)}catch(d){}}if(null!=N&&D.ajax.trackWebSockets){window.WebSocket=function(a,b){var d;return d=null!=b?new N(a,b):new N(a),J("socket")&&c.trigger("request",{type:"socket",url:a,protocols:b,request:d}),d};try{w(window.WebSocket,N)}catch(d){}}}return Z(b,a),b}(h),R=null,y=function(){return null==R&&(R=new k),R},I=function(a){var b,c,d,e;for(e=D.ajax.ignoreURLs,c=0,d=e.length;d>c;c++)if(b=e[c],"string"==typeof b){if(-1!==a.indexOf(b))return!0}else if(b.test(a))return!0;return!1},y().on("request",function(b){var c,d,e,f,g;return f=b.type,e=b.request,g=b.url,I(g)?void 0:j.running||D.restartOnRequestAfter===!1&&"force"!==J(f)?void 0:(d=arguments,c=D.restartOnRequestAfter||0,"boolean"==typeof c&&(c=0),setTimeout(function(){var b,c,g,h,i,k;if(b="socket"===f?e.readyState<2:0<(h=e.readyState)&&4>h){for(j.restart(),i=j.sources,k=[],c=0,g=i.length;g>c;c++){if(K=i[c],K instanceof a){K.watch.apply(K,d);break}k.push(void 0)}return k}},c))}),a=function(){function a(){var a=this;this.elements=[],y().on("request",function(){return a.watch.apply(a,arguments)})}return a.prototype.watch=function(a){var b,c,d,e;return d=a.type,b=a.request,e=a.url,I(e)?void 0:(c="socket"===d?new n(b):new o(b),this.elements.push(c))},a}(),o=function(){function a(a){var b,c,d,e,f,g,h=this;if(this.progress=0,null!=window.ProgressEvent)for(c=null,a.addEventListener("progress",function(a){return h.progress=a.lengthComputable?100*a.loaded/a.total:h.progress+(100-h.progress)/2},!1),g=["load","abort","timeout","error"],d=0,e=g.length;e>d;d++)b=g[d],a.addEventListener(b,function(){return h.progress=100},!1);else f=a.onreadystatechange,a.onreadystatechange=function(){var b;return 0===(b=a.readyState)||4===b?h.progress=100:3===a.readyState&&(h.progress=50),"function"==typeof f?f.apply(null,arguments):void 0}}return a}(),n=function(){function a(a){var b,c,d,e,f=this;for(this.progress=0,e=["error","open"],c=0,d=e.length;d>c;c++)b=e[c],a.addEventListener(b,function(){return f.progress=100},!1)}return a}(),d=function(){function a(a){var b,c,d,f;for(null==a&&(a={}),this.elements=[],null==a.selectors&&(a.selectors=[]),f=a.selectors,c=0,d=f.length;d>c;c++)b=f[c],this.elements.push(new e(b))}return a}(),e=function(){function a(a){this.selector=a,this.progress=0,this.check()}return a.prototype.check=function(){var a=this;return document.querySelector(this.selector)?this.done():setTimeout(function(){return a.check()},D.elements.checkInterval)},a.prototype.done=function(){return this.progress=100},a}(),c=function(){function a(){var a,b,c=this;this.progress=null!=(b=this.states[document.readyState])?b:100,a=document.onreadystatechange,document.onreadystatechange=function(){return null!=c.states[document.readyState]&&(c.progress=c.states[document.readyState]),"function"==typeof a?a.apply(null,arguments):void 0}}return a.prototype.states={loading:0,interactive:50,complete:100},a}(),f=function(){function a(){var a,b,c,d,e,f=this;this.progress=0,a=0,e=[],d=0,c=C(),b=setInterval(function(){var g;return g=C()-c-50,c=C(),e.push(g),e.length>D.eventLag.sampleCount&&e.shift(),a=q(e),++d>=D.eventLag.minSamples&&a<D.eventLag.lagThreshold?(f.progress=100,clearInterval(b)):f.progress=100*(3/(a+3))},50)}return a}(),m=function(){function a(a){this.source=a,this.last=this.sinceLastUpdate=0,this.rate=D.initialRate,this.catchup=0,this.progress=this.lastProgress=0,null!=this.source&&(this.progress=F(this.source,"progress"))}return a.prototype.tick=function(a,b){var c;return null==b&&(b=F(this.source,"progress")),b>=100&&(this.done=!0),b===this.last?this.sinceLastUpdate+=a:(this.sinceLastUpdate&&(this.rate=(b-this.last)/this.sinceLastUpdate),this.catchup=(b-this.progress)/D.catchupTime,this.sinceLastUpdate=0,this.last=b),b>this.progress&&(this.progress+=this.catchup*a),c=1-Math.pow(this.progress/100,D.easeFactor),this.progress+=c*this.rate*a,this.progress=Math.min(this.lastProgress+D.maxProgressPerFrame,this.progress),this.progress=Math.max(0,this.progress),this.progress=Math.min(100,this.progress),this.lastProgress=this.progress,this.progress},a}(),L=null,H=null,r=null,M=null,p=null,s=null,j.running=!1,z=function(){return D.restartOnPushState?j.restart():void 0},null!=window.history.pushState&&(T=window.history.pushState,window.history.pushState=function(){return z(),T.apply(window.history,arguments)}),null!=window.history.replaceState&&(W=window.history.replaceState,window.history.replaceState=function(){return z(),W.apply(window.history,arguments)}),l={ajax:a,elements:d,document:c,eventLag:f},(B=function(){var a,c,d,e,f,g,h,i;for(j.sources=L=[],g=["ajax","elements","document","eventLag"],c=0,e=g.length;e>c;c++)a=g[c],D[a]!==!1&&L.push(new l[a](D[a]));for(i=null!=(h=D.extraSources)?h:[],d=0,f=i.length;f>d;d++)K=i[d],L.push(new K(D));return j.bar=r=new b,H=[],M=new m})(),j.stop=function(){return j.trigger("stop"),j.running=!1,r.destroy(),s=!0,null!=p&&("function"==typeof t&&t(p),p=null),B()},j.restart=function(){return j.trigger("restart"),j.stop(),j.start()},j.go=function(){var a;return j.running=!0,r.render(),a=C(),s=!1,p=G(function(b,c){var d,e,f,g,h,i,k,l,n,o,p,q,t,u,v,w;for(l=100-r.progress,e=p=0,f=!0,i=q=0,u=L.length;u>q;i=++q)for(K=L[i],o=null!=H[i]?H[i]:H[i]=[],h=null!=(w=K.elements)?w:[K],k=t=0,v=h.length;v>t;k=++t)g=h[k],n=null!=o[k]?o[k]:o[k]=new m(g),f&=n.done,n.done||(e++,p+=n.tick(b));return d=p/e,r.update(M.tick(b,d)),r.done()||f||s?(r.update(100),j.trigger("done"),setTimeout(function(){return r.finish(),j.running=!1,j.trigger("hide")},Math.max(D.ghostTime,Math.max(D.minTime-(C()-a),0)))):c()})},j.start=function(a){v(D,a),j.running=!0;try{r.render()}catch(b){i=b}return document.querySelector(".pace")?(j.trigger("start"),j.go()):setTimeout(j.start,50)},"function"==typeof define&&define.amd?define(function(){return j}):"object"==typeof exports?module.exports=j:D.startOnPageLoad&&j.start()}).call(this);
},{}],59:[function(require,module,exports){
var noMobileComponent = {
  controller: noMobileComponentController,
  transclude: true,
  template: '<div ng-if="$ctrl.isVisible"><div><div ng-transclude></div></div></div>',
};

noMobileComponentController.$inject = ['$window', 'MobileDetect'];
function noMobileComponentController($window, MobileDetect){
  var ctrl = this;
  ctrl.isVisible = false;
  ctrl.$onInit = function(){
    var md = new MobileDetect($window.navigator.userAgent);
    ctrl.isVisible = md.mobile();
    /*
    // Feature Detection would be ideal, but I'm just monkeypatching the MVP
    try {
      document.createEvent("TouchEvent");
      ctrl.isVisible = true;
    } catch(e) {
      ctrl.isVisible = false;
    }
    */
  }
}

angular
  .module('app')
  .component('noMobile', noMobileComponent);

},{}],60:[function(require,module,exports){
/** SUBMIT / VALIDATE - DIRECTIVE
 *
 *      Unifies the way that forms are handled on ACMS, use
 *       this as an alternative to `ng-submit` to add some
 *       standardized validaton and feedback. The idea is to
 *       remove our controllers from handling basic validation,
 *       leaving just business logic.
 *
 *      Usage:
 *          <form submit-validate="callback"></form> -- automatically triggered with `formCtrl` as the first argument
 *          <form submit-validate="callback(formCtrl, 'staticVar', localVar)"></form>
 *
 *      Notes:
 *          This caters for nested forms (using `ng-form`).
 *          We use just such a mechanism on the add-credentials
 *           pages, where we have an `ng-form` for each
 *           credential we are adding.
 *
 *      References:
 *          https://gist.github.com/maikeldaloo/5133963
 *          https://github.com/angular/angular.js/blob/07849779ba365f371a8caa3b58e23f677cfdc5ad/src/ng/directive/ngEventDirs.js#L48
 *          ... this one's not overly obvious, but it demonstrates the general method that angular creates the standard ng-eventname="" directives
 *
 *      @author   David "oodavid" King
 *
 *      @todo
 *        SAVE > Consider adding CMD+ENTER to submit the form
 */
submitValidateDirective.$inject = ['$timeout', 'alertService'];
function submitValidateDirective($timeout, alertService) {
  return {
    restrict: 'A', // Attribute only
    require: '^form',
    link: submitValidateLink,
    scope: {
      callback: '&submitValidate',
      ignoreEnter: '<?'
    },
  };
  // Recursive input dirtying
  function dirtyInputsRecursive(formCtrl) {
    formCtrl.$getControls().forEach(function(obj) {
      if (obj.$name) {
        // Dirty the input (or ng-form)
        if (obj.hasOwnProperty('$dirty') && obj.hasOwnProperty('$touched')) {
          obj.$setDirty();
          obj.$setTouched();
        }
        // Recurse into the ng-form
        if (obj.$$controls) {
          dirtyInputsRecursive(obj);
        }
      }
    });
  }
  // Add a submit event when the element is ready
  function submitValidateLink(scope, element, attrs, formCtrl) {
    // Add 'novalidate'
    attrs.$set('novalidate', 'novalidate');
    // If required, ignore enter key presses
    if (scope.ignoreEnter) {
      element.bind('keydown', function(event) {
        // If enter key was pressed on a form element, prevent that key press from submitting the form and click on the element instead
        if (event.key === 'Enter' && event.target !== event.currentTarget) {
          event.preventDefault();
          $(event.target).click();
        }
      });
    }
    // Search DOM for label
    function getLabelFor($el) {
      var id = $el.attr('id');
      var text = null;
      if (id) {
        text = $('label[for="' + id + '"]').text();
      } else {
        id = $el.attr('access-id');
        if (id) {
          text = $('label[id="' + id + '-label"]').text();
        } else {
          text = $el.attr('aria-label');
        }
      }
      return text;
    }
    // From https://stackoverflow.com/questions/6520192/how-to-get-the-text-node-of-an-element
    // Returns the text of the first, non-blank text node or span
    function getFirstNodeText($el) {
      return $el.contents().filter(function() {
        return (this.nodeType == Node.TEXT_NODE && !/^\s+$/.test($(this).text())) || (this.nodeType == Node.ELEMENT_NODE && this.tagName == 'SPAN');
      }).first().text().trim();
    }
    // Collate errors from form (and sub-forms!)
    function collateErrors(formErrors, control) {
      control.$getControls().forEach(function(subControl) {
        if (subControl.$invalid) {
          if (subControl.$$controls) {
            collateErrors(formErrors, subControl);
          } else {
            var detectedError = false;
            var el = subControl.$$element;
            $.each(subControl.$error, function(key, value) {
              if (value && !detectedError) {
                formErrors.push({
                  label: getLabelFor(el) || getFirstNodeText(el.closest('label')),
                  key: key,
                  translateValues: {
                    min: el.attr('min'),
                    max: el.attr('max'),
                    minlength: el.attr('minlength') || el.attr('ng-minlength'),
                    maxlength: el.attr('maxlength') || el.attr('ng-maxlength'),
                    step: el.attr('step'),
                  }
                });
                detectedError = true;
              }
            });
          }
        } else if (subControl.$$element[0].tagName.toLowerCase() === 'input-recaptcha' && !subControl.$viewValue) { // Handle recaptcha
          formErrors.push({ label: getLabelFor(subControl.$$element), key: 'required' });
        }
      });
    }
    // Add a submit event
    element.bind('submit', function(event) {
      // Trigger digest
      $timeout(function() {
        // We want the form to be dirty, but not submitted
        formCtrl.$setPristine();
        formCtrl.$setDirty();
        // Recursive input dirtying
        dirtyInputsRecursive(formCtrl);
        // Quit if invalid
        if (formCtrl.$invalid) {
          var formErrors = [];
          collateErrors(formErrors, formCtrl);
          // ...throw an alert by default
          if(!attrs.hasOwnProperty('noAlert')){
            // z-index should be higher than the forms inside modals
            alertService.warning('@:FORM_INVALID_PLEASE_CHECK_FORM', formErrors, 2000);
          }
          return;
        }
        // Flag the form
        formCtrl.$setSubmitted();
        // Trigger the callback
        if(attrs.submitValidate.indexOf('(') !== -1){
          scope.callback({ formCtrl: formCtrl }); // Using expression binding
        } else {
          var expressionHandler = scope.callback();
          expressionHandler(formCtrl); // Manually trigger the function passing formCtrl as the only argument
        }
      });
    });
    // Add a `submitValidate()` method to the form Controller
    formCtrl.submitValidate = submitValidate;
    function submitValidate(){
      element.triggerHandler('submit');
    }
    // Modify the form Controller, so the consumer can notify us of successes
    // Usage? See <save-button>
    formCtrl.saveSuccess = saveSuccess;
    function saveSuccess(){
      formCtrl.$setPristine();
      formCtrl.$submittedWithError = false;
      formCtrl.showSuccess = true;
      $timeout(function(){
        formCtrl.showSuccess = false;
      }, 1000);
    }
    formCtrl.saveError = saveError;
    function saveError(){
      formCtrl.$submittedWithError = true;
    }
  }
}

angular
  .module('app')
  .directive('submitValidate', submitValidateDirective);

},{}],61:[function(require,module,exports){
/** TOOLTIP
 *
 *    I'm not using AngularJS by design - why? Because I don't want
 *       to assign new scopes or events for every element, this will
 *     be pretty damn lightweight in action:
 *
 *      <div tooltip="Hello World!"></div>
 *
 *    Override the automatic placement with the [tooltip-placement]
 *     attribute:
 *
 *      <div tooltip="Hello World!" tooltip-placement="bottom"></div>
 *
 *      CSS Note
 *
 *          To render these correctly, be sure to use _toolip.scss
 *           which is available as part of our CSS framework.
 *
 *    @author   David "oodavid" King
 *    @author   Andrew Bateman (accessibility revisions)
 *
 */
(function() {
  // When we mouseover or focus
  var maskingContainer = null;
  var initiator = null;
  var toolTipEnter = function(e) {
    toolTipLeave(e);
    initiator = e.target;
    // Handle tooltip on dropdown root
    var initiatorParent = angular.element(initiator).parent();
    var initiatorParentTagName = initiatorParent.prop('tagName').toLowerCase() ;
    if ((initiatorParentTagName === 'dropdown-button' && initiatorParent.siblings('dropdown-content').find('> div').length > 0) || initiatorParentTagName === 'dropdown-content') {
      return;
    }
    var target = angular.element(e.target).closest('[tooltip]');
    // Only activate if there isn't a tooltip already or, if it is a toggletip, on the 'toggletipactivate' event
    if (target.attr('hidetooltip') && Boolean(target.attr('hidetooltip').value) || target.siblings().is('#tooltip') || (target.attr('toggletip') && e.type !== 'toggletipactivate' && e.type !== 'mouseenter')) {
      return;
    }
    var $tooltip = angular.element('<span id="tooltip" role="tooltip" aria-live="true"></span>'); // Create tooltip container
    target.append($tooltip); // Insert it into the DOM in context
    var text = target.attr('tooltip');
    var placement = target.attr('tooltip-placement'); // Likely to be null...
    var offset = target.offset();
    var customWidth = target.attr('tooltip-width');
    $tooltip.css({ maxWidth: customWidth + 'px' });
    offset.top -= angular.element(document).scrollTop();
    offset.left -= angular.element(document).scrollLeft();
    var parent = target;
    while (parent[0] !== angular.element('body')[0] && !maskingContainer) {
      var parentOverflow = parent.css('overflow');
      if (parentOverflow === 'auto' || parentOverflow === 'scroll') {
        maskingContainer = parent;
      } else {
        parent = parent.parent();
      }
    }
    maskingContainer = maskingContainer || angular.element('body');
    // Make sure "\\n" are converted to "\n"
    text = text.replace(/\\n/g, '\n');
    // Do nothing if we're in a disabled DOM tree, or we have no text to show
    if (target.closest('[disabled]').length || !text) {
      toolTipLeave();
      return;
    }
    // Reset with text immediately, then we can access the rendered tooltip dimensions
    $tooltip.text(text).removeClass('top right bottom left').css({
      left: 0,
      top: 0
    }).show();
    // Automatic placement
    if (!placement || ['top', 'left', 'bottom', 'right'].indexOf(placement) === -1) {
      placement = 'top';
      var centreX = offset.left + (target.outerWidth() / 2);
      var left = centreX - ($tooltip.outerWidth() / 2);
      var right = centreX + ($tooltip.outerWidth() / 2);
      if (left < maskingContainer.offset().left) {
        placement = 'right';
      } else if (right > maskingContainer.offset().left + maskingContainer.innerWidth()) {
        placement = 'left';
      } else if ((offset.top) - $tooltip.outerHeight() < 10) {
        placement = 'bottom';
      }
    }
    // Now position
    if (placement === 'bottom') {
      $tooltip
        .css({
          left: offset.left - ($tooltip.outerWidth() / 2) + (target.outerWidth() / 2),
          top: offset.top + target.outerHeight()
        });
    } else if (placement === 'right') {
      $tooltip
        .css({
          left: offset.left + target.outerWidth(),
          top: offset.top - ($tooltip.outerHeight() / 2) + (target.outerHeight() / 2)
        });
    } else if (placement === 'left') {
      $tooltip
        .css({
          left: offset.left - $tooltip.outerWidth(),
          top: offset.top + (target.outerHeight() / 2) - ($tooltip.outerHeight() / 2)
        });
    } else if (placement === 'top') {
      $tooltip
        .css({
          left: offset.left - ($tooltip.outerWidth() / 2) + (target.outerWidth() / 2),
          top: offset.top - $tooltip.outerHeight()
        });
    } else {
      $tooltip.hide(); // We shouldn't get here
    }
    // Make sure tooltip doesn't overflow masking container
    var leftOverflow = maskingContainer.offset().left - $tooltip.offset().left;
    var rightOverflow = ($tooltip.offset().left + $tooltip.outerWidth()) - (maskingContainer.offset().left + maskingContainer.innerWidth());
    var overflow = (leftOverflow > 0 ? leftOverflow + 8 : 0) + (rightOverflow > 0 ? rightOverflow + 8 : 0);
    if (overflow > 0) {
      var tooltipWidth = customWidth ? Number(customWidth.value) : 240;
      $tooltip.css('max-width', tooltipWidth - overflow);
    }
    // Style
    target.addClass('has-tooltip');
    $tooltip.addClass(placement);
    // SHAME
    //  The tooltip was never intended to be used as a conveyor of permissions
    //  For want of a refactor of tooltips at large, I have quickly added this
    //  logic to render the tooltip as a "warning"
    $tooltip.removeClass('not-allowed');
    if (target.hasClass('not-allowed')) {
      $tooltip.addClass('not-allowed');
    }
    if (maskingContainer[0] !== angular.element('body')[0]) {
      maskingContainer.on('scroll', toolTipLeave);
    }
  };
  // When we mouseleave
  var toolTipLeave = function(event) {
    angular.element('#tooltip').remove();
    angular.element('.has-tooltip').removeClass('has-tooltip');
    if (maskingContainer && maskingContainer[0] !== angular.element('body')[0]) {
      maskingContainer.off('scroll', toolTipLeave);
    }
    maskingContainer = null;
    // If the tooltip is on a <dropdown-button>, force the menu to open (if it hasn't already)
    if (initiator) {
      if (event && event.type === 'mousedown') {
        var currentInitiator = initiator;
        var initiatorParent = angular.element(currentInitiator).parent();
        // Using setTimeout here to avoid refactoring the entire directive
        if (initiatorParent.prop('tagName').toLowerCase() === 'dropdown-button') {
          // eslint-disable-next-line angular/timeout-service
          setTimeout(function() {
            if (initiatorParent.siblings('dropdown-content').find('> div').length === 0) {
              currentInitiator.click();
            }
          }, 200);
        }
      }
      initiator = null;
    }
  };
  // For speed, tooltips are "pure" jQuery.
  angular.element(document).ready(function() {
    angular.element('body').on('mouseenter', '[tooltip]', toolTipEnter);
    angular.element('body').on('focus', '[tooltip]', toolTipEnter);
    angular.element('body').on('toggletipactivate', '[tooltip]', toolTipEnter);
    angular.element('body').on('mouseleave', '[tooltip]', toolTipLeave);
    angular.element('body').on('blur', '[tooltip]', toolTipLeave);
    angular.element('body').on('mousedown', toolTipLeave);
    angular.element(document).on('scroll', toolTipLeave);
    angular.element('body').on('keydown', function(event) {
      if (event.key === 'Escape') {
        toolTipLeave();
      }
    });
  });
  // To make sure tooltips are correctly tidied up, we need to hide the tooltip if the parent is destroyed
  angular
    .module('app')
    .directive('tooltip', [function() {
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          // Add and update label for screen readers, if one isn't already set
          if (!element.attr('aria-label')) {
            element.attr('aria-label', '');
            attrs.$observe('tooltip', function(value) {
              attrs.$set('aria-label', attrs.toggletip ? attrs.toggletip : value);
            });
          }
          if (attrs.toggletip) {
            element.on('click', function() {
              if (element.hasClass('has-tooltip')) {
                toolTipLeave();
              } else {
                element.trigger('toggletipactivate');
              }
            });
          }
          scope.$on('$destroy', function() {
            if (element.hasClass('has-tooltip')) {
              toolTipLeave();
            }
          });
        }
      };
    }]);
})();

},{}],62:[function(require,module,exports){
/** Unsaved Changes - DIRECTIVE
 *
 *    A simple directive that adds a warning to unsaved forms
 *     when attempting to navigate away from a view.
 *
 *    Example
 *      <form name="formCtrl" unsaved-changes>
 *        <input ... >
 *      </form>
 *
 *    This Directive relies on the angular $dirty property
 *     that is assigned to form elements. In order to properly
 *     handle submitted changes you will need to make sure that
 *     $setPristine(); is triggered on your form after a
 *     successful submit or reset, like so:
 *      formCtrl.$setPristine();
 *
 *    @author   David "oodavid" King
 */
unsavedChangesDirective.$inject = ['$window', '$injector', '$filter', '_'];
function unsavedChangesDirective($window, $injector, $filter, _) {

  // Tracking the active forms
  var allForms = [];
  function trackForm(form){
    allForms.push(form);
  }
  function untrackForm(form){
    _.pull(allForms, form);
  }

  // Handle user navigation - window event
  function unsavedChangesOnBeforeUnload(e) {
    var numDirtyForms = getNumDirtyForms();
    if(numDirtyForms){
      var message = getWarningMessage(numDirtyForms);
      e = e || $window.event;
      if (e) {
        e.returnValue = message; // IE / Firefox
      }
      return message; // Webkit / Safari / Chrome
    }
  }
  $window.onbeforeunload = unsavedChangesOnBeforeUnload;

  // Handle user navigation - via ui-router
  if($injector.has('$transitions')){
    var $transitions = $injector.get('$transitions');
    $transitions.onStart({}, unsavedChangesUiRouterOnStart);
  }
  function unsavedChangesUiRouterOnStart($transition) {
    // NOTE: This doesn't work correctly with browser back as it fires after the history has already been popped
    // Can't see any way of fixing this at the moment
    // The transitions service has a bug; it sometimes triggers an event from and to the same page.
    // console > options > reload: true
    if($transition.from().name == $transition.to().name && angular.equals($transition.params('from'), $transition.params('to'))){
      return true; // OK to close / redirect
    }
    // Prompt the user, if necessary
    var numDirtyForms = getNumDirtyForms();
    if(numDirtyForms){
      var message = getWarningMessage(numDirtyForms);
      if (!$window.confirm(message)) {
        return false; // Don't close / redirect
      }
    }
    return true; // OK to close / redirect
  }

  // Manually run a check on a single form
  function unsavedChangesCanClose(form){
    if(form.$dirty){
      var message = getWarningMessage(1);
      if (!$window.confirm(message)) {
        return false; // Don't close / redirect
      }
    }
    return true; // It's OK to close the form
  }

  // Returns a warning message for the number of forms - pluralisation
  function getWarningMessage(numForms){
    var translate = $filter('translate');
    var message = numForms > 1 ? translate('unsaved.changes-multiple-forms', { numForms: numForms}) : translate('unsaved.changes-single-form'); // Notify
    message += '\n\n' + translate('unsaved.leave-confirm'); // Action
    return message;
  }

  // Returns the number of dirty forms
  function getNumDirtyForms() {
    var dirtyForms = _.filter(allForms, function(form) {
      return form.$dirty;
    });
    return dirtyForms.length;
  }

  // Forms with the unsaved-changes attribute are simply added to our watch list
  function unsavedChangesDirectiveLink(scope, element, attrs, form) {
    // Tracking
    trackForm(form);
    element.on('$destroy', function() {
      untrackForm(form);
    });
    // Add a helper method to the form scope
    scope.unsavedChangesCanClose = function(){
      return unsavedChangesCanClose(form);
    };
  }

  // The directive
  return {
    restrict: 'A', // Attribute only
    require: '^form',
    link: unsavedChangesDirectiveLink,
  };

}

angular
  .module('app')
  .directive('unsavedChanges', unsavedChangesDirective);

},{}],63:[function(require,module,exports){
/** UPLOAD FILE - DIRECTIVE
 *
 *      The file upload Custom Directive abstracts away the logic
 *       of ng-file-upload, dealing with our S3 bucket and the
 *       various common edge-cases. Leaving the designer to create
 *       a nice interace, and keeping our Controllers clean.
 *
 *      Usage
 *
 *          <button class="button" upload-file upload-preset="issuerImage" on-upload="onFile(fileUrl)" upload-progress="progressA" ng-style="{ 'background-size': progressA+'% 100%' }">
 *              Upload an Issuer Image
 *          </button>
 *
 *      NOTES
 *
 *          The progress system uses real data when available, but
 *           falls back to spoofing it. This is similar to the way
 *           the angular-loading-bar works, which is effective.
 *
 *      @author   David "oodavid" King
 */
require('../upload/uploadPresets.constant.js');

(function() {
  angular.module('app')
    .directive('uploadFile', ['uploadPresets', 'swalService', '$compile', 'fileSize', '$document', '$injector', function(uploadPresets, swalService, $compile, fileSize, $document, $injector) {
      // To "seed" our progress estimation, we assume the user has
      //  uploaded a small file (200kb) at 1Mbps.
      var Mbps = 1; // Megabits per second
      var Bpms = Mbps * 0.125 * 1000; // Bytes per Millisecond
      var uploadedBytes = fileSize.parse('3kB'); // Bytes
      var durationMs = uploadedBytes / Bpms; // Milliseconds
      // Then, whenever a file is uploaded, we adjust these values
      //  to get a more accurate reading. This is a similar method
      //  that angular-loading-bar uses. Smoke and Mirrors.
      var adjustUploadSettings = function(bytes, ms) {
        uploadedBytes += bytes;
        durationMs += ms;
        Bpms = uploadedBytes / durationMs;
      };
      // This returns an estimated time to upload
      var estimateUploadTimeMs = function(fileSizeBytes) {
        return (fileSizeBytes / Bpms) + 1500; // Add 1.5s for the HTTP round-trip
      };
      // This returns a estimated progress percentage based on the known
      //  size of the file AND historical upload sizes and times.
      // See https://github.com/oodavid/timestep/blob/master/src/animate/transitions.js
      //  for alternative easing logic
      var esimateProgress = function(fileSizeBytes, timeElapsedMs) {
        var estimatedTotalMs = estimateUploadTimeMs(fileSizeBytes);
        var n = timeElapsedMs / estimatedTotalMs;
        n += 0.05; // Never be 0
        if (n > 1) {
          n = 1;
        }
        n *= 0.9; // Never get to 1
        return n * (2 - n); // EaseOutQuad
      };
      // S3 response with XML, we need a formatter
      var x2js = new window.X2JS();
      // Controller applies to the (transcluded) element
      var controller = ['$scope', '$element', '$timeout', 'api', 'Upload', function($scope, $element, $timeout, api, Upload) {
        $scope.progress = undefined;
        $scope.error = false;
        $scope.preset = uploadPresets[$scope.uploadPreset] || uploadPresets['default'];
        $scope.isDisabled = false;
        //
        // Estimates the progress
        //
        var startTimeMs;
        var progressTimeout;
        var fileSizeBytes;
        var estimateProgress = function() {
          var elapsedTimeMs = Date.now() - startTimeMs;
          $scope.progress = (esimateProgress(fileSizeBytes, elapsedTimeMs) * 100).toFixed(2);
          progressTimeout = $timeout(estimateProgress, 50);
        };
        var startEstimatingProgress = function(myFileSizeBytes) {
          fileSizeBytes = myFileSizeBytes;
          startTimeMs = Date.now();
          $scope.progress = 0;
          estimateProgress();
        };
        var stopEstimatingProgress = function(success) {
          if (progressTimeout) {
            $timeout.cancel(progressTimeout);
            progressTimeout = false;
          }
          if (success) {
            var elapsedTimeMs = Date.now() - startTimeMs;
            adjustUploadSettings(fileSizeBytes, elapsedTimeMs);
          }
        };
        //
        // When clicking, we "reset" the button, but temporarily
        //  disable it to prevent the user machine-gunning the button
        //
        $scope.doClick = function() {
          $element.removeClass('uploading error'); //.blur(); // Removed the blur as it interferes with focus-trapping
          $scope.error = false;
          $scope.isDisabled = true;
          $timeout(function() {
            $scope.isDisabled = false;
          }, 2500);
        };
        //
        // Shows an error message
        //
        var doError = function(err) {
          err = err || 'Unknown error occurred';
          console.error(err);
          $scope.error = err;
          stopEstimatingProgress(false);
          $element.addClass('uploading error');
          $scope.isDisabled = false;
          $timeout(function() {
            $element.removeClass('uploading error');
            $scope.progress = undefined;
          }, 2000);
        };
        //
        // When we have a successful upload
        //
        var doSuccess = function(fileUrl, fileType, fileName, s3Bucket, s3Key, fileSizeBytes) {
          $scope.onUpload({
            fileUrl: fileUrl,
            fileType: fileType,
            fileName: fileName,
            s3Bucket: s3Bucket,
            s3Key: s3Key,
            fileSizeBytes: fileSizeBytes,
          });
          stopEstimatingProgress(true);
          $scope.progress = 100;
          $scope.isDisabled = false;
          $element.removeClass('uploading error');
          $timeout(function() {
            $scope.progress = undefined;
          }, 500);
        };
        //
        // When we select a file
        //
        $scope.onFileSelect = function($file) {
          var displayGenericError = function() {
            swalService.showAlert('fileUploadError');
          };
          // Check for files etc.
          if($file){
            // Once we've acknowledged the event, the user is free to re-click
            $scope.isDisabled = false;
            // Silently ignore incorrect file extentions (crude check)
            var ext = '.'+$file.name.split('.').pop().toLowerCase();
            if($scope.preset.accept && $scope.preset.accept.indexOf(ext) === -1){
              return;
            }
            // Validate the size
            if ($file.size < fileSize.parse($scope.preset.size)) {
              // Now we're uploading...
              $element.addClass('uploading');
              $scope.progress = 0;

              var policyUrl =  $scope.preset.policy + '?content_type=' + $file.type;
              // Grab the S3 policy
              api.request(policyUrl)
                .then(function(s3Params) {
                  //console.log('s3Params', s3Params);
                  var fileKey = s3Params.key;
                  if ($file.name.indexOf('.') !== -1) {
                    fileKey += '.' + $file.name.split('.').pop(); // Add the file extension (it's useful)
                  }
                  // The final Url
                  // var fileUrl = 'https://s3.amazonaws.com/' + s3Params.bucket_name + '/' + fileKey;
                  var fileUrl = s3Params.bucket_file_url_prefix + fileKey;
                  // Run supplied start function
                  if ($scope.onStart) {
                    $scope.onStart();
                  }
                  // Estimate progress
                  startEstimatingProgress($file.size);
                  // IE8 won't get a response, simulate one
                  if ($('body').is('.ie8')) {
                    var delay = estimateUploadTimeMs($file.size);
                    $timeout(function() {
                      doSuccess(fileUrl, $file.type, $file.name, s3Params.bucket_name, fileKey, $file.size);
                    }, delay);
                  }
                  // Upload the file
                  Upload.upload({
                      // url: 'https://' + s3Params.bucket_name + '.s3.amazonaws.com/',
                      url: s3Params.bucket_url,
                      method: 'POST',
                      // data: {
                      //   'key': fileKey,
                      //   'acl': $scope.preset.acl,
                      //   'Content-Type': ($file.type || 'application/octet-stream'),
                      //   'success_action_status': '201',
                      //   'AWSAccessKeyId': s3Params.access_key_id,
                      //   'Policy': s3Params.policy,
                      //   'Signature': s3Params.signature,
                      //   'Filename': $file.name.replace(/ /g, '_').replace(/[\[,\]]/g, ''),
                      // },
                      data: {
                        'key': fileKey,
                        'acl': $scope.preset.acl,
                        'Content-Type': ($file.type || 'application/octet-stream'),
                        'success_action_status': '201',
                        'X-Amz-Credential' : s3Params['x-amz-credential'],
                        'X-Amz-Algorithm': s3Params['x-amz-algorithm'],
                        'X-Amz-Date': s3Params['x-amz-date'],
                        'X-Amz-Signature': s3Params['x-amz-signature'],
                        'Policy': s3Params.policy,
                        'Filename': $file.name.replace(/ /g, '_').replace(/[\[,\]]/g, ''),
                      },
                      file: $file,
                    })
                    .progress(function(evt) {
                      stopEstimatingProgress(false); // No need to estimate, we got real progress
                      $scope.progress = ((evt.loaded / evt.total) * 100).toFixed(2);
                    })
                    .success(function(xmlResponse, status, headers, config) {
                      if (status === 200 || status === 201) {
                        // File was uploaded successfully
                        var jsonResponse = x2js.xml_str2json(xmlResponse);
                        doSuccess(fileUrl, $file.type, $file.name, s3Params.bucket_name, fileKey, $file.size);
                      } else {
                        doError(status);
                        displayGenericError();
                      }
                    })
                    .error(function(err) {
                      doError(err);
                      displayGenericError();
                    });
                })
                .catch(function(err) {
                  doError(err || 'Upload Policy Error');
                  displayGenericError();
                });
            } else {
              swalService.showAlert('fileTooLargeError', $scope.preset.size);
            }
          }
        };
      }];
      // Our Custom Directive hoists some variables into the scope, sets the controller and adds the angular-file-upload attributes
      return {
        restrict: 'A',
        scope: {
          uploadPreset: '@?',
          progress: '=?uploadProgress',
          error: '=?onError',
          onStart: '&?onStart',
          onUpload: '&?onUpload',
          ngDisabled: '=?',
          onUploadFullscreen: '@uploadFullscreen',
        },
        require: '?^fullscreenUpload',
        controller: controller,
        link: function(scope, element, attrs, fullscreenUploadCtrl) {
          if(element[0].tagName === 'button'){
            attrs.$set('type', 'button'); // Force the button `type`
          }
          attrs.$set('ng-disabled', 'ngDisabled || isDisabled'); // ngDisabled MIGHT be available as an attribute, but this is fine either way
          attrs.$set('ng-click', 'doClick()');
          attrs.$set('ngf-select', 'onFileSelect($file)');
          attrs.$set('ngf-drop', 'onFileSelect($file)');
          attrs.$set('ngf-drag-over-class', '\'dragover\'');
          attrs.$set('ngf-accept', 'preset.accept'); // This slows the browser modal down
          attrs.$set('ngf-pattern', 'preset.accept');
          attrs.$set('ngf-drop-available', 'isDropAvailable');
          element.removeAttr('upload-file'); // Prevents compile creating an infinite loop
          element.addClass('upload-file');
          $compile(element)(scope);
          // We might be contained within a fullscreenUpload directive, communicate to it if possible
          // ...this can be disabled by adding upload-fullscreen="false" to the element
          if(fullscreenUploadCtrl && (!attrs['uploadFullscreen'] || attrs['uploadFullscreen'] !== 'false')){
            fullscreenUploadCtrl.setListener(scope.onFileSelect);
            scope.$on('$destroy', function() {
              fullscreenUploadCtrl.unsetListener(scope.onFileSelect);
            });
          }
        },
      };
    }]);
})();

},{"../upload/uploadPresets.constant.js":64}],64:[function(require,module,exports){
/** UPLOAD PRESETS
 *
 *    Settings for the various buckets that we can upload to.
 *
 *    To see which canned ACL rules are available, go to:
 *     http://docs.aws.amazon.com/AmazonS3/latest/dev/acl-overview.html#canned-acl
 *
 *    Don't use mime-types in the 'accept' value as they slow down the browser
 *     file-select modal, clearly because it has to read all the file headers.
 */
angular
  .module('app')
  .constant('uploadPresets', {
    'default': {
      accept: '.png,.jpg,.jpeg,.gif',
      size: '5Mb',
      policy: '/s3_policy/',
      acl: 'public-read',
    },
    'issuerImage': {
      accept: '.png,.jpg,.jpeg,.gif',
      size: '5Mb',
      policy: '/s3_policy/templates/',
      acl: 'public-read',
    },
    'evidence': {
      accept: '',
      size: '20Mb',
      policy: '/s3_policy/evidence/',
      acl: 'public-read',
      folder: 'temp/',
    },
    'issuerSpreadsheet': {
      accept: '.xls,.xlsx,.csv,.txt',
      size: '20Mb',
      policy: '/s3_policy/organizations/',
      acl: 'public-read',
    },
    'issuerFiles': {
      accept: '',
      size: '20Mb',
      policy: '/s3_policy/organizations/',
      acl: 'public-read',
    },
  });

},{}],65:[function(require,module,exports){
/** EMAIL : VALIDATOR
 *
 *    Adds email validation to an input. This updates the built-in
 *     AngularJS logic with a superior regex.
 *
 *      <input type="email" validate-email>
 *
 *    @author   David "oodavid" King
 */
require('../_services/email.service.js');

validateEmailDirective.$inject = ['emailService'];
function validateEmailDirective(emailService){
  // Validator
  function validateEmail(modelValue, viewValue){
    return emailService.isValid(modelValue || viewValue);
  }
  // Link
  function validateEmailDirectiveLink(scope, elem, attr, ngModel) {
    ngModel.$validators.email = validateEmail; // REPLACE the default angular validator with our own
    if (!attr.placeholder) {
      attr.$set('placeholder', '...@...'); // Set the placeholder if we don't have one
    }
  }
  // Our directive
  return {
    restrict: 'A',
    require: 'ngModel',
    link: validateEmailDirectiveLink,
  };
}

angular
  .module('app')
  .directive('validateEmail', validateEmailDirective);

},{"../_services/email.service.js":23}],66:[function(require,module,exports){
/** PIXELS : VALIDATOR
 *
 *      Input utility that displays a number in the input,
 *       but the model value includes the "px" suffix.
 *
 *          $scope.pixelWidth = '30px';
 *          <input type="number" validate-px ng-model="pixelWidth"> pixels
 *
 *      @author   David "oodavid" King
 */
validatePxDirective.$inject = [];
function validatePxDirective(){
  return {
    restrict: 'A',
    require: 'ngModel',
    link: validatePxDirectiveLink,
  };
  // Link
  function validatePxDirectiveLink(scope, elem, attrs, ngModelCtrl) {
    ngModelCtrl.$formatters.push(function(value) {
      return parseInt(value);
    });
    ngModelCtrl.$parsers.push(function(value) {
      return value + 'px';
    });
  }
}

angular
  .module('app')
  .directive('validatePx', validatePxDirective);

},{}],67:[function(require,module,exports){
/** VALIDATION
 *
 *      Renders validation errors
 *
 *      <validation model="formCtrl.myInput">
 *      <validation model="formCtrl.myInput" left-align="true"> - left align the validation message
 */

require('angular-messages');
angular.module('app').requires.push('ngMessages');

var validationComponent = {
  controller: validationComponentController,
  bindings: {
    model: '<',
    leftAlign: '<?'
  },
  templateUrl: '/shared/validation/validation.html',
  transclude: true,
};

validationComponentController.$inject = [];
function validationComponentController(){
  var $ctrl = this;
  $ctrl.$onInit = $onInit;
  $ctrl.attr;

  // Pull out attributes for `min`, `max`... so we can have messages like "the minlength is 8"
  function $onInit(){
    if($ctrl.model){
      var element = $ctrl.model.$$element;
      $ctrl.attr = {
        maxlength: element.attr('maxlength') || element.attr('ng-maxlength'),
        minlength: element.attr('minlength') || element.attr('ng-minlength'),
        min: element.attr('min') || element.attr('ng-min'),
        max: element.attr('max') || element.attr('ng-max'),
        step: element.attr('step') || element.attr('ng-step'),
      };
    }
  }

}

angular
  .module('app')
  .component('validation', validationComponent);

},{"angular-messages":3}],68:[function(require,module,exports){
/** Vendor Factories
 *
 *      If we are using 3rd party libraries, Angular should
 *       be able to reference them as dependencies. This
 *       factories file is a simple way to expose these libs.
 *
 *      http://www.jvandemo.com/how-to-properly-integrate-non-angularjs-libraries-in-your-angularjs-application/
 *
 *      Factories
 *          _         lodash
 *          WebFont   Google Font Loader
 *          swal      Sweet Alerts
 *          moment    Moment.js date logic
 *          GS        GetSocial (share tracking)
 *
 *    @author   David "oodavid" King
 */
(function() {
  angular.module('app')
    // Lodash
    .factory('_', ['$window',
      function($window) {
        return $window._ || false;
      }
    ])
    // Sweet Alerts (swal)
    .factory('swal', ['$window',
      function($window) {
        return $window.swal || false;
      }
    ])
    // Momentjs
    .factory('moment', ['$window',
      function($window) {
        return $window.myMoment || false;
      }
    ])
    // Entities
    .factory('Entities', ['$window',
      function($window) {
        return $window.Entities || false;
      }
    ])
    // MobileDetect
    .factory('MobileDetect', ['$window',
      function($window) {
        return $window.MobileDetect || false;
      }
    ])
    // QRCode
    .factory('QRCode', ['$window',
      function($window) {
        return $window.QRCode || false;
      }
    ])
    // SHA256
    .factory('SHA256', ['$window',
      function($window) {
        return $window.SHA256 || false;
      }
    ])
    // Google Pay API
    .factory('gapi', ['$window',
      function($window) {
        return $window.gapi || false;
      }
    ])
    // GetSocial
    .factory('GS', ['$window',
      function($window) {
        return $window.GS || false;
      }
    ]);
})();

},{}]},{},[15]);
